export default {
  municipios: [
    {
      value: 5200050,
      label: "Abadia de Goiás",
      reference: 52
    },
    {
      value: 3100104,
      label: "Abadia dos Dourados",
      reference: 31
    },
    {
      value: 5200100,
      label: "Abadiânia",
      reference: 52
    },
    {
      value: 3100203,
      label: "Abaeté",
      reference: 31
    },
    {
      value: 1500107,
      label: "Abaetetuba",
      reference: 15
    },
    {
      value: 2300101,
      label: "Abaiara",
      reference: 23
    },
    {
      value: 2900108,
      label: "Abaíra",
      reference: 29
    },
    {
      value: 2900207,
      label: "Abaré",
      reference: 29
    },
    {
      value: 4100103,
      label: "Abatiá",
      reference: 41
    },
    {
      value: 4200051,
      label: "Abdon Batista",
      reference: 42
    },
    {
      value: 1500131,
      label: "Abel Figueiredo",
      reference: 15
    },
    {
      value: 4200101,
      label: "Abelardo Luz",
      reference: 42
    },
    {
      value: 3100302,
      label: "Abre Campo",
      reference: 31
    },
    {
      value: 2600054,
      label: "Abreu e Lima",
      reference: 26
    },
    {
      value: 1700251,
      label: "Abreulândia",
      reference: 17
    },
    {
      value: 3100401,
      label: "Acaiaca",
      reference: 31
    },
    {
      value: 2100055,
      label: "Açailândia",
      reference: 21
    },
    {
      value: 2900306,
      label: "Acajutiba",
      reference: 29
    },
    {
      value: 1500206,
      label: "Acará",
      reference: 15
    },
    {
      value: 2300150,
      label: "Acarape",
      reference: 23
    },
    {
      value: 2300200,
      label: "Acaraú",
      reference: 23
    },
    {
      value: 2400109,
      label: "Acari",
      reference: 24
    },
    {
      value: 2200053,
      label: "Acauã",
      reference: 22
    },
    {
      value: 4300034,
      label: "Aceguá",
      reference: 43
    },
    {
      value: 2300309,
      label: "Acopiara",
      reference: 23
    },
    {
      value: 5100102,
      label: "Acorizal",
      reference: 51
    },
    {
      value: 1200013,
      label: "Acrelândia",
      reference: 12
    },
    {
      value: 5200134,
      label: "Acreúna",
      reference: 52
    },
    {
      value: 2400208,
      label: "Açu",
      reference: 24
    },
    {
      value: 3100500,
      label: "Açucena",
      reference: 31
    },
    {
      value: 3500105,
      label: "Adamantina",
      reference: 35
    },
    {
      value: 5200159,
      label: "Adelândia",
      reference: 52
    },
    {
      value: 3500204,
      label: "Adolfo",
      reference: 35
    },
    {
      value: 4100202,
      label: "Adrianópolis",
      reference: 41
    },
    {
      value: 2900355,
      label: "Adustina",
      reference: 29
    },
    {
      value: 2600104,
      label: "Afogados da Ingazeira",
      reference: 26
    },
    {
      value: 2400307,
      label: "Afonso Bezerra",
      reference: 24
    },
    {
      value: 3200102,
      label: "Afonso Cláudio",
      reference: 32
    },
    {
      value: 2100105,
      label: "Afonso Cunha",
      reference: 21
    },
    {
      value: 2600203,
      label: "Afrânio",
      reference: 26
    },
    {
      value: 1500305,
      label: "Afuá",
      reference: 15
    },
    {
      value: 2600302,
      label: "Agrestina",
      reference: 26
    },
    {
      value: 2200103,
      label: "Agricolândia",
      reference: 22
    },
    {
      value: 4200200,
      label: "Agrolândia",
      reference: 42
    },
    {
      value: 4200309,
      label: "Agronômica",
      reference: 42
    },
    {
      value: 1500347,
      label: "Água Azul do Norte",
      reference: 15
    },
    {
      value: 3100609,
      label: "Água Boa",
      reference: 31
    },
    {
      value: 5100201,
      label: "Água Boa",
      reference: 51
    },
    {
      value: 2200202,
      label: "Água Branca",
      reference: 22
    },
    {
      value: 2500106,
      label: "Água Branca",
      reference: 25
    },
    {
      value: 2700102,
      label: "Água Branca",
      reference: 27
    },
    {
      value: 5000203,
      label: "Água Clara",
      reference: 50
    },
    {
      value: 3100708,
      label: "Água Comprida",
      reference: 31
    },
    {
      value: 4200408,
      label: "Água Doce",
      reference: 42
    },
    {
      value: 2100154,
      label: "Água Doce do Maranhão",
      reference: 21
    },
    {
      value: 3200169,
      label: "Água Doce do Norte",
      reference: 32
    },
    {
      value: 2900405,
      label: "Água Fria",
      reference: 29
    },
    {
      value: 5200175,
      label: "Água Fria de Goiás",
      reference: 52
    },
    {
      value: 5200209,
      label: "Água Limpa",
      reference: 52
    },
    {
      value: 2400406,
      label: "Água Nova",
      reference: 24
    },
    {
      value: 2600401,
      label: "Água Preta",
      reference: 26
    },
    {
      value: 4300059,
      label: "Água Santa",
      reference: 43
    },
    {
      value: 3500303,
      label: "Aguaí",
      reference: 35
    },
    {
      value: 3100807,
      label: "Aguanil",
      reference: 31
    },
    {
      value: 2600500,
      label: "Águas Belas",
      reference: 26
    },
    {
      value: 3500402,
      label: "Águas da Prata",
      reference: 35
    },
    {
      value: 4200507,
      label: "Águas de Chapecó",
      reference: 42
    },
    {
      value: 3500501,
      label: "Águas de Lindóia",
      reference: 35
    },
    {
      value: 3500550,
      label: "Águas de Santa Bárbara",
      reference: 35
    },
    {
      value: 3500600,
      label: "Águas de São Pedro",
      reference: 35
    },
    {
      value: 3100906,
      label: "Águas Formosas",
      reference: 31
    },
    {
      value: 4200556,
      label: "Águas Frias",
      reference: 42
    },
    {
      value: 5200258,
      label: "Águas Lindas de Goiás",
      reference: 52
    },
    {
      value: 4200606,
      label: "Águas Mornas",
      reference: 42
    },
    {
      value: 3101003,
      label: "Águas Vermelhas",
      reference: 31
    },
    {
      value: 4300109,
      label: "Agudo",
      reference: 43
    },
    {
      value: 3500709,
      label: "Agudos",
      reference: 35
    },
    {
      value: 4100301,
      label: "Agudos do Sul",
      reference: 41
    },
    {
      value: 3200136,
      label: "Águia Branca",
      reference: 32
    },
    {
      value: 2500205,
      label: "Aguiar",
      reference: 25
    },
    {
      value: 1700301,
      label: "Aguiarnópolis",
      reference: 17
    },
    {
      value: 3101102,
      label: "Aimorés",
      reference: 31
    },
    {
      value: 2900603,
      label: "Aiquara",
      reference: 29
    },
    {
      value: 2300408,
      label: "Aiuaba",
      reference: 23
    },
    {
      value: 3101201,
      label: "Aiuruoca",
      reference: 31
    },
    {
      value: 4300208,
      label: "Ajuricaba",
      reference: 43
    },
    {
      value: 3101300,
      label: "Alagoa",
      reference: 31
    },
    {
      value: 2500304,
      label: "Alagoa Grande",
      reference: 25
    },
    {
      value: 2500403,
      label: "Alagoa Nova",
      reference: 25
    },
    {
      value: 2500502,
      label: "Alagoinha",
      reference: 25
    },
    {
      value: 2600609,
      label: "Alagoinha",
      reference: 26
    },
    {
      value: 2200251,
      label: "Alagoinha do Piauí",
      reference: 22
    },
    {
      value: 2900702,
      label: "Alagoinhas",
      reference: 29
    },
    {
      value: 3500758,
      label: "Alambari",
      reference: 35
    },
    {
      value: 3101409,
      label: "Albertina",
      reference: 31
    },
    {
      value: 2100204,
      label: "Alcântara",
      reference: 21
    },
    {
      value: 2300507,
      label: "Alcântaras",
      reference: 23
    },
    {
      value: 2500536,
      label: "Alcantil",
      reference: 25
    },
    {
      value: 5000252,
      label: "Alcinópolis",
      reference: 50
    },
    {
      value: 2900801,
      label: "Alcobaça",
      reference: 29
    },
    {
      value: 2100303,
      label: "Aldeias Altas",
      reference: 21
    },
    {
      value: 4300307,
      label: "Alecrim",
      reference: 43
    },
    {
      value: 3200201,
      label: "Alegre",
      reference: 32
    },
    {
      value: 4300406,
      label: "Alegrete",
      reference: 43
    },
    {
      value: 2200277,
      label: "Alegrete do Piauí",
      reference: 22
    },
    {
      value: 4300455,
      label: "Alegria",
      reference: 43
    },
    {
      value: 3101508,
      label: "Além Paraíba",
      reference: 31
    },
    {
      value: 1500404,
      label: "Alenquer",
      reference: 15
    },
    {
      value: 2400505,
      label: "Alexandria",
      reference: 24
    },
    {
      value: 5200308,
      label: "Alexânia",
      reference: 52
    },
    {
      value: 3101607,
      label: "Alfenas",
      reference: 31
    },
    {
      value: 3200300,
      label: "Alfredo Chaves",
      reference: 32
    },
    {
      value: 3500808,
      label: "Alfredo Marcondes",
      reference: 35
    },
    {
      value: 3101631,
      label: "Alfredo Vasconcelos",
      reference: 31
    },
    {
      value: 4200705,
      label: "Alfredo Wagner",
      reference: 42
    },
    {
      value: 2500577,
      label: "Algodão de Jandaíra",
      reference: 25
    },
    {
      value: 2500601,
      label: "Alhandra",
      reference: 25
    },
    {
      value: 2600708,
      label: "Aliança",
      reference: 26
    },
    {
      value: 1700350,
      label: "Aliança do Tocantins",
      reference: 17
    },
    {
      value: 2900900,
      label: "Almadina",
      reference: 29
    },
    {
      value: 1700400,
      label: "Almas",
      reference: 17
    },
    {
      value: 1500503,
      label: "Almeirim",
      reference: 15
    },
    {
      value: 3101706,
      label: "Almenara",
      reference: 31
    },
    {
      value: 2400604,
      label: "Almino Afonso",
      reference: 24
    },
    {
      value: 4100400,
      label: "Almirante Tamandaré",
      reference: 41
    },
    {
      value: 4300471,
      label: "Almirante Tamandaré do Sul",
      reference: 43
    },
    {
      value: 5200506,
      label: "Aloândia",
      reference: 52
    },
    {
      value: 3101805,
      label: "Alpercata",
      reference: 31
    },
    {
      value: 4300505,
      label: "Alpestre",
      reference: 43
    },
    {
      value: 3101904,
      label: "Alpinópolis",
      reference: 31
    },
    {
      value: 5100250,
      label: "Alta Floresta",
      reference: 51
    },
    {
      value: 1100015,
      label: "Alta Floresta D'Oeste",
      reference: 11
    },
    {
      value: 3500907,
      label: "Altair",
      reference: 35
    },
    {
      value: 1500602,
      label: "Altamira",
      reference: 15
    },
    {
      value: 2100402,
      label: "Altamira do Maranhão",
      reference: 21
    },
    {
      value: 4100459,
      label: "Altamira do Paraná",
      reference: 41
    },
    {
      value: 2300606,
      label: "Altaneira",
      reference: 23
    },
    {
      value: 3102001,
      label: "Alterosa",
      reference: 31
    },
    {
      value: 2600807,
      label: "Altinho",
      reference: 26
    },
    {
      value: 3501004,
      label: "Altinópolis",
      reference: 35
    },
    {
      value: 3501103,
      label: "Alto Alegre",
      reference: 35
    },
    {
      value: 1400050,
      label: "Alto Alegre",
      reference: 14
    },
    {
      value: 4300554,
      label: "Alto Alegre",
      reference: 43
    },
    {
      value: 2100436,
      label: "Alto Alegre do Maranhão",
      reference: 21
    },
    {
      value: 2100477,
      label: "Alto Alegre do Pindaré",
      reference: 21
    },
    {
      value: 1100379,
      label: "Alto Alegre dos Parecis",
      reference: 11
    },
    {
      value: 5100300,
      label: "Alto Araguaia",
      reference: 51
    },
    {
      value: 4200754,
      label: "Alto Bela Vista",
      reference: 42
    },
    {
      value: 5100359,
      label: "Alto Boa Vista",
      reference: 51
    },
    {
      value: 3102050,
      label: "Alto Caparaó",
      reference: 31
    },
    {
      value: 2400703,
      label: "Alto do Rodrigues",
      reference: 24
    },
    {
      value: 4300570,
      label: "Alto Feliz",
      reference: 43
    },
    {
      value: 5100409,
      label: "Alto Garças",
      reference: 51
    },
    {
      value: 5200555,
      label: "Alto Horizonte",
      reference: 52
    },
    {
      value: 3153509,
      label: "Alto Jequitibá",
      reference: 31
    },
    {
      value: 2200301,
      label: "Alto Longá",
      reference: 22
    },
    {
      value: 5100508,
      label: "Alto Paraguai",
      reference: 51
    },
    {
      value: 4128625,
      label: "Alto Paraíso",
      reference: 41
    },
    {
      value: 1100403,
      label: "Alto Paraíso",
      reference: 11
    },
    {
      value: 5200605,
      label: "Alto Paraíso de Goiás",
      reference: 52
    },
    {
      value: 4100608,
      label: "Alto Paraná",
      reference: 41
    },
    {
      value: 2100501,
      label: "Alto Parnaíba",
      reference: 21
    },
    {
      value: 4100707,
      label: "Alto Piquiri",
      reference: 41
    },
    {
      value: 3102100,
      label: "Alto Rio Doce",
      reference: 31
    },
    {
      value: 3200359,
      label: "Alto Rio Novo",
      reference: 32
    },
    {
      value: 2300705,
      label: "Alto Santo",
      reference: 23
    },
    {
      value: 5100607,
      label: "Alto Taquari",
      reference: 51
    },
    {
      value: 4100509,
      label: "Altônia",
      reference: 41
    },
    {
      value: 2200400,
      label: "Altos",
      reference: 22
    },
    {
      value: 3501152,
      label: "Alumínio",
      reference: 35
    },
    {
      value: 1300029,
      label: "Alvarães",
      reference: 13
    },
    {
      value: 3102209,
      label: "Alvarenga",
      reference: 31
    },
    {
      value: 3501202,
      label: "Álvares Florence",
      reference: 35
    },
    {
      value: 3501301,
      label: "Álvares Machado",
      reference: 35
    },
    {
      value: 3501400,
      label: "Álvaro de Carvalho",
      reference: 35
    },
    {
      value: 3501509,
      label: "Alvinlândia",
      reference: 35
    },
    {
      value: 3102308,
      label: "Alvinópolis",
      reference: 31
    },
    {
      value: 1700707,
      label: "Alvorada",
      reference: 17
    },
    {
      value: 4300604,
      label: "Alvorada",
      reference: 43
    },
    {
      value: 1100346,
      label: "Alvorada D'Oeste",
      reference: 11
    },
    {
      value: 3102407,
      label: "Alvorada de Minas",
      reference: 31
    },
    {
      value: 2200459,
      label: "Alvorada do Gurguéia",
      reference: 22
    },
    {
      value: 5200803,
      label: "Alvorada do Norte",
      reference: 52
    },
    {
      value: 4100806,
      label: "Alvorada do Sul",
      reference: 41
    },
    {
      value: 1400027,
      label: "Amajari",
      reference: 14
    },
    {
      value: 5000609,
      label: "Amambai",
      reference: 50
    },
    {
      value: 1600105,
      label: "Amapá",
      reference: 16
    },
    {
      value: 2100550,
      label: "Amapá do Maranhão",
      reference: 21
    },
    {
      value: 4100905,
      label: "Amaporã",
      reference: 41
    },
    {
      value: 2600906,
      label: "Amaraji",
      reference: 26
    },
    {
      value: 4300638,
      label: "Amaral Ferrador",
      reference: 43
    },
    {
      value: 5200829,
      label: "Amaralina",
      reference: 52
    },
    {
      value: 2200509,
      label: "Amarante",
      reference: 22
    },
    {
      value: 2100600,
      label: "Amarante do Maranhão",
      reference: 21
    },
    {
      value: 2901007,
      label: "Amargosa",
      reference: 29
    },
    {
      value: 1300060,
      label: "Amaturá",
      reference: 13
    },
    {
      value: 2901106,
      label: "Amélia Rodrigues",
      reference: 29
    },
    {
      value: 2901155,
      label: "América Dourada",
      reference: 29
    },
    {
      value: 3501608,
      label: "Americana",
      reference: 35
    },
    {
      value: 5200852,
      label: "Americano do Brasil",
      reference: 52
    },
    {
      value: 3501707,
      label: "Américo Brasiliense",
      reference: 35
    },
    {
      value: 3501806,
      label: "Américo de Campos",
      reference: 35
    },
    {
      value: 4300646,
      label: "Ametista do Sul",
      reference: 43
    },
    {
      value: 2300754,
      label: "Amontada",
      reference: 23
    },
    {
      value: 5200902,
      label: "Amorinópolis",
      reference: 52
    },
    {
      value: 2500734,
      label: "Amparo",
      reference: 25
    },
    {
      value: 3501905,
      label: "Amparo",
      reference: 35
    },
    {
      value: 2800100,
      label: "Amparo de São Francisco",
      reference: 28
    },
    {
      value: 3102506,
      label: "Amparo do Serra",
      reference: 31
    },
    {
      value: 4101002,
      label: "Ampére",
      reference: 41
    },
    {
      value: 2700201,
      label: "Anadia",
      reference: 27
    },
    {
      value: 2901205,
      label: "Anagé",
      reference: 29
    },
    {
      value: 4101051,
      label: "Anahy",
      reference: 41
    },
    {
      value: 1500701,
      label: "Anajás",
      reference: 15
    },
    {
      value: 2100709,
      label: "Anajatuba",
      reference: 21
    },
    {
      value: 3502002,
      label: "Analândia",
      reference: 35
    },
    {
      value: 1300086,
      label: "Anamã",
      reference: 13
    },
    {
      value: 1701002,
      label: "Ananás",
      reference: 17
    },
    {
      value: 1500800,
      label: "Ananindeua",
      reference: 15
    },
    {
      value: 5201108,
      label: "Anápolis",
      reference: 52
    },
    {
      value: 1500859,
      label: "Anapu",
      reference: 15
    },
    {
      value: 2100808,
      label: "Anapurus",
      reference: 21
    },
    {
      value: 5000708,
      label: "Anastácio",
      reference: 50
    },
    {
      value: 5000807,
      label: "Anaurilândia",
      reference: 50
    },
    {
      value: 4200804,
      label: "Anchieta",
      reference: 42
    },
    {
      value: 3200409,
      label: "Anchieta",
      reference: 32
    },
    {
      value: 2901304,
      label: "Andaraí",
      reference: 29
    },
    {
      value: 4101101,
      label: "Andirá",
      reference: 41
    },
    {
      value: 2901353,
      label: "Andorinha",
      reference: 29
    },
    {
      value: 3102605,
      label: "Andradas",
      reference: 31
    },
    {
      value: 3502101,
      label: "Andradina",
      reference: 35
    },
    {
      value: 4300661,
      label: "André da Rocha",
      reference: 43
    },
    {
      value: 3102803,
      label: "Andrelândia",
      reference: 31
    },
    {
      value: 3502200,
      label: "Angatuba",
      reference: 35
    },
    {
      value: 3102852,
      label: "Angelândia",
      reference: 31
    },
    {
      value: 5000856,
      label: "Angélica",
      reference: 50
    },
    {
      value: 2601003,
      label: "Angelim",
      reference: 26
    },
    {
      value: 4200903,
      label: "Angelina",
      reference: 42
    },
    {
      value: 2901403,
      label: "Angical",
      reference: 29
    },
    {
      value: 2200608,
      label: "Angical do Piauí",
      reference: 22
    },
    {
      value: 1701051,
      label: "Angico",
      reference: 17
    },
    {
      value: 2400802,
      label: "Angicos",
      reference: 24
    },
    {
      value: 3300100,
      label: "Angra dos Reis",
      reference: 33
    },
    {
      value: 2901502,
      label: "Anguera",
      reference: 29
    },
    {
      value: 4101150,
      label: "Ângulo",
      reference: 41
    },
    {
      value: 5201207,
      label: "Anhanguera",
      reference: 52
    },
    {
      value: 3502309,
      label: "Anhembi",
      reference: 35
    },
    {
      value: 3502408,
      label: "Anhumas",
      reference: 35
    },
    {
      value: 5201306,
      label: "Anicuns",
      reference: 52
    },
    {
      value: 2200707,
      label: "Anísio de Abreu",
      reference: 22
    },
    {
      value: 4201000,
      label: "Anita Garibaldi",
      reference: 42
    },
    {
      value: 4201109,
      label: "Anitápolis",
      reference: 42
    },
    {
      value: 1300102,
      label: "Anori",
      reference: 13
    },
    {
      value: 4300703,
      label: "Anta Gorda",
      reference: 43
    },
    {
      value: 2901601,
      label: "Antas",
      reference: 29
    },
    {
      value: 4101200,
      label: "Antonina",
      reference: 41
    },
    {
      value: 2300804,
      label: "Antonina do Norte",
      reference: 23
    },
    {
      value: 2200806,
      label: "Antônio Almeida",
      reference: 22
    },
    {
      value: 2901700,
      label: "Antônio Cardoso",
      reference: 29
    },
    {
      value: 4201208,
      label: "Antônio Carlos",
      reference: 42
    },
    {
      value: 3102902,
      label: "Antônio Carlos",
      reference: 31
    },
    {
      value: 3103009,
      label: "Antônio Dias",
      reference: 31
    },
    {
      value: 2901809,
      label: "Antônio Gonçalves",
      reference: 29
    },
    {
      value: 5000906,
      label: "Antônio João",
      reference: 50
    },
    {
      value: 2400901,
      label: "Antônio Martins",
      reference: 24
    },
    {
      value: 4101309,
      label: "Antônio Olinto",
      reference: 41
    },
    {
      value: 4300802,
      label: "Antônio Prado",
      reference: 43
    },
    {
      value: 3103108,
      label: "Antônio Prado de Minas",
      reference: 31
    },
    {
      value: 2500775,
      label: "Aparecida",
      reference: 25
    },
    {
      value: 3502507,
      label: "Aparecida",
      reference: 35
    },
    {
      value: 3502606,
      label: "Aparecida d'Oeste",
      reference: 35
    },
    {
      value: 5201405,
      label: "Aparecida de Goiânia",
      reference: 52
    },
    {
      value: 5201454,
      label: "Aparecida do Rio Doce",
      reference: 52
    },
    {
      value: 1701101,
      label: "Aparecida do Rio Negro",
      reference: 17
    },
    {
      value: 5001003,
      label: "Aparecida do Taboado",
      reference: 50
    },
    {
      value: 3300159,
      label: "Aperibé",
      reference: 33
    },
    {
      value: 3200508,
      label: "Apiacá",
      reference: 32
    },
    {
      value: 5100805,
      label: "Apiacás",
      reference: 51
    },
    {
      value: 3502705,
      label: "Apiaí",
      reference: 35
    },
    {
      value: 2100832,
      label: "Apicum-Açu",
      reference: 21
    },
    {
      value: 4201257,
      label: "Apiúna",
      reference: 42
    },
    {
      value: 2401008,
      label: "Apodi",
      reference: 24
    },
    {
      value: 2901908,
      label: "Aporá",
      reference: 29
    },
    {
      value: 5201504,
      label: "Aporé",
      reference: 52
    },
    {
      value: 2901957,
      label: "Apuarema",
      reference: 29
    },
    {
      value: 4101408,
      label: "Apucarana",
      reference: 41
    },
    {
      value: 1300144,
      label: "Apuí",
      reference: 13
    },
    {
      value: 2300903,
      label: "Apuiarés",
      reference: 23
    },
    {
      value: 2800209,
      label: "Aquidabã",
      reference: 28
    },
    {
      value: 5001102,
      label: "Aquidauana",
      reference: 50
    },
    {
      value: 2301000,
      label: "Aquiraz",
      reference: 23
    },
    {
      value: 4201273,
      label: "Arabutã",
      reference: 42
    },
    {
      value: 2500809,
      label: "Araçagi",
      reference: 25
    },
    {
      value: 3103207,
      label: "Araçaí",
      reference: 31
    },
    {
      value: 2800308,
      label: "Aracaju",
      reference: 28
    },
    {
      value: 3502754,
      label: "Araçariguama",
      reference: 35
    },
    {
      value: 2902054,
      label: "Araças",
      reference: 29
    },
    {
      value: 2301109,
      label: "Aracati",
      reference: 23
    },
    {
      value: 2902005,
      label: "Aracatu",
      reference: 29
    },
    {
      value: 3502804,
      label: "Araçatuba",
      reference: 35
    },
    {
      value: 2902104,
      label: "Araci",
      reference: 29
    },
    {
      value: 3103306,
      label: "Aracitaba",
      reference: 31
    },
    {
      value: 2601052,
      label: "Araçoiaba",
      reference: 26
    },
    {
      value: 2301208,
      label: "Aracoiaba",
      reference: 23
    },
    {
      value: 3502903,
      label: "Araçoiaba da Serra",
      reference: 35
    },
    {
      value: 3200607,
      label: "Aracruz",
      reference: 32
    },
    {
      value: 5201603,
      label: "Araçu",
      reference: 52
    },
    {
      value: 3103405,
      label: "Araçuaí",
      reference: 31
    },
    {
      value: 5201702,
      label: "Aragarças",
      reference: 52
    },
    {
      value: 5201801,
      label: "Aragoiânia",
      reference: 52
    },
    {
      value: 1701309,
      label: "Aragominas",
      reference: 17
    },
    {
      value: 1701903,
      label: "Araguacema",
      reference: 17
    },
    {
      value: 1702000,
      label: "Araguaçu",
      reference: 17
    },
    {
      value: 5101001,
      label: "Araguaiana",
      reference: 51
    },
    {
      value: 1702109,
      label: "Araguaína",
      reference: 17
    },
    {
      value: 5101209,
      label: "Araguainha",
      reference: 51
    },
    {
      value: 1702158,
      label: "Araguanã",
      reference: 17
    },
    {
      value: 2100873,
      label: "Araguanã",
      reference: 21
    },
    {
      value: 5202155,
      label: "Araguapaz",
      reference: 52
    },
    {
      value: 3103504,
      label: "Araguari",
      reference: 31
    },
    {
      value: 1702208,
      label: "Araguatins",
      reference: 17
    },
    {
      value: 2100907,
      label: "Araioses",
      reference: 21
    },
    {
      value: 5001243,
      label: "Aral Moreira",
      reference: 50
    },
    {
      value: 2902203,
      label: "Aramari",
      reference: 29
    },
    {
      value: 4300851,
      label: "Arambaré",
      reference: 43
    },
    {
      value: 2100956,
      label: "Arame",
      reference: 21
    },
    {
      value: 3503000,
      label: "Aramina",
      reference: 35
    },
    {
      value: 3503109,
      label: "Arandu",
      reference: 35
    },
    {
      value: 3103603,
      label: "Arantina",
      reference: 31
    },
    {
      value: 3503158,
      label: "Arapeí",
      reference: 35
    },
    {
      value: 2700300,
      label: "Arapiraca",
      reference: 27
    },
    {
      value: 1702307,
      label: "Arapoema",
      reference: 17
    },
    {
      value: 3103702,
      label: "Araponga",
      reference: 31
    },
    {
      value: 4101507,
      label: "Arapongas",
      reference: 41
    },
    {
      value: 3103751,
      label: "Araporã",
      reference: 31
    },
    {
      value: 4101606,
      label: "Arapoti",
      reference: 41
    },
    {
      value: 4101655,
      label: "Arapuã",
      reference: 41
    },
    {
      value: 3103801,
      label: "Arapuá",
      reference: 31
    },
    {
      value: 5101258,
      label: "Araputanga",
      reference: 51
    },
    {
      value: 4201307,
      label: "Araquari",
      reference: 42
    },
    {
      value: 2500908,
      label: "Arara",
      reference: 25
    },
    {
      value: 4201406,
      label: "Araranguá",
      reference: 42
    },
    {
      value: 3503208,
      label: "Araraquara",
      reference: 35
    },
    {
      value: 3503307,
      label: "Araras",
      reference: 35
    },
    {
      value: 2301257,
      label: "Ararendá",
      reference: 23
    },
    {
      value: 2101004,
      label: "Arari",
      reference: 21
    },
    {
      value: 4300877,
      label: "Araricá",
      reference: 43
    },
    {
      value: 2301307,
      label: "Araripe",
      reference: 23
    },
    {
      value: 2601102,
      label: "Araripina",
      reference: 26
    },
    {
      value: 3300209,
      label: "Araruama",
      reference: 33
    },
    {
      value: 4101705,
      label: "Araruna",
      reference: 41
    },
    {
      value: 2501005,
      label: "Araruna",
      reference: 25
    },
    {
      value: 2902252,
      label: "Arataca",
      reference: 29
    },
    {
      value: 4300901,
      label: "Aratiba",
      reference: 43
    },
    {
      value: 2301406,
      label: "Aratuba",
      reference: 23
    },
    {
      value: 2902302,
      label: "Aratuípe",
      reference: 29
    },
    {
      value: 2800407,
      label: "Arauá",
      reference: 28
    },
    {
      value: 4101804,
      label: "Araucária",
      reference: 41
    },
    {
      value: 3103900,
      label: "Araújos",
      reference: 31
    },
    {
      value: 3104007,
      label: "Araxá",
      reference: 31
    },
    {
      value: 3104106,
      label: "Arceburgo",
      reference: 31
    },
    {
      value: 3503356,
      label: "Arco-Íris",
      reference: 35
    },
    {
      value: 3104205,
      label: "Arcos",
      reference: 31
    },
    {
      value: 2601201,
      label: "Arcoverde",
      reference: 26
    },
    {
      value: 3104304,
      label: "Areado",
      reference: 31
    },
    {
      value: 3300225,
      label: "Areal",
      reference: 33
    },
    {
      value: 3503406,
      label: "Arealva",
      reference: 35
    },
    {
      value: 2501104,
      label: "Areia",
      reference: 25
    },
    {
      value: 2401107,
      label: "Areia Branca",
      reference: 24
    },
    {
      value: 2800506,
      label: "Areia Branca",
      reference: 28
    },
    {
      value: 2501153,
      label: "Areia de Baraúnas",
      reference: 25
    },
    {
      value: 2501203,
      label: "Areial",
      reference: 25
    },
    {
      value: 3503505,
      label: "Areias",
      reference: 35
    },
    {
      value: 3503604,
      label: "Areiópolis",
      reference: 35
    },
    {
      value: 5101308,
      label: "Arenápolis",
      reference: 51
    },
    {
      value: 5202353,
      label: "Arenópolis",
      reference: 52
    },
    {
      value: 2401206,
      label: "Arês",
      reference: 24
    },
    {
      value: 3104403,
      label: "Argirita",
      reference: 31
    },
    {
      value: 3104452,
      label: "Aricanduva",
      reference: 31
    },
    {
      value: 3104502,
      label: "Arinos",
      reference: 31
    },
    {
      value: 5101407,
      label: "Aripuanã",
      reference: 51
    },
    {
      value: 1100023,
      label: "Ariquemes",
      reference: 11
    },
    {
      value: 3503703,
      label: "Ariranha",
      reference: 35
    },
    {
      value: 4101853,
      label: "Ariranha do Ivaí",
      reference: 41
    },
    {
      value: 3300233,
      label: "Armação dos Búzios",
      reference: 33
    },
    {
      value: 4201505,
      label: "Armazém",
      reference: 42
    },
    {
      value: 2301505,
      label: "Arneiroz",
      reference: 23
    },
    {
      value: 2200905,
      label: "Aroazes",
      reference: 22
    },
    {
      value: 2501302,
      label: "Aroeiras",
      reference: 25
    },
    {
      value: 2200954,
      label: "Aroeiras do Itaim",
      reference: 22
    },
    {
      value: 2201002,
      label: "Arraial",
      reference: 22
    },
    {
      value: 3300258,
      label: "Arraial do Cabo",
      reference: 33
    },
    {
      value: 1702406,
      label: "Arraias",
      reference: 17
    },
    {
      value: 4301008,
      label: "Arroio do Meio",
      reference: 43
    },
    {
      value: 4301073,
      label: "Arroio do Padre",
      reference: 43
    },
    {
      value: 4301057,
      label: "Arroio do Sal",
      reference: 43
    },
    {
      value: 4301206,
      label: "Arroio do Tigre",
      reference: 43
    },
    {
      value: 4301107,
      label: "Arroio dos Ratos",
      reference: 43
    },
    {
      value: 4301305,
      label: "Arroio Grande",
      reference: 43
    },
    {
      value: 4201604,
      label: "Arroio Trinta",
      reference: 42
    },
    {
      value: 3503802,
      label: "Artur Nogueira",
      reference: 35
    },
    {
      value: 5202502,
      label: "Aruanã",
      reference: 52
    },
    {
      value: 3503901,
      label: "Arujá",
      reference: 35
    },
    {
      value: 4201653,
      label: "Arvoredo",
      reference: 42
    },
    {
      value: 4301404,
      label: "Arvorezinha",
      reference: 43
    },
    {
      value: 4201703,
      label: "Ascurra",
      reference: 42
    },
    {
      value: 3503950,
      label: "Aspásia",
      reference: 35
    },
    {
      value: 4101903,
      label: "Assaí",
      reference: 41
    },
    {
      value: 2301604,
      label: "Assaré",
      reference: 23
    },
    {
      value: 3504008,
      label: "Assis",
      reference: 35
    },
    {
      value: 1200054,
      label: "Assis Brasil",
      reference: 12
    },
    {
      value: 4102000,
      label: "Assis Chateaubriand",
      reference: 41
    },
    {
      value: 2501351,
      label: "Assunção",
      reference: 25
    },
    {
      value: 2201051,
      label: "Assunção do Piauí",
      reference: 22
    },
    {
      value: 3104601,
      label: "Astolfo Dutra",
      reference: 31
    },
    {
      value: 4102109,
      label: "Astorga",
      reference: 41
    },
    {
      value: 4102208,
      label: "Atalaia",
      reference: 41
    },
    {
      value: 2700409,
      label: "Atalaia",
      reference: 27
    },
    {
      value: 1300201,
      label: "Atalaia do Norte",
      reference: 13
    },
    {
      value: 4201802,
      label: "Atalanta",
      reference: 42
    },
    {
      value: 3104700,
      label: "Ataléia",
      reference: 31
    },
    {
      value: 3504107,
      label: "Atibaia",
      reference: 35
    },
    {
      value: 3200706,
      label: "Atilio Vivacqua",
      reference: 32
    },
    {
      value: 1702554,
      label: "Augustinópolis",
      reference: 17
    },
    {
      value: 1500909,
      label: "Augusto Corrêa",
      reference: 15
    },
    {
      value: 3104809,
      label: "Augusto de Lima",
      reference: 31
    },
    {
      value: 4301503,
      label: "Augusto Pestana",
      reference: 43
    },
    {
      value: 2401305,
      label: "Augusto Severo (Campo Grande)",
      reference: 24
    },
    {
      value: 4301552,
      label: "Áurea",
      reference: 43
    },
    {
      value: 2902401,
      label: "Aurelino Leal",
      reference: 29
    },
    {
      value: 3504206,
      label: "Auriflama",
      reference: 35
    },
    {
      value: 5202601,
      label: "Aurilândia",
      reference: 52
    },
    {
      value: 2301703,
      label: "Aurora",
      reference: 23
    },
    {
      value: 4201901,
      label: "Aurora",
      reference: 42
    },
    {
      value: 1500958,
      label: "Aurora do Pará",
      reference: 15
    },
    {
      value: 1702703,
      label: "Aurora do Tocantins",
      reference: 17
    },
    {
      value: 1300300,
      label: "Autazes",
      reference: 13
    },
    {
      value: 3504305,
      label: "Avaí",
      reference: 35
    },
    {
      value: 3504404,
      label: "Avanhandava",
      reference: 35
    },
    {
      value: 3504503,
      label: "Avaré",
      reference: 35
    },
    {
      value: 1501006,
      label: "Aveiro",
      reference: 15
    },
    {
      value: 2201101,
      label: "Avelino Lopes",
      reference: 22
    },
    {
      value: 5202809,
      label: "Avelinópolis",
      reference: 52
    },
    {
      value: 2101103,
      label: "Axixá",
      reference: 21
    },
    {
      value: 1702901,
      label: "Axixá do Tocantins",
      reference: 17
    },
    {
      value: 1703008,
      label: "Babaçulândia",
      reference: 17
    },
    {
      value: 2101202,
      label: "Bacabal",
      reference: 21
    },
    {
      value: 2101251,
      label: "Bacabeira",
      reference: 21
    },
    {
      value: 2101301,
      label: "Bacuri",
      reference: 21
    },
    {
      value: 2101350,
      label: "Bacurituba",
      reference: 21
    },
    {
      value: 3504602,
      label: "Bady Bassitt",
      reference: 35
    },
    {
      value: 3104908,
      label: "Baependi",
      reference: 31
    },
    {
      value: 4301602,
      label: "Bagé",
      reference: 43
    },
    {
      value: 1501105,
      label: "Bagre",
      reference: 15
    },
    {
      value: 2501401,
      label: "Baía da Traição",
      reference: 25
    },
    {
      value: 2401404,
      label: "Baía Formosa",
      reference: 24
    },
    {
      value: 2902500,
      label: "Baianópolis",
      reference: 29
    },
    {
      value: 1501204,
      label: "Baião",
      reference: 15
    },
    {
      value: 2902609,
      label: "Baixa Grande",
      reference: 29
    },
    {
      value: 2201150,
      label: "Baixa Grande do Ribeiro",
      reference: 22
    },
    {
      value: 2301802,
      label: "Baixio",
      reference: 23
    },
    {
      value: 3200805,
      label: "Baixo Guandu",
      reference: 32
    },
    {
      value: 3504701,
      label: "Balbinos",
      reference: 35
    },
    {
      value: 3105004,
      label: "Baldim",
      reference: 31
    },
    {
      value: 5203104,
      label: "Baliza",
      reference: 52
    },
    {
      value: 4201950,
      label: "Balneário Arroio do Silva",
      reference: 42
    },
    {
      value: 4202057,
      label: "Balneário Barra do Sul",
      reference: 42
    },
    {
      value: 4202008,
      label: "Balneário Camboriú",
      reference: 42
    },
    {
      value: 4202073,
      label: "Balneário Gaivota",
      reference: 42
    },
    {
      value: 4212809,
      label: "Balneário Piçarras",
      reference: 42
    },
    {
      value: 4301636,
      label: "Balneário Pinhal",
      reference: 43
    },
    {
      value: 4220000,
      label: "Balneário Rincão",
      reference: 42
    },
    {
      value: 4102307,
      label: "Balsa Nova",
      reference: 41
    },
    {
      value: 3504800,
      label: "Bálsamo",
      reference: 35
    },
    {
      value: 2101400,
      label: "Balsas",
      reference: 21
    },
    {
      value: 3105103,
      label: "Bambuí",
      reference: 31
    },
    {
      value: 2301851,
      label: "Banabuiú",
      reference: 23
    },
    {
      value: 3504909,
      label: "Bananal",
      reference: 35
    },
    {
      value: 2501500,
      label: "Bananeiras",
      reference: 25
    },
    {
      value: 3105202,
      label: "Bandeira",
      reference: 31
    },
    {
      value: 3105301,
      label: "Bandeira do Sul",
      reference: 31
    },
    {
      value: 4202081,
      label: "Bandeirante",
      reference: 42
    },
    {
      value: 5001508,
      label: "Bandeirantes",
      reference: 50
    },
    {
      value: 4102406,
      label: "Bandeirantes",
      reference: 41
    },
    {
      value: 1703057,
      label: "Bandeirantes do Tocantins",
      reference: 17
    },
    {
      value: 1501253,
      label: "Bannach",
      reference: 15
    },
    {
      value: 2902658,
      label: "Banzaê",
      reference: 29
    },
    {
      value: 4301651,
      label: "Barão",
      reference: 43
    },
    {
      value: 3505005,
      label: "Barão de Antonina",
      reference: 35
    },
    {
      value: 3105400,
      label: "Barão de Cocais",
      reference: 31
    },
    {
      value: 4301701,
      label: "Barão de Cotegipe",
      reference: 43
    },
    {
      value: 2101509,
      label: "Barão de Grajaú",
      reference: 21
    },
    {
      value: 5101605,
      label: "Barão de Melgaço",
      reference: 51
    },
    {
      value: 3105509,
      label: "Barão de Monte Alto",
      reference: 31
    },
    {
      value: 4301750,
      label: "Barão do Triunfo",
      reference: 43
    },
    {
      value: 2401453,
      label: "Baraúna",
      reference: 24
    },
    {
      value: 2501534,
      label: "Baraúna",
      reference: 25
    },
    {
      value: 3105608,
      label: "Barbacena",
      reference: 31
    },
    {
      value: 2301901,
      label: "Barbalha",
      reference: 23
    },
    {
      value: 3505104,
      label: "Barbosa",
      reference: 35
    },
    {
      value: 4102505,
      label: "Barbosa Ferraz",
      reference: 41
    },
    {
      value: 1501303,
      label: "Barcarena",
      reference: 15
    },
    {
      value: 2401503,
      label: "Barcelona",
      reference: 24
    },
    {
      value: 1300409,
      label: "Barcelos",
      reference: 13
    },
    {
      value: 3505203,
      label: "Bariri",
      reference: 35
    },
    {
      value: 2902708,
      label: "Barra",
      reference: 29
    },
    {
      value: 4202099,
      label: "Barra Bonita",
      reference: 42
    },
    {
      value: 3505302,
      label: "Barra Bonita",
      reference: 35
    },
    {
      value: 2201176,
      label: "Barra D'Alcântara",
      reference: 22
    },
    {
      value: 2902807,
      label: "Barra da Estiva",
      reference: 29
    },
    {
      value: 2601300,
      label: "Barra de Guabiraba",
      reference: 26
    },
    {
      value: 2501609,
      label: "Barra de Santa Rosa",
      reference: 25
    },
    {
      value: 2501575,
      label: "Barra de Santana",
      reference: 25
    },
    {
      value: 2700508,
      label: "Barra de Santo Antônio",
      reference: 27
    },
    {
      value: 3200904,
      label: "Barra de São Francisco",
      reference: 32
    },
    {
      value: 2501708,
      label: "Barra de São Miguel",
      reference: 25
    },
    {
      value: 2700607,
      label: "Barra de São Miguel",
      reference: 27
    },
    {
      value: 5101704,
      label: "Barra do Bugres",
      reference: 51
    },
    {
      value: 3505351,
      label: "Barra do Chapéu",
      reference: 35
    },
    {
      value: 2902906,
      label: "Barra do Choça",
      reference: 29
    },
    {
      value: 2101608,
      label: "Barra do Corda",
      reference: 21
    },
    {
      value: 5101803,
      label: "Barra do Garças",
      reference: 51
    },
    {
      value: 4301859,
      label: "Barra do Guarita",
      reference: 43
    },
    {
      value: 4102703,
      label: "Barra do Jacaré",
      reference: 41
    },
    {
      value: 2903003,
      label: "Barra do Mendes",
      reference: 29
    },
    {
      value: 1703073,
      label: "Barra do Ouro",
      reference: 17
    },
    {
      value: 3300308,
      label: "Barra do Piraí",
      reference: 33
    },
    {
      value: 4301875,
      label: "Barra do Quaraí",
      reference: 43
    },
    {
      value: 4301909,
      label: "Barra do Ribeiro",
      reference: 43
    },
    {
      value: 4301925,
      label: "Barra do Rio Azul",
      reference: 43
    },
    {
      value: 2903102,
      label: "Barra do Rocha",
      reference: 29
    },
    {
      value: 3505401,
      label: "Barra do Turvo",
      reference: 35
    },
    {
      value: 2800605,
      label: "Barra dos Coqueiros",
      reference: 28
    },
    {
      value: 4301958,
      label: "Barra Funda",
      reference: 43
    },
    {
      value: 3105707,
      label: "Barra Longa",
      reference: 31
    },
    {
      value: 3300407,
      label: "Barra Mansa",
      reference: 33
    },
    {
      value: 4202107,
      label: "Barra Velha",
      reference: 42
    },
    {
      value: 4301800,
      label: "Barracão",
      reference: 43
    },
    {
      value: 4102604,
      label: "Barracão",
      reference: 41
    },
    {
      value: 2201200,
      label: "Barras",
      reference: 22
    },
    {
      value: 2301950,
      label: "Barreira",
      reference: 23
    },
    {
      value: 2903201,
      label: "Barreiras",
      reference: 29
    },
    {
      value: 2201309,
      label: "Barreiras do Piauí",
      reference: 22
    },
    {
      value: 1300508,
      label: "Barreirinha",
      reference: 13
    },
    {
      value: 2101707,
      label: "Barreirinhas",
      reference: 21
    },
    {
      value: 2601409,
      label: "Barreiros",
      reference: 26
    },
    {
      value: 3505500,
      label: "Barretos",
      reference: 35
    },
    {
      value: 3505609,
      label: "Barrinha",
      reference: 35
    },
    {
      value: 2302008,
      label: "Barro",
      reference: 23
    },
    {
      value: 2903235,
      label: "Barro Alto",
      reference: 29
    },
    {
      value: 5203203,
      label: "Barro Alto",
      reference: 52
    },
    {
      value: 2201408,
      label: "Barro Duro",
      reference: 22
    },
    {
      value: 2903300,
      label: "Barro Preto",
      reference: 29
    },
    {
      value: 2903276,
      label: "Barrocas",
      reference: 29
    },
    {
      value: 1703107,
      label: "Barrolândia",
      reference: 17
    },
    {
      value: 2302057,
      label: "Barroquinha",
      reference: 23
    },
    {
      value: 4302006,
      label: "Barros Cassal",
      reference: 43
    },
    {
      value: 3105905,
      label: "Barroso",
      reference: 31
    },
    {
      value: 3505708,
      label: "Barueri",
      reference: 35
    },
    {
      value: 3505807,
      label: "Bastos",
      reference: 35
    },
    {
      value: 5001904,
      label: "Bataguassu",
      reference: 50
    },
    {
      value: 2201507,
      label: "Batalha",
      reference: 22
    },
    {
      value: 2700706,
      label: "Batalha",
      reference: 27
    },
    {
      value: 3505906,
      label: "Batatais",
      reference: 35
    },
    {
      value: 5002001,
      label: "Batayporã",
      reference: 50
    },
    {
      value: 2302107,
      label: "Baturité",
      reference: 23
    },
    {
      value: 3506003,
      label: "Bauru",
      reference: 35
    },
    {
      value: 2501807,
      label: "Bayeux",
      reference: 25
    },
    {
      value: 3506102,
      label: "Bebedouro",
      reference: 35
    },
    {
      value: 2302206,
      label: "Beberibe",
      reference: 23
    },
    {
      value: 2302305,
      label: "Bela Cruz",
      reference: 23
    },
    {
      value: 5002100,
      label: "Bela Vista",
      reference: 50
    },
    {
      value: 4102752,
      label: "Bela Vista da Caroba",
      reference: 41
    },
    {
      value: 5203302,
      label: "Bela Vista de Goiás",
      reference: 52
    },
    {
      value: 3106002,
      label: "Bela Vista de Minas",
      reference: 31
    },
    {
      value: 2101772,
      label: "Bela Vista do Maranhão",
      reference: 21
    },
    {
      value: 4102802,
      label: "Bela Vista do Paraíso",
      reference: 41
    },
    {
      value: 2201556,
      label: "Bela Vista do Piauí",
      reference: 22
    },
    {
      value: 4202131,
      label: "Bela Vista do Toldo",
      reference: 42
    },
    {
      value: 2101731,
      label: "Belágua",
      reference: 21
    },
    {
      value: 1501402,
      label: "Belém",
      reference: 15
    },
    {
      value: 2501906,
      label: "Belém",
      reference: 25
    },
    {
      value: 2700805,
      label: "Belém",
      reference: 27
    },
    {
      value: 2601508,
      label: "Belém de Maria",
      reference: 26
    },
    {
      value: 2502003,
      label: "Belém do Brejo do Cruz",
      reference: 25
    },
    {
      value: 2201572,
      label: "Belém do Piauí",
      reference: 22
    },
    {
      value: 2601607,
      label: "Belém do São Francisco",
      reference: 26
    },
    {
      value: 3300456,
      label: "Belford Roxo",
      reference: 33
    },
    {
      value: 3106101,
      label: "Belmiro Braga",
      reference: 31
    },
    {
      value: 4202156,
      label: "Belmonte",
      reference: 42
    },
    {
      value: 2903409,
      label: "Belmonte",
      reference: 29
    },
    {
      value: 2903508,
      label: "Belo Campo",
      reference: 29
    },
    {
      value: 3106200,
      label: "Belo Horizonte",
      reference: 31
    },
    {
      value: 2601706,
      label: "Belo Jardim",
      reference: 26
    },
    {
      value: 2700904,
      label: "Belo Monte",
      reference: 27
    },
    {
      value: 3106309,
      label: "Belo Oriente",
      reference: 31
    },
    {
      value: 3106408,
      label: "Belo Vale",
      reference: 31
    },
    {
      value: 1501451,
      label: "Belterra",
      reference: 15
    },
    {
      value: 2201606,
      label: "Beneditinos",
      reference: 22
    },
    {
      value: 2101806,
      label: "Benedito Leite",
      reference: 21
    },
    {
      value: 4202206,
      label: "Benedito Novo",
      reference: 42
    },
    {
      value: 1501501,
      label: "Benevides",
      reference: 15
    },
    {
      value: 1300607,
      label: "Benjamin Constant",
      reference: 13
    },
    {
      value: 4302055,
      label: "Benjamin Constant do Sul",
      reference: 43
    },
    {
      value: 3506201,
      label: "Bento de Abreu",
      reference: 35
    },
    {
      value: 2401602,
      label: "Bento Fernandes",
      reference: 24
    },
    {
      value: 4302105,
      label: "Bento Gonçalves",
      reference: 43
    },
    {
      value: 2101905,
      label: "Bequimão",
      reference: 21
    },
    {
      value: 3106507,
      label: "Berilo",
      reference: 31
    },
    {
      value: 3106655,
      label: "Berizal",
      reference: 31
    },
    {
      value: 2502052,
      label: "Bernardino Batista",
      reference: 25
    },
    {
      value: 3506300,
      label: "Bernardino de Campos",
      reference: 35
    },
    {
      value: 2101939,
      label: "Bernardo do Mearim",
      reference: 21
    },
    {
      value: 1703206,
      label: "Bernardo Sayão",
      reference: 17
    },
    {
      value: 3506359,
      label: "Bertioga",
      reference: 35
    },
    {
      value: 2201705,
      label: "Bertolínia",
      reference: 22
    },
    {
      value: 3106606,
      label: "Bertópolis",
      reference: 31
    },
    {
      value: 1300631,
      label: "Beruri",
      reference: 13
    },
    {
      value: 2601805,
      label: "Betânia",
      reference: 26
    },
    {
      value: 2201739,
      label: "Betânia do Piauí",
      reference: 22
    },
    {
      value: 3106705,
      label: "Betim",
      reference: 31
    },
    {
      value: 2601904,
      label: "Bezerros",
      reference: 26
    },
    {
      value: 3106804,
      label: "Bias Fortes",
      reference: 31
    },
    {
      value: 3106903,
      label: "Bicas",
      reference: 31
    },
    {
      value: 4202305,
      label: "Biguaçu",
      reference: 42
    },
    {
      value: 3506409,
      label: "Bilac",
      reference: 35
    },
    {
      value: 3107000,
      label: "Biquinhas",
      reference: 31
    },
    {
      value: 3506508,
      label: "Birigui",
      reference: 35
    },
    {
      value: 3506607,
      label: "Biritiba-Mirim",
      reference: 35
    },
    {
      value: 2903607,
      label: "Biritinga",
      reference: 29
    },
    {
      value: 4102901,
      label: "Bituruna",
      reference: 41
    },
    {
      value: 4202404,
      label: "Blumenau",
      reference: 42
    },
    {
      value: 4103008,
      label: "Boa Esperança",
      reference: 41
    },
    {
      value: 3107109,
      label: "Boa Esperança",
      reference: 31
    },
    {
      value: 3201001,
      label: "Boa Esperança",
      reference: 32
    },
    {
      value: 4103024,
      label: "Boa Esperança do Iguaçu",
      reference: 41
    },
    {
      value: 3506706,
      label: "Boa Esperança do Sul",
      reference: 35
    },
    {
      value: 2201770,
      label: "Boa Hora",
      reference: 22
    },
    {
      value: 2903706,
      label: "Boa Nova",
      reference: 29
    },
    {
      value: 2502102,
      label: "Boa Ventura",
      reference: 25
    },
    {
      value: 4103040,
      label: "Boa Ventura de São Roque",
      reference: 41
    },
    {
      value: 2302404,
      label: "Boa Viagem",
      reference: 23
    },
    {
      value: 1400100,
      label: "Boa Vista",
      reference: 14
    },
    {
      value: 2502151,
      label: "Boa Vista",
      reference: 25
    },
    {
      value: 4103057,
      label: "Boa Vista da Aparecida",
      reference: 41
    },
    {
      value: 4302154,
      label: "Boa Vista das Missões",
      reference: 43
    },
    {
      value: 4302204,
      label: "Boa Vista do Buricá",
      reference: 43
    },
    {
      value: 4302220,
      label: "Boa Vista do Cadeado",
      reference: 43
    },
    {
      value: 2101970,
      label: "Boa Vista do Gurupi",
      reference: 21
    },
    {
      value: 4302238,
      label: "Boa Vista do Incra",
      reference: 43
    },
    {
      value: 1300680,
      label: "Boa Vista do Ramos",
      reference: 13
    },
    {
      value: 4302253,
      label: "Boa Vista do Sul",
      reference: 43
    },
    {
      value: 2903805,
      label: "Boa Vista do Tupim",
      reference: 29
    },
    {
      value: 2701001,
      label: "Boca da Mata",
      reference: 27
    },
    {
      value: 1300706,
      label: "Boca do Acre",
      reference: 13
    },
    {
      value: 2201804,
      label: "Bocaina",
      reference: 22
    },
    {
      value: 3506805,
      label: "Bocaina",
      reference: 35
    },
    {
      value: 3107208,
      label: "Bocaina de Minas",
      reference: 31
    },
    {
      value: 4202438,
      label: "Bocaina do Sul",
      reference: 42
    },
    {
      value: 3107307,
      label: "Bocaiúva",
      reference: 31
    },
    {
      value: 4103107,
      label: "Bocaiúva do Sul",
      reference: 41
    },
    {
      value: 2401651,
      label: "Bodó",
      reference: 24
    },
    {
      value: 2602001,
      label: "Bodocó",
      reference: 26
    },
    {
      value: 5002159,
      label: "Bodoquena",
      reference: 50
    },
    {
      value: 3506904,
      label: "Bofete",
      reference: 35
    },
    {
      value: 3507001,
      label: "Boituva",
      reference: 35
    },
    {
      value: 2602100,
      label: "Bom Conselho",
      reference: 26
    },
    {
      value: 3107406,
      label: "Bom Despacho",
      reference: 31
    },
    {
      value: 3300506,
      label: "Bom Jardim",
      reference: 33
    },
    {
      value: 2602209,
      label: "Bom Jardim",
      reference: 26
    },
    {
      value: 2102002,
      label: "Bom Jardim",
      reference: 21
    },
    {
      value: 4202503,
      label: "Bom Jardim da Serra",
      reference: 42
    },
    {
      value: 5203401,
      label: "Bom Jardim de Goiás",
      reference: 52
    },
    {
      value: 3107505,
      label: "Bom Jardim de Minas",
      reference: 31
    },
    {
      value: 4202537,
      label: "Bom Jesus",
      reference: 42
    },
    {
      value: 4302303,
      label: "Bom Jesus",
      reference: 43
    },
    {
      value: 2201903,
      label: "Bom Jesus",
      reference: 22
    },
    {
      value: 2401701,
      label: "Bom Jesus",
      reference: 24
    },
    {
      value: 2502201,
      label: "Bom Jesus",
      reference: 25
    },
    {
      value: 2903904,
      label: "Bom Jesus da Lapa",
      reference: 29
    },
    {
      value: 3107604,
      label: "Bom Jesus da Penha",
      reference: 31
    },
    {
      value: 2903953,
      label: "Bom Jesus da Serra",
      reference: 29
    },
    {
      value: 2102036,
      label: "Bom Jesus das Selvas",
      reference: 21
    },
    {
      value: 5203500,
      label: "Bom Jesus de Goiás",
      reference: 52
    },
    {
      value: 3107703,
      label: "Bom Jesus do Amparo",
      reference: 31
    },
    {
      value: 5101852,
      label: "Bom Jesus do Araguaia",
      reference: 51
    },
    {
      value: 3107802,
      label: "Bom Jesus do Galho",
      reference: 31
    },
    {
      value: 3300605,
      label: "Bom Jesus do Itabapoana",
      reference: 33
    },
    {
      value: 3201100,
      label: "Bom Jesus do Norte",
      reference: 32
    },
    {
      value: 4202578,
      label: "Bom Jesus do Oeste",
      reference: 42
    },
    {
      value: 4103156,
      label: "Bom Jesus do Sul",
      reference: 41
    },
    {
      value: 1501576,
      label: "Bom Jesus do Tocantins",
      reference: 15
    },
    {
      value: 1703305,
      label: "Bom Jesus do Tocantins",
      reference: 17
    },
    {
      value: 3507100,
      label: "Bom Jesus dos Perdões",
      reference: 35
    },
    {
      value: 2102077,
      label: "Bom Lugar",
      reference: 21
    },
    {
      value: 4302352,
      label: "Bom Princípio",
      reference: 43
    },
    {
      value: 2201919,
      label: "Bom Princípio do Piauí",
      reference: 22
    },
    {
      value: 4302378,
      label: "Bom Progresso",
      reference: 43
    },
    {
      value: 3107901,
      label: "Bom Repouso",
      reference: 31
    },
    {
      value: 4202602,
      label: "Bom Retiro",
      reference: 42
    },
    {
      value: 4302402,
      label: "Bom Retiro do Sul",
      reference: 43
    },
    {
      value: 3108008,
      label: "Bom Sucesso",
      reference: 31
    },
    {
      value: 4103206,
      label: "Bom Sucesso",
      reference: 41
    },
    {
      value: 2502300,
      label: "Bom Sucesso",
      reference: 25
    },
    {
      value: 3507159,
      label: "Bom Sucesso de Itararé",
      reference: 35
    },
    {
      value: 4103222,
      label: "Bom Sucesso do Sul",
      reference: 41
    },
    {
      value: 4202453,
      label: "Bombinhas",
      reference: 42
    },
    {
      value: 1400159,
      label: "Bonfim",
      reference: 14
    },
    {
      value: 3108107,
      label: "Bonfim",
      reference: 31
    },
    {
      value: 2201929,
      label: "Bonfim do Piauí",
      reference: 22
    },
    {
      value: 5203559,
      label: "Bonfinópolis",
      reference: 52
    },
    {
      value: 3108206,
      label: "Bonfinópolis de Minas",
      reference: 31
    },
    {
      value: 2904001,
      label: "Boninal",
      reference: 29
    },
    {
      value: 2602308,
      label: "Bonito",
      reference: 26
    },
    {
      value: 2904050,
      label: "Bonito",
      reference: 29
    },
    {
      value: 1501600,
      label: "Bonito",
      reference: 15
    },
    {
      value: 5002209,
      label: "Bonito",
      reference: 50
    },
    {
      value: 3108255,
      label: "Bonito de Minas",
      reference: 31
    },
    {
      value: 2502409,
      label: "Bonito de Santa Fé",
      reference: 25
    },
    {
      value: 5203575,
      label: "Bonópolis",
      reference: 52
    },
    {
      value: 2502508,
      label: "Boqueirão",
      reference: 25
    },
    {
      value: 4302451,
      label: "Boqueirão do Leão",
      reference: 43
    },
    {
      value: 2201945,
      label: "Boqueirão do Piauí",
      reference: 22
    },
    {
      value: 2800670,
      label: "Boquim",
      reference: 28
    },
    {
      value: 2904100,
      label: "Boquira",
      reference: 29
    },
    {
      value: 3507209,
      label: "Borá",
      reference: 35
    },
    {
      value: 3507308,
      label: "Boracéia",
      reference: 35
    },
    {
      value: 1300805,
      label: "Borba",
      reference: 13
    },
    {
      value: 2502706,
      label: "Borborema",
      reference: 25
    },
    {
      value: 3507407,
      label: "Borborema",
      reference: 35
    },
    {
      value: 3108305,
      label: "Borda da Mata",
      reference: 31
    },
    {
      value: 3507456,
      label: "Borebi",
      reference: 35
    },
    {
      value: 4103305,
      label: "Borrazópolis",
      reference: 41
    },
    {
      value: 4302501,
      label: "Bossoroca",
      reference: 43
    },
    {
      value: 3108404,
      label: "Botelhos",
      reference: 31
    },
    {
      value: 3507506,
      label: "Botucatu",
      reference: 35
    },
    {
      value: 3108503,
      label: "Botumirim",
      reference: 31
    },
    {
      value: 2904209,
      label: "Botuporã",
      reference: 29
    },
    {
      value: 4202701,
      label: "Botuverá",
      reference: 42
    },
    {
      value: 4302584,
      label: "Bozano",
      reference: 43
    },
    {
      value: 4202800,
      label: "Braço do Norte",
      reference: 42
    },
    {
      value: 4202859,
      label: "Braço do Trombudo",
      reference: 42
    },
    {
      value: 4302600,
      label: "Braga",
      reference: 43
    },
    {
      value: 1501709,
      label: "Bragança",
      reference: 15
    },
    {
      value: 3507605,
      label: "Bragança Paulista",
      reference: 35
    },
    {
      value: 4103354,
      label: "Braganey",
      reference: 41
    },
    {
      value: 2701100,
      label: "Branquinha",
      reference: 27
    },
    {
      value: 3108701,
      label: "Brás Pires",
      reference: 31
    },
    {
      value: 1501725,
      label: "Brasil Novo",
      reference: 15
    },
    {
      value: 5002308,
      label: "Brasilândia",
      reference: 50
    },
    {
      value: 3108552,
      label: "Brasilândia de Minas",
      reference: 31
    },
    {
      value: 4103370,
      label: "Brasilândia do Sul",
      reference: 41
    },
    {
      value: 1703602,
      label: "Brasilândia do Tocantins",
      reference: 17
    },
    {
      value: 1200104,
      label: "Brasiléia",
      reference: 12
    },
    {
      value: 2201960,
      label: "Brasileira",
      reference: 22
    },
    {
      value: 5300108,
      label: "Brasília",
      reference: 53
    },
    {
      value: 3108602,
      label: "Brasília de Minas",
      reference: 31
    },
    {
      value: 5101902,
      label: "Brasnorte",
      reference: 51
    },
    {
      value: 3507704,
      label: "Braúna",
      reference: 35
    },
    {
      value: 3108800,
      label: "Braúnas",
      reference: 31
    },
    {
      value: 5203609,
      label: "Brazabrantes",
      reference: 52
    },
    {
      value: 3108909,
      label: "Brazópolis",
      reference: 31
    },
    {
      value: 2602407,
      label: "Brejão",
      reference: 26
    },
    {
      value: 3201159,
      label: "Brejetuba",
      reference: 32
    },
    {
      value: 2401800,
      label: "Brejinho",
      reference: 24
    },
    {
      value: 2602506,
      label: "Brejinho",
      reference: 26
    },
    {
      value: 1703701,
      label: "Brejinho de Nazaré",
      reference: 17
    },
    {
      value: 2102101,
      label: "Brejo",
      reference: 21
    },
    {
      value: 3507753,
      label: "Brejo Alegre",
      reference: 35
    },
    {
      value: 2602605,
      label: "Brejo da Madre de Deus",
      reference: 26
    },
    {
      value: 2102150,
      label: "Brejo de Areia",
      reference: 21
    },
    {
      value: 2502805,
      label: "Brejo do Cruz",
      reference: 25
    },
    {
      value: 2201988,
      label: "Brejo do Piauí",
      reference: 22
    },
    {
      value: 2502904,
      label: "Brejo dos Santos",
      reference: 25
    },
    {
      value: 2800704,
      label: "Brejo Grande",
      reference: 28
    },
    {
      value: 1501758,
      label: "Brejo Grande do Araguaia",
      reference: 15
    },
    {
      value: 2302503,
      label: "Brejo Santo",
      reference: 23
    },
    {
      value: 2904308,
      label: "Brejões",
      reference: 29
    },
    {
      value: 2904407,
      label: "Brejolândia",
      reference: 29
    },
    {
      value: 1501782,
      label: "Breu Branco",
      reference: 15
    },
    {
      value: 1501808,
      label: "Breves",
      reference: 15
    },
    {
      value: 5203807,
      label: "Britânia",
      reference: 52
    },
    {
      value: 4302659,
      label: "Brochier",
      reference: 43
    },
    {
      value: 3507803,
      label: "Brodowski",
      reference: 35
    },
    {
      value: 3507902,
      label: "Brotas",
      reference: 35
    },
    {
      value: 2904506,
      label: "Brotas de Macaúbas",
      reference: 29
    },
    {
      value: 3109006,
      label: "Brumadinho",
      reference: 31
    },
    {
      value: 2904605,
      label: "Brumado",
      reference: 29
    },
    {
      value: 4202875,
      label: "Brunópolis",
      reference: 42
    },
    {
      value: 4202909,
      label: "Brusque",
      reference: 42
    },
    {
      value: 3109105,
      label: "Bueno Brandão",
      reference: 31
    },
    {
      value: 3109204,
      label: "Buenópolis",
      reference: 31
    },
    {
      value: 2602704,
      label: "Buenos Aires",
      reference: 26
    },
    {
      value: 2904704,
      label: "Buerarema",
      reference: 29
    },
    {
      value: 3109253,
      label: "Bugre",
      reference: 31
    },
    {
      value: 2602803,
      label: "Buíque",
      reference: 26
    },
    {
      value: 1200138,
      label: "Bujari",
      reference: 12
    },
    {
      value: 1501907,
      label: "Bujaru",
      reference: 15
    },
    {
      value: 3508009,
      label: "Buri",
      reference: 35
    },
    {
      value: 3508108,
      label: "Buritama",
      reference: 35
    },
    {
      value: 2102200,
      label: "Buriti",
      reference: 21
    },
    {
      value: 5203906,
      label: "Buriti Alegre",
      reference: 52
    },
    {
      value: 2102309,
      label: "Buriti Bravo",
      reference: 21
    },
    {
      value: 5203939,
      label: "Buriti de Goiás",
      reference: 52
    },
    {
      value: 1703800,
      label: "Buriti do Tocantins",
      reference: 17
    },
    {
      value: 2202000,
      label: "Buriti dos Lopes",
      reference: 22
    },
    {
      value: 2202026,
      label: "Buriti dos Montes",
      reference: 22
    },
    {
      value: 2102325,
      label: "Buriticupu",
      reference: 21
    },
    {
      value: 5203962,
      label: "Buritinópolis",
      reference: 52
    },
    {
      value: 2904753,
      label: "Buritirama",
      reference: 29
    },
    {
      value: 2102358,
      label: "Buritirana",
      reference: 21
    },
    {
      value: 1100452,
      label: "Buritis",
      reference: 11
    },
    {
      value: 3109303,
      label: "Buritis",
      reference: 31
    },
    {
      value: 3508207,
      label: "Buritizal",
      reference: 35
    },
    {
      value: 3109402,
      label: "Buritizeiro",
      reference: 31
    },
    {
      value: 4302709,
      label: "Butiá",
      reference: 43
    },
    {
      value: 1300839,
      label: "Caapiranga",
      reference: 13
    },
    {
      value: 2503001,
      label: "Caaporã",
      reference: 25
    },
    {
      value: 5002407,
      label: "Caarapó",
      reference: 50
    },
    {
      value: 2904803,
      label: "Caatiba",
      reference: 29
    },
    {
      value: 2503100,
      label: "Cabaceiras",
      reference: 25
    },
    {
      value: 2904852,
      label: "Cabaceiras do Paraguaçu",
      reference: 29
    },
    {
      value: 3109451,
      label: "Cabeceira Grande",
      reference: 31
    },
    {
      value: 5204003,
      label: "Cabeceiras",
      reference: 52
    },
    {
      value: 2202059,
      label: "Cabeceiras do Piauí",
      reference: 22
    },
    {
      value: 2503209,
      label: "Cabedelo",
      reference: 25
    },
    {
      value: 1100031,
      label: "Cabixi",
      reference: 11
    },
    {
      value: 2602902,
      label: "Cabo de Santo Agostinho",
      reference: 26
    },
    {
      value: 3300704,
      label: "Cabo Frio",
      reference: 33
    },
    {
      value: 3109501,
      label: "Cabo Verde",
      reference: 31
    },
    {
      value: 3508306,
      label: "Cabrália Paulista",
      reference: 35
    },
    {
      value: 3508405,
      label: "Cabreúva",
      reference: 35
    },
    {
      value: 2603009,
      label: "Cabrobó",
      reference: 26
    },
    {
      value: 4203006,
      label: "Caçador",
      reference: 42
    },
    {
      value: 3508504,
      label: "Caçapava",
      reference: 35
    },
    {
      value: 4302808,
      label: "Caçapava do Sul",
      reference: 43
    },
    {
      value: 1100601,
      label: "Cacaulândia",
      reference: 11
    },
    {
      value: 4302907,
      label: "Cacequi",
      reference: 43
    },
    {
      value: 5102504,
      label: "Cáceres",
      reference: 51
    },
    {
      value: 2904902,
      label: "Cachoeira",
      reference: 29
    },
    {
      value: 5204102,
      label: "Cachoeira Alta",
      reference: 52
    },
    {
      value: 3109600,
      label: "Cachoeira da Prata",
      reference: 31
    },
    {
      value: 5204201,
      label: "Cachoeira de Goiás",
      reference: 52
    },
    {
      value: 3109709,
      label: "Cachoeira de Minas",
      reference: 31
    },
    {
      value: 3102704,
      label: "Cachoeira de Pajeú",
      reference: 31
    },
    {
      value: 1502004,
      label: "Cachoeira do Arari",
      reference: 15
    },
    {
      value: 1501956,
      label: "Cachoeira do Piriá",
      reference: 15
    },
    {
      value: 4303004,
      label: "Cachoeira do Sul",
      reference: 43
    },
    {
      value: 2503308,
      label: "Cachoeira dos Índios",
      reference: 25
    },
    {
      value: 5204250,
      label: "Cachoeira Dourada",
      reference: 52
    },
    {
      value: 3109808,
      label: "Cachoeira Dourada",
      reference: 31
    },
    {
      value: 2102374,
      label: "Cachoeira Grande",
      reference: 21
    },
    {
      value: 3508603,
      label: "Cachoeira Paulista",
      reference: 35
    },
    {
      value: 3300803,
      label: "Cachoeiras de Macacu",
      reference: 33
    },
    {
      value: 1703826,
      label: "Cachoeirinha",
      reference: 17
    },
    {
      value: 2603108,
      label: "Cachoeirinha",
      reference: 26
    },
    {
      value: 4303103,
      label: "Cachoeirinha",
      reference: 43
    },
    {
      value: 3201209,
      label: "Cachoeiro de Itapemirim",
      reference: 32
    },
    {
      value: 2503407,
      label: "Cacimba de Areia",
      reference: 25
    },
    {
      value: 2503506,
      label: "Cacimba de Dentro",
      reference: 25
    },
    {
      value: 2503555,
      label: "Cacimbas",
      reference: 25
    },
    {
      value: 2701209,
      label: "Cacimbinhas",
      reference: 27
    },
    {
      value: 4303202,
      label: "Cacique Doble",
      reference: 43
    },
    {
      value: 1100049,
      label: "Cacoal",
      reference: 11
    },
    {
      value: 3508702,
      label: "Caconde",
      reference: 35
    },
    {
      value: 5204300,
      label: "Caçu",
      reference: 52
    },
    {
      value: 2905008,
      label: "Caculé",
      reference: 29
    },
    {
      value: 2905107,
      label: "Caém",
      reference: 29
    },
    {
      value: 3109907,
      label: "Caetanópolis",
      reference: 31
    },
    {
      value: 2905156,
      label: "Caetanos",
      reference: 29
    },
    {
      value: 3110004,
      label: "Caeté",
      reference: 31
    },
    {
      value: 2603207,
      label: "Caetés",
      reference: 26
    },
    {
      value: 2905206,
      label: "Caetité",
      reference: 29
    },
    {
      value: 2905305,
      label: "Cafarnaum",
      reference: 29
    },
    {
      value: 4103404,
      label: "Cafeara",
      reference: 41
    },
    {
      value: 3508801,
      label: "Cafelândia",
      reference: 35
    },
    {
      value: 4103453,
      label: "Cafelândia",
      reference: 41
    },
    {
      value: 4103479,
      label: "Cafezal do Sul",
      reference: 41
    },
    {
      value: 3508900,
      label: "Caiabu",
      reference: 35
    },
    {
      value: 3110103,
      label: "Caiana",
      reference: 31
    },
    {
      value: 5204409,
      label: "Caiapônia",
      reference: 52
    },
    {
      value: 4303301,
      label: "Caibaté",
      reference: 43
    },
    {
      value: 4203105,
      label: "Caibi",
      reference: 42
    },
    {
      value: 4303400,
      label: "Caiçara",
      reference: 43
    },
    {
      value: 2503605,
      label: "Caiçara",
      reference: 25
    },
    {
      value: 2401859,
      label: "Caiçara do Norte",
      reference: 24
    },
    {
      value: 2401909,
      label: "Caiçara do Rio do Vento",
      reference: 24
    },
    {
      value: 2402006,
      label: "Caicó",
      reference: 24
    },
    {
      value: 3509007,
      label: "Caieiras",
      reference: 35
    },
    {
      value: 2905404,
      label: "Cairu",
      reference: 29
    },
    {
      value: 3509106,
      label: "Caiuá",
      reference: 35
    },
    {
      value: 3509205,
      label: "Cajamar",
      reference: 35
    },
    {
      value: 2102408,
      label: "Cajapió",
      reference: 21
    },
    {
      value: 2102507,
      label: "Cajari",
      reference: 21
    },
    {
      value: 3509254,
      label: "Cajati",
      reference: 35
    },
    {
      value: 2503704,
      label: "Cajazeiras",
      reference: 25
    },
    {
      value: 2202075,
      label: "Cajazeiras do Piauí",
      reference: 22
    },
    {
      value: 2503753,
      label: "Cajazeirinhas",
      reference: 25
    },
    {
      value: 3509304,
      label: "Cajobi",
      reference: 35
    },
    {
      value: 2701308,
      label: "Cajueiro",
      reference: 27
    },
    {
      value: 2202083,
      label: "Cajueiro da Praia",
      reference: 22
    },
    {
      value: 3110202,
      label: "Cajuri",
      reference: 31
    },
    {
      value: 3509403,
      label: "Cajuru",
      reference: 35
    },
    {
      value: 2603306,
      label: "Calçado",
      reference: 26
    },
    {
      value: 1600204,
      label: "Calçoene",
      reference: 16
    },
    {
      value: 3110301,
      label: "Caldas",
      reference: 31
    },
    {
      value: 2503803,
      label: "Caldas Brandão",
      reference: 25
    },
    {
      value: 5204508,
      label: "Caldas Novas",
      reference: 52
    },
    {
      value: 5204557,
      label: "Caldazinha",
      reference: 52
    },
    {
      value: 2905503,
      label: "Caldeirão Grande",
      reference: 29
    },
    {
      value: 2202091,
      label: "Caldeirão Grande do Piauí",
      reference: 22
    },
    {
      value: 4103503,
      label: "Califórnia",
      reference: 41
    },
    {
      value: 4203154,
      label: "Calmon",
      reference: 42
    },
    {
      value: 2603405,
      label: "Calumbi",
      reference: 26
    },
    {
      value: 2905602,
      label: "Camacan",
      reference: 29
    },
    {
      value: 2905701,
      label: "Camaçari",
      reference: 29
    },
    {
      value: 3110400,
      label: "Camacho",
      reference: 31
    },
    {
      value: 2503902,
      label: "Camalaú",
      reference: 25
    },
    {
      value: 2905800,
      label: "Camamu",
      reference: 29
    },
    {
      value: 3110509,
      label: "Camanducaia",
      reference: 31
    },
    {
      value: 5002605,
      label: "Camapuã",
      reference: 50
    },
    {
      value: 4303509,
      label: "Camaquã",
      reference: 43
    },
    {
      value: 2603454,
      label: "Camaragibe",
      reference: 26
    },
    {
      value: 4303558,
      label: "Camargo",
      reference: 43
    },
    {
      value: 4103602,
      label: "Cambará",
      reference: 41
    },
    {
      value: 4303608,
      label: "Cambará do Sul",
      reference: 43
    },
    {
      value: 4103701,
      label: "Cambé",
      reference: 41
    },
    {
      value: 4103800,
      label: "Cambira",
      reference: 41
    },
    {
      value: 4203204,
      label: "Camboriú",
      reference: 42
    },
    {
      value: 3300902,
      label: "Cambuci",
      reference: 33
    },
    {
      value: 3110608,
      label: "Cambuí",
      reference: 31
    },
    {
      value: 3110707,
      label: "Cambuquira",
      reference: 31
    },
    {
      value: 1502103,
      label: "Cametá",
      reference: 15
    },
    {
      value: 2302602,
      label: "Camocim",
      reference: 23
    },
    {
      value: 2603504,
      label: "Camocim de São Félix",
      reference: 26
    },
    {
      value: 3110806,
      label: "Campanário",
      reference: 31
    },
    {
      value: 3110905,
      label: "Campanha",
      reference: 31
    },
    {
      value: 3111002,
      label: "Campestre",
      reference: 31
    },
    {
      value: 2701357,
      label: "Campestre",
      reference: 27
    },
    {
      value: 4303673,
      label: "Campestre da Serra",
      reference: 43
    },
    {
      value: 5204607,
      label: "Campestre de Goiás",
      reference: 52
    },
    {
      value: 2102556,
      label: "Campestre do Maranhão",
      reference: 21
    },
    {
      value: 4103909,
      label: "Campina da Lagoa",
      reference: 41
    },
    {
      value: 4303707,
      label: "Campina das Missões",
      reference: 43
    },
    {
      value: 3509452,
      label: "Campina do Monte Alegre",
      reference: 35
    },
    {
      value: 4103958,
      label: "Campina do Simão",
      reference: 41
    },
    {
      value: 2504009,
      label: "Campina Grande",
      reference: 25
    },
    {
      value: 4104006,
      label: "Campina Grande do Sul",
      reference: 41
    },
    {
      value: 3111101,
      label: "Campina Verde",
      reference: 31
    },
    {
      value: 5204656,
      label: "Campinaçu",
      reference: 52
    },
    {
      value: 5102603,
      label: "Campinápolis",
      reference: 51
    },
    {
      value: 3509502,
      label: "Campinas",
      reference: 35
    },
    {
      value: 2202109,
      label: "Campinas do Piauí",
      reference: 22
    },
    {
      value: 4303806,
      label: "Campinas do Sul",
      reference: 43
    },
    {
      value: 5204706,
      label: "Campinorte",
      reference: 52
    },
    {
      value: 4203303,
      label: "Campo Alegre",
      reference: 42
    },
    {
      value: 2701407,
      label: "Campo Alegre",
      reference: 27
    },
    {
      value: 5204805,
      label: "Campo Alegre de Goiás",
      reference: 52
    },
    {
      value: 2905909,
      label: "Campo Alegre de Lourdes",
      reference: 29
    },
    {
      value: 2202117,
      label: "Campo Alegre do Fidalgo",
      reference: 22
    },
    {
      value: 3111150,
      label: "Campo Azul",
      reference: 31
    },
    {
      value: 3111200,
      label: "Campo Belo",
      reference: 31
    },
    {
      value: 4203402,
      label: "Campo Belo do Sul",
      reference: 42
    },
    {
      value: 4303905,
      label: "Campo Bom",
      reference: 43
    },
    {
      value: 4104055,
      label: "Campo Bonito",
      reference: 41
    },
    {
      value: 2801009,
      label: "Campo do Brito",
      reference: 28
    },
    {
      value: 3111309,
      label: "Campo do Meio",
      reference: 31
    },
    {
      value: 4104105,
      label: "Campo do Tenente",
      reference: 41
    },
    {
      value: 4203501,
      label: "Campo Erê",
      reference: 42
    },
    {
      value: 3111408,
      label: "Campo Florido",
      reference: 31
    },
    {
      value: 2906006,
      label: "Campo Formoso",
      reference: 29
    },
    {
      value: 2701506,
      label: "Campo Grande",
      reference: 27
    },
    {
      value: 5002704,
      label: "Campo Grande",
      reference: 50
    },
    {
      value: 2202133,
      label: "Campo Grande do Piauí",
      reference: 22
    },
    {
      value: 4104204,
      label: "Campo Largo",
      reference: 41
    },
    {
      value: 2202174,
      label: "Campo Largo do Piauí",
      reference: 22
    },
    {
      value: 5204854,
      label: "Campo Limpo de Goiás",
      reference: 52
    },
    {
      value: 3509601,
      label: "Campo Limpo Paulista",
      reference: 35
    },
    {
      value: 4104253,
      label: "Campo Magro",
      reference: 41
    },
    {
      value: 2202208,
      label: "Campo Maior",
      reference: 22
    },
    {
      value: 4104303,
      label: "Campo Mourão",
      reference: 41
    },
    {
      value: 4304002,
      label: "Campo Novo",
      reference: 43
    },
    {
      value: 1100700,
      label: "Campo Novo de Rondônia",
      reference: 11
    },
    {
      value: 5102637,
      label: "Campo Novo do Parecis",
      reference: 51
    },
    {
      value: 2402105,
      label: "Campo Redondo",
      reference: 24
    },
    {
      value: 5102678,
      label: "Campo Verde",
      reference: 51
    },
    {
      value: 3111507,
      label: "Campos Altos",
      reference: 31
    },
    {
      value: 5204904,
      label: "Campos Belos",
      reference: 52
    },
    {
      value: 4304101,
      label: "Campos Borges",
      reference: 43
    },
    {
      value: 5102686,
      label: "Campos de Júlio",
      reference: 51
    },
    {
      value: 3509700,
      label: "Campos do Jordão",
      reference: 35
    },
    {
      value: 3301009,
      label: "Campos dos Goytacazes",
      reference: 33
    },
    {
      value: 3111606,
      label: "Campos Gerais",
      reference: 31
    },
    {
      value: 1703842,
      label: "Campos Lindos",
      reference: 17
    },
    {
      value: 4203600,
      label: "Campos Novos",
      reference: 42
    },
    {
      value: 3509809,
      label: "Campos Novos Paulista",
      reference: 35
    },
    {
      value: 2302701,
      label: "Campos Sales",
      reference: 23
    },
    {
      value: 5204953,
      label: "Campos Verdes",
      reference: 52
    },
    {
      value: 2603603,
      label: "Camutanga",
      reference: 26
    },
    {
      value: 3111903,
      label: "Cana Verde",
      reference: 31
    },
    {
      value: 3111705,
      label: "Canaã",
      reference: 31
    },
    {
      value: 1502152,
      label: "Canaã dos Carajás",
      reference: 15
    },
    {
      value: 5102694,
      label: "Canabrava do Norte",
      reference: 51
    },
    {
      value: 3509908,
      label: "Cananéia",
      reference: 35
    },
    {
      value: 2701605,
      label: "Canapi",
      reference: 27
    },
    {
      value: 2906105,
      label: "Canápolis",
      reference: 29
    },
    {
      value: 3111804,
      label: "Canápolis",
      reference: 31
    },
    {
      value: 2906204,
      label: "Canarana",
      reference: 29
    },
    {
      value: 5102702,
      label: "Canarana",
      reference: 51
    },
    {
      value: 3509957,
      label: "Canas",
      reference: 35
    },
    {
      value: 2202251,
      label: "Canavieira",
      reference: 22
    },
    {
      value: 2906303,
      label: "Canavieiras",
      reference: 29
    },
    {
      value: 2906402,
      label: "Candeal",
      reference: 29
    },
    {
      value: 2906501,
      label: "Candeias",
      reference: 29
    },
    {
      value: 3112000,
      label: "Candeias",
      reference: 31
    },
    {
      value: 1100809,
      label: "Candeias do Jamari",
      reference: 11
    },
    {
      value: 4304200,
      label: "Candelária",
      reference: 43
    },
    {
      value: 2906600,
      label: "Candiba",
      reference: 29
    },
    {
      value: 4104402,
      label: "Cândido de Abreu",
      reference: 41
    },
    {
      value: 4304309,
      label: "Cândido Godói",
      reference: 43
    },
    {
      value: 2102606,
      label: "Cândido Mendes",
      reference: 21
    },
    {
      value: 3510005,
      label: "Cândido Mota",
      reference: 35
    },
    {
      value: 3510104,
      label: "Cândido Rodrigues",
      reference: 35
    },
    {
      value: 2906709,
      label: "Cândido Sales",
      reference: 29
    },
    {
      value: 4304358,
      label: "Candiota",
      reference: 43
    },
    {
      value: 4104428,
      label: "Candói",
      reference: 41
    },
    {
      value: 4304408,
      label: "Canela",
      reference: 43
    },
    {
      value: 4203709,
      label: "Canelinha",
      reference: 42
    },
    {
      value: 2402204,
      label: "Canguaretama",
      reference: 24
    },
    {
      value: 4304507,
      label: "Canguçu",
      reference: 43
    },
    {
      value: 2801108,
      label: "Canhoba",
      reference: 28
    },
    {
      value: 2603702,
      label: "Canhotinho",
      reference: 26
    },
    {
      value: 2302800,
      label: "Canindé",
      reference: 23
    },
    {
      value: 2801207,
      label: "Canindé de São Francisco",
      reference: 28
    },
    {
      value: 3510153,
      label: "Canitar",
      reference: 35
    },
    {
      value: 4304606,
      label: "Canoas",
      reference: 43
    },
    {
      value: 4203808,
      label: "Canoinhas",
      reference: 42
    },
    {
      value: 2906808,
      label: "Cansanção",
      reference: 29
    },
    {
      value: 1400175,
      label: "Cantá",
      reference: 14
    },
    {
      value: 3301108,
      label: "Cantagalo",
      reference: 33
    },
    {
      value: 4104451,
      label: "Cantagalo",
      reference: 41
    },
    {
      value: 3112059,
      label: "Cantagalo",
      reference: 31
    },
    {
      value: 2102705,
      label: "Cantanhede",
      reference: 21
    },
    {
      value: 2202307,
      label: "Canto do Buriti",
      reference: 22
    },
    {
      value: 2906824,
      label: "Canudos",
      reference: 29
    },
    {
      value: 4304614,
      label: "Canudos do Vale",
      reference: 43
    },
    {
      value: 1300904,
      label: "Canutama",
      reference: 13
    },
    {
      value: 1502202,
      label: "Capanema",
      reference: 15
    },
    {
      value: 4104501,
      label: "Capanema",
      reference: 41
    },
    {
      value: 4203253,
      label: "Capão Alto",
      reference: 42
    },
    {
      value: 3510203,
      label: "Capão Bonito",
      reference: 35
    },
    {
      value: 4304622,
      label: "Capão Bonito do Sul",
      reference: 43
    },
    {
      value: 4304630,
      label: "Capão da Canoa",
      reference: 43
    },
    {
      value: 4304655,
      label: "Capão do Cipó",
      reference: 43
    },
    {
      value: 4304663,
      label: "Capão do Leão",
      reference: 43
    },
    {
      value: 3112109,
      label: "Caparaó",
      reference: 31
    },
    {
      value: 2701704,
      label: "Capela",
      reference: 27
    },
    {
      value: 2801306,
      label: "Capela",
      reference: 28
    },
    {
      value: 4304689,
      label: "Capela de Santana",
      reference: 43
    },
    {
      value: 3510302,
      label: "Capela do Alto",
      reference: 35
    },
    {
      value: 2906857,
      label: "Capela do Alto Alegre",
      reference: 29
    },
    {
      value: 3112208,
      label: "Capela Nova",
      reference: 31
    },
    {
      value: 3112307,
      label: "Capelinha",
      reference: 31
    },
    {
      value: 3112406,
      label: "Capetinga",
      reference: 31
    },
    {
      value: 2504033,
      label: "Capim",
      reference: 25
    },
    {
      value: 3112505,
      label: "Capim Branco",
      reference: 31
    },
    {
      value: 2906873,
      label: "Capim Grosso",
      reference: 29
    },
    {
      value: 3112604,
      label: "Capinópolis",
      reference: 31
    },
    {
      value: 4203907,
      label: "Capinzal",
      reference: 42
    },
    {
      value: 2102754,
      label: "Capinzal do Norte",
      reference: 21
    },
    {
      value: 2302909,
      label: "Capistrano",
      reference: 23
    },
    {
      value: 4304697,
      label: "Capitão",
      reference: 43
    },
    {
      value: 3112653,
      label: "Capitão Andrade",
      reference: 31
    },
    {
      value: 2202406,
      label: "Capitão de Campos",
      reference: 22
    },
    {
      value: 3112703,
      label: "Capitão Enéas",
      reference: 31
    },
    {
      value: 2202455,
      label: "Capitão Gervásio Oliveira",
      reference: 22
    },
    {
      value: 4104600,
      label: "Capitão Leônidas Marques",
      reference: 41
    },
    {
      value: 1502301,
      label: "Capitão Poço",
      reference: 15
    },
    {
      value: 3112802,
      label: "Capitólio",
      reference: 31
    },
    {
      value: 3510401,
      label: "Capivari",
      reference: 35
    },
    {
      value: 4203956,
      label: "Capivari de Baixo",
      reference: 42
    },
    {
      value: 4304671,
      label: "Capivari do Sul",
      reference: 43
    },
    {
      value: 1200179,
      label: "Capixaba",
      reference: 12
    },
    {
      value: 2603801,
      label: "Capoeiras",
      reference: 26
    },
    {
      value: 3112901,
      label: "Caputira",
      reference: 31
    },
    {
      value: 4304713,
      label: "Caraá",
      reference: 43
    },
    {
      value: 1400209,
      label: "Caracaraí",
      reference: 14
    },
    {
      value: 2202505,
      label: "Caracol",
      reference: 22
    },
    {
      value: 5002803,
      label: "Caracol",
      reference: 50
    },
    {
      value: 3510500,
      label: "Caraguatatuba",
      reference: 35
    },
    {
      value: 3113008,
      label: "Caraí",
      reference: 31
    },
    {
      value: 2906899,
      label: "Caraíbas",
      reference: 29
    },
    {
      value: 4104659,
      label: "Carambeí",
      reference: 41
    },
    {
      value: 3113107,
      label: "Caranaíba",
      reference: 31
    },
    {
      value: 3113206,
      label: "Carandaí",
      reference: 31
    },
    {
      value: 3113305,
      label: "Carangola",
      reference: 31
    },
    {
      value: 3300936,
      label: "Carapebus",
      reference: 33
    },
    {
      value: 3510609,
      label: "Carapicuíba",
      reference: 35
    },
    {
      value: 3113404,
      label: "Caratinga",
      reference: 31
    },
    {
      value: 1301001,
      label: "Carauari",
      reference: 13
    },
    {
      value: 2402303,
      label: "Caraúbas",
      reference: 24
    },
    {
      value: 2504074,
      label: "Caraúbas",
      reference: 25
    },
    {
      value: 2202539,
      label: "Caraúbas do Piauí",
      reference: 22
    },
    {
      value: 2906907,
      label: "Caravelas",
      reference: 29
    },
    {
      value: 4304705,
      label: "Carazinho",
      reference: 43
    },
    {
      value: 3113503,
      label: "Carbonita",
      reference: 31
    },
    {
      value: 2907004,
      label: "Cardeal da Silva",
      reference: 29
    },
    {
      value: 3510708,
      label: "Cardoso",
      reference: 35
    },
    {
      value: 3301157,
      label: "Cardoso Moreira",
      reference: 33
    },
    {
      value: 3113602,
      label: "Careaçu",
      reference: 31
    },
    {
      value: 1301100,
      label: "Careiro",
      reference: 13
    },
    {
      value: 1301159,
      label: "Careiro da Várzea",
      reference: 13
    },
    {
      value: 3201308,
      label: "Cariacica",
      reference: 32
    },
    {
      value: 2303006,
      label: "Caridade",
      reference: 23
    },
    {
      value: 2202554,
      label: "Caridade do Piauí",
      reference: 22
    },
    {
      value: 2907103,
      label: "Carinhanha",
      reference: 29
    },
    {
      value: 2801405,
      label: "Carira",
      reference: 28
    },
    {
      value: 2303105,
      label: "Cariré",
      reference: 23
    },
    {
      value: 1703867,
      label: "Cariri do Tocantins",
      reference: 17
    },
    {
      value: 2303204,
      label: "Caririaçu",
      reference: 23
    },
    {
      value: 2303303,
      label: "Cariús",
      reference: 23
    },
    {
      value: 5102793,
      label: "Carlinda",
      reference: 51
    },
    {
      value: 4104709,
      label: "Carlópolis",
      reference: 41
    },
    {
      value: 4304804,
      label: "Carlos Barbosa",
      reference: 43
    },
    {
      value: 3113701,
      label: "Carlos Chagas",
      reference: 31
    },
    {
      value: 4304853,
      label: "Carlos Gomes",
      reference: 43
    },
    {
      value: 3113800,
      label: "Carmésia",
      reference: 31
    },
    {
      value: 3301207,
      label: "Carmo",
      reference: 33
    },
    {
      value: 3113909,
      label: "Carmo da Cachoeira",
      reference: 31
    },
    {
      value: 3114006,
      label: "Carmo da Mata",
      reference: 31
    },
    {
      value: 3114105,
      label: "Carmo de Minas",
      reference: 31
    },
    {
      value: 3114204,
      label: "Carmo do Cajuru",
      reference: 31
    },
    {
      value: 3114303,
      label: "Carmo do Paranaíba",
      reference: 31
    },
    {
      value: 3114402,
      label: "Carmo do Rio Claro",
      reference: 31
    },
    {
      value: 5205000,
      label: "Carmo do Rio Verde",
      reference: 52
    },
    {
      value: 1703883,
      label: "Carmolândia",
      reference: 17
    },
    {
      value: 2801504,
      label: "Carmópolis",
      reference: 28
    },
    {
      value: 3114501,
      label: "Carmópolis de Minas",
      reference: 31
    },
    {
      value: 2603900,
      label: "Carnaíba",
      reference: 26
    },
    {
      value: 2402402,
      label: "Carnaúba dos Dantas",
      reference: 24
    },
    {
      value: 2402501,
      label: "Carnaubais",
      reference: 24
    },
    {
      value: 2303402,
      label: "Carnaubal",
      reference: 23
    },
    {
      value: 2603926,
      label: "Carnaubeira da Penha",
      reference: 26
    },
    {
      value: 3114550,
      label: "Carneirinho",
      reference: 31
    },
    {
      value: 2701803,
      label: "Carneiros",
      reference: 27
    },
    {
      value: 1400233,
      label: "Caroebe",
      reference: 14
    },
    {
      value: 2102804,
      label: "Carolina",
      reference: 21
    },
    {
      value: 2604007,
      label: "Carpina",
      reference: 26
    },
    {
      value: 3114600,
      label: "Carrancas",
      reference: 31
    },
    {
      value: 2504108,
      label: "Carrapateira",
      reference: 25
    },
    {
      value: 1703891,
      label: "Carrasco Bonito",
      reference: 17
    },
    {
      value: 2604106,
      label: "Caruaru",
      reference: 26
    },
    {
      value: 2102903,
      label: "Carutapera",
      reference: 21
    },
    {
      value: 3114709,
      label: "Carvalhópolis",
      reference: 31
    },
    {
      value: 3114808,
      label: "Carvalhos",
      reference: 31
    },
    {
      value: 3510807,
      label: "Casa Branca",
      reference: 35
    },
    {
      value: 3114907,
      label: "Casa Grande",
      reference: 31
    },
    {
      value: 2907202,
      label: "Casa Nova",
      reference: 29
    },
    {
      value: 4304903,
      label: "Casca",
      reference: 43
    },
    {
      value: 3115003,
      label: "Cascalho Rico",
      reference: 31
    },
    {
      value: 4104808,
      label: "Cascavel",
      reference: 41
    },
    {
      value: 2303501,
      label: "Cascavel",
      reference: 23
    },
    {
      value: 1703909,
      label: "Caseara",
      reference: 17
    },
    {
      value: 4304952,
      label: "Caseiros",
      reference: 43
    },
    {
      value: 3301306,
      label: "Casimiro de Abreu",
      reference: 33
    },
    {
      value: 2604155,
      label: "Casinhas",
      reference: 26
    },
    {
      value: 2504157,
      label: "Casserengue",
      reference: 25
    },
    {
      value: 3115102,
      label: "Cássia",
      reference: 31
    },
    {
      value: 3510906,
      label: "Cássia dos Coqueiros",
      reference: 35
    },
    {
      value: 5002902,
      label: "Cassilândia",
      reference: 50
    },
    {
      value: 1502400,
      label: "Castanhal",
      reference: 15
    },
    {
      value: 5102850,
      label: "Castanheira",
      reference: 51
    },
    {
      value: 1100908,
      label: "Castanheiras",
      reference: 11
    },
    {
      value: 5205059,
      label: "Castelândia",
      reference: 52
    },
    {
      value: 3201407,
      label: "Castelo",
      reference: 32
    },
    {
      value: 2202604,
      label: "Castelo do Piauí",
      reference: 22
    },
    {
      value: 3511003,
      label: "Castilho",
      reference: 35
    },
    {
      value: 4104907,
      label: "Castro",
      reference: 41
    },
    {
      value: 2907301,
      label: "Castro Alves",
      reference: 29
    },
    {
      value: 3115300,
      label: "Cataguases",
      reference: 31
    },
    {
      value: 5205109,
      label: "Catalão",
      reference: 52
    },
    {
      value: 3511102,
      label: "Catanduva",
      reference: 35
    },
    {
      value: 4105003,
      label: "Catanduvas",
      reference: 41
    },
    {
      value: 4204004,
      label: "Catanduvas",
      reference: 42
    },
    {
      value: 2303600,
      label: "Catarina",
      reference: 23
    },
    {
      value: 3115359,
      label: "Catas Altas",
      reference: 31
    },
    {
      value: 3115409,
      label: "Catas Altas da Noruega",
      reference: 31
    },
    {
      value: 2604205,
      label: "Catende",
      reference: 26
    },
    {
      value: 3511201,
      label: "Catiguá",
      reference: 35
    },
    {
      value: 2504207,
      label: "Catingueira",
      reference: 25
    },
    {
      value: 2907400,
      label: "Catolândia",
      reference: 29
    },
    {
      value: 2504306,
      label: "Catolé do Rocha",
      reference: 25
    },
    {
      value: 2907509,
      label: "Catu",
      reference: 29
    },
    {
      value: 4305009,
      label: "Catuípe",
      reference: 43
    },
    {
      value: 3115458,
      label: "Catuji",
      reference: 31
    },
    {
      value: 2303659,
      label: "Catunda",
      reference: 23
    },
    {
      value: 5205208,
      label: "Caturaí",
      reference: 52
    },
    {
      value: 2907558,
      label: "Caturama",
      reference: 29
    },
    {
      value: 2504355,
      label: "Caturité",
      reference: 25
    },
    {
      value: 3115474,
      label: "Catuti",
      reference: 31
    },
    {
      value: 2303709,
      label: "Caucaia",
      reference: 23
    },
    {
      value: 5205307,
      label: "Cavalcante",
      reference: 52
    },
    {
      value: 3115508,
      label: "Caxambu",
      reference: 31
    },
    {
      value: 4204103,
      label: "Caxambu do Sul",
      reference: 42
    },
    {
      value: 2103000,
      label: "Caxias",
      reference: 21
    },
    {
      value: 4305108,
      label: "Caxias do Sul",
      reference: 43
    },
    {
      value: 2202653,
      label: "Caxingó",
      reference: 22
    },
    {
      value: 2402600,
      label: "Ceará-Mirim",
      reference: 24
    },
    {
      value: 2103109,
      label: "Cedral",
      reference: 21
    },
    {
      value: 3511300,
      label: "Cedral",
      reference: 35
    },
    {
      value: 2303808,
      label: "Cedro",
      reference: 23
    },
    {
      value: 2604304,
      label: "Cedro",
      reference: 26
    },
    {
      value: 2801603,
      label: "Cedro de São João",
      reference: 28
    },
    {
      value: 3115607,
      label: "Cedro do Abaeté",
      reference: 31
    },
    {
      value: 4204152,
      label: "Celso Ramos",
      reference: 42
    },
    {
      value: 4305116,
      label: "Centenário",
      reference: 43
    },
    {
      value: 1704105,
      label: "Centenário",
      reference: 17
    },
    {
      value: 4105102,
      label: "Centenário do Sul",
      reference: 41
    },
    {
      value: 2907608,
      label: "Central",
      reference: 29
    },
    {
      value: 3115706,
      label: "Central de Minas",
      reference: 31
    },
    {
      value: 2103125,
      label: "Central do Maranhão",
      reference: 21
    },
    {
      value: 3115805,
      label: "Centralina",
      reference: 31
    },
    {
      value: 2103158,
      label: "Centro do Guilherme",
      reference: 21
    },
    {
      value: 2103174,
      label: "Centro Novo do Maranhão",
      reference: 21
    },
    {
      value: 1100056,
      label: "Cerejeiras",
      reference: 11
    },
    {
      value: 5205406,
      label: "Ceres",
      reference: 52
    },
    {
      value: 3511409,
      label: "Cerqueira César",
      reference: 35
    },
    {
      value: 3511508,
      label: "Cerquilho",
      reference: 35
    },
    {
      value: 4305124,
      label: "Cerrito",
      reference: 43
    },
    {
      value: 4105201,
      label: "Cerro Azul",
      reference: 41
    },
    {
      value: 4305132,
      label: "Cerro Branco",
      reference: 43
    },
    {
      value: 2402709,
      label: "Cerro Corá",
      reference: 24
    },
    {
      value: 4305157,
      label: "Cerro Grande",
      reference: 43
    },
    {
      value: 4305173,
      label: "Cerro Grande do Sul",
      reference: 43
    },
    {
      value: 4305207,
      label: "Cerro Largo",
      reference: 43
    },
    {
      value: 4204178,
      label: "Cerro Negro",
      reference: 42
    },
    {
      value: 3511607,
      label: "Cesário Lange",
      reference: 35
    },
    {
      value: 4105300,
      label: "Céu Azul",
      reference: 41
    },
    {
      value: 5205455,
      label: "Cezarina",
      reference: 52
    },
    {
      value: 2604403,
      label: "Chã de Alegria",
      reference: 26
    },
    {
      value: 2604502,
      label: "Chã Grande",
      reference: 26
    },
    {
      value: 2701902,
      label: "Chã Preta",
      reference: 27
    },
    {
      value: 3115904,
      label: "Chácara",
      reference: 31
    },
    {
      value: 3116001,
      label: "Chalé",
      reference: 31
    },
    {
      value: 4305306,
      label: "Chapada",
      reference: 43
    },
    {
      value: 1705102,
      label: "Chapada da Natividade",
      reference: 17
    },
    {
      value: 1704600,
      label: "Chapada de Areia",
      reference: 17
    },
    {
      value: 3116100,
      label: "Chapada do Norte",
      reference: 31
    },
    {
      value: 5103007,
      label: "Chapada dos Guimarães",
      reference: 51
    },
    {
      value: 3116159,
      label: "Chapada Gaúcha",
      reference: 31
    },
    {
      value: 5205471,
      label: "Chapadão do Céu",
      reference: 52
    },
    {
      value: 4204194,
      label: "Chapadão do Lageado",
      reference: 42
    },
    {
      value: 5002951,
      label: "Chapadão do Sul",
      reference: 50
    },
    {
      value: 2103208,
      label: "Chapadinha",
      reference: 21
    },
    {
      value: 4204202,
      label: "Chapecó",
      reference: 42
    },
    {
      value: 3511706,
      label: "Charqueada",
      reference: 35
    },
    {
      value: 4305355,
      label: "Charqueadas",
      reference: 43
    },
    {
      value: 4305371,
      label: "Charrua",
      reference: 43
    },
    {
      value: 2303907,
      label: "Chaval",
      reference: 23
    },
    {
      value: 3557204,
      label: "Chavantes",
      reference: 35
    },
    {
      value: 1502509,
      label: "Chaves",
      reference: 15
    },
    {
      value: 3116209,
      label: "Chiador",
      reference: 31
    },
    {
      value: 4305405,
      label: "Chiapetta",
      reference: 43
    },
    {
      value: 4105409,
      label: "Chopinzinho",
      reference: 41
    },
    {
      value: 2303931,
      label: "Choró",
      reference: 23
    },
    {
      value: 2303956,
      label: "Chorozinho",
      reference: 23
    },
    {
      value: 2907707,
      label: "Chorrochó",
      reference: 29
    },
    {
      value: 4305439,
      label: "Chuí",
      reference: 43
    },
    {
      value: 1100924,
      label: "Chupinguaia",
      reference: 11
    },
    {
      value: 4305447,
      label: "Chuvisca",
      reference: 43
    },
    {
      value: 4105508,
      label: "Cianorte",
      reference: 41
    },
    {
      value: 2907806,
      label: "Cícero Dantas",
      reference: 29
    },
    {
      value: 4105607,
      label: "Cidade Gaúcha",
      reference: 41
    },
    {
      value: 5205497,
      label: "Cidade Ocidental",
      reference: 52
    },
    {
      value: 2103257,
      label: "Cidelândia",
      reference: 21
    },
    {
      value: 4305454,
      label: "Cidreira",
      reference: 43
    },
    {
      value: 2907905,
      label: "Cipó",
      reference: 29
    },
    {
      value: 3116308,
      label: "Cipotânea",
      reference: 31
    },
    {
      value: 4305504,
      label: "Ciríaco",
      reference: 43
    },
    {
      value: 3116407,
      label: "Claraval",
      reference: 31
    },
    {
      value: 3116506,
      label: "Claro dos Poções",
      reference: 31
    },
    {
      value: 5103056,
      label: "Cláudia",
      reference: 51
    },
    {
      value: 3116605,
      label: "Cláudio",
      reference: 31
    },
    {
      value: 3511904,
      label: "Clementina",
      reference: 35
    },
    {
      value: 4105706,
      label: "Clevelândia",
      reference: 41
    },
    {
      value: 2908002,
      label: "Coaraci",
      reference: 29
    },
    {
      value: 1301209,
      label: "Coari",
      reference: 13
    },
    {
      value: 2202703,
      label: "Cocal",
      reference: 22
    },
    {
      value: 2202711,
      label: "Cocal de Telha",
      reference: 22
    },
    {
      value: 4204251,
      label: "Cocal do Sul",
      reference: 42
    },
    {
      value: 2202729,
      label: "Cocal dos Alves",
      reference: 22
    },
    {
      value: 5103106,
      label: "Cocalinho",
      reference: 51
    },
    {
      value: 5205513,
      label: "Cocalzinho de Goiás",
      reference: 52
    },
    {
      value: 2908101,
      label: "Cocos",
      reference: 29
    },
    {
      value: 1301308,
      label: "Codajás",
      reference: 13
    },
    {
      value: 2103307,
      label: "Codó",
      reference: 21
    },
    {
      value: 2103406,
      label: "Coelho Neto",
      reference: 21
    },
    {
      value: 3116704,
      label: "Coimbra",
      reference: 31
    },
    {
      value: 2702009,
      label: "Coité do Nóia",
      reference: 27
    },
    {
      value: 2202737,
      label: "Coivaras",
      reference: 22
    },
    {
      value: 1502608,
      label: "Colares",
      reference: 15
    },
    {
      value: 3201506,
      label: "Colatina",
      reference: 32
    },
    {
      value: 5103205,
      label: "Colíder",
      reference: 51
    },
    {
      value: 3512001,
      label: "Colina",
      reference: 35
    },
    {
      value: 4305587,
      label: "Colinas",
      reference: 43
    },
    {
      value: 2103505,
      label: "Colinas",
      reference: 21
    },
    {
      value: 5205521,
      label: "Colinas do Sul",
      reference: 52
    },
    {
      value: 1705508,
      label: "Colinas do Tocantins",
      reference: 17
    },
    {
      value: 1716703,
      label: "Colméia",
      reference: 17
    },
    {
      value: 5103254,
      label: "Colniza",
      reference: 51
    },
    {
      value: 3512100,
      label: "Colômbia",
      reference: 35
    },
    {
      value: 4105805,
      label: "Colombo",
      reference: 41
    },
    {
      value: 2202752,
      label: "Colônia do Gurguéia",
      reference: 22
    },
    {
      value: 2202778,
      label: "Colônia do Piauí",
      reference: 22
    },
    {
      value: 2702108,
      label: "Colônia Leopoldina",
      reference: 27
    },
    {
      value: 4305603,
      label: "Colorado",
      reference: 43
    },
    {
      value: 4105904,
      label: "Colorado",
      reference: 41
    },
    {
      value: 1100064,
      label: "Colorado do Oeste",
      reference: 11
    },
    {
      value: 3116803,
      label: "Coluna",
      reference: 31
    },
    {
      value: 1705557,
      label: "Combinado",
      reference: 17
    },
    {
      value: 3116902,
      label: "Comendador Gomes",
      reference: 31
    },
    {
      value: 3300951,
      label: "Comendador Levy Gasparian",
      reference: 33
    },
    {
      value: 3117009,
      label: "Comercinho",
      reference: 31
    },
    {
      value: 5103304,
      label: "Comodoro",
      reference: 51
    },
    {
      value: 2504405,
      label: "Conceição",
      reference: 25
    },
    {
      value: 3117108,
      label: "Conceição da Aparecida",
      reference: 31
    },
    {
      value: 3201605,
      label: "Conceição da Barra",
      reference: 32
    },
    {
      value: 3115201,
      label: "Conceição da Barra de Minas",
      reference: 31
    },
    {
      value: 2908200,
      label: "Conceição da Feira",
      reference: 29
    },
    {
      value: 3117306,
      label: "Conceição das Alagoas",
      reference: 31
    },
    {
      value: 3117207,
      label: "Conceição das Pedras",
      reference: 31
    },
    {
      value: 3117405,
      label: "Conceição de Ipanema",
      reference: 31
    },
    {
      value: 3301405,
      label: "Conceição de Macabu",
      reference: 33
    },
    {
      value: 2908309,
      label: "Conceição do Almeida",
      reference: 29
    },
    {
      value: 1502707,
      label: "Conceição do Araguaia",
      reference: 15
    },
    {
      value: 2202802,
      label: "Conceição do Canindé",
      reference: 22
    },
    {
      value: 3201704,
      label: "Conceição do Castelo",
      reference: 32
    },
    {
      value: 2908408,
      label: "Conceição do Coité",
      reference: 29
    },
    {
      value: 2908507,
      label: "Conceição do Jacuípe",
      reference: 29
    },
    {
      value: 2103554,
      label: "Conceição do Lago-Açu",
      reference: 21
    },
    {
      value: 3117504,
      label: "Conceição do Mato Dentro",
      reference: 31
    },
    {
      value: 3117603,
      label: "Conceição do Pará",
      reference: 31
    },
    {
      value: 3117702,
      label: "Conceição do Rio Verde",
      reference: 31
    },
    {
      value: 1705607,
      label: "Conceição do Tocantins",
      reference: 17
    },
    {
      value: 3117801,
      label: "Conceição dos Ouros",
      reference: 31
    },
    {
      value: 3512209,
      label: "Conchal",
      reference: 35
    },
    {
      value: 3512308,
      label: "Conchas",
      reference: 35
    },
    {
      value: 4204301,
      label: "Concórdia",
      reference: 42
    },
    {
      value: 1502756,
      label: "Concórdia do Pará",
      reference: 15
    },
    {
      value: 2504504,
      label: "Condado",
      reference: 25
    },
    {
      value: 2604601,
      label: "Condado",
      reference: 26
    },
    {
      value: 2504603,
      label: "Conde",
      reference: 25
    },
    {
      value: 2908606,
      label: "Conde",
      reference: 29
    },
    {
      value: 2908705,
      label: "Condeúba",
      reference: 29
    },
    {
      value: 4305702,
      label: "Condor",
      reference: 43
    },
    {
      value: 3117836,
      label: "Cônego Marinho",
      reference: 31
    },
    {
      value: 3117876,
      label: "Confins",
      reference: 31
    },
    {
      value: 5103353,
      label: "Confresa",
      reference: 51
    },
    {
      value: 2504702,
      label: "Congo",
      reference: 25
    },
    {
      value: 3117900,
      label: "Congonhal",
      reference: 31
    },
    {
      value: 3118007,
      label: "Congonhas",
      reference: 31
    },
    {
      value: 3118106,
      label: "Congonhas do Norte",
      reference: 31
    },
    {
      value: 4106001,
      label: "Congonhinhas",
      reference: 41
    },
    {
      value: 3118205,
      label: "Conquista",
      reference: 31
    },
    {
      value: 5103361,
      label: "Conquista D'Oeste",
      reference: 51
    },
    {
      value: 3118304,
      label: "Conselheiro Lafaiete",
      reference: 31
    },
    {
      value: 4106100,
      label: "Conselheiro Mairinck",
      reference: 41
    },
    {
      value: 3118403,
      label: "Conselheiro Pena",
      reference: 31
    },
    {
      value: 3118502,
      label: "Consolação",
      reference: 31
    },
    {
      value: 4305801,
      label: "Constantina",
      reference: 43
    },
    {
      value: 3118601,
      label: "Contagem",
      reference: 31
    },
    {
      value: 4106209,
      label: "Contenda",
      reference: 41
    },
    {
      value: 2908804,
      label: "Contendas do Sincorá",
      reference: 29
    },
    {
      value: 3118700,
      label: "Coqueiral",
      reference: 31
    },
    {
      value: 4305835,
      label: "Coqueiro Baixo",
      reference: 43
    },
    {
      value: 2702207,
      label: "Coqueiro Seco",
      reference: 27
    },
    {
      value: 4305850,
      label: "Coqueiros do Sul",
      reference: 43
    },
    {
      value: 3118809,
      label: "Coração de Jesus",
      reference: 31
    },
    {
      value: 2908903,
      label: "Coração de Maria",
      reference: 29
    },
    {
      value: 4106308,
      label: "Corbélia",
      reference: 41
    },
    {
      value: 3301504,
      label: "Cordeiro",
      reference: 33
    },
    {
      value: 3512407,
      label: "Cordeirópolis",
      reference: 35
    },
    {
      value: 2909000,
      label: "Cordeiros",
      reference: 29
    },
    {
      value: 4204350,
      label: "Cordilheira Alta",
      reference: 42
    },
    {
      value: 3118908,
      label: "Cordisburgo",
      reference: 31
    },
    {
      value: 3119005,
      label: "Cordislândia",
      reference: 31
    },
    {
      value: 2304004,
      label: "Coreaú",
      reference: 23
    },
    {
      value: 2504801,
      label: "Coremas",
      reference: 25
    },
    {
      value: 5003108,
      label: "Corguinho",
      reference: 50
    },
    {
      value: 2909109,
      label: "Coribe",
      reference: 29
    },
    {
      value: 3119104,
      label: "Corinto",
      reference: 31
    },
    {
      value: 4106407,
      label: "Cornélio Procópio",
      reference: 41
    },
    {
      value: 3119203,
      label: "Coroaci",
      reference: 31
    },
    {
      value: 3512506,
      label: "Coroados",
      reference: 35
    },
    {
      value: 2103604,
      label: "Coroatá",
      reference: 21
    },
    {
      value: 3119302,
      label: "Coromandel",
      reference: 31
    },
    {
      value: 4305871,
      label: "Coronel Barros",
      reference: 43
    },
    {
      value: 4305900,
      label: "Coronel Bicaco",
      reference: 43
    },
    {
      value: 4106456,
      label: "Coronel Domingos Soares",
      reference: 41
    },
    {
      value: 2402808,
      label: "Coronel Ezequiel",
      reference: 24
    },
    {
      value: 3119401,
      label: "Coronel Fabriciano",
      reference: 31
    },
    {
      value: 4204400,
      label: "Coronel Freitas",
      reference: 42
    },
    {
      value: 2402907,
      label: "Coronel João Pessoa",
      reference: 24
    },
    {
      value: 2909208,
      label: "Coronel João Sá",
      reference: 29
    },
    {
      value: 2202851,
      label: "Coronel José Dias",
      reference: 22
    },
    {
      value: 3512605,
      label: "Coronel Macedo",
      reference: 35
    },
    {
      value: 4204459,
      label: "Coronel Martins",
      reference: 42
    },
    {
      value: 3119500,
      label: "Coronel Murta",
      reference: 31
    },
    {
      value: 3119609,
      label: "Coronel Pacheco",
      reference: 31
    },
    {
      value: 4305934,
      label: "Coronel Pilar",
      reference: 43
    },
    {
      value: 5003157,
      label: "Coronel Sapucaia",
      reference: 50
    },
    {
      value: 4106506,
      label: "Coronel Vivida",
      reference: 41
    },
    {
      value: 3119708,
      label: "Coronel Xavier Chaves",
      reference: 31
    },
    {
      value: 3119807,
      label: "Córrego Danta",
      reference: 31
    },
    {
      value: 3119906,
      label: "Córrego do Bom Jesus",
      reference: 31
    },
    {
      value: 5205703,
      label: "Córrego do Ouro",
      reference: 52
    },
    {
      value: 3119955,
      label: "Córrego Fundo",
      reference: 31
    },
    {
      value: 3120003,
      label: "Córrego Novo",
      reference: 31
    },
    {
      value: 4204558,
      label: "Correia Pinto",
      reference: 42
    },
    {
      value: 2202901,
      label: "Corrente",
      reference: 22
    },
    {
      value: 2604700,
      label: "Correntes",
      reference: 26
    },
    {
      value: 2909307,
      label: "Correntina",
      reference: 29
    },
    {
      value: 2604809,
      label: "Cortês",
      reference: 26
    },
    {
      value: 5003207,
      label: "Corumbá",
      reference: 50
    },
    {
      value: 5205802,
      label: "Corumbá de Goiás",
      reference: 52
    },
    {
      value: 5205901,
      label: "Corumbaíba",
      reference: 52
    },
    {
      value: 3512704,
      label: "Corumbataí",
      reference: 35
    },
    {
      value: 4106555,
      label: "Corumbataí do Sul",
      reference: 41
    },
    {
      value: 1100072,
      label: "Corumbiara",
      reference: 11
    },
    {
      value: 4204509,
      label: "Corupá",
      reference: 42
    },
    {
      value: 2702306,
      label: "Coruripe",
      reference: 27
    },
    {
      value: 3512803,
      label: "Cosmópolis",
      reference: 35
    },
    {
      value: 3512902,
      label: "Cosmorama",
      reference: 35
    },
    {
      value: 1100080,
      label: "Costa Marques",
      reference: 11
    },
    {
      value: 5003256,
      label: "Costa Rica",
      reference: 50
    },
    {
      value: 2909406,
      label: "Cotegipe",
      reference: 29
    },
    {
      value: 3513009,
      label: "Cotia",
      reference: 35
    },
    {
      value: 4305959,
      label: "Cotiporã",
      reference: 43
    },
    {
      value: 5103379,
      label: "Cotriguaçu",
      reference: 51
    },
    {
      value: 3120102,
      label: "Couto de Magalhães de Minas",
      reference: 31
    },
    {
      value: 1706001,
      label: "Couto Magalhães",
      reference: 17
    },
    {
      value: 4305975,
      label: "Coxilha",
      reference: 43
    },
    {
      value: 5003306,
      label: "Coxim",
      reference: 50
    },
    {
      value: 2504850,
      label: "Coxixola",
      reference: 25
    },
    {
      value: 2702355,
      label: "Craíbas",
      reference: 27
    },
    {
      value: 2304103,
      label: "Crateús",
      reference: 23
    },
    {
      value: 2304202,
      label: "Crato",
      reference: 23
    },
    {
      value: 3513108,
      label: "Cravinhos",
      reference: 35
    },
    {
      value: 2909505,
      label: "Cravolândia",
      reference: 29
    },
    {
      value: 4204608,
      label: "Criciúma",
      reference: 42
    },
    {
      value: 3120151,
      label: "Crisólita",
      reference: 31
    },
    {
      value: 2909604,
      label: "Crisópolis",
      reference: 29
    },
    {
      value: 4306007,
      label: "Crissiumal",
      reference: 43
    },
    {
      value: 3120201,
      label: "Cristais",
      reference: 31
    },
    {
      value: 3513207,
      label: "Cristais Paulista",
      reference: 35
    },
    {
      value: 4306056,
      label: "Cristal",
      reference: 43
    },
    {
      value: 4306072,
      label: "Cristal do Sul",
      reference: 43
    },
    {
      value: 1706100,
      label: "Cristalândia",
      reference: 17
    },
    {
      value: 2203008,
      label: "Cristalândia do Piauí",
      reference: 22
    },
    {
      value: 3120300,
      label: "Cristália",
      reference: 31
    },
    {
      value: 5206206,
      label: "Cristalina",
      reference: 52
    },
    {
      value: 3120409,
      label: "Cristiano Otoni",
      reference: 31
    },
    {
      value: 5206305,
      label: "Cristianópolis",
      reference: 52
    },
    {
      value: 3120508,
      label: "Cristina",
      reference: 31
    },
    {
      value: 2801702,
      label: "Cristinápolis",
      reference: 28
    },
    {
      value: 2203107,
      label: "Cristino Castro",
      reference: 22
    },
    {
      value: 2909703,
      label: "Cristópolis",
      reference: 29
    },
    {
      value: 5206404,
      label: "Crixás",
      reference: 52
    },
    {
      value: 1706258,
      label: "Crixás do Tocantins",
      reference: 17
    },
    {
      value: 2304236,
      label: "Croatá",
      reference: 23
    },
    {
      value: 5206503,
      label: "Cromínia",
      reference: 52
    },
    {
      value: 3120607,
      label: "Crucilândia",
      reference: 31
    },
    {
      value: 2304251,
      label: "Cruz",
      reference: 23
    },
    {
      value: 4306106,
      label: "Cruz Alta",
      reference: 43
    },
    {
      value: 2909802,
      label: "Cruz das Almas",
      reference: 29
    },
    {
      value: 2504900,
      label: "Cruz do Espírito Santo",
      reference: 25
    },
    {
      value: 4106803,
      label: "Cruz Machado",
      reference: 41
    },
    {
      value: 3513306,
      label: "Cruzália",
      reference: 35
    },
    {
      value: 4306130,
      label: "Cruzaltense",
      reference: 43
    },
    {
      value: 3513405,
      label: "Cruzeiro",
      reference: 35
    },
    {
      value: 3120706,
      label: "Cruzeiro da Fortaleza",
      reference: 31
    },
    {
      value: 4106571,
      label: "Cruzeiro do Iguaçu",
      reference: 41
    },
    {
      value: 4106605,
      label: "Cruzeiro do Oeste",
      reference: 41
    },
    {
      value: 4106704,
      label: "Cruzeiro do Sul",
      reference: 41
    },
    {
      value: 4306205,
      label: "Cruzeiro do Sul",
      reference: 43
    },
    {
      value: 1200203,
      label: "Cruzeiro do Sul",
      reference: 12
    },
    {
      value: 2403004,
      label: "Cruzeta",
      reference: 24
    },
    {
      value: 3120805,
      label: "Cruzília",
      reference: 31
    },
    {
      value: 4106852,
      label: "Cruzmaltina",
      reference: 41
    },
    {
      value: 3513504,
      label: "Cubatão",
      reference: 35
    },
    {
      value: 2505006,
      label: "Cubati",
      reference: 25
    },
    {
      value: 5103403,
      label: "Cuiabá",
      reference: 51
    },
    {
      value: 2505105,
      label: "Cuité",
      reference: 25
    },
    {
      value: 2505238,
      label: "Cuité de Mamanguape",
      reference: 25
    },
    {
      value: 2505204,
      label: "Cuitegi",
      reference: 25
    },
    {
      value: 1100940,
      label: "Cujubim",
      reference: 11
    },
    {
      value: 5206602,
      label: "Cumari",
      reference: 52
    },
    {
      value: 2604908,
      label: "Cumaru",
      reference: 26
    },
    {
      value: 1502764,
      label: "Cumaru do Norte",
      reference: 15
    },
    {
      value: 2801900,
      label: "Cumbe",
      reference: 28
    },
    {
      value: 3513603,
      label: "Cunha",
      reference: 35
    },
    {
      value: 4204707,
      label: "Cunha Porã",
      reference: 42
    },
    {
      value: 4204756,
      label: "Cunhataí",
      reference: 42
    },
    {
      value: 3120839,
      label: "Cuparaque",
      reference: 31
    },
    {
      value: 2605004,
      label: "Cupira",
      reference: 26
    },
    {
      value: 2909901,
      label: "Curaçá",
      reference: 29
    },
    {
      value: 2203206,
      label: "Curimatá",
      reference: 22
    },
    {
      value: 1502772,
      label: "Curionópolis",
      reference: 15
    },
    {
      value: 4106902,
      label: "Curitiba",
      reference: 41
    },
    {
      value: 4204806,
      label: "Curitibanos",
      reference: 42
    },
    {
      value: 4107009,
      label: "Curiúva",
      reference: 41
    },
    {
      value: 2203230,
      label: "Currais",
      reference: 22
    },
    {
      value: 2403103,
      label: "Currais Novos",
      reference: 24
    },
    {
      value: 2505279,
      label: "Curral de Cima",
      reference: 25
    },
    {
      value: 3120870,
      label: "Curral de Dentro",
      reference: 31
    },
    {
      value: 2203271,
      label: "Curral Novo do Piauí",
      reference: 22
    },
    {
      value: 2505303,
      label: "Curral Velho",
      reference: 25
    },
    {
      value: 1502806,
      label: "Curralinho",
      reference: 15
    },
    {
      value: 2203255,
      label: "Curralinhos",
      reference: 22
    },
    {
      value: 1502855,
      label: "Curuá",
      reference: 15
    },
    {
      value: 1502905,
      label: "Curuçá",
      reference: 15
    },
    {
      value: 2103703,
      label: "Cururupu",
      reference: 21
    },
    {
      value: 5103437,
      label: "Curvelândia",
      reference: 51
    },
    {
      value: 3120904,
      label: "Curvelo",
      reference: 31
    },
    {
      value: 2605103,
      label: "Custódia",
      reference: 26
    },
    {
      value: 1600212,
      label: "Cutias",
      reference: 16
    },
    {
      value: 5206701,
      label: "Damianópolis",
      reference: 52
    },
    {
      value: 2505352,
      label: "Damião",
      reference: 25
    },
    {
      value: 5206800,
      label: "Damolândia",
      reference: 52
    },
    {
      value: 1706506,
      label: "Darcinópolis",
      reference: 17
    },
    {
      value: 2910008,
      label: "Dário Meira",
      reference: 29
    },
    {
      value: 3121001,
      label: "Datas",
      reference: 31
    },
    {
      value: 4306304,
      label: "David Canabarro",
      reference: 43
    },
    {
      value: 2103752,
      label: "Davinópolis",
      reference: 21
    },
    {
      value: 5206909,
      label: "Davinópolis",
      reference: 52
    },
    {
      value: 3121100,
      label: "Delfim Moreira",
      reference: 31
    },
    {
      value: 3121209,
      label: "Delfinópolis",
      reference: 31
    },
    {
      value: 2702405,
      label: "Delmiro Gouveia",
      reference: 27
    },
    {
      value: 3121258,
      label: "Delta",
      reference: 31
    },
    {
      value: 2203305,
      label: "Demerval Lobão",
      reference: 22
    },
    {
      value: 5103452,
      label: "Denise",
      reference: 51
    },
    {
      value: 5003454,
      label: "Deodápolis",
      reference: 50
    },
    {
      value: 2304269,
      label: "Deputado Irapuan Pinheiro",
      reference: 23
    },
    {
      value: 4306320,
      label: "Derrubadas",
      reference: 43
    },
    {
      value: 3513702,
      label: "Descalvado",
      reference: 35
    },
    {
      value: 4204905,
      label: "Descanso",
      reference: 42
    },
    {
      value: 3121308,
      label: "Descoberto",
      reference: 31
    },
    {
      value: 2505402,
      label: "Desterro",
      reference: 25
    },
    {
      value: 3121407,
      label: "Desterro de Entre Rios",
      reference: 31
    },
    {
      value: 3121506,
      label: "Desterro do Melo",
      reference: 31
    },
    {
      value: 4306353,
      label: "Dezesseis de Novembro",
      reference: 43
    },
    {
      value: 3513801,
      label: "Diadema",
      reference: 35
    },
    {
      value: 2505600,
      label: "Diamante",
      reference: 25
    },
    {
      value: 4107157,
      label: "Diamante D'Oeste",
      reference: 41
    },
    {
      value: 4107108,
      label: "Diamante do Norte",
      reference: 41
    },
    {
      value: 4107124,
      label: "Diamante do Sul",
      reference: 41
    },
    {
      value: 3121605,
      label: "Diamantina",
      reference: 31
    },
    {
      value: 5103502,
      label: "Diamantino",
      reference: 51
    },
    {
      value: 1707009,
      label: "Dianópolis",
      reference: 17
    },
    {
      value: 2910057,
      label: "Dias d'Ávila",
      reference: 29
    },
    {
      value: 4306379,
      label: "Dilermando de Aguiar",
      reference: 43
    },
    {
      value: 3121704,
      label: "Diogo de Vasconcelos",
      reference: 31
    },
    {
      value: 3121803,
      label: "Dionísio",
      reference: 31
    },
    {
      value: 4205001,
      label: "Dionísio Cerqueira",
      reference: 42
    },
    {
      value: 5207105,
      label: "Diorama",
      reference: 52
    },
    {
      value: 3513850,
      label: "Dirce Reis",
      reference: 35
    },
    {
      value: 2203354,
      label: "Dirceu Arcoverde",
      reference: 22
    },
    {
      value: 2802007,
      label: "Divina Pastora",
      reference: 28
    },
    {
      value: 3121902,
      label: "Divinésia",
      reference: 31
    },
    {
      value: 3122009,
      label: "Divino",
      reference: 31
    },
    {
      value: 3122108,
      label: "Divino das Laranjeiras",
      reference: 31
    },
    {
      value: 3201803,
      label: "Divino de São Lourenço",
      reference: 32
    },
    {
      value: 3513900,
      label: "Divinolândia",
      reference: 35
    },
    {
      value: 3122207,
      label: "Divinolândia de Minas",
      reference: 31
    },
    {
      value: 3122306,
      label: "Divinópolis",
      reference: 31
    },
    {
      value: 5208301,
      label: "Divinópolis de Goiás",
      reference: 52
    },
    {
      value: 1707108,
      label: "Divinópolis do Tocantins",
      reference: 17
    },
    {
      value: 3122355,
      label: "Divisa Alegre",
      reference: 31
    },
    {
      value: 3122405,
      label: "Divisa Nova",
      reference: 31
    },
    {
      value: 3122454,
      label: "Divisópolis",
      reference: 31
    },
    {
      value: 3514007,
      label: "Dobrada",
      reference: 35
    },
    {
      value: 3514106,
      label: "Dois Córregos",
      reference: 35
    },
    {
      value: 4306403,
      label: "Dois Irmãos",
      reference: 43
    },
    {
      value: 4306429,
      label: "Dois Irmãos das Missões",
      reference: 43
    },
    {
      value: 5003488,
      label: "Dois Irmãos do Buriti",
      reference: 50
    },
    {
      value: 1707207,
      label: "Dois Irmãos do Tocantins",
      reference: 17
    },
    {
      value: 4306452,
      label: "Dois Lajeados",
      reference: 43
    },
    {
      value: 2702504,
      label: "Dois Riachos",
      reference: 27
    },
    {
      value: 4107207,
      label: "Dois Vizinhos",
      reference: 41
    },
    {
      value: 3514205,
      label: "Dolcinópolis",
      reference: 35
    },
    {
      value: 5103601,
      label: "Dom Aquino",
      reference: 51
    },
    {
      value: 2910107,
      label: "Dom Basílio",
      reference: 29
    },
    {
      value: 3122470,
      label: "Dom Bosco",
      reference: 31
    },
    {
      value: 3122504,
      label: "Dom Cavati",
      reference: 31
    },
    {
      value: 1502939,
      label: "Dom Eliseu",
      reference: 15
    },
    {
      value: 2203404,
      label: "Dom Expedito Lopes",
      reference: 22
    },
    {
      value: 4306502,
      label: "Dom Feliciano",
      reference: 43
    },
    {
      value: 2203453,
      label: "Dom Inocêncio",
      reference: 22
    },
    {
      value: 3122603,
      label: "Dom Joaquim",
      reference: 31
    },
    {
      value: 2910206,
      label: "Dom Macedo Costa",
      reference: 29
    },
    {
      value: 4306601,
      label: "Dom Pedrito",
      reference: 43
    },
    {
      value: 2103802,
      label: "Dom Pedro",
      reference: 21
    },
    {
      value: 4306551,
      label: "Dom Pedro de Alcântara",
      reference: 43
    },
    {
      value: 3122702,
      label: "Dom Silvério",
      reference: 31
    },
    {
      value: 3122801,
      label: "Dom Viçoso",
      reference: 31
    },
    {
      value: 3201902,
      label: "Domingos Martins",
      reference: 32
    },
    {
      value: 2203420,
      label: "Domingos Mourão",
      reference: 22
    },
    {
      value: 4205100,
      label: "Dona Emma",
      reference: 42
    },
    {
      value: 3122900,
      label: "Dona Eusébia",
      reference: 31
    },
    {
      value: 4306700,
      label: "Dona Francisca",
      reference: 43
    },
    {
      value: 2505709,
      label: "Dona Inês",
      reference: 25
    },
    {
      value: 3123007,
      label: "Dores de Campos",
      reference: 31
    },
    {
      value: 3123106,
      label: "Dores de Guanhães",
      reference: 31
    },
    {
      value: 3123205,
      label: "Dores do Indaiá",
      reference: 31
    },
    {
      value: 3202009,
      label: "Dores do Rio Preto",
      reference: 32
    },
    {
      value: 3123304,
      label: "Dores do Turvo",
      reference: 31
    },
    {
      value: 3123403,
      label: "Doresópolis",
      reference: 31
    },
    {
      value: 2605152,
      label: "Dormentes",
      reference: 26
    },
    {
      value: 5003504,
      label: "Douradina",
      reference: 50
    },
    {
      value: 4107256,
      label: "Douradina",
      reference: 41
    },
    {
      value: 3514304,
      label: "Dourado",
      reference: 35
    },
    {
      value: 3123502,
      label: "Douradoquara",
      reference: 31
    },
    {
      value: 5003702,
      label: "Dourados",
      reference: 50
    },
    {
      value: 4107306,
      label: "Doutor Camargo",
      reference: 41
    },
    {
      value: 4306734,
      label: "Doutor Maurício Cardoso",
      reference: 43
    },
    {
      value: 4205159,
      label: "Doutor Pedrinho",
      reference: 42
    },
    {
      value: 4306759,
      label: "Doutor Ricardo",
      reference: 43
    },
    {
      value: 2403202,
      label: "Doutor Severiano",
      reference: 24
    },
    {
      value: 4128633,
      label: "Doutor Ulysses",
      reference: 41
    },
    {
      value: 5207253,
      label: "Doverlândia",
      reference: 52
    },
    {
      value: 3514403,
      label: "Dracena",
      reference: 35
    },
    {
      value: 3514502,
      label: "Duartina",
      reference: 35
    },
    {
      value: 3301603,
      label: "Duas Barras",
      reference: 33
    },
    {
      value: 2505808,
      label: "Duas Estradas",
      reference: 25
    },
    {
      value: 1707306,
      label: "Dueré",
      reference: 17
    },
    {
      value: 3514601,
      label: "Dumont",
      reference: 35
    },
    {
      value: 2103901,
      label: "Duque Bacelar",
      reference: 21
    },
    {
      value: 3301702,
      label: "Duque de Caxias",
      reference: 33
    },
    {
      value: 3123528,
      label: "Durandé",
      reference: 31
    },
    {
      value: 3514700,
      label: "Echaporã",
      reference: 35
    },
    {
      value: 3202108,
      label: "Ecoporanga",
      reference: 32
    },
    {
      value: 5207352,
      label: "Edealina",
      reference: 52
    },
    {
      value: 5207402,
      label: "Edéia",
      reference: 52
    },
    {
      value: 1301407,
      label: "Eirunepé",
      reference: 13
    },
    {
      value: 5003751,
      label: "Eldorado",
      reference: 50
    },
    {
      value: 3514809,
      label: "Eldorado",
      reference: 35
    },
    {
      value: 1502954,
      label: "Eldorado do Carajás",
      reference: 15
    },
    {
      value: 4306767,
      label: "Eldorado do Sul",
      reference: 43
    },
    {
      value: 2203503,
      label: "Elesbão Veloso",
      reference: 22
    },
    {
      value: 3514908,
      label: "Elias Fausto",
      reference: 35
    },
    {
      value: 2203602,
      label: "Eliseu Martins",
      reference: 22
    },
    {
      value: 3514924,
      label: "Elisiário",
      reference: 35
    },
    {
      value: 2910305,
      label: "Elísio Medrado",
      reference: 29
    },
    {
      value: 3123601,
      label: "Elói Mendes",
      reference: 31
    },
    {
      value: 2505907,
      label: "Emas",
      reference: 25
    },
    {
      value: 3514957,
      label: "Embaúba",
      reference: 35
    },
    {
      value: 3515004,
      label: "Embu das Artes",
      reference: 35
    },
    {
      value: 3515103,
      label: "Embu-Guaçu",
      reference: 35
    },
    {
      value: 3515129,
      label: "Emilianópolis",
      reference: 35
    },
    {
      value: 4306809,
      label: "Encantado",
      reference: 43
    },
    {
      value: 2403301,
      label: "Encanto",
      reference: 24
    },
    {
      value: 2910404,
      label: "Encruzilhada",
      reference: 29
    },
    {
      value: 4306908,
      label: "Encruzilhada do Sul",
      reference: 43
    },
    {
      value: 4107405,
      label: "Enéas Marques",
      reference: 41
    },
    {
      value: 4107504,
      label: "Engenheiro Beltrão",
      reference: 41
    },
    {
      value: 3123700,
      label: "Engenheiro Caldas",
      reference: 31
    },
    {
      value: 3515152,
      label: "Engenheiro Coelho",
      reference: 35
    },
    {
      value: 3123809,
      label: "Engenheiro Navarro",
      reference: 31
    },
    {
      value: 3301801,
      label: "Engenheiro Paulo de Frontin",
      reference: 33
    },
    {
      value: 4306924,
      label: "Engenho Velho",
      reference: 43
    },
    {
      value: 3123858,
      label: "Entre Folhas",
      reference: 31
    },
    {
      value: 2910503,
      label: "Entre Rios",
      reference: 29
    },
    {
      value: 4205175,
      label: "Entre Rios",
      reference: 42
    },
    {
      value: 3123908,
      label: "Entre Rios de Minas",
      reference: 31
    },
    {
      value: 4107538,
      label: "Entre Rios do Oeste",
      reference: 41
    },
    {
      value: 4306957,
      label: "Entre Rios do Sul",
      reference: 43
    },
    {
      value: 4306932,
      label: "Entre-Ijuís",
      reference: 43
    },
    {
      value: 1301506,
      label: "Envira",
      reference: 13
    },
    {
      value: 1200252,
      label: "Epitaciolândia",
      reference: 12
    },
    {
      value: 2403400,
      label: "Equador",
      reference: 24
    },
    {
      value: 4306973,
      label: "Erebango",
      reference: 43
    },
    {
      value: 4307005,
      label: "Erechim",
      reference: 43
    },
    {
      value: 2304277,
      label: "Ererê",
      reference: 23
    },
    {
      value: 2900504,
      label: "Érico Cardoso",
      reference: 29
    },
    {
      value: 4205191,
      label: "Ermo",
      reference: 42
    },
    {
      value: 4307054,
      label: "Ernestina",
      reference: 43
    },
    {
      value: 4307203,
      label: "Erval Grande",
      reference: 43
    },
    {
      value: 4307302,
      label: "Erval Seco",
      reference: 43
    },
    {
      value: 4205209,
      label: "Erval Velho",
      reference: 42
    },
    {
      value: 3124005,
      label: "Ervália",
      reference: 31
    },
    {
      value: 2605202,
      label: "Escada",
      reference: 26
    },
    {
      value: 4307401,
      label: "Esmeralda",
      reference: 43
    },
    {
      value: 3124104,
      label: "Esmeraldas",
      reference: 31
    },
    {
      value: 3124203,
      label: "Espera Feliz",
      reference: 31
    },
    {
      value: 2506004,
      label: "Esperança",
      reference: 25
    },
    {
      value: 4307450,
      label: "Esperança do Sul",
      reference: 43
    },
    {
      value: 4107520,
      label: "Esperança Nova",
      reference: 41
    },
    {
      value: 1707405,
      label: "Esperantina",
      reference: 17
    },
    {
      value: 2203701,
      label: "Esperantina",
      reference: 22
    },
    {
      value: 2104008,
      label: "Esperantinópolis",
      reference: 21
    },
    {
      value: 4107546,
      label: "Espigão Alto do Iguaçu",
      reference: 41
    },
    {
      value: 1100098,
      label: "Espigão D'Oeste",
      reference: 11
    },
    {
      value: 3124302,
      label: "Espinosa",
      reference: 31
    },
    {
      value: 2403509,
      label: "Espírito Santo",
      reference: 24
    },
    {
      value: 3124401,
      label: "Espírito Santo do Dourado",
      reference: 31
    },
    {
      value: 3515186,
      label: "Espírito Santo do Pinhal",
      reference: 35
    },
    {
      value: 3515194,
      label: "Espírito Santo do Turvo",
      reference: 35
    },
    {
      value: 2910602,
      label: "Esplanada",
      reference: 29
    },
    {
      value: 4307500,
      label: "Espumoso",
      reference: 43
    },
    {
      value: 4307559,
      label: "Estação",
      reference: 43
    },
    {
      value: 2802106,
      label: "Estância",
      reference: 28
    },
    {
      value: 4307609,
      label: "Estância Velha",
      reference: 43
    },
    {
      value: 4307708,
      label: "Esteio",
      reference: 43
    },
    {
      value: 3124500,
      label: "Estiva",
      reference: 31
    },
    {
      value: 3557303,
      label: "Estiva Gerbi",
      reference: 35
    },
    {
      value: 2104057,
      label: "Estreito",
      reference: 21
    },
    {
      value: 4307807,
      label: "Estrela",
      reference: 43
    },
    {
      value: 3515202,
      label: "Estrela d'Oeste",
      reference: 35
    },
    {
      value: 3124609,
      label: "Estrela Dalva",
      reference: 31
    },
    {
      value: 2702553,
      label: "Estrela de Alagoas",
      reference: 27
    },
    {
      value: 3124708,
      label: "Estrela do Indaiá",
      reference: 31
    },
    {
      value: 5207501,
      label: "Estrela do Norte",
      reference: 52
    },
    {
      value: 3515301,
      label: "Estrela do Norte",
      reference: 35
    },
    {
      value: 3124807,
      label: "Estrela do Sul",
      reference: 31
    },
    {
      value: 4307815,
      label: "Estrela Velha",
      reference: 43
    },
    {
      value: 2910701,
      label: "Euclides da Cunha",
      reference: 29
    },
    {
      value: 3515350,
      label: "Euclides da Cunha Paulista",
      reference: 35
    },
    {
      value: 4307831,
      label: "Eugênio de Castro",
      reference: 43
    },
    {
      value: 3124906,
      label: "Eugenópolis",
      reference: 31
    },
    {
      value: 2910727,
      label: "Eunápolis",
      reference: 29
    },
    {
      value: 2304285,
      label: "Eusébio",
      reference: 23
    },
    {
      value: 3125002,
      label: "Ewbank da Câmara",
      reference: 31
    },
    {
      value: 3125101,
      label: "Extrema",
      reference: 31
    },
    {
      value: 2403608,
      label: "Extremoz",
      reference: 24
    },
    {
      value: 2605301,
      label: "Exu",
      reference: 26
    },
    {
      value: 2506103,
      label: "Fagundes",
      reference: 25
    },
    {
      value: 4307864,
      label: "Fagundes Varela",
      reference: 43
    },
    {
      value: 5207535,
      label: "Faina",
      reference: 52
    },
    {
      value: 3125200,
      label: "Fama",
      reference: 31
    },
    {
      value: 3125309,
      label: "Faria Lemos",
      reference: 31
    },
    {
      value: 2304301,
      label: "Farias Brito",
      reference: 23
    },
    {
      value: 1503002,
      label: "Faro",
      reference: 15
    },
    {
      value: 4107553,
      label: "Farol",
      reference: 41
    },
    {
      value: 4307906,
      label: "Farroupilha",
      reference: 43
    },
    {
      value: 3515400,
      label: "Fartura",
      reference: 35
    },
    {
      value: 2203750,
      label: "Fartura do Piauí",
      reference: 22
    },
    {
      value: 1707553,
      label: "Fátima",
      reference: 17
    },
    {
      value: 2910750,
      label: "Fátima",
      reference: 29
    },
    {
      value: 5003801,
      label: "Fátima do Sul",
      reference: 50
    },
    {
      value: 4107603,
      label: "Faxinal",
      reference: 41
    },
    {
      value: 4308003,
      label: "Faxinal do Soturno",
      reference: 43
    },
    {
      value: 4205308,
      label: "Faxinal dos Guedes",
      reference: 42
    },
    {
      value: 4308052,
      label: "Faxinalzinho",
      reference: 43
    },
    {
      value: 5207600,
      label: "Fazenda Nova",
      reference: 52
    },
    {
      value: 4107652,
      label: "Fazenda Rio Grande",
      reference: 41
    },
    {
      value: 4308078,
      label: "Fazenda Vilanova",
      reference: 43
    },
    {
      value: 1200302,
      label: "Feijó",
      reference: 12
    },
    {
      value: 2910776,
      label: "Feira da Mata",
      reference: 29
    },
    {
      value: 2910800,
      label: "Feira de Santana",
      reference: 29
    },
    {
      value: 2702603,
      label: "Feira Grande",
      reference: 27
    },
    {
      value: 2605400,
      label: "Feira Nova",
      reference: 26
    },
    {
      value: 2802205,
      label: "Feira Nova",
      reference: 28
    },
    {
      value: 2104073,
      label: "Feira Nova do Maranhão",
      reference: 21
    },
    {
      value: 3125408,
      label: "Felício dos Santos",
      reference: 31
    },
    {
      value: 2403707,
      label: "Felipe Guerra",
      reference: 24
    },
    {
      value: 3125606,
      label: "Felisburgo",
      reference: 31
    },
    {
      value: 3125705,
      label: "Felixlândia",
      reference: 31
    },
    {
      value: 4308102,
      label: "Feliz",
      reference: 43
    },
    {
      value: 2702702,
      label: "Feliz Deserto",
      reference: 27
    },
    {
      value: 5103700,
      label: "Feliz Natal",
      reference: 51
    },
    {
      value: 4107702,
      label: "Fênix",
      reference: 41
    },
    {
      value: 4107736,
      label: "Fernandes Pinheiro",
      reference: 41
    },
    {
      value: 3125804,
      label: "Fernandes Tourinho",
      reference: 31
    },
    {
      value: 2605459,
      label: "Fernando de Noronha",
      reference: 26
    },
    {
      value: 2104081,
      label: "Fernando Falcão",
      reference: 21
    },
    {
      value: 2403756,
      label: "Fernando Pedroza",
      reference: 24
    },
    {
      value: 3515608,
      label: "Fernando Prestes",
      reference: 35
    },
    {
      value: 3515509,
      label: "Fernandópolis",
      reference: 35
    },
    {
      value: 3515657,
      label: "Fernão",
      reference: 35
    },
    {
      value: 3515707,
      label: "Ferraz de Vasconcelos",
      reference: 35
    },
    {
      value: 1600238,
      label: "Ferreira Gomes",
      reference: 16
    },
    {
      value: 2605509,
      label: "Ferreiros",
      reference: 26
    },
    {
      value: 3125903,
      label: "Ferros",
      reference: 31
    },
    {
      value: 3125952,
      label: "Fervedouro",
      reference: 31
    },
    {
      value: 4107751,
      label: "Figueira",
      reference: 41
    },
    {
      value: 5003900,
      label: "Figueirão",
      reference: 50
    },
    {
      value: 1707652,
      label: "Figueirópolis",
      reference: 17
    },
    {
      value: 5103809,
      label: "Figueirópolis D'Oeste",
      reference: 51
    },
    {
      value: 1707702,
      label: "Filadélfia",
      reference: 17
    },
    {
      value: 2910859,
      label: "Filadélfia",
      reference: 29
    },
    {
      value: 2910909,
      label: "Firmino Alves",
      reference: 29
    },
    {
      value: 5207808,
      label: "Firminópolis",
      reference: 52
    },
    {
      value: 2702801,
      label: "Flexeiras",
      reference: 27
    },
    {
      value: 4107850,
      label: "Flor da Serra do Sul",
      reference: 41
    },
    {
      value: 4205357,
      label: "Flor do Sertão",
      reference: 42
    },
    {
      value: 3515806,
      label: "Flora Rica",
      reference: 35
    },
    {
      value: 4107801,
      label: "Floraí",
      reference: 41
    },
    {
      value: 2403806,
      label: "Florânia",
      reference: 24
    },
    {
      value: 3515905,
      label: "Floreal",
      reference: 35
    },
    {
      value: 2605608,
      label: "Flores",
      reference: 26
    },
    {
      value: 4308201,
      label: "Flores da Cunha",
      reference: 43
    },
    {
      value: 5207907,
      label: "Flores de Goiás",
      reference: 52
    },
    {
      value: 2203800,
      label: "Flores do Piauí",
      reference: 22
    },
    {
      value: 4107900,
      label: "Floresta",
      reference: 41
    },
    {
      value: 2605707,
      label: "Floresta",
      reference: 26
    },
    {
      value: 2911006,
      label: "Floresta Azul",
      reference: 29
    },
    {
      value: 1503044,
      label: "Floresta do Araguaia",
      reference: 15
    },
    {
      value: 2203859,
      label: "Floresta do Piauí",
      reference: 22
    },
    {
      value: 3126000,
      label: "Florestal",
      reference: 31
    },
    {
      value: 4108007,
      label: "Florestópolis",
      reference: 41
    },
    {
      value: 2203909,
      label: "Floriano",
      reference: 22
    },
    {
      value: 4308250,
      label: "Floriano Peixoto",
      reference: 43
    },
    {
      value: 4205407,
      label: "Florianópolis",
      reference: 42
    },
    {
      value: 4108106,
      label: "Flórida",
      reference: 41
    },
    {
      value: 3516002,
      label: "Flórida Paulista",
      reference: 35
    },
    {
      value: 3516101,
      label: "Florínia",
      reference: 35
    },
    {
      value: 1301605,
      label: "Fonte Boa",
      reference: 13
    },
    {
      value: 4308300,
      label: "Fontoura Xavier",
      reference: 43
    },
    {
      value: 3126109,
      label: "Formiga",
      reference: 31
    },
    {
      value: 4308409,
      label: "Formigueiro",
      reference: 43
    },
    {
      value: 5208004,
      label: "Formosa",
      reference: 52
    },
    {
      value: 2104099,
      label: "Formosa da Serra Negra",
      reference: 21
    },
    {
      value: 4108205,
      label: "Formosa do Oeste",
      reference: 41
    },
    {
      value: 2911105,
      label: "Formosa do Rio Preto",
      reference: 29
    },
    {
      value: 4205431,
      label: "Formosa do Sul",
      reference: 42
    },
    {
      value: 5208103,
      label: "Formoso",
      reference: 52
    },
    {
      value: 3126208,
      label: "Formoso",
      reference: 31
    },
    {
      value: 1708205,
      label: "Formoso do Araguaia",
      reference: 17
    },
    {
      value: 4308433,
      label: "Forquetinha",
      reference: 43
    },
    {
      value: 2304350,
      label: "Forquilha",
      reference: 23
    },
    {
      value: 4205456,
      label: "Forquilhinha",
      reference: 42
    },
    {
      value: 2304400,
      label: "Fortaleza",
      reference: 23
    },
    {
      value: 3126307,
      label: "Fortaleza de Minas",
      reference: 31
    },
    {
      value: 1708254,
      label: "Fortaleza do Tabocão",
      reference: 17
    },
    {
      value: 2104107,
      label: "Fortaleza dos Nogueiras",
      reference: 21
    },
    {
      value: 4308458,
      label: "Fortaleza dos Valos",
      reference: 43
    },
    {
      value: 2304459,
      label: "Fortim",
      reference: 23
    },
    {
      value: 2104206,
      label: "Fortuna",
      reference: 21
    },
    {
      value: 3126406,
      label: "Fortuna de Minas",
      reference: 31
    },
    {
      value: 4108304,
      label: "Foz do Iguaçu",
      reference: 41
    },
    {
      value: 4108452,
      label: "Foz do Jordão",
      reference: 41
    },
    {
      value: 4205506,
      label: "Fraiburgo",
      reference: 42
    },
    {
      value: 3516200,
      label: "Franca",
      reference: 35
    },
    {
      value: 2204006,
      label: "Francinópolis",
      reference: 22
    },
    {
      value: 4108320,
      label: "Francisco Alves",
      reference: 41
    },
    {
      value: 2204105,
      label: "Francisco Ayres",
      reference: 22
    },
    {
      value: 3126505,
      label: "Francisco Badaró",
      reference: 31
    },
    {
      value: 4108403,
      label: "Francisco Beltrão",
      reference: 41
    },
    {
      value: 2403905,
      label: "Francisco Dantas",
      reference: 24
    },
    {
      value: 3126604,
      label: "Francisco Dumont",
      reference: 31
    },
    {
      value: 2204154,
      label: "Francisco Macedo",
      reference: 22
    },
    {
      value: 3516309,
      label: "Francisco Morato",
      reference: 35
    },
    {
      value: 3126703,
      label: "Francisco Sá",
      reference: 31
    },
    {
      value: 2204204,
      label: "Francisco Santos",
      reference: 22
    },
    {
      value: 3126752,
      label: "Franciscópolis",
      reference: 31
    },
    {
      value: 3516408,
      label: "Franco da Rocha",
      reference: 35
    },
    {
      value: 2304509,
      label: "Frecheirinha",
      reference: 23
    },
    {
      value: 4308508,
      label: "Frederico Westphalen",
      reference: 43
    },
    {
      value: 3126802,
      label: "Frei Gaspar",
      reference: 31
    },
    {
      value: 3126901,
      label: "Frei Inocêncio",
      reference: 31
    },
    {
      value: 3126950,
      label: "Frei Lagonegro",
      reference: 31
    },
    {
      value: 2506202,
      label: "Frei Martinho",
      reference: 25
    },
    {
      value: 2605806,
      label: "Frei Miguelinho",
      reference: 26
    },
    {
      value: 2802304,
      label: "Frei Paulo",
      reference: 28
    },
    {
      value: 4205555,
      label: "Frei Rogério",
      reference: 42
    },
    {
      value: 3127008,
      label: "Fronteira",
      reference: 31
    },
    {
      value: 3127057,
      label: "Fronteira dos Vales",
      reference: 31
    },
    {
      value: 2204303,
      label: "Fronteiras",
      reference: 22
    },
    {
      value: 3127073,
      label: "Fruta de Leite",
      reference: 31
    },
    {
      value: 3127107,
      label: "Frutal",
      reference: 31
    },
    {
      value: 2404002,
      label: "Frutuoso Gomes",
      reference: 24
    },
    {
      value: 3202207,
      label: "Fundão",
      reference: 32
    },
    {
      value: 3127206,
      label: "Funilândia",
      reference: 31
    },
    {
      value: 3516507,
      label: "Gabriel Monteiro",
      reference: 35
    },
    {
      value: 2506251,
      label: "Gado Bravo",
      reference: 25
    },
    {
      value: 3516606,
      label: "Gália",
      reference: 35
    },
    {
      value: 3127305,
      label: "Galiléia",
      reference: 31
    },
    {
      value: 2404101,
      label: "Galinhos",
      reference: 24
    },
    {
      value: 4205605,
      label: "Galvão",
      reference: 42
    },
    {
      value: 2605905,
      label: "Gameleira",
      reference: 26
    },
    {
      value: 5208152,
      label: "Gameleira de Goiás",
      reference: 52
    },
    {
      value: 3127339,
      label: "Gameleiras",
      reference: 31
    },
    {
      value: 2911204,
      label: "Gandu",
      reference: 29
    },
    {
      value: 2606002,
      label: "Garanhuns",
      reference: 26
    },
    {
      value: 2802403,
      label: "Gararu",
      reference: 28
    },
    {
      value: 3516705,
      label: "Garça",
      reference: 35
    },
    {
      value: 4308607,
      label: "Garibaldi",
      reference: 43
    },
    {
      value: 4205704,
      label: "Garopaba",
      reference: 42
    },
    {
      value: 1503077,
      label: "Garrafão do Norte",
      reference: 15
    },
    {
      value: 4308656,
      label: "Garruchos",
      reference: 43
    },
    {
      value: 4205803,
      label: "Garuva",
      reference: 42
    },
    {
      value: 4205902,
      label: "Gaspar",
      reference: 42
    },
    {
      value: 3516804,
      label: "Gastão Vidigal",
      reference: 35
    },
    {
      value: 5103858,
      label: "Gaúcha do Norte",
      reference: 51
    },
    {
      value: 4308706,
      label: "Gaurama",
      reference: 43
    },
    {
      value: 2911253,
      label: "Gavião",
      reference: 29
    },
    {
      value: 3516853,
      label: "Gavião Peixoto",
      reference: 35
    },
    {
      value: 2204352,
      label: "Geminiano",
      reference: 22
    },
    {
      value: 4308805,
      label: "General Câmara",
      reference: 43
    },
    {
      value: 5103908,
      label: "General Carneiro",
      reference: 51
    },
    {
      value: 4108502,
      label: "General Carneiro",
      reference: 41
    },
    {
      value: 2802502,
      label: "General Maynard",
      reference: 28
    },
    {
      value: 3516903,
      label: "General Salgado",
      reference: 35
    },
    {
      value: 2304608,
      label: "General Sampaio",
      reference: 23
    },
    {
      value: 4308854,
      label: "Gentil",
      reference: 43
    },
    {
      value: 2911303,
      label: "Gentio do Ouro",
      reference: 29
    },
    {
      value: 3517000,
      label: "Getulina",
      reference: 35
    },
    {
      value: 4308904,
      label: "Getúlio Vargas",
      reference: 43
    },
    {
      value: 2204402,
      label: "Gilbués",
      reference: 22
    },
    {
      value: 2702900,
      label: "Girau do Ponciano",
      reference: 27
    },
    {
      value: 4309001,
      label: "Giruá",
      reference: 43
    },
    {
      value: 3127354,
      label: "Glaucilândia",
      reference: 31
    },
    {
      value: 3517109,
      label: "Glicério",
      reference: 35
    },
    {
      value: 2911402,
      label: "Glória",
      reference: 29
    },
    {
      value: 5103957,
      label: "Glória D'Oeste",
      reference: 51
    },
    {
      value: 5004007,
      label: "Glória de Dourados",
      reference: 50
    },
    {
      value: 2606101,
      label: "Glória do Goitá",
      reference: 26
    },
    {
      value: 4309050,
      label: "Glorinha",
      reference: 43
    },
    {
      value: 2104305,
      label: "Godofredo Viana",
      reference: 21
    },
    {
      value: 4108551,
      label: "Godoy Moreira",
      reference: 41
    },
    {
      value: 3127370,
      label: "Goiabeira",
      reference: 31
    },
    {
      value: 3127388,
      label: "Goianá",
      reference: 31
    },
    {
      value: 2606200,
      label: "Goiana",
      reference: 26
    },
    {
      value: 5208400,
      label: "Goianápolis",
      reference: 52
    },
    {
      value: 5208509,
      label: "Goiandira",
      reference: 52
    },
    {
      value: 5208608,
      label: "Goianésia",
      reference: 52
    },
    {
      value: 1503093,
      label: "Goianésia do Pará",
      reference: 15
    },
    {
      value: 5208707,
      label: "Goiânia",
      reference: 52
    },
    {
      value: 2404200,
      label: "Goianinha",
      reference: 24
    },
    {
      value: 5208806,
      label: "Goianira",
      reference: 52
    },
    {
      value: 1708304,
      label: "Goianorte",
      reference: 17
    },
    {
      value: 5208905,
      label: "Goiás",
      reference: 52
    },
    {
      value: 1709005,
      label: "Goiatins",
      reference: 17
    },
    {
      value: 5209101,
      label: "Goiatuba",
      reference: 52
    },
    {
      value: 4108601,
      label: "Goioerê",
      reference: 41
    },
    {
      value: 4108650,
      label: "Goioxim",
      reference: 41
    },
    {
      value: 3127404,
      label: "Gonçalves",
      reference: 31
    },
    {
      value: 2104404,
      label: "Gonçalves Dias",
      reference: 21
    },
    {
      value: 2911501,
      label: "Gongogi",
      reference: 29
    },
    {
      value: 3127503,
      label: "Gonzaga",
      reference: 31
    },
    {
      value: 3127602,
      label: "Gouveia",
      reference: 31
    },
    {
      value: 5209150,
      label: "Gouvelândia",
      reference: 52
    },
    {
      value: 2104503,
      label: "Governador Archer",
      reference: 21
    },
    {
      value: 4206009,
      label: "Governador Celso Ramos",
      reference: 42
    },
    {
      value: 2404309,
      label: "Governador Dix-Sept Rosado",
      reference: 24
    },
    {
      value: 2104552,
      label: "Governador Edison Lobão",
      reference: 21
    },
    {
      value: 2104602,
      label: "Governador Eugênio Barros",
      reference: 21
    },
    {
      value: 1101005,
      label: "Governador Jorge Teixeira",
      reference: 11
    },
    {
      value: 3202256,
      label: "Governador Lindenberg",
      reference: 32
    },
    {
      value: 2104628,
      label: "Governador Luiz Rocha",
      reference: 21
    },
    {
      value: 2911600,
      label: "Governador Mangabeira",
      reference: 29
    },
    {
      value: 2104651,
      label: "Governador Newton Bello",
      reference: 21
    },
    {
      value: 2104677,
      label: "Governador Nunes Freire",
      reference: 21
    },
    {
      value: 3127701,
      label: "Governador Valadares",
      reference: 31
    },
    {
      value: 2304657,
      label: "Graça",
      reference: 23
    },
    {
      value: 2104701,
      label: "Graça Aranha",
      reference: 21
    },
    {
      value: 2802601,
      label: "Gracho Cardoso",
      reference: 28
    },
    {
      value: 2104800,
      label: "Grajaú",
      reference: 21
    },
    {
      value: 4309100,
      label: "Gramado",
      reference: 43
    },
    {
      value: 4309126,
      label: "Gramado dos Loureiros",
      reference: 43
    },
    {
      value: 4309159,
      label: "Gramado Xavier",
      reference: 43
    },
    {
      value: 4108700,
      label: "Grandes Rios",
      reference: 41
    },
    {
      value: 2606309,
      label: "Granito",
      reference: 26
    },
    {
      value: 2304707,
      label: "Granja",
      reference: 23
    },
    {
      value: 2304806,
      label: "Granjeiro",
      reference: 23
    },
    {
      value: 3127800,
      label: "Grão Mogol",
      reference: 31
    },
    {
      value: 4206108,
      label: "Grão Pará",
      reference: 42
    },
    {
      value: 2606408,
      label: "Gravatá",
      reference: 26
    },
    {
      value: 4309209,
      label: "Gravataí",
      reference: 43
    },
    {
      value: 4206207,
      label: "Gravatal",
      reference: 42
    },
    {
      value: 2304905,
      label: "Groaíras",
      reference: 23
    },
    {
      value: 2404408,
      label: "Grossos",
      reference: 24
    },
    {
      value: 3127909,
      label: "Grupiara",
      reference: 31
    },
    {
      value: 4309258,
      label: "Guabiju",
      reference: 43
    },
    {
      value: 4206306,
      label: "Guabiruba",
      reference: 42
    },
    {
      value: 3202306,
      label: "Guaçuí",
      reference: 32
    },
    {
      value: 2204501,
      label: "Guadalupe",
      reference: 22
    },
    {
      value: 4309308,
      label: "Guaíba",
      reference: 43
    },
    {
      value: 3517208,
      label: "Guaiçara",
      reference: 35
    },
    {
      value: 3517307,
      label: "Guaimbê",
      reference: 35
    },
    {
      value: 3517406,
      label: "Guaíra",
      reference: 35
    },
    {
      value: 4108809,
      label: "Guaíra",
      reference: 41
    },
    {
      value: 4108908,
      label: "Guairaçá",
      reference: 41
    },
    {
      value: 2304954,
      label: "Guaiúba",
      reference: 23
    },
    {
      value: 1301654,
      label: "Guajará",
      reference: 13
    },
    {
      value: 1100106,
      label: "Guajará-Mirim",
      reference: 11
    },
    {
      value: 2911659,
      label: "Guajeru",
      reference: 29
    },
    {
      value: 2404507,
      label: "Guamaré",
      reference: 24
    },
    {
      value: 4108957,
      label: "Guamiranga",
      reference: 41
    },
    {
      value: 2911709,
      label: "Guanambi",
      reference: 29
    },
    {
      value: 3128006,
      label: "Guanhães",
      reference: 31
    },
    {
      value: 3128105,
      label: "Guapé",
      reference: 31
    },
    {
      value: 3517505,
      label: "Guapiaçu",
      reference: 35
    },
    {
      value: 3517604,
      label: "Guapiara",
      reference: 35
    },
    {
      value: 3301850,
      label: "Guapimirim",
      reference: 33
    },
    {
      value: 4109005,
      label: "Guapirama",
      reference: 41
    },
    {
      value: 5209200,
      label: "Guapó",
      reference: 52
    },
    {
      value: 4309407,
      label: "Guaporé",
      reference: 43
    },
    {
      value: 4109104,
      label: "Guaporema",
      reference: 41
    },
    {
      value: 3517703,
      label: "Guará",
      reference: 35
    },
    {
      value: 2506301,
      label: "Guarabira",
      reference: 25
    },
    {
      value: 3517802,
      label: "Guaraçaí",
      reference: 35
    },
    {
      value: 3517901,
      label: "Guaraci",
      reference: 35
    },
    {
      value: 4109203,
      label: "Guaraci",
      reference: 41
    },
    {
      value: 3128204,
      label: "Guaraciaba",
      reference: 31
    },
    {
      value: 4206405,
      label: "Guaraciaba",
      reference: 42
    },
    {
      value: 2305001,
      label: "Guaraciaba do Norte",
      reference: 23
    },
    {
      value: 3128253,
      label: "Guaraciama",
      reference: 31
    },
    {
      value: 1709302,
      label: "Guaraí",
      reference: 17
    },
    {
      value: 5209291,
      label: "Guaraíta",
      reference: 52
    },
    {
      value: 2305100,
      label: "Guaramiranga",
      reference: 23
    },
    {
      value: 4206504,
      label: "Guaramirim",
      reference: 42
    },
    {
      value: 3128303,
      label: "Guaranésia",
      reference: 31
    },
    {
      value: 3128402,
      label: "Guarani",
      reference: 31
    },
    {
      value: 3518008,
      label: "Guarani d'Oeste",
      reference: 35
    },
    {
      value: 4309506,
      label: "Guarani das Missões",
      reference: 43
    },
    {
      value: 5209408,
      label: "Guarani de Goiás",
      reference: 52
    },
    {
      value: 4109302,
      label: "Guaraniaçu",
      reference: 41
    },
    {
      value: 3518107,
      label: "Guarantã",
      reference: 35
    },
    {
      value: 5104104,
      label: "Guarantã do Norte",
      reference: 51
    },
    {
      value: 3202405,
      label: "Guarapari",
      reference: 32
    },
    {
      value: 4109401,
      label: "Guarapuava",
      reference: 41
    },
    {
      value: 4109500,
      label: "Guaraqueçaba",
      reference: 41
    },
    {
      value: 3128501,
      label: "Guarará",
      reference: 31
    },
    {
      value: 3518206,
      label: "Guararapes",
      reference: 35
    },
    {
      value: 3518305,
      label: "Guararema",
      reference: 35
    },
    {
      value: 2911808,
      label: "Guaratinga",
      reference: 29
    },
    {
      value: 3518404,
      label: "Guaratinguetá",
      reference: 35
    },
    {
      value: 4109609,
      label: "Guaratuba",
      reference: 41
    },
    {
      value: 3128600,
      label: "Guarda-Mor",
      reference: 31
    },
    {
      value: 3518503,
      label: "Guareí",
      reference: 35
    },
    {
      value: 3518602,
      label: "Guariba",
      reference: 35
    },
    {
      value: 2204550,
      label: "Guaribas",
      reference: 22
    },
    {
      value: 5209457,
      label: "Guarinos",
      reference: 52
    },
    {
      value: 3518701,
      label: "Guarujá",
      reference: 35
    },
    {
      value: 4206603,
      label: "Guarujá do Sul",
      reference: 42
    },
    {
      value: 3518800,
      label: "Guarulhos",
      reference: 35
    },
    {
      value: 4206652,
      label: "Guatambú",
      reference: 42
    },
    {
      value: 3518859,
      label: "Guatapará",
      reference: 35
    },
    {
      value: 3128709,
      label: "Guaxupé",
      reference: 31
    },
    {
      value: 5004106,
      label: "Guia Lopes da Laguna",
      reference: 50
    },
    {
      value: 3128808,
      label: "Guidoval",
      reference: 31
    },
    {
      value: 2104909,
      label: "Guimarães",
      reference: 21
    },
    {
      value: 3128907,
      label: "Guimarânia",
      reference: 31
    },
    {
      value: 5104203,
      label: "Guiratinga",
      reference: 51
    },
    {
      value: 3129004,
      label: "Guiricema",
      reference: 31
    },
    {
      value: 3129103,
      label: "Gurinhatã",
      reference: 31
    },
    {
      value: 2506400,
      label: "Gurinhém",
      reference: 25
    },
    {
      value: 2506509,
      label: "Gurjão",
      reference: 25
    },
    {
      value: 1503101,
      label: "Gurupá",
      reference: 15
    },
    {
      value: 1709500,
      label: "Gurupi",
      reference: 17
    },
    {
      value: 3518909,
      label: "Guzolândia",
      reference: 35
    },
    {
      value: 4309555,
      label: "Harmonia",
      reference: 43
    },
    {
      value: 5209606,
      label: "Heitoraí",
      reference: 52
    },
    {
      value: 3129202,
      label: "Heliodora",
      reference: 31
    },
    {
      value: 2911857,
      label: "Heliópolis",
      reference: 29
    },
    {
      value: 3519006,
      label: "Herculândia",
      reference: 35
    },
    {
      value: 4307104,
      label: "Herval",
      reference: 43
    },
    {
      value: 4206702,
      label: "Herval d'Oeste",
      reference: 42
    },
    {
      value: 4309571,
      label: "Herveiras",
      reference: 43
    },
    {
      value: 5209705,
      label: "Hidrolândia",
      reference: 52
    },
    {
      value: 2305209,
      label: "Hidrolândia",
      reference: 23
    },
    {
      value: 5209804,
      label: "Hidrolina",
      reference: 52
    },
    {
      value: 3519055,
      label: "Holambra",
      reference: 35
    },
    {
      value: 4109658,
      label: "Honório Serpa",
      reference: 41
    },
    {
      value: 2305233,
      label: "Horizonte",
      reference: 23
    },
    {
      value: 4309605,
      label: "Horizontina",
      reference: 43
    },
    {
      value: 3519071,
      label: "Hortolândia",
      reference: 35
    },
    {
      value: 2204600,
      label: "Hugo Napoleão",
      reference: 22
    },
    {
      value: 4309654,
      label: "Hulha Negra",
      reference: 43
    },
    {
      value: 4309704,
      label: "Humaitá",
      reference: 43
    },
    {
      value: 1301704,
      label: "Humaitá",
      reference: 13
    },
    {
      value: 2105005,
      label: "Humberto de Campos",
      reference: 21
    },
    {
      value: 3519105,
      label: "Iacanga",
      reference: 35
    },
    {
      value: 5209903,
      label: "Iaciara",
      reference: 52
    },
    {
      value: 3519204,
      label: "Iacri",
      reference: 35
    },
    {
      value: 2911907,
      label: "Iaçu",
      reference: 29
    },
    {
      value: 3129301,
      label: "Iapu",
      reference: 31
    },
    {
      value: 3519253,
      label: "Iaras",
      reference: 35
    },
    {
      value: 2606507,
      label: "Iati",
      reference: 26
    },
    {
      value: 4109708,
      label: "Ibaiti",
      reference: 41
    },
    {
      value: 4309753,
      label: "Ibarama",
      reference: 43
    },
    {
      value: 2305266,
      label: "Ibaretama",
      reference: 23
    },
    {
      value: 3519303,
      label: "Ibaté",
      reference: 35
    },
    {
      value: 2703007,
      label: "Ibateguara",
      reference: 27
    },
    {
      value: 3202454,
      label: "Ibatiba",
      reference: 32
    },
    {
      value: 4109757,
      label: "Ibema",
      reference: 41
    },
    {
      value: 3129400,
      label: "Ibertioga",
      reference: 31
    },
    {
      value: 3129509,
      label: "Ibiá",
      reference: 31
    },
    {
      value: 4309803,
      label: "Ibiaçá",
      reference: 43
    },
    {
      value: 3129608,
      label: "Ibiaí",
      reference: 31
    },
    {
      value: 4206751,
      label: "Ibiam",
      reference: 42
    },
    {
      value: 2305308,
      label: "Ibiapina",
      reference: 23
    },
    {
      value: 2506608,
      label: "Ibiara",
      reference: 25
    },
    {
      value: 2912004,
      label: "Ibiassucê",
      reference: 29
    },
    {
      value: 2912103,
      label: "Ibicaraí",
      reference: 29
    },
    {
      value: 4206801,
      label: "Ibicaré",
      reference: 42
    },
    {
      value: 2912202,
      label: "Ibicoara",
      reference: 29
    },
    {
      value: 2912301,
      label: "Ibicuí",
      reference: 29
    },
    {
      value: 2305332,
      label: "Ibicuitinga",
      reference: 23
    },
    {
      value: 2606606,
      label: "Ibimirim",
      reference: 26
    },
    {
      value: 2912400,
      label: "Ibipeba",
      reference: 29
    },
    {
      value: 2912509,
      label: "Ibipitanga",
      reference: 29
    },
    {
      value: 4109807,
      label: "Ibiporã",
      reference: 41
    },
    {
      value: 2912608,
      label: "Ibiquera",
      reference: 29
    },
    {
      value: 3519402,
      label: "Ibirá",
      reference: 35
    },
    {
      value: 3129657,
      label: "Ibiracatu",
      reference: 31
    },
    {
      value: 3129707,
      label: "Ibiraci",
      reference: 31
    },
    {
      value: 3202504,
      label: "Ibiraçu",
      reference: 32
    },
    {
      value: 4309902,
      label: "Ibiraiaras",
      reference: 43
    },
    {
      value: 2606705,
      label: "Ibirajuba",
      reference: 26
    },
    {
      value: 4206900,
      label: "Ibirama",
      reference: 42
    },
    {
      value: 2912707,
      label: "Ibirapitanga",
      reference: 29
    },
    {
      value: 2912806,
      label: "Ibirapuã",
      reference: 29
    },
    {
      value: 4309951,
      label: "Ibirapuitã",
      reference: 43
    },
    {
      value: 3519501,
      label: "Ibirarema",
      reference: 35
    },
    {
      value: 2912905,
      label: "Ibirataia",
      reference: 29
    },
    {
      value: 3129806,
      label: "Ibirité",
      reference: 31
    },
    {
      value: 4310009,
      label: "Ibirubá",
      reference: 43
    },
    {
      value: 2913002,
      label: "Ibitiara",
      reference: 29
    },
    {
      value: 3519600,
      label: "Ibitinga",
      reference: 35
    },
    {
      value: 3202553,
      label: "Ibitirama",
      reference: 32
    },
    {
      value: 2913101,
      label: "Ibititá",
      reference: 29
    },
    {
      value: 3129905,
      label: "Ibitiúra de Minas",
      reference: 31
    },
    {
      value: 3130002,
      label: "Ibituruna",
      reference: 31
    },
    {
      value: 3519709,
      label: "Ibiúna",
      reference: 35
    },
    {
      value: 2913200,
      label: "Ibotirama",
      reference: 29
    },
    {
      value: 2305357,
      label: "Icapuí",
      reference: 23
    },
    {
      value: 4207007,
      label: "Içara",
      reference: 42
    },
    {
      value: 3130051,
      label: "Icaraí de Minas",
      reference: 31
    },
    {
      value: 4109906,
      label: "Icaraíma",
      reference: 41
    },
    {
      value: 2105104,
      label: "Icatu",
      reference: 21
    },
    {
      value: 3519808,
      label: "Icém",
      reference: 35
    },
    {
      value: 2913309,
      label: "Ichu",
      reference: 29
    },
    {
      value: 2305407,
      label: "Icó",
      reference: 23
    },
    {
      value: 3202603,
      label: "Iconha",
      reference: 32
    },
    {
      value: 2404606,
      label: "Ielmo Marinho",
      reference: 24
    },
    {
      value: 3519907,
      label: "Iepê",
      reference: 35
    },
    {
      value: 2703106,
      label: "Igaci",
      reference: 27
    },
    {
      value: 2913408,
      label: "Igaporã",
      reference: 29
    },
    {
      value: 3520004,
      label: "Igaraçu do Tietê",
      reference: 35
    },
    {
      value: 2502607,
      label: "Igaracy",
      reference: 25
    },
    {
      value: 3520103,
      label: "Igarapava",
      reference: 35
    },
    {
      value: 3130101,
      label: "Igarapé",
      reference: 31
    },
    {
      value: 2105153,
      label: "Igarapé do Meio",
      reference: 21
    },
    {
      value: 2105203,
      label: "Igarapé Grande",
      reference: 21
    },
    {
      value: 1503200,
      label: "Igarapé-Açu",
      reference: 15
    },
    {
      value: 1503309,
      label: "Igarapé-Miri",
      reference: 15
    },
    {
      value: 2606804,
      label: "Igarassu",
      reference: 26
    },
    {
      value: 3520202,
      label: "Igaratá",
      reference: 35
    },
    {
      value: 3130200,
      label: "Igaratinga",
      reference: 31
    },
    {
      value: 2913457,
      label: "Igrapiúna",
      reference: 29
    },
    {
      value: 2703205,
      label: "Igreja Nova",
      reference: 27
    },
    {
      value: 4310108,
      label: "Igrejinha",
      reference: 43
    },
    {
      value: 3301876,
      label: "Iguaba Grande",
      reference: 33
    },
    {
      value: 2913507,
      label: "Iguaí",
      reference: 29
    },
    {
      value: 3520301,
      label: "Iguape",
      reference: 35
    },
    {
      value: 4110003,
      label: "Iguaraçu",
      reference: 41
    },
    {
      value: 2606903,
      label: "Iguaracy",
      reference: 26
    },
    {
      value: 3130309,
      label: "Iguatama",
      reference: 31
    },
    {
      value: 5004304,
      label: "Iguatemi",
      reference: 50
    },
    {
      value: 2305506,
      label: "Iguatu",
      reference: 23
    },
    {
      value: 4110052,
      label: "Iguatu",
      reference: 41
    },
    {
      value: 3130408,
      label: "Ijaci",
      reference: 31
    },
    {
      value: 4310207,
      label: "Ijuí",
      reference: 43
    },
    {
      value: 3520426,
      label: "Ilha Comprida",
      reference: 35
    },
    {
      value: 2802700,
      label: "Ilha das Flores",
      reference: 28
    },
    {
      value: 2607604,
      label: "Ilha de Itamaracá",
      reference: 26
    },
    {
      value: 2204659,
      label: "Ilha Grande",
      reference: 22
    },
    {
      value: 3520442,
      label: "Ilha Solteira",
      reference: 35
    },
    {
      value: 3520400,
      label: "Ilhabela",
      reference: 35
    },
    {
      value: 2913606,
      label: "Ilhéus",
      reference: 29
    },
    {
      value: 4207106,
      label: "Ilhota",
      reference: 42
    },
    {
      value: 3130507,
      label: "Ilicínea",
      reference: 31
    },
    {
      value: 4310306,
      label: "Ilópolis",
      reference: 43
    },
    {
      value: 2506707,
      label: "Imaculada",
      reference: 25
    },
    {
      value: 4207205,
      label: "Imaruí",
      reference: 42
    },
    {
      value: 4110078,
      label: "Imbaú",
      reference: 41
    },
    {
      value: 4310330,
      label: "Imbé",
      reference: 43
    },
    {
      value: 3130556,
      label: "Imbé de Minas",
      reference: 31
    },
    {
      value: 4207304,
      label: "Imbituba",
      reference: 42
    },
    {
      value: 4110102,
      label: "Imbituva",
      reference: 41
    },
    {
      value: 4207403,
      label: "Imbuia",
      reference: 42
    },
    {
      value: 4310363,
      label: "Imigrante",
      reference: 43
    },
    {
      value: 2105302,
      label: "Imperatriz",
      reference: 21
    },
    {
      value: 4110201,
      label: "Inácio Martins",
      reference: 41
    },
    {
      value: 5209937,
      label: "Inaciolândia",
      reference: 52
    },
    {
      value: 2607000,
      label: "Inajá",
      reference: 26
    },
    {
      value: 4110300,
      label: "Inajá",
      reference: 41
    },
    {
      value: 3130606,
      label: "Inconfidentes",
      reference: 31
    },
    {
      value: 3130655,
      label: "Indaiabira",
      reference: 31
    },
    {
      value: 4207502,
      label: "Indaial",
      reference: 42
    },
    {
      value: 3520509,
      label: "Indaiatuba",
      reference: 35
    },
    {
      value: 4310405,
      label: "Independência",
      reference: 43
    },
    {
      value: 2305605,
      label: "Independência",
      reference: 23
    },
    {
      value: 3520608,
      label: "Indiana",
      reference: 35
    },
    {
      value: 4110409,
      label: "Indianópolis",
      reference: 41
    },
    {
      value: 3130705,
      label: "Indianópolis",
      reference: 31
    },
    {
      value: 3520707,
      label: "Indiaporã",
      reference: 35
    },
    {
      value: 5209952,
      label: "Indiara",
      reference: 52
    },
    {
      value: 2802809,
      label: "Indiaroba",
      reference: 28
    },
    {
      value: 5104500,
      label: "Indiavaí",
      reference: 51
    },
    {
      value: 2506806,
      label: "Ingá",
      reference: 25
    },
    {
      value: 3130804,
      label: "Ingaí",
      reference: 31
    },
    {
      value: 2607109,
      label: "Ingazeira",
      reference: 26
    },
    {
      value: 4310413,
      label: "Inhacorá",
      reference: 43
    },
    {
      value: 2913705,
      label: "Inhambupe",
      reference: 29
    },
    {
      value: 1503408,
      label: "Inhangapi",
      reference: 15
    },
    {
      value: 2703304,
      label: "Inhapi",
      reference: 27
    },
    {
      value: 3130903,
      label: "Inhapim",
      reference: 31
    },
    {
      value: 3131000,
      label: "Inhaúma",
      reference: 31
    },
    {
      value: 2204709,
      label: "Inhuma",
      reference: 22
    },
    {
      value: 5210000,
      label: "Inhumas",
      reference: 52
    },
    {
      value: 3131109,
      label: "Inimutaba",
      reference: 31
    },
    {
      value: 5004403,
      label: "Inocência",
      reference: 50
    },
    {
      value: 3520806,
      label: "Inúbia Paulista",
      reference: 35
    },
    {
      value: 4207577,
      label: "Iomerê",
      reference: 42
    },
    {
      value: 3131158,
      label: "Ipaba",
      reference: 31
    },
    {
      value: 5210109,
      label: "Ipameri",
      reference: 52
    },
    {
      value: 3131208,
      label: "Ipanema",
      reference: 31
    },
    {
      value: 2404705,
      label: "Ipanguaçu",
      reference: 24
    },
    {
      value: 2305654,
      label: "Ipaporanga",
      reference: 23
    },
    {
      value: 3131307,
      label: "Ipatinga",
      reference: 31
    },
    {
      value: 2305704,
      label: "Ipaumirim",
      reference: 23
    },
    {
      value: 3520905,
      label: "Ipaussu",
      reference: 35
    },
    {
      value: 4310439,
      label: "Ipê",
      reference: 43
    },
    {
      value: 2913804,
      label: "Ipecaetá",
      reference: 29
    },
    {
      value: 3521002,
      label: "Iperó",
      reference: 35
    },
    {
      value: 3521101,
      label: "Ipeúna",
      reference: 35
    },
    {
      value: 3131406,
      label: "Ipiaçu",
      reference: 31
    },
    {
      value: 2913903,
      label: "Ipiaú",
      reference: 29
    },
    {
      value: 3521150,
      label: "Ipiguá",
      reference: 35
    },
    {
      value: 2914000,
      label: "Ipirá",
      reference: 29
    },
    {
      value: 4207601,
      label: "Ipira",
      reference: 42
    },
    {
      value: 4110508,
      label: "Ipiranga",
      reference: 41
    },
    {
      value: 5210158,
      label: "Ipiranga de Goiás",
      reference: 52
    },
    {
      value: 5104526,
      label: "Ipiranga do Norte",
      reference: 51
    },
    {
      value: 2204808,
      label: "Ipiranga do Piauí",
      reference: 22
    },
    {
      value: 4310462,
      label: "Ipiranga do Sul",
      reference: 43
    },
    {
      value: 1301803,
      label: "Ipixuna",
      reference: 13
    },
    {
      value: 1503457,
      label: "Ipixuna do Pará",
      reference: 15
    },
    {
      value: 2607208,
      label: "Ipojuca",
      reference: 26
    },
    {
      value: 4110607,
      label: "Iporã",
      reference: 41
    },
    {
      value: 5210208,
      label: "Iporá",
      reference: 52
    },
    {
      value: 4207650,
      label: "Iporã do Oeste",
      reference: 42
    },
    {
      value: 3521200,
      label: "Iporanga",
      reference: 35
    },
    {
      value: 2305803,
      label: "Ipu",
      reference: 23
    },
    {
      value: 3521309,
      label: "Ipuã",
      reference: 35
    },
    {
      value: 4207684,
      label: "Ipuaçu",
      reference: 42
    },
    {
      value: 2607307,
      label: "Ipubi",
      reference: 26
    },
    {
      value: 2404804,
      label: "Ipueira",
      reference: 24
    },
    {
      value: 1709807,
      label: "Ipueiras",
      reference: 17
    },
    {
      value: 2305902,
      label: "Ipueiras",
      reference: 23
    },
    {
      value: 3131505,
      label: "Ipuiúna",
      reference: 31
    },
    {
      value: 4207700,
      label: "Ipumirim",
      reference: 42
    },
    {
      value: 2914109,
      label: "Ipupiara",
      reference: 29
    },
    {
      value: 1400282,
      label: "Iracema",
      reference: 14
    },
    {
      value: 2306009,
      label: "Iracema",
      reference: 23
    },
    {
      value: 4110656,
      label: "Iracema do Oeste",
      reference: 41
    },
    {
      value: 3521408,
      label: "Iracemápolis",
      reference: 35
    },
    {
      value: 4207759,
      label: "Iraceminha",
      reference: 42
    },
    {
      value: 4310504,
      label: "Iraí",
      reference: 43
    },
    {
      value: 3131604,
      label: "Iraí de Minas",
      reference: 31
    },
    {
      value: 2914208,
      label: "Irajuba",
      reference: 29
    },
    {
      value: 2914307,
      label: "Iramaia",
      reference: 29
    },
    {
      value: 1301852,
      label: "Iranduba",
      reference: 13
    },
    {
      value: 4207809,
      label: "Irani",
      reference: 42
    },
    {
      value: 3521507,
      label: "Irapuã",
      reference: 35
    },
    {
      value: 3521606,
      label: "Irapuru",
      reference: 35
    },
    {
      value: 2914406,
      label: "Iraquara",
      reference: 29
    },
    {
      value: 2914505,
      label: "Irará",
      reference: 29
    },
    {
      value: 4110706,
      label: "Irati",
      reference: 41
    },
    {
      value: 4207858,
      label: "Irati",
      reference: 42
    },
    {
      value: 2306108,
      label: "Irauçuba",
      reference: 23
    },
    {
      value: 2914604,
      label: "Irecê",
      reference: 29
    },
    {
      value: 4110805,
      label: "Iretama",
      reference: 41
    },
    {
      value: 4207908,
      label: "Irineópolis",
      reference: 42
    },
    {
      value: 1503507,
      label: "Irituia",
      reference: 15
    },
    {
      value: 3202652,
      label: "Irupi",
      reference: 32
    },
    {
      value: 2204907,
      label: "Isaías Coelho",
      reference: 22
    },
    {
      value: 5210307,
      label: "Israelândia",
      reference: 52
    },
    {
      value: 4208005,
      label: "Itá",
      reference: 42
    },
    {
      value: 4310538,
      label: "Itaara",
      reference: 43
    },
    {
      value: 2506905,
      label: "Itabaiana",
      reference: 25
    },
    {
      value: 2802908,
      label: "Itabaiana",
      reference: 28
    },
    {
      value: 2803005,
      label: "Itabaianinha",
      reference: 28
    },
    {
      value: 2914653,
      label: "Itabela",
      reference: 29
    },
    {
      value: 3521705,
      label: "Itaberá",
      reference: 35
    },
    {
      value: 2914703,
      label: "Itaberaba",
      reference: 29
    },
    {
      value: 5210406,
      label: "Itaberaí",
      reference: 52
    },
    {
      value: 2803104,
      label: "Itabi",
      reference: 28
    },
    {
      value: 3131703,
      label: "Itabira",
      reference: 31
    },
    {
      value: 3131802,
      label: "Itabirinha",
      reference: 31
    },
    {
      value: 3131901,
      label: "Itabirito",
      reference: 31
    },
    {
      value: 3301900,
      label: "Itaboraí",
      reference: 33
    },
    {
      value: 2914802,
      label: "Itabuna",
      reference: 29
    },
    {
      value: 1710508,
      label: "Itacajá",
      reference: 17
    },
    {
      value: 3132008,
      label: "Itacambira",
      reference: 31
    },
    {
      value: 3132107,
      label: "Itacarambi",
      reference: 31
    },
    {
      value: 2914901,
      label: "Itacaré",
      reference: 29
    },
    {
      value: 1301902,
      label: "Itacoatiara",
      reference: 13
    },
    {
      value: 2607406,
      label: "Itacuruba",
      reference: 26
    },
    {
      value: 4310553,
      label: "Itacurubi",
      reference: 43
    },
    {
      value: 2915007,
      label: "Itaeté",
      reference: 29
    },
    {
      value: 2915106,
      label: "Itagi",
      reference: 29
    },
    {
      value: 2915205,
      label: "Itagibá",
      reference: 29
    },
    {
      value: 2915304,
      label: "Itagimirim",
      reference: 29
    },
    {
      value: 3202702,
      label: "Itaguaçu",
      reference: 32
    },
    {
      value: 2915353,
      label: "Itaguaçu da Bahia",
      reference: 29
    },
    {
      value: 3302007,
      label: "Itaguaí",
      reference: 33
    },
    {
      value: 4110904,
      label: "Itaguajé",
      reference: 41
    },
    {
      value: 3132206,
      label: "Itaguara",
      reference: 31
    },
    {
      value: 5210562,
      label: "Itaguari",
      reference: 52
    },
    {
      value: 5210604,
      label: "Itaguaru",
      reference: 52
    },
    {
      value: 1710706,
      label: "Itaguatins",
      reference: 17
    },
    {
      value: 3521804,
      label: "Itaí",
      reference: 35
    },
    {
      value: 2607505,
      label: "Itaíba",
      reference: 26
    },
    {
      value: 2306207,
      label: "Itaiçaba",
      reference: 23
    },
    {
      value: 2205003,
      label: "Itainópolis",
      reference: 22
    },
    {
      value: 4208104,
      label: "Itaiópolis",
      reference: 42
    },
    {
      value: 2105351,
      label: "Itaipava do Grajaú",
      reference: 21
    },
    {
      value: 3132305,
      label: "Itaipé",
      reference: 31
    },
    {
      value: 4110953,
      label: "Itaipulândia",
      reference: 41
    },
    {
      value: 2306256,
      label: "Itaitinga",
      reference: 23
    },
    {
      value: 1503606,
      label: "Itaituba",
      reference: 15
    },
    {
      value: 2404853,
      label: "Itajá",
      reference: 24
    },
    {
      value: 5210802,
      label: "Itajá",
      reference: 52
    },
    {
      value: 4208203,
      label: "Itajaí",
      reference: 42
    },
    {
      value: 3521903,
      label: "Itajobi",
      reference: 35
    },
    {
      value: 3522000,
      label: "Itaju",
      reference: 35
    },
    {
      value: 2915403,
      label: "Itaju do Colônia",
      reference: 29
    },
    {
      value: 3132404,
      label: "Itajubá",
      reference: 31
    },
    {
      value: 2915502,
      label: "Itajuípe",
      reference: 29
    },
    {
      value: 3302056,
      label: "Italva",
      reference: 33
    },
    {
      value: 2915601,
      label: "Itamaraju",
      reference: 29
    },
    {
      value: 3132503,
      label: "Itamarandiba",
      reference: 31
    },
    {
      value: 1301951,
      label: "Itamarati",
      reference: 13
    },
    {
      value: 3132602,
      label: "Itamarati de Minas",
      reference: 31
    },
    {
      value: 2915700,
      label: "Itamari",
      reference: 29
    },
    {
      value: 3132701,
      label: "Itambacuri",
      reference: 31
    },
    {
      value: 4111001,
      label: "Itambaracá",
      reference: 41
    },
    {
      value: 4111100,
      label: "Itambé",
      reference: 41
    },
    {
      value: 2607653,
      label: "Itambé",
      reference: 26
    },
    {
      value: 2915809,
      label: "Itambé",
      reference: 29
    },
    {
      value: 3132800,
      label: "Itambé do Mato Dentro",
      reference: 31
    },
    {
      value: 3132909,
      label: "Itamogi",
      reference: 31
    },
    {
      value: 3133006,
      label: "Itamonte",
      reference: 31
    },
    {
      value: 2915908,
      label: "Itanagra",
      reference: 29
    },
    {
      value: 3522109,
      label: "Itanhaém",
      reference: 35
    },
    {
      value: 3133105,
      label: "Itanhandu",
      reference: 31
    },
    {
      value: 5104542,
      label: "Itanhangá",
      reference: 51
    },
    {
      value: 2916005,
      label: "Itanhém",
      reference: 29
    },
    {
      value: 3133204,
      label: "Itanhomi",
      reference: 31
    },
    {
      value: 3133303,
      label: "Itaobim",
      reference: 31
    },
    {
      value: 3522158,
      label: "Itaóca",
      reference: 35
    },
    {
      value: 3302106,
      label: "Itaocara",
      reference: 33
    },
    {
      value: 5210901,
      label: "Itapaci",
      reference: 52
    },
    {
      value: 3133402,
      label: "Itapagipe",
      reference: 31
    },
    {
      value: 2306306,
      label: "Itapajé",
      reference: 23
    },
    {
      value: 2916104,
      label: "Itaparica",
      reference: 29
    },
    {
      value: 2916203,
      label: "Itapé",
      reference: 29
    },
    {
      value: 2916302,
      label: "Itapebi",
      reference: 29
    },
    {
      value: 3133501,
      label: "Itapecerica",
      reference: 31
    },
    {
      value: 3522208,
      label: "Itapecerica da Serra",
      reference: 35
    },
    {
      value: 2105401,
      label: "Itapecuru Mirim",
      reference: 21
    },
    {
      value: 4111209,
      label: "Itapejara d'Oeste",
      reference: 41
    },
    {
      value: 4208302,
      label: "Itapema",
      reference: 42
    },
    {
      value: 3202801,
      label: "Itapemirim",
      reference: 32
    },
    {
      value: 4111258,
      label: "Itaperuçu",
      reference: 41
    },
    {
      value: 3302205,
      label: "Itaperuna",
      reference: 33
    },
    {
      value: 2607703,
      label: "Itapetim",
      reference: 26
    },
    {
      value: 2916401,
      label: "Itapetinga",
      reference: 29
    },
    {
      value: 3522307,
      label: "Itapetininga",
      reference: 35
    },
    {
      value: 3522406,
      label: "Itapeva",
      reference: 35
    },
    {
      value: 3133600,
      label: "Itapeva",
      reference: 31
    },
    {
      value: 3522505,
      label: "Itapevi",
      reference: 35
    },
    {
      value: 2916500,
      label: "Itapicuru",
      reference: 29
    },
    {
      value: 2306405,
      label: "Itapipoca",
      reference: 23
    },
    {
      value: 3522604,
      label: "Itapira",
      reference: 35
    },
    {
      value: 1302009,
      label: "Itapiranga",
      reference: 13
    },
    {
      value: 4208401,
      label: "Itapiranga",
      reference: 42
    },
    {
      value: 5211008,
      label: "Itapirapuã",
      reference: 52
    },
    {
      value: 3522653,
      label: "Itapirapuã Paulista",
      reference: 35
    },
    {
      value: 1710904,
      label: "Itapiratins",
      reference: 17
    },
    {
      value: 2607752,
      label: "Itapissuma",
      reference: 26
    },
    {
      value: 2916609,
      label: "Itapitanga",
      reference: 29
    },
    {
      value: 2306504,
      label: "Itapiúna",
      reference: 23
    },
    {
      value: 4208450,
      label: "Itapoá",
      reference: 42
    },
    {
      value: 3522703,
      label: "Itápolis",
      reference: 35
    },
    {
      value: 5004502,
      label: "Itaporã",
      reference: 50
    },
    {
      value: 1711100,
      label: "Itaporã do Tocantins",
      reference: 17
    },
    {
      value: 3522802,
      label: "Itaporanga",
      reference: 35
    },
    {
      value: 2507002,
      label: "Itaporanga",
      reference: 25
    },
    {
      value: 2803203,
      label: "Itaporanga d'Ajuda",
      reference: 28
    },
    {
      value: 2507101,
      label: "Itapororoca",
      reference: 25
    },
    {
      value: 1101104,
      label: "Itapuã do Oeste",
      reference: 11
    },
    {
      value: 4310579,
      label: "Itapuca",
      reference: 43
    },
    {
      value: 3522901,
      label: "Itapuí",
      reference: 35
    },
    {
      value: 3523008,
      label: "Itapura",
      reference: 35
    },
    {
      value: 5211206,
      label: "Itapuranga",
      reference: 52
    },
    {
      value: 3523107,
      label: "Itaquaquecetuba",
      reference: 35
    },
    {
      value: 2916708,
      label: "Itaquara",
      reference: 29
    },
    {
      value: 4310603,
      label: "Itaqui",
      reference: 43
    },
    {
      value: 5004601,
      label: "Itaquiraí",
      reference: 50
    },
    {
      value: 2607802,
      label: "Itaquitinga",
      reference: 26
    },
    {
      value: 3202900,
      label: "Itarana",
      reference: 32
    },
    {
      value: 2916807,
      label: "Itarantim",
      reference: 29
    },
    {
      value: 3523206,
      label: "Itararé",
      reference: 35
    },
    {
      value: 2306553,
      label: "Itarema",
      reference: 23
    },
    {
      value: 3523305,
      label: "Itariri",
      reference: 35
    },
    {
      value: 5211305,
      label: "Itarumã",
      reference: 52
    },
    {
      value: 4310652,
      label: "Itati",
      reference: 43
    },
    {
      value: 3302254,
      label: "Itatiaia",
      reference: 33
    },
    {
      value: 3133709,
      label: "Itatiaiuçu",
      reference: 31
    },
    {
      value: 3523404,
      label: "Itatiba",
      reference: 35
    },
    {
      value: 4310702,
      label: "Itatiba do Sul",
      reference: 43
    },
    {
      value: 2916856,
      label: "Itatim",
      reference: 29
    },
    {
      value: 3523503,
      label: "Itatinga",
      reference: 35
    },
    {
      value: 2306603,
      label: "Itatira",
      reference: 23
    },
    {
      value: 2507200,
      label: "Itatuba",
      reference: 25
    },
    {
      value: 2404903,
      label: "Itaú",
      reference: 24
    },
    {
      value: 3133758,
      label: "Itaú de Minas",
      reference: 31
    },
    {
      value: 5104559,
      label: "Itaúba",
      reference: 51
    },
    {
      value: 1600253,
      label: "Itaubal",
      reference: 16
    },
    {
      value: 5211404,
      label: "Itauçu",
      reference: 52
    },
    {
      value: 2205102,
      label: "Itaueira",
      reference: 22
    },
    {
      value: 3133808,
      label: "Itaúna",
      reference: 31
    },
    {
      value: 4111308,
      label: "Itaúna do Sul",
      reference: 41
    },
    {
      value: 3133907,
      label: "Itaverava",
      reference: 31
    },
    {
      value: 3134004,
      label: "Itinga",
      reference: 31
    },
    {
      value: 2105427,
      label: "Itinga do Maranhão",
      reference: 21
    },
    {
      value: 5104609,
      label: "Itiquira",
      reference: 51
    },
    {
      value: 3523602,
      label: "Itirapina",
      reference: 35
    },
    {
      value: 3523701,
      label: "Itirapuã",
      reference: 35
    },
    {
      value: 2916906,
      label: "Itiruçu",
      reference: 29
    },
    {
      value: 2917003,
      label: "Itiúba",
      reference: 29
    },
    {
      value: 3523800,
      label: "Itobi",
      reference: 35
    },
    {
      value: 2917102,
      label: "Itororó",
      reference: 29
    },
    {
      value: 3523909,
      label: "Itu",
      reference: 35
    },
    {
      value: 2917201,
      label: "Ituaçu",
      reference: 29
    },
    {
      value: 2917300,
      label: "Ituberá",
      reference: 29
    },
    {
      value: 3134103,
      label: "Itueta",
      reference: 31
    },
    {
      value: 3134202,
      label: "Ituiutaba",
      reference: 31
    },
    {
      value: 5211503,
      label: "Itumbiara",
      reference: 52
    },
    {
      value: 3134301,
      label: "Itumirim",
      reference: 31
    },
    {
      value: 3524006,
      label: "Itupeva",
      reference: 35
    },
    {
      value: 1503705,
      label: "Itupiranga",
      reference: 15
    },
    {
      value: 4208500,
      label: "Ituporanga",
      reference: 42
    },
    {
      value: 3134400,
      label: "Iturama",
      reference: 31
    },
    {
      value: 3134509,
      label: "Itutinga",
      reference: 31
    },
    {
      value: 3524105,
      label: "Ituverava",
      reference: 35
    },
    {
      value: 2917334,
      label: "Iuiú",
      reference: 29
    },
    {
      value: 3203007,
      label: "Iúna",
      reference: 32
    },
    {
      value: 4111407,
      label: "Ivaí",
      reference: 41
    },
    {
      value: 4111506,
      label: "Ivaiporã",
      reference: 41
    },
    {
      value: 4111555,
      label: "Ivaté",
      reference: 41
    },
    {
      value: 4111605,
      label: "Ivatuba",
      reference: 41
    },
    {
      value: 5004700,
      label: "Ivinhema",
      reference: 50
    },
    {
      value: 5211602,
      label: "Ivolândia",
      reference: 52
    },
    {
      value: 4310751,
      label: "Ivorá",
      reference: 43
    },
    {
      value: 4310801,
      label: "Ivoti",
      reference: 43
    },
    {
      value: 2607901,
      label: "Jaboatão dos Guararapes",
      reference: 26
    },
    {
      value: 4208609,
      label: "Jaborá",
      reference: 42
    },
    {
      value: 2917359,
      label: "Jaborandi",
      reference: 29
    },
    {
      value: 3524204,
      label: "Jaborandi",
      reference: 35
    },
    {
      value: 4111704,
      label: "Jaboti",
      reference: 41
    },
    {
      value: 4310850,
      label: "Jaboticaba",
      reference: 43
    },
    {
      value: 3524303,
      label: "Jaboticabal",
      reference: 35
    },
    {
      value: 3134608,
      label: "Jaboticatubas",
      reference: 31
    },
    {
      value: 2405009,
      label: "Jaçanã",
      reference: 24
    },
    {
      value: 2917409,
      label: "Jacaraci",
      reference: 29
    },
    {
      value: 2507309,
      label: "Jacaraú",
      reference: 25
    },
    {
      value: 2703403,
      label: "Jacaré dos Homens",
      reference: 27
    },
    {
      value: 1503754,
      label: "Jacareacanga",
      reference: 15
    },
    {
      value: 3524402,
      label: "Jacareí",
      reference: 35
    },
    {
      value: 4111803,
      label: "Jacarezinho",
      reference: 41
    },
    {
      value: 3524501,
      label: "Jaci",
      reference: 35
    },
    {
      value: 5104807,
      label: "Jaciara",
      reference: 51
    },
    {
      value: 3134707,
      label: "Jacinto",
      reference: 31
    },
    {
      value: 4208708,
      label: "Jacinto Machado",
      reference: 42
    },
    {
      value: 2917508,
      label: "Jacobina",
      reference: 29
    },
    {
      value: 2205151,
      label: "Jacobina do Piauí",
      reference: 22
    },
    {
      value: 3134806,
      label: "Jacuí",
      reference: 31
    },
    {
      value: 2703502,
      label: "Jacuípe",
      reference: 27
    },
    {
      value: 4310876,
      label: "Jacuizinho",
      reference: 43
    },
    {
      value: 1503804,
      label: "Jacundá",
      reference: 15
    },
    {
      value: 3524600,
      label: "Jacupiranga",
      reference: 35
    },
    {
      value: 4310900,
      label: "Jacutinga",
      reference: 43
    },
    {
      value: 3134905,
      label: "Jacutinga",
      reference: 31
    },
    {
      value: 4111902,
      label: "Jaguapitã",
      reference: 41
    },
    {
      value: 2917607,
      label: "Jaguaquara",
      reference: 29
    },
    {
      value: 3135001,
      label: "Jaguaraçu",
      reference: 31
    },
    {
      value: 4311007,
      label: "Jaguarão",
      reference: 43
    },
    {
      value: 2917706,
      label: "Jaguarari",
      reference: 29
    },
    {
      value: 3203056,
      label: "Jaguaré",
      reference: 32
    },
    {
      value: 2306702,
      label: "Jaguaretama",
      reference: 23
    },
    {
      value: 4311106,
      label: "Jaguari",
      reference: 43
    },
    {
      value: 4112009,
      label: "Jaguariaíva",
      reference: 41
    },
    {
      value: 2306801,
      label: "Jaguaribara",
      reference: 23
    },
    {
      value: 2306900,
      label: "Jaguaribe",
      reference: 23
    },
    {
      value: 2917805,
      label: "Jaguaripe",
      reference: 29
    },
    {
      value: 3524709,
      label: "Jaguariúna",
      reference: 35
    },
    {
      value: 2307007,
      label: "Jaguaruana",
      reference: 23
    },
    {
      value: 4208807,
      label: "Jaguaruna",
      reference: 42
    },
    {
      value: 3135050,
      label: "Jaíba",
      reference: 31
    },
    {
      value: 2205201,
      label: "Jaicós",
      reference: 22
    },
    {
      value: 3524808,
      label: "Jales",
      reference: 35
    },
    {
      value: 3524907,
      label: "Jambeiro",
      reference: 35
    },
    {
      value: 3135076,
      label: "Jampruca",
      reference: 31
    },
    {
      value: 3135100,
      label: "Janaúba",
      reference: 31
    },
    {
      value: 5211701,
      label: "Jandaia",
      reference: 52
    },
    {
      value: 4112108,
      label: "Jandaia do Sul",
      reference: 41
    },
    {
      value: 2405108,
      label: "Jandaíra",
      reference: 24
    },
    {
      value: 2917904,
      label: "Jandaíra",
      reference: 29
    },
    {
      value: 3525003,
      label: "Jandira",
      reference: 35
    },
    {
      value: 2405207,
      label: "Janduís",
      reference: 24
    },
    {
      value: 5104906,
      label: "Jangada",
      reference: 51
    },
    {
      value: 4112207,
      label: "Janiópolis",
      reference: 41
    },
    {
      value: 3135209,
      label: "Januária",
      reference: 31
    },
    {
      value: 2405306,
      label: "Januário Cicco (Boa Saúde)",
      reference: 24
    },
    {
      value: 3135308,
      label: "Japaraíba",
      reference: 31
    },
    {
      value: 2703601,
      label: "Japaratinga",
      reference: 27
    },
    {
      value: 2803302,
      label: "Japaratuba",
      reference: 28
    },
    {
      value: 3302270,
      label: "Japeri",
      reference: 33
    },
    {
      value: 2405405,
      label: "Japi",
      reference: 24
    },
    {
      value: 4112306,
      label: "Japira",
      reference: 41
    },
    {
      value: 2803401,
      label: "Japoatã",
      reference: 28
    },
    {
      value: 3135357,
      label: "Japonvar",
      reference: 31
    },
    {
      value: 5004809,
      label: "Japorã",
      reference: 50
    },
    {
      value: 4112405,
      label: "Japurá",
      reference: 41
    },
    {
      value: 1302108,
      label: "Japurá",
      reference: 13
    },
    {
      value: 2607950,
      label: "Jaqueira",
      reference: 26
    },
    {
      value: 4311122,
      label: "Jaquirana",
      reference: 43
    },
    {
      value: 5211800,
      label: "Jaraguá",
      reference: 52
    },
    {
      value: 4208906,
      label: "Jaraguá do Sul",
      reference: 42
    },
    {
      value: 5004908,
      label: "Jaraguari",
      reference: 50
    },
    {
      value: 2703700,
      label: "Jaramataia",
      reference: 27
    },
    {
      value: 2307106,
      label: "Jardim",
      reference: 23
    },
    {
      value: 5005004,
      label: "Jardim",
      reference: 50
    },
    {
      value: 4112504,
      label: "Jardim Alegre",
      reference: 41
    },
    {
      value: 2405504,
      label: "Jardim de Angicos",
      reference: 24
    },
    {
      value: 2405603,
      label: "Jardim de Piranhas",
      reference: 24
    },
    {
      value: 2205250,
      label: "Jardim do Mulato",
      reference: 22
    },
    {
      value: 2405702,
      label: "Jardim do Seridó",
      reference: 24
    },
    {
      value: 4112603,
      label: "Jardim Olinda",
      reference: 41
    },
    {
      value: 3525102,
      label: "Jardinópolis",
      reference: 35
    },
    {
      value: 4208955,
      label: "Jardinópolis",
      reference: 42
    },
    {
      value: 4311130,
      label: "Jari",
      reference: 43
    },
    {
      value: 3525201,
      label: "Jarinu",
      reference: 35
    },
    {
      value: 1100114,
      label: "Jaru",
      reference: 11
    },
    {
      value: 5211909,
      label: "Jataí",
      reference: 52
    },
    {
      value: 4112702,
      label: "Jataizinho",
      reference: 41
    },
    {
      value: 2608008,
      label: "Jataúba",
      reference: 26
    },
    {
      value: 5005103,
      label: "Jateí",
      reference: 50
    },
    {
      value: 2307205,
      label: "Jati",
      reference: 23
    },
    {
      value: 2105450,
      label: "Jatobá",
      reference: 21
    },
    {
      value: 2608057,
      label: "Jatobá",
      reference: 26
    },
    {
      value: 2205276,
      label: "Jatobá do Piauí",
      reference: 22
    },
    {
      value: 3525300,
      label: "Jaú",
      reference: 35
    },
    {
      value: 1711506,
      label: "Jaú do Tocantins",
      reference: 17
    },
    {
      value: 5212006,
      label: "Jaupaci",
      reference: 52
    },
    {
      value: 5105002,
      label: "Jauru",
      reference: 51
    },
    {
      value: 3135407,
      label: "Jeceaba",
      reference: 31
    },
    {
      value: 3135456,
      label: "Jenipapo de Minas",
      reference: 31
    },
    {
      value: 2105476,
      label: "Jenipapo dos Vieiras",
      reference: 21
    },
    {
      value: 3135506,
      label: "Jequeri",
      reference: 31
    },
    {
      value: 2703759,
      label: "Jequiá da Praia",
      reference: 27
    },
    {
      value: 2918001,
      label: "Jequié",
      reference: 29
    },
    {
      value: 3135605,
      label: "Jequitaí",
      reference: 31
    },
    {
      value: 3135704,
      label: "Jequitibá",
      reference: 31
    },
    {
      value: 3135803,
      label: "Jequitinhonha",
      reference: 31
    },
    {
      value: 2918100,
      label: "Jeremoabo",
      reference: 29
    },
    {
      value: 2507408,
      label: "Jericó",
      reference: 25
    },
    {
      value: 3525409,
      label: "Jeriquara",
      reference: 35
    },
    {
      value: 3203106,
      label: "Jerônimo Monteiro",
      reference: 32
    },
    {
      value: 2205300,
      label: "Jerumenha",
      reference: 22
    },
    {
      value: 3135902,
      label: "Jesuânia",
      reference: 31
    },
    {
      value: 4112751,
      label: "Jesuítas",
      reference: 41
    },
    {
      value: 5212055,
      label: "Jesúpolis",
      reference: 52
    },
    {
      value: 1100122,
      label: "Ji-Paraná",
      reference: 11
    },
    {
      value: 2307254,
      label: "Jijoca de Jericoacoara",
      reference: 23
    },
    {
      value: 2918209,
      label: "Jiquiriçá",
      reference: 29
    },
    {
      value: 2918308,
      label: "Jitaúna",
      reference: 29
    },
    {
      value: 4209003,
      label: "Joaçaba",
      reference: 42
    },
    {
      value: 3136009,
      label: "Joaíma",
      reference: 31
    },
    {
      value: 3136108,
      label: "Joanésia",
      reference: 31
    },
    {
      value: 3525508,
      label: "Joanópolis",
      reference: 35
    },
    {
      value: 2608107,
      label: "João Alfredo",
      reference: 26
    },
    {
      value: 2405801,
      label: "João Câmara",
      reference: 24
    },
    {
      value: 2205359,
      label: "João Costa",
      reference: 22
    },
    {
      value: 2405900,
      label: "João Dias",
      reference: 24
    },
    {
      value: 2918357,
      label: "João Dourado",
      reference: 29
    },
    {
      value: 2105500,
      label: "João Lisboa",
      reference: 21
    },
    {
      value: 3136207,
      label: "João Monlevade",
      reference: 31
    },
    {
      value: 3203130,
      label: "João Neiva",
      reference: 32
    },
    {
      value: 2507507,
      label: "João Pessoa",
      reference: 25
    },
    {
      value: 3136306,
      label: "João Pinheiro",
      reference: 31
    },
    {
      value: 3525607,
      label: "João Ramalho",
      reference: 35
    },
    {
      value: 3136405,
      label: "Joaquim Felício",
      reference: 31
    },
    {
      value: 2703809,
      label: "Joaquim Gomes",
      reference: 27
    },
    {
      value: 2608206,
      label: "Joaquim Nabuco",
      reference: 26
    },
    {
      value: 2205409,
      label: "Joaquim Pires",
      reference: 22
    },
    {
      value: 4112801,
      label: "Joaquim Távora",
      reference: 41
    },
    {
      value: 2513653,
      label: "Joca Claudino",
      reference: 25
    },
    {
      value: 2205458,
      label: "Joca Marques",
      reference: 22
    },
    {
      value: 4311155,
      label: "Jóia",
      reference: 43
    },
    {
      value: 4209102,
      label: "Joinville",
      reference: 42
    },
    {
      value: 3136504,
      label: "Jordânia",
      reference: 31
    },
    {
      value: 1200328,
      label: "Jordão",
      reference: 12
    },
    {
      value: 4209151,
      label: "José Boiteux",
      reference: 42
    },
    {
      value: 3525706,
      label: "José Bonifácio",
      reference: 35
    },
    {
      value: 2406007,
      label: "José da Penha",
      reference: 24
    },
    {
      value: 2205508,
      label: "José de Freitas",
      reference: 22
    },
    {
      value: 3136520,
      label: "José Gonçalves de Minas",
      reference: 31
    },
    {
      value: 3136553,
      label: "José Raydan",
      reference: 31
    },
    {
      value: 2105609,
      label: "Joselândia",
      reference: 21
    },
    {
      value: 3136579,
      label: "Josenópolis",
      reference: 31
    },
    {
      value: 5212105,
      label: "Joviânia",
      reference: 52
    },
    {
      value: 5105101,
      label: "Juara",
      reference: 51
    },
    {
      value: 2507606,
      label: "Juarez Távora",
      reference: 25
    },
    {
      value: 1711803,
      label: "Juarina",
      reference: 17
    },
    {
      value: 3136652,
      label: "Juatuba",
      reference: 31
    },
    {
      value: 2507705,
      label: "Juazeirinho",
      reference: 25
    },
    {
      value: 2918407,
      label: "Juazeiro",
      reference: 29
    },
    {
      value: 2307304,
      label: "Juazeiro do Norte",
      reference: 23
    },
    {
      value: 2205516,
      label: "Juazeiro do Piauí",
      reference: 22
    },
    {
      value: 2307403,
      label: "Jucás",
      reference: 23
    },
    {
      value: 2608255,
      label: "Jucati",
      reference: 26
    },
    {
      value: 2918456,
      label: "Jucuruçu",
      reference: 29
    },
    {
      value: 2406106,
      label: "Jucurutu",
      reference: 24
    },
    {
      value: 5105150,
      label: "Juína",
      reference: 51
    },
    {
      value: 3136702,
      label: "Juiz de Fora",
      reference: 31
    },
    {
      value: 2205524,
      label: "Júlio Borges",
      reference: 22
    },
    {
      value: 4311205,
      label: "Júlio de Castilhos",
      reference: 43
    },
    {
      value: 3525805,
      label: "Júlio Mesquita",
      reference: 35
    },
    {
      value: 3525854,
      label: "Jumirim",
      reference: 35
    },
    {
      value: 2105658,
      label: "Junco do Maranhão",
      reference: 21
    },
    {
      value: 2507804,
      label: "Junco do Seridó",
      reference: 25
    },
    {
      value: 2406155,
      label: "Jundiá",
      reference: 24
    },
    {
      value: 2703908,
      label: "Jundiá",
      reference: 27
    },
    {
      value: 3525904,
      label: "Jundiaí",
      reference: 35
    },
    {
      value: 4112900,
      label: "Jundiaí do Sul",
      reference: 41
    },
    {
      value: 2704005,
      label: "Junqueiro",
      reference: 27
    },
    {
      value: 3526001,
      label: "Junqueirópolis",
      reference: 35
    },
    {
      value: 2608305,
      label: "Jupi",
      reference: 26
    },
    {
      value: 4209177,
      label: "Jupiá",
      reference: 42
    },
    {
      value: 3526100,
      label: "Juquiá",
      reference: 35
    },
    {
      value: 3526209,
      label: "Juquitiba",
      reference: 35
    },
    {
      value: 3136801,
      label: "Juramento",
      reference: 31
    },
    {
      value: 4112959,
      label: "Juranda",
      reference: 41
    },
    {
      value: 2608404,
      label: "Jurema",
      reference: 26
    },
    {
      value: 2205532,
      label: "Jurema",
      reference: 22
    },
    {
      value: 2507903,
      label: "Juripiranga",
      reference: 25
    },
    {
      value: 2508000,
      label: "Juru",
      reference: 25
    },
    {
      value: 1302207,
      label: "Juruá",
      reference: 13
    },
    {
      value: 3136900,
      label: "Juruaia",
      reference: 31
    },
    {
      value: 5105176,
      label: "Juruena",
      reference: 51
    },
    {
      value: 1503903,
      label: "Juruti",
      reference: 15
    },
    {
      value: 5105200,
      label: "Juscimeira",
      reference: 51
    },
    {
      value: 2918506,
      label: "Jussara",
      reference: 29
    },
    {
      value: 5212204,
      label: "Jussara",
      reference: 52
    },
    {
      value: 4113007,
      label: "Jussara",
      reference: 41
    },
    {
      value: 2918555,
      label: "Jussari",
      reference: 29
    },
    {
      value: 2918605,
      label: "Jussiape",
      reference: 29
    },
    {
      value: 1302306,
      label: "Jutaí",
      reference: 13
    },
    {
      value: 5005152,
      label: "Juti",
      reference: 50
    },
    {
      value: 3136959,
      label: "Juvenília",
      reference: 31
    },
    {
      value: 4113106,
      label: "Kaloré",
      reference: 41
    },
    {
      value: 1302405,
      label: "Lábrea",
      reference: 13
    },
    {
      value: 4209201,
      label: "Lacerdópolis",
      reference: 42
    },
    {
      value: 3137007,
      label: "Ladainha",
      reference: 31
    },
    {
      value: 5005202,
      label: "Ladário",
      reference: 50
    },
    {
      value: 2918704,
      label: "Lafaiete Coutinho",
      reference: 29
    },
    {
      value: 3137106,
      label: "Lagamar",
      reference: 31
    },
    {
      value: 2803500,
      label: "Lagarto",
      reference: 28
    },
    {
      value: 4209300,
      label: "Lages",
      reference: 42
    },
    {
      value: 2105708,
      label: "Lago da Pedra",
      reference: 21
    },
    {
      value: 2105807,
      label: "Lago do Junco",
      reference: 21
    },
    {
      value: 2105948,
      label: "Lago dos Rodrigues",
      reference: 21
    },
    {
      value: 2105906,
      label: "Lago Verde",
      reference: 21
    },
    {
      value: 2508109,
      label: "Lagoa",
      reference: 25
    },
    {
      value: 2205557,
      label: "Lagoa Alegre",
      reference: 22
    },
    {
      value: 4311239,
      label: "Lagoa Bonita do Sul",
      reference: 43
    },
    {
      value: 2406205,
      label: "Lagoa d'Anta",
      reference: 24
    },
    {
      value: 2704104,
      label: "Lagoa da Canoa",
      reference: 27
    },
    {
      value: 1711902,
      label: "Lagoa da Confusão",
      reference: 17
    },
    {
      value: 3137205,
      label: "Lagoa da Prata",
      reference: 31
    },
    {
      value: 2508208,
      label: "Lagoa de Dentro",
      reference: 25
    },
    {
      value: 2608503,
      label: "Lagoa de Itaenga",
      reference: 26
    },
    {
      value: 2406304,
      label: "Lagoa de Pedras",
      reference: 24
    },
    {
      value: 2205573,
      label: "Lagoa de São Francisco",
      reference: 22
    },
    {
      value: 2406403,
      label: "Lagoa de Velhos",
      reference: 24
    },
    {
      value: 2205565,
      label: "Lagoa do Barro do Piauí",
      reference: 22
    },
    {
      value: 2608453,
      label: "Lagoa do Carro",
      reference: 26
    },
    {
      value: 2105922,
      label: "Lagoa do Mato",
      reference: 21
    },
    {
      value: 2608602,
      label: "Lagoa do Ouro",
      reference: 26
    },
    {
      value: 2205581,
      label: "Lagoa do Piauí",
      reference: 22
    },
    {
      value: 2205599,
      label: "Lagoa do Sítio",
      reference: 22
    },
    {
      value: 1711951,
      label: "Lagoa do Tocantins",
      reference: 17
    },
    {
      value: 2608701,
      label: "Lagoa dos Gatos",
      reference: 26
    },
    {
      value: 3137304,
      label: "Lagoa dos Patos",
      reference: 31
    },
    {
      value: 4311270,
      label: "Lagoa dos Três Cantos",
      reference: 43
    },
    {
      value: 3137403,
      label: "Lagoa Dourada",
      reference: 31
    },
    {
      value: 3137502,
      label: "Lagoa Formosa",
      reference: 31
    },
    {
      value: 3137536,
      label: "Lagoa Grande",
      reference: 31
    },
    {
      value: 2608750,
      label: "Lagoa Grande",
      reference: 26
    },
    {
      value: 2105963,
      label: "Lagoa Grande do Maranhão",
      reference: 21
    },
    {
      value: 2406502,
      label: "Lagoa Nova",
      reference: 24
    },
    {
      value: 2918803,
      label: "Lagoa Real",
      reference: 29
    },
    {
      value: 2406601,
      label: "Lagoa Salgada",
      reference: 24
    },
    {
      value: 5212253,
      label: "Lagoa Santa",
      reference: 52
    },
    {
      value: 3137601,
      label: "Lagoa Santa",
      reference: 31
    },
    {
      value: 2508307,
      label: "Lagoa Seca",
      reference: 25
    },
    {
      value: 4311304,
      label: "Lagoa Vermelha",
      reference: 43
    },
    {
      value: 4311254,
      label: "Lagoão",
      reference: 43
    },
    {
      value: 3526308,
      label: "Lagoinha",
      reference: 35
    },
    {
      value: 2205540,
      label: "Lagoinha do Piauí",
      reference: 22
    },
    {
      value: 4209409,
      label: "Laguna",
      reference: 42
    },
    {
      value: 5005251,
      label: "Laguna Carapã",
      reference: 50
    },
    {
      value: 2918902,
      label: "Laje",
      reference: 29
    },
    {
      value: 3302304,
      label: "Laje do Muriaé",
      reference: 33
    },
    {
      value: 1712009,
      label: "Lajeado",
      reference: 17
    },
    {
      value: 4311403,
      label: "Lajeado",
      reference: 43
    },
    {
      value: 4311429,
      label: "Lajeado do Bugre",
      reference: 43
    },
    {
      value: 4209458,
      label: "Lajeado Grande",
      reference: 42
    },
    {
      value: 2105989,
      label: "Lajeado Novo",
      reference: 21
    },
    {
      value: 2919009,
      label: "Lajedão",
      reference: 29
    },
    {
      value: 2919058,
      label: "Lajedinho",
      reference: 29
    },
    {
      value: 2608800,
      label: "Lajedo",
      reference: 26
    },
    {
      value: 2918753,
      label: "Lajedo do Tabocal",
      reference: 29
    },
    {
      value: 2406700,
      label: "Lajes",
      reference: 24
    },
    {
      value: 2406809,
      label: "Lajes Pintadas",
      reference: 24
    },
    {
      value: 3137700,
      label: "Lajinha",
      reference: 31
    },
    {
      value: 2919108,
      label: "Lamarão",
      reference: 29
    },
    {
      value: 3137809,
      label: "Lambari",
      reference: 31
    },
    {
      value: 5105234,
      label: "Lambari D'Oeste",
      reference: 51
    },
    {
      value: 3137908,
      label: "Lamim",
      reference: 31
    },
    {
      value: 2205607,
      label: "Landri Sales",
      reference: 22
    },
    {
      value: 4113205,
      label: "Lapa",
      reference: 41
    },
    {
      value: 2919157,
      label: "Lapão",
      reference: 29
    },
    {
      value: 3203163,
      label: "Laranja da Terra",
      reference: 32
    },
    {
      value: 3138005,
      label: "Laranjal",
      reference: 31
    },
    {
      value: 4113254,
      label: "Laranjal",
      reference: 41
    },
    {
      value: 1600279,
      label: "Laranjal do Jari",
      reference: 16
    },
    {
      value: 3526407,
      label: "Laranjal Paulista",
      reference: 35
    },
    {
      value: 2803609,
      label: "Laranjeiras",
      reference: 28
    },
    {
      value: 4113304,
      label: "Laranjeiras do Sul",
      reference: 41
    },
    {
      value: 3138104,
      label: "Lassance",
      reference: 31
    },
    {
      value: 2508406,
      label: "Lastro",
      reference: 25
    },
    {
      value: 4209508,
      label: "Laurentino",
      reference: 42
    },
    {
      value: 2919207,
      label: "Lauro de Freitas",
      reference: 29
    },
    {
      value: 4209607,
      label: "Lauro Muller",
      reference: 42
    },
    {
      value: 1712157,
      label: "Lavandeira",
      reference: 17
    },
    {
      value: 3526506,
      label: "Lavínia",
      reference: 35
    },
    {
      value: 3138203,
      label: "Lavras",
      reference: 31
    },
    {
      value: 2307502,
      label: "Lavras da Mangabeira",
      reference: 23
    },
    {
      value: 4311502,
      label: "Lavras do Sul",
      reference: 43
    },
    {
      value: 3526605,
      label: "Lavrinhas",
      reference: 35
    },
    {
      value: 3138302,
      label: "Leandro Ferreira",
      reference: 31
    },
    {
      value: 4209706,
      label: "Lebon Régis",
      reference: 42
    },
    {
      value: 3526704,
      label: "Leme",
      reference: 35
    },
    {
      value: 3138351,
      label: "Leme do Prado",
      reference: 31
    },
    {
      value: 2919306,
      label: "Lençóis",
      reference: 29
    },
    {
      value: 3526803,
      label: "Lençóis Paulista",
      reference: 35
    },
    {
      value: 4209805,
      label: "Leoberto Leal",
      reference: 42
    },
    {
      value: 3138401,
      label: "Leopoldina",
      reference: 31
    },
    {
      value: 5212303,
      label: "Leopoldo de Bulhões",
      reference: 52
    },
    {
      value: 4113403,
      label: "Leópolis",
      reference: 41
    },
    {
      value: 4311601,
      label: "Liberato Salzano",
      reference: 43
    },
    {
      value: 3138500,
      label: "Liberdade",
      reference: 31
    },
    {
      value: 2919405,
      label: "Licínio de Almeida",
      reference: 29
    },
    {
      value: 4113429,
      label: "Lidianópolis",
      reference: 41
    },
    {
      value: 2106003,
      label: "Lima Campos",
      reference: 21
    },
    {
      value: 3138609,
      label: "Lima Duarte",
      reference: 31
    },
    {
      value: 3526902,
      label: "Limeira",
      reference: 35
    },
    {
      value: 3138625,
      label: "Limeira do Oeste",
      reference: 31
    },
    {
      value: 2608909,
      label: "Limoeiro",
      reference: 26
    },
    {
      value: 2704203,
      label: "Limoeiro de Anadia",
      reference: 27
    },
    {
      value: 1504000,
      label: "Limoeiro do Ajuru",
      reference: 15
    },
    {
      value: 2307601,
      label: "Limoeiro do Norte",
      reference: 23
    },
    {
      value: 4113452,
      label: "Lindoeste",
      reference: 41
    },
    {
      value: 3527009,
      label: "Lindóia",
      reference: 35
    },
    {
      value: 4209854,
      label: "Lindóia do Sul",
      reference: 42
    },
    {
      value: 4311627,
      label: "Lindolfo Collor",
      reference: 43
    },
    {
      value: 4311643,
      label: "Linha Nova",
      reference: 43
    },
    {
      value: 3203205,
      label: "Linhares",
      reference: 32
    },
    {
      value: 3527108,
      label: "Lins",
      reference: 35
    },
    {
      value: 2508505,
      label: "Livramento",
      reference: 25
    },
    {
      value: 2919504,
      label: "Livramento de Nossa Senhora",
      reference: 29
    },
    {
      value: 1712405,
      label: "Lizarda",
      reference: 17
    },
    {
      value: 4113502,
      label: "Loanda",
      reference: 41
    },
    {
      value: 4113601,
      label: "Lobato",
      reference: 41
    },
    {
      value: 2508554,
      label: "Logradouro",
      reference: 25
    },
    {
      value: 4113700,
      label: "Londrina",
      reference: 41
    },
    {
      value: 3138658,
      label: "Lontra",
      reference: 31
    },
    {
      value: 4209904,
      label: "Lontras",
      reference: 42
    },
    {
      value: 3527207,
      label: "Lorena",
      reference: 35
    },
    {
      value: 2106102,
      label: "Loreto",
      reference: 21
    },
    {
      value: 3527256,
      label: "Lourdes",
      reference: 35
    },
    {
      value: 3527306,
      label: "Louveira",
      reference: 35
    },
    {
      value: 5105259,
      label: "Lucas do Rio Verde",
      reference: 51
    },
    {
      value: 3527405,
      label: "Lucélia",
      reference: 35
    },
    {
      value: 2508604,
      label: "Lucena",
      reference: 25
    },
    {
      value: 3527504,
      label: "Lucianópolis",
      reference: 35
    },
    {
      value: 5105309,
      label: "Luciara",
      reference: 51
    },
    {
      value: 2406908,
      label: "Lucrécia",
      reference: 24
    },
    {
      value: 3527603,
      label: "Luís Antônio",
      reference: 35
    },
    {
      value: 2205706,
      label: "Luís Correia",
      reference: 22
    },
    {
      value: 2106201,
      label: "Luís Domingues",
      reference: 21
    },
    {
      value: 2919553,
      label: "Luís Eduardo Magalhães",
      reference: 29
    },
    {
      value: 2407005,
      label: "Luís Gomes",
      reference: 24
    },
    {
      value: 3138674,
      label: "Luisburgo",
      reference: 31
    },
    {
      value: 3138682,
      label: "Luislândia",
      reference: 31
    },
    {
      value: 4210001,
      label: "Luiz Alves",
      reference: 42
    },
    {
      value: 4113734,
      label: "Luiziana",
      reference: 41
    },
    {
      value: 3527702,
      label: "Luiziânia",
      reference: 35
    },
    {
      value: 3138708,
      label: "Luminárias",
      reference: 31
    },
    {
      value: 4113759,
      label: "Lunardelli",
      reference: 41
    },
    {
      value: 3527801,
      label: "Lupércio",
      reference: 35
    },
    {
      value: 4113809,
      label: "Lupionópolis",
      reference: 41
    },
    {
      value: 3527900,
      label: "Lutécia",
      reference: 35
    },
    {
      value: 3138807,
      label: "Luz",
      reference: 31
    },
    {
      value: 4210035,
      label: "Luzerna",
      reference: 42
    },
    {
      value: 5212501,
      label: "Luziânia",
      reference: 52
    },
    {
      value: 2205805,
      label: "Luzilândia",
      reference: 22
    },
    {
      value: 1712454,
      label: "Luzinópolis",
      reference: 17
    },
    {
      value: 3302403,
      label: "Macaé",
      reference: 33
    },
    {
      value: 2407104,
      label: "Macaíba",
      reference: 24
    },
    {
      value: 2919603,
      label: "Macajuba",
      reference: 29
    },
    {
      value: 4311718,
      label: "Maçambará",
      reference: 43
    },
    {
      value: 2803708,
      label: "Macambira",
      reference: 28
    },
    {
      value: 1600303,
      label: "Macapá",
      reference: 16
    },
    {
      value: 2609006,
      label: "Macaparana",
      reference: 26
    },
    {
      value: 2919702,
      label: "Macarani",
      reference: 29
    },
    {
      value: 3528007,
      label: "Macatuba",
      reference: 35
    },
    {
      value: 2407203,
      label: "Macau",
      reference: 24
    },
    {
      value: 3528106,
      label: "Macaubal",
      reference: 35
    },
    {
      value: 2919801,
      label: "Macaúbas",
      reference: 29
    },
    {
      value: 3528205,
      label: "Macedônia",
      reference: 35
    },
    {
      value: 2704302,
      label: "Maceió",
      reference: 27
    },
    {
      value: 3138906,
      label: "Machacalis",
      reference: 31
    },
    {
      value: 4311700,
      label: "Machadinho",
      reference: 43
    },
    {
      value: 1100130,
      label: "Machadinho D'Oeste",
      reference: 11
    },
    {
      value: 3139003,
      label: "Machado",
      reference: 31
    },
    {
      value: 2609105,
      label: "Machados",
      reference: 26
    },
    {
      value: 4210050,
      label: "Macieira",
      reference: 42
    },
    {
      value: 3302452,
      label: "Macuco",
      reference: 33
    },
    {
      value: 2919900,
      label: "Macururé",
      reference: 29
    },
    {
      value: 2307635,
      label: "Madalena",
      reference: 23
    },
    {
      value: 2205854,
      label: "Madeiro",
      reference: 22
    },
    {
      value: 2919926,
      label: "Madre de Deus",
      reference: 29
    },
    {
      value: 3139102,
      label: "Madre de Deus de Minas",
      reference: 31
    },
    {
      value: 2508703,
      label: "Mãe d'Água",
      reference: 25
    },
    {
      value: 1504059,
      label: "Mãe do Rio",
      reference: 15
    },
    {
      value: 2919959,
      label: "Maetinga",
      reference: 29
    },
    {
      value: 4210100,
      label: "Mafra",
      reference: 42
    },
    {
      value: 1504109,
      label: "Magalhães Barata",
      reference: 15
    },
    {
      value: 2106300,
      label: "Magalhães de Almeida",
      reference: 21
    },
    {
      value: 3528304,
      label: "Magda",
      reference: 35
    },
    {
      value: 3302502,
      label: "Magé",
      reference: 33
    },
    {
      value: 2920007,
      label: "Maiquinique",
      reference: 29
    },
    {
      value: 2920106,
      label: "Mairi",
      reference: 29
    },
    {
      value: 3528403,
      label: "Mairinque",
      reference: 35
    },
    {
      value: 3528502,
      label: "Mairiporã",
      reference: 35
    },
    {
      value: 5212600,
      label: "Mairipotaba",
      reference: 52
    },
    {
      value: 4210209,
      label: "Major Gercino",
      reference: 42
    },
    {
      value: 2704401,
      label: "Major Isidoro",
      reference: 27
    },
    {
      value: 2407252,
      label: "Major Sales",
      reference: 24
    },
    {
      value: 4210308,
      label: "Major Vieira",
      reference: 42
    },
    {
      value: 3139201,
      label: "Malacacheta",
      reference: 31
    },
    {
      value: 2920205,
      label: "Malhada",
      reference: 29
    },
    {
      value: 2920304,
      label: "Malhada de Pedras",
      reference: 29
    },
    {
      value: 2803807,
      label: "Malhada dos Bois",
      reference: 28
    },
    {
      value: 2803906,
      label: "Malhador",
      reference: 28
    },
    {
      value: 4113908,
      label: "Mallet",
      reference: 41
    },
    {
      value: 2508802,
      label: "Malta",
      reference: 25
    },
    {
      value: 2508901,
      label: "Mamanguape",
      reference: 25
    },
    {
      value: 5212709,
      label: "Mambaí",
      reference: 52
    },
    {
      value: 4114005,
      label: "Mamborê",
      reference: 41
    },
    {
      value: 3139250,
      label: "Mamonas",
      reference: 31
    },
    {
      value: 4311734,
      label: "Mampituba",
      reference: 43
    },
    {
      value: 1302504,
      label: "Manacapuru",
      reference: 13
    },
    {
      value: 2509008,
      label: "Manaíra",
      reference: 25
    },
    {
      value: 1302553,
      label: "Manaquiri",
      reference: 13
    },
    {
      value: 2609154,
      label: "Manari",
      reference: 26
    },
    {
      value: 1302603,
      label: "Manaus",
      reference: 13
    },
    {
      value: 1200336,
      label: "Mâncio Lima",
      reference: 12
    },
    {
      value: 4114104,
      label: "Mandaguaçu",
      reference: 41
    },
    {
      value: 4114203,
      label: "Mandaguari",
      reference: 41
    },
    {
      value: 4114302,
      label: "Mandirituba",
      reference: 41
    },
    {
      value: 3528601,
      label: "Manduri",
      reference: 35
    },
    {
      value: 4114351,
      label: "Manfrinópolis",
      reference: 41
    },
    {
      value: 3139300,
      label: "Manga",
      reference: 31
    },
    {
      value: 3302601,
      label: "Mangaratiba",
      reference: 33
    },
    {
      value: 4114401,
      label: "Mangueirinha",
      reference: 41
    },
    {
      value: 3139409,
      label: "Manhuaçu",
      reference: 31
    },
    {
      value: 3139508,
      label: "Manhumirim",
      reference: 31
    },
    {
      value: 1302702,
      label: "Manicoré",
      reference: 13
    },
    {
      value: 2205904,
      label: "Manoel Emídio",
      reference: 22
    },
    {
      value: 4114500,
      label: "Manoel Ribas",
      reference: 41
    },
    {
      value: 1200344,
      label: "Manoel Urbano",
      reference: 12
    },
    {
      value: 4311759,
      label: "Manoel Viana",
      reference: 43
    },
    {
      value: 2920403,
      label: "Manoel Vitorino",
      reference: 29
    },
    {
      value: 2920452,
      label: "Mansidão",
      reference: 29
    },
    {
      value: 3139607,
      label: "Mantena",
      reference: 31
    },
    {
      value: 3203304,
      label: "Mantenópolis",
      reference: 32
    },
    {
      value: 4311775,
      label: "Maquiné",
      reference: 43
    },
    {
      value: 3139805,
      label: "Mar de Espanha",
      reference: 31
    },
    {
      value: 2704906,
      label: "Mar Vermelho",
      reference: 27
    },
    {
      value: 5212808,
      label: "Mara Rosa",
      reference: 52
    },
    {
      value: 1302801,
      label: "Maraã",
      reference: 13
    },
    {
      value: 1504208,
      label: "Marabá",
      reference: 15
    },
    {
      value: 3528700,
      label: "Marabá Paulista",
      reference: 35
    },
    {
      value: 2106326,
      label: "Maracaçumé",
      reference: 21
    },
    {
      value: 3528809,
      label: "Maracaí",
      reference: 35
    },
    {
      value: 4210407,
      label: "Maracajá",
      reference: 42
    },
    {
      value: 5005400,
      label: "Maracaju",
      reference: 50
    },
    {
      value: 1504307,
      label: "Maracanã",
      reference: 15
    },
    {
      value: 2307650,
      label: "Maracanaú",
      reference: 23
    },
    {
      value: 2920502,
      label: "Maracás",
      reference: 29
    },
    {
      value: 2704500,
      label: "Maragogi",
      reference: 27
    },
    {
      value: 2920601,
      label: "Maragogipe",
      reference: 29
    },
    {
      value: 2609204,
      label: "Maraial",
      reference: 26
    },
    {
      value: 2106359,
      label: "Marajá do Sena",
      reference: 21
    },
    {
      value: 2307700,
      label: "Maranguape",
      reference: 23
    },
    {
      value: 2106375,
      label: "Maranhãozinho",
      reference: 21
    },
    {
      value: 1504406,
      label: "Marapanim",
      reference: 15
    },
    {
      value: 3528858,
      label: "Marapoama",
      reference: 35
    },
    {
      value: 4311791,
      label: "Maratá",
      reference: 43
    },
    {
      value: 3203320,
      label: "Marataízes",
      reference: 32
    },
    {
      value: 4311809,
      label: "Marau",
      reference: 43
    },
    {
      value: 2920700,
      label: "Maraú",
      reference: 29
    },
    {
      value: 2704609,
      label: "Maravilha",
      reference: 27
    },
    {
      value: 4210506,
      label: "Maravilha",
      reference: 42
    },
    {
      value: 3139706,
      label: "Maravilhas",
      reference: 31
    },
    {
      value: 2509057,
      label: "Marcação",
      reference: 25
    },
    {
      value: 5105580,
      label: "Marcelândia",
      reference: 51
    },
    {
      value: 4311908,
      label: "Marcelino Ramos",
      reference: 43
    },
    {
      value: 2407302,
      label: "Marcelino Vieira",
      reference: 24
    },
    {
      value: 2920809,
      label: "Marcionílio Souza",
      reference: 29
    },
    {
      value: 2307809,
      label: "Marco",
      reference: 23
    },
    {
      value: 2205953,
      label: "Marcolândia",
      reference: 22
    },
    {
      value: 2206001,
      label: "Marcos Parente",
      reference: 22
    },
    {
      value: 4114609,
      label: "Marechal Cândido Rondon",
      reference: 41
    },
    {
      value: 2704708,
      label: "Marechal Deodoro",
      reference: 27
    },
    {
      value: 3203346,
      label: "Marechal Floriano",
      reference: 32
    },
    {
      value: 1200351,
      label: "Marechal Thaumaturgo",
      reference: 12
    },
    {
      value: 4210555,
      label: "Marema",
      reference: 42
    },
    {
      value: 2509107,
      label: "Mari",
      reference: 25
    },
    {
      value: 3139904,
      label: "Maria da Fé",
      reference: 31
    },
    {
      value: 4114708,
      label: "Maria Helena",
      reference: 41
    },
    {
      value: 4114807,
      label: "Marialva",
      reference: 41
    },
    {
      value: 3140001,
      label: "Mariana",
      reference: 31
    },
    {
      value: 4311981,
      label: "Mariana Pimentel",
      reference: 43
    },
    {
      value: 4312005,
      label: "Mariano Moro",
      reference: 43
    },
    {
      value: 1712504,
      label: "Marianópolis do Tocantins",
      reference: 17
    },
    {
      value: 3528908,
      label: "Mariápolis",
      reference: 35
    },
    {
      value: 2704807,
      label: "Maribondo",
      reference: 27
    },
    {
      value: 3302700,
      label: "Maricá",
      reference: 33
    },
    {
      value: 3140100,
      label: "Marilac",
      reference: 31
    },
    {
      value: 3203353,
      label: "Marilândia",
      reference: 32
    },
    {
      value: 4114906,
      label: "Marilândia do Sul",
      reference: 41
    },
    {
      value: 4115002,
      label: "Marilena",
      reference: 41
    },
    {
      value: 3529005,
      label: "Marília",
      reference: 35
    },
    {
      value: 4115101,
      label: "Mariluz",
      reference: 41
    },
    {
      value: 4115200,
      label: "Maringá",
      reference: 41
    },
    {
      value: 3529104,
      label: "Marinópolis",
      reference: 35
    },
    {
      value: 3140159,
      label: "Mário Campos",
      reference: 31
    },
    {
      value: 4115309,
      label: "Mariópolis",
      reference: 41
    },
    {
      value: 4115358,
      label: "Maripá",
      reference: 41
    },
    {
      value: 3140209,
      label: "Maripá de Minas",
      reference: 31
    },
    {
      value: 1504422,
      label: "Marituba",
      reference: 15
    },
    {
      value: 2509156,
      label: "Marizópolis",
      reference: 25
    },
    {
      value: 3140308,
      label: "Marliéria",
      reference: 31
    },
    {
      value: 4115408,
      label: "Marmeleiro",
      reference: 41
    },
    {
      value: 3140407,
      label: "Marmelópolis",
      reference: 31
    },
    {
      value: 4312054,
      label: "Marques de Souza",
      reference: 43
    },
    {
      value: 4115457,
      label: "Marquinho",
      reference: 41
    },
    {
      value: 3140506,
      label: "Martinho Campos",
      reference: 31
    },
    {
      value: 2307908,
      label: "Martinópole",
      reference: 23
    },
    {
      value: 3529203,
      label: "Martinópolis",
      reference: 35
    },
    {
      value: 2407401,
      label: "Martins",
      reference: 24
    },
    {
      value: 3140530,
      label: "Martins Soares",
      reference: 31
    },
    {
      value: 2804003,
      label: "Maruim",
      reference: 28
    },
    {
      value: 4115507,
      label: "Marumbi",
      reference: 41
    },
    {
      value: 5212907,
      label: "Marzagão",
      reference: 52
    },
    {
      value: 2920908,
      label: "Mascote",
      reference: 29
    },
    {
      value: 2308005,
      label: "Massapê",
      reference: 23
    },
    {
      value: 2206050,
      label: "Massapê do Piauí",
      reference: 22
    },
    {
      value: 2509206,
      label: "Massaranduba",
      reference: 25
    },
    {
      value: 4210605,
      label: "Massaranduba",
      reference: 42
    },
    {
      value: 4312104,
      label: "Mata",
      reference: 43
    },
    {
      value: 2921005,
      label: "Mata de São João",
      reference: 29
    },
    {
      value: 2705002,
      label: "Mata Grande",
      reference: 27
    },
    {
      value: 2106409,
      label: "Mata Roma",
      reference: 21
    },
    {
      value: 3140555,
      label: "Mata Verde",
      reference: 31
    },
    {
      value: 3529302,
      label: "Matão",
      reference: 35
    },
    {
      value: 2509305,
      label: "Mataraca",
      reference: 25
    },
    {
      value: 1712702,
      label: "Mateiros",
      reference: 17
    },
    {
      value: 4115606,
      label: "Matelândia",
      reference: 41
    },
    {
      value: 3140605,
      label: "Materlândia",
      reference: 31
    },
    {
      value: 3140704,
      label: "Mateus Leme",
      reference: 31
    },
    {
      value: 3171501,
      label: "Mathias Lobato",
      reference: 31
    },
    {
      value: 3140803,
      label: "Matias Barbosa",
      reference: 31
    },
    {
      value: 3140852,
      label: "Matias Cardoso",
      reference: 31
    },
    {
      value: 2206100,
      label: "Matias Olímpio",
      reference: 22
    },
    {
      value: 2921054,
      label: "Matina",
      reference: 29
    },
    {
      value: 2106508,
      label: "Matinha",
      reference: 21
    },
    {
      value: 2509339,
      label: "Matinhas",
      reference: 25
    },
    {
      value: 4115705,
      label: "Matinhos",
      reference: 41
    },
    {
      value: 3140902,
      label: "Matipó",
      reference: 31
    },
    {
      value: 4312138,
      label: "Mato Castelhano",
      reference: 43
    },
    {
      value: 2509370,
      label: "Mato Grosso",
      reference: 25
    },
    {
      value: 4312153,
      label: "Mato Leitão",
      reference: 43
    },
    {
      value: 4312179,
      label: "Mato Queimado",
      reference: 43
    },
    {
      value: 4115739,
      label: "Mato Rico",
      reference: 41
    },
    {
      value: 3141009,
      label: "Mato Verde",
      reference: 31
    },
    {
      value: 2106607,
      label: "Matões",
      reference: 21
    },
    {
      value: 2106631,
      label: "Matões do Norte",
      reference: 21
    },
    {
      value: 4210704,
      label: "Matos Costa",
      reference: 42
    },
    {
      value: 3141108,
      label: "Matozinhos",
      reference: 31
    },
    {
      value: 5212956,
      label: "Matrinchã",
      reference: 52
    },
    {
      value: 2705101,
      label: "Matriz de Camaragibe",
      reference: 27
    },
    {
      value: 5105606,
      label: "Matupá",
      reference: 51
    },
    {
      value: 2509396,
      label: "Maturéia",
      reference: 25
    },
    {
      value: 3141207,
      label: "Matutina",
      reference: 31
    },
    {
      value: 3529401,
      label: "Mauá",
      reference: 35
    },
    {
      value: 4115754,
      label: "Mauá da Serra",
      reference: 41
    },
    {
      value: 1302900,
      label: "Maués",
      reference: 13
    },
    {
      value: 5213004,
      label: "Maurilândia",
      reference: 52
    },
    {
      value: 1712801,
      label: "Maurilândia do Tocantins",
      reference: 17
    },
    {
      value: 2308104,
      label: "Mauriti",
      reference: 23
    },
    {
      value: 2407500,
      label: "Maxaranguape",
      reference: 24
    },
    {
      value: 4312203,
      label: "Maximiliano de Almeida",
      reference: 43
    },
    {
      value: 1600402,
      label: "Mazagão",
      reference: 16
    },
    {
      value: 3141306,
      label: "Medeiros",
      reference: 31
    },
    {
      value: 2921104,
      label: "Medeiros Neto",
      reference: 29
    },
    {
      value: 4115804,
      label: "Medianeira",
      reference: 41
    },
    {
      value: 1504455,
      label: "Medicilândia",
      reference: 15
    },
    {
      value: 3141405,
      label: "Medina",
      reference: 31
    },
    {
      value: 4210803,
      label: "Meleiro",
      reference: 42
    },
    {
      value: 1504505,
      label: "Melgaço",
      reference: 15
    },
    {
      value: 3302809,
      label: "Mendes",
      reference: 33
    },
    {
      value: 3141504,
      label: "Mendes Pimentel",
      reference: 31
    },
    {
      value: 3529500,
      label: "Mendonça",
      reference: 35
    },
    {
      value: 4115853,
      label: "Mercedes",
      reference: 41
    },
    {
      value: 3141603,
      label: "Mercês",
      reference: 31
    },
    {
      value: 3529609,
      label: "Meridiano",
      reference: 35
    },
    {
      value: 2308203,
      label: "Meruoca",
      reference: 23
    },
    {
      value: 3529658,
      label: "Mesópolis",
      reference: 35
    },
    {
      value: 3302858,
      label: "Mesquita",
      reference: 33
    },
    {
      value: 3141702,
      label: "Mesquita",
      reference: 31
    },
    {
      value: 2705200,
      label: "Messias",
      reference: 27
    },
    {
      value: 2407609,
      label: "Messias Targino",
      reference: 24
    },
    {
      value: 2206209,
      label: "Miguel Alves",
      reference: 22
    },
    {
      value: 2921203,
      label: "Miguel Calmon",
      reference: 29
    },
    {
      value: 2206308,
      label: "Miguel Leão",
      reference: 22
    },
    {
      value: 3302908,
      label: "Miguel Pereira",
      reference: 33
    },
    {
      value: 3529708,
      label: "Miguelópolis",
      reference: 35
    },
    {
      value: 2308302,
      label: "Milagres",
      reference: 23
    },
    {
      value: 2921302,
      label: "Milagres",
      reference: 29
    },
    {
      value: 2106672,
      label: "Milagres do Maranhão",
      reference: 21
    },
    {
      value: 2308351,
      label: "Milhã",
      reference: 23
    },
    {
      value: 2206357,
      label: "Milton Brandão",
      reference: 22
    },
    {
      value: 5213053,
      label: "Mimoso de Goiás",
      reference: 52
    },
    {
      value: 3203403,
      label: "Mimoso do Sul",
      reference: 32
    },
    {
      value: 5213087,
      label: "Minaçu",
      reference: 52
    },
    {
      value: 2705309,
      label: "Minador do Negrão",
      reference: 27
    },
    {
      value: 4312252,
      label: "Minas do Leão",
      reference: 43
    },
    {
      value: 3141801,
      label: "Minas Novas",
      reference: 31
    },
    {
      value: 3141900,
      label: "Minduri",
      reference: 31
    },
    {
      value: 5213103,
      label: "Mineiros",
      reference: 52
    },
    {
      value: 3529807,
      label: "Mineiros do Tietê",
      reference: 35
    },
    {
      value: 1101203,
      label: "Ministro Andreazza",
      reference: 11
    },
    {
      value: 3530003,
      label: "Mira Estrela",
      reference: 35
    },
    {
      value: 3142007,
      label: "Mirabela",
      reference: 31
    },
    {
      value: 3529906,
      label: "Miracatu",
      reference: 35
    },
    {
      value: 3303005,
      label: "Miracema",
      reference: 33
    },
    {
      value: 1713205,
      label: "Miracema do Tocantins",
      reference: 17
    },
    {
      value: 2106706,
      label: "Mirador",
      reference: 21
    },
    {
      value: 4115903,
      label: "Mirador",
      reference: 41
    },
    {
      value: 3142106,
      label: "Miradouro",
      reference: 31
    },
    {
      value: 4312302,
      label: "Miraguaí",
      reference: 43
    },
    {
      value: 3142205,
      label: "Miraí",
      reference: 31
    },
    {
      value: 2308377,
      label: "Miraíma",
      reference: 23
    },
    {
      value: 5005608,
      label: "Miranda",
      reference: 50
    },
    {
      value: 2106755,
      label: "Miranda do Norte",
      reference: 21
    },
    {
      value: 2609303,
      label: "Mirandiba",
      reference: 26
    },
    {
      value: 3530102,
      label: "Mirandópolis",
      reference: 35
    },
    {
      value: 2921401,
      label: "Mirangaba",
      reference: 29
    },
    {
      value: 1713304,
      label: "Miranorte",
      reference: 17
    },
    {
      value: 2921450,
      label: "Mirante",
      reference: 29
    },
    {
      value: 1101302,
      label: "Mirante da Serra",
      reference: 11
    },
    {
      value: 3530201,
      label: "Mirante do Paranapanema",
      reference: 35
    },
    {
      value: 4116000,
      label: "Miraselva",
      reference: 41
    },
    {
      value: 3530300,
      label: "Mirassol",
      reference: 35
    },
    {
      value: 5105622,
      label: "Mirassol d'Oeste",
      reference: 51
    },
    {
      value: 3530409,
      label: "Mirassolândia",
      reference: 35
    },
    {
      value: 3142254,
      label: "Miravânia",
      reference: 31
    },
    {
      value: 4210852,
      label: "Mirim Doce",
      reference: 42
    },
    {
      value: 2106805,
      label: "Mirinzal",
      reference: 21
    },
    {
      value: 4116059,
      label: "Missal",
      reference: 41
    },
    {
      value: 2308401,
      label: "Missão Velha",
      reference: 23
    },
    {
      value: 1504604,
      label: "Mocajuba",
      reference: 15
    },
    {
      value: 3530508,
      label: "Mococa",
      reference: 35
    },
    {
      value: 4210902,
      label: "Modelo",
      reference: 42
    },
    {
      value: 3142304,
      label: "Moeda",
      reference: 31
    },
    {
      value: 3142403,
      label: "Moema",
      reference: 31
    },
    {
      value: 2509404,
      label: "Mogeiro",
      reference: 25
    },
    {
      value: 3530607,
      label: "Mogi das Cruzes",
      reference: 35
    },
    {
      value: 3530706,
      label: "Mogi Guaçu",
      reference: 35
    },
    {
      value: 3530805,
      label: "Mogi Mirim",
      reference: 35
    },
    {
      value: 5213400,
      label: "Moiporá",
      reference: 52
    },
    {
      value: 2804102,
      label: "Moita Bonita",
      reference: 28
    },
    {
      value: 1504703,
      label: "Moju",
      reference: 15
    },
    {
      value: 1504752,
      label: "Mojuí dos Campos",
      reference: 15
    },
    {
      value: 2308500,
      label: "Mombaça",
      reference: 23
    },
    {
      value: 3530904,
      label: "Mombuca",
      reference: 35
    },
    {
      value: 2106904,
      label: "Monção",
      reference: 21
    },
    {
      value: 3531001,
      label: "Monções",
      reference: 35
    },
    {
      value: 4211009,
      label: "Mondaí",
      reference: 42
    },
    {
      value: 3531100,
      label: "Mongaguá",
      reference: 35
    },
    {
      value: 3142502,
      label: "Monjolos",
      reference: 31
    },
    {
      value: 2206407,
      label: "Monsenhor Gil",
      reference: 22
    },
    {
      value: 2206506,
      label: "Monsenhor Hipólito",
      reference: 22
    },
    {
      value: 3142601,
      label: "Monsenhor Paulo",
      reference: 31
    },
    {
      value: 2308609,
      label: "Monsenhor Tabosa",
      reference: 23
    },
    {
      value: 2509503,
      label: "Montadas",
      reference: 25
    },
    {
      value: 3142700,
      label: "Montalvânia",
      reference: 31
    },
    {
      value: 3203502,
      label: "Montanha",
      reference: 32
    },
    {
      value: 2407708,
      label: "Montanhas",
      reference: 24
    },
    {
      value: 4312351,
      label: "Montauri",
      reference: 43
    },
    {
      value: 1504802,
      label: "Monte Alegre",
      reference: 15
    },
    {
      value: 2407807,
      label: "Monte Alegre",
      reference: 24
    },
    {
      value: 5213509,
      label: "Monte Alegre de Goiás",
      reference: 52
    },
    {
      value: 3142809,
      label: "Monte Alegre de Minas",
      reference: 31
    },
    {
      value: 2804201,
      label: "Monte Alegre de Sergipe",
      reference: 28
    },
    {
      value: 2206605,
      label: "Monte Alegre do Piauí",
      reference: 22
    },
    {
      value: 3531209,
      label: "Monte Alegre do Sul",
      reference: 35
    },
    {
      value: 4312377,
      label: "Monte Alegre dos Campos",
      reference: 43
    },
    {
      value: 3531308,
      label: "Monte Alto",
      reference: 35
    },
    {
      value: 3531407,
      label: "Monte Aprazível",
      reference: 35
    },
    {
      value: 3142908,
      label: "Monte Azul",
      reference: 31
    },
    {
      value: 3531506,
      label: "Monte Azul Paulista",
      reference: 35
    },
    {
      value: 3143005,
      label: "Monte Belo",
      reference: 31
    },
    {
      value: 4312385,
      label: "Monte Belo do Sul",
      reference: 43
    },
    {
      value: 4211058,
      label: "Monte Carlo",
      reference: 42
    },
    {
      value: 3143104,
      label: "Monte Carmelo",
      reference: 31
    },
    {
      value: 4211108,
      label: "Monte Castelo",
      reference: 42
    },
    {
      value: 3531605,
      label: "Monte Castelo",
      reference: 35
    },
    {
      value: 2407906,
      label: "Monte das Gameleiras",
      reference: 24
    },
    {
      value: 1713601,
      label: "Monte do Carmo",
      reference: 17
    },
    {
      value: 3143153,
      label: "Monte Formoso",
      reference: 31
    },
    {
      value: 2509602,
      label: "Monte Horebe",
      reference: 25
    },
    {
      value: 3531803,
      label: "Monte Mor",
      reference: 35
    },
    {
      value: 1101401,
      label: "Monte Negro",
      reference: 11
    },
    {
      value: 2921500,
      label: "Monte Santo",
      reference: 29
    },
    {
      value: 3143203,
      label: "Monte Santo de Minas",
      reference: 31
    },
    {
      value: 1713700,
      label: "Monte Santo do Tocantins",
      reference: 17
    },
    {
      value: 3143401,
      label: "Monte Sião",
      reference: 31
    },
    {
      value: 2509701,
      label: "Monteiro",
      reference: 25
    },
    {
      value: 3531704,
      label: "Monteiro Lobato",
      reference: 35
    },
    {
      value: 2705408,
      label: "Monteirópolis",
      reference: 27
    },
    {
      value: 4312401,
      label: "Montenegro",
      reference: 43
    },
    {
      value: 2107001,
      label: "Montes Altos",
      reference: 21
    },
    {
      value: 3143302,
      label: "Montes Claros",
      reference: 31
    },
    {
      value: 5213707,
      label: "Montes Claros de Goiás",
      reference: 52
    },
    {
      value: 3143450,
      label: "Montezuma",
      reference: 31
    },
    {
      value: 5213756,
      label: "Montividiu",
      reference: 52
    },
    {
      value: 5213772,
      label: "Montividiu do Norte",
      reference: 52
    },
    {
      value: 2308708,
      label: "Morada Nova",
      reference: 23
    },
    {
      value: 3143500,
      label: "Morada Nova de Minas",
      reference: 31
    },
    {
      value: 2308807,
      label: "Moraújo",
      reference: 23
    },
    {
      value: 2614303,
      label: "Moreilândia",
      reference: 26
    },
    {
      value: 4116109,
      label: "Moreira Sales",
      reference: 41
    },
    {
      value: 2609402,
      label: "Moreno",
      reference: 26
    },
    {
      value: 4312427,
      label: "Mormaço",
      reference: 43
    },
    {
      value: 2921609,
      label: "Morpará",
      reference: 29
    },
    {
      value: 4116208,
      label: "Morretes",
      reference: 41
    },
    {
      value: 5213806,
      label: "Morrinhos",
      reference: 52
    },
    {
      value: 2308906,
      label: "Morrinhos",
      reference: 23
    },
    {
      value: 4312443,
      label: "Morrinhos do Sul",
      reference: 43
    },
    {
      value: 3531902,
      label: "Morro Agudo",
      reference: 35
    },
    {
      value: 5213855,
      label: "Morro Agudo de Goiás",
      reference: 52
    },
    {
      value: 2206654,
      label: "Morro Cabeça no Tempo",
      reference: 22
    },
    {
      value: 4211207,
      label: "Morro da Fumaça",
      reference: 42
    },
    {
      value: 3143609,
      label: "Morro da Garça",
      reference: 31
    },
    {
      value: 2921708,
      label: "Morro do Chapéu",
      reference: 29
    },
    {
      value: 2206670,
      label: "Morro do Chapéu do Piauí",
      reference: 22
    },
    {
      value: 3143708,
      label: "Morro do Pilar",
      reference: 31
    },
    {
      value: 4211256,
      label: "Morro Grande",
      reference: 42
    },
    {
      value: 4312450,
      label: "Morro Redondo",
      reference: 43
    },
    {
      value: 4312476,
      label: "Morro Reuter",
      reference: 43
    },
    {
      value: 2107100,
      label: "Morros",
      reference: 21
    },
    {
      value: 2921807,
      label: "Mortugaba",
      reference: 29
    },
    {
      value: 3532009,
      label: "Morungaba",
      reference: 35
    },
    {
      value: 5213905,
      label: "Mossâmedes",
      reference: 52
    },
    {
      value: 2408003,
      label: "Mossoró",
      reference: 24
    },
    {
      value: 4312500,
      label: "Mostardas",
      reference: 43
    },
    {
      value: 3532058,
      label: "Motuca",
      reference: 35
    },
    {
      value: 5214002,
      label: "Mozarlândia",
      reference: 52
    },
    {
      value: 1504901,
      label: "Muaná",
      reference: 15
    },
    {
      value: 1400308,
      label: "Mucajaí",
      reference: 14
    },
    {
      value: 2309003,
      label: "Mucambo",
      reference: 23
    },
    {
      value: 2921906,
      label: "Mucugê",
      reference: 29
    },
    {
      value: 4312609,
      label: "Muçum",
      reference: 43
    },
    {
      value: 2922003,
      label: "Mucuri",
      reference: 29
    },
    {
      value: 3203601,
      label: "Mucurici",
      reference: 32
    },
    {
      value: 4312617,
      label: "Muitos Capões",
      reference: 43
    },
    {
      value: 4312625,
      label: "Muliterno",
      reference: 43
    },
    {
      value: 2509800,
      label: "Mulungu",
      reference: 25
    },
    {
      value: 2309102,
      label: "Mulungu",
      reference: 23
    },
    {
      value: 2922052,
      label: "Mulungu do Morro",
      reference: 29
    },
    {
      value: 2922102,
      label: "Mundo Novo",
      reference: 29
    },
    {
      value: 5005681,
      label: "Mundo Novo",
      reference: 50
    },
    {
      value: 5214051,
      label: "Mundo Novo",
      reference: 52
    },
    {
      value: 3143807,
      label: "Munhoz",
      reference: 31
    },
    {
      value: 4116307,
      label: "Munhoz de Melo",
      reference: 41
    },
    {
      value: 2922201,
      label: "Muniz Ferreira",
      reference: 29
    },
    {
      value: 3203700,
      label: "Muniz Freire",
      reference: 32
    },
    {
      value: 2922250,
      label: "Muquém de São Francisco",
      reference: 29
    },
    {
      value: 3203809,
      label: "Muqui",
      reference: 32
    },
    {
      value: 3143906,
      label: "Muriaé",
      reference: 31
    },
    {
      value: 2804300,
      label: "Muribeca",
      reference: 28
    },
    {
      value: 2705507,
      label: "Murici",
      reference: 27
    },
    {
      value: 2206696,
      label: "Murici dos Portelas",
      reference: 22
    },
    {
      value: 1713957,
      label: "Muricilândia",
      reference: 17
    },
    {
      value: 2922300,
      label: "Muritiba",
      reference: 29
    },
    {
      value: 3532108,
      label: "Murutinga do Sul",
      reference: 35
    },
    {
      value: 2922409,
      label: "Mutuípe",
      reference: 29
    },
    {
      value: 3144003,
      label: "Mutum",
      reference: 31
    },
    {
      value: 5214101,
      label: "Mutunópolis",
      reference: 52
    },
    {
      value: 3144102,
      label: "Muzambinho",
      reference: 31
    },
    {
      value: 3144201,
      label: "Nacip Raydan",
      reference: 31
    },
    {
      value: 3532157,
      label: "Nantes",
      reference: 35
    },
    {
      value: 3144300,
      label: "Nanuque",
      reference: 31
    },
    {
      value: 4312658,
      label: "Não-Me-Toque",
      reference: 43
    },
    {
      value: 3144359,
      label: "Naque",
      reference: 31
    },
    {
      value: 3532207,
      label: "Narandiba",
      reference: 35
    },
    {
      value: 2408102,
      label: "Natal",
      reference: 24
    },
    {
      value: 3144375,
      label: "Natalândia",
      reference: 31
    },
    {
      value: 3144409,
      label: "Natércia",
      reference: 31
    },
    {
      value: 1714203,
      label: "Natividade",
      reference: 17
    },
    {
      value: 3303104,
      label: "Natividade",
      reference: 33
    },
    {
      value: 3532306,
      label: "Natividade da Serra",
      reference: 35
    },
    {
      value: 2509909,
      label: "Natuba",
      reference: 25
    },
    {
      value: 4211306,
      label: "Navegantes",
      reference: 42
    },
    {
      value: 5005707,
      label: "Naviraí",
      reference: 50
    },
    {
      value: 2922508,
      label: "Nazaré",
      reference: 29
    },
    {
      value: 1714302,
      label: "Nazaré",
      reference: 17
    },
    {
      value: 2609501,
      label: "Nazaré da Mata",
      reference: 26
    },
    {
      value: 2206704,
      label: "Nazaré do Piauí",
      reference: 22
    },
    {
      value: 3532405,
      label: "Nazaré Paulista",
      reference: 35
    },
    {
      value: 3144508,
      label: "Nazareno",
      reference: 31
    },
    {
      value: 2510006,
      label: "Nazarezinho",
      reference: 25
    },
    {
      value: 2206720,
      label: "Nazária",
      reference: 22
    },
    {
      value: 5214408,
      label: "Nazário",
      reference: 52
    },
    {
      value: 2804409,
      label: "Neópolis",
      reference: 28
    },
    {
      value: 3144607,
      label: "Nepomuceno",
      reference: 31
    },
    {
      value: 5214507,
      label: "Nerópolis",
      reference: 52
    },
    {
      value: 3532504,
      label: "Neves Paulista",
      reference: 35
    },
    {
      value: 1303007,
      label: "Nhamundá",
      reference: 13
    },
    {
      value: 3532603,
      label: "Nhandeara",
      reference: 35
    },
    {
      value: 4312674,
      label: "Nicolau Vergueiro",
      reference: 43
    },
    {
      value: 2922607,
      label: "Nilo Peçanha",
      reference: 29
    },
    {
      value: 3303203,
      label: "Nilópolis",
      reference: 33
    },
    {
      value: 2107209,
      label: "Nina Rodrigues",
      reference: 21
    },
    {
      value: 3144656,
      label: "Ninheira",
      reference: 31
    },
    {
      value: 5005806,
      label: "Nioaque",
      reference: 50
    },
    {
      value: 3532702,
      label: "Nipoã",
      reference: 35
    },
    {
      value: 5214606,
      label: "Niquelândia",
      reference: 52
    },
    {
      value: 2408201,
      label: "Nísia Floresta",
      reference: 24
    },
    {
      value: 3303302,
      label: "Niterói",
      reference: 33
    },
    {
      value: 5105903,
      label: "Nobres",
      reference: 51
    },
    {
      value: 4312708,
      label: "Nonoai",
      reference: 43
    },
    {
      value: 2922656,
      label: "Nordestina",
      reference: 29
    },
    {
      value: 1400407,
      label: "Normandia",
      reference: 14
    },
    {
      value: 5106000,
      label: "Nortelândia",
      reference: 51
    },
    {
      value: 2804458,
      label: "Nossa Senhora Aparecida",
      reference: 28
    },
    {
      value: 2804508,
      label: "Nossa Senhora da Glória",
      reference: 28
    },
    {
      value: 2804607,
      label: "Nossa Senhora das Dores",
      reference: 28
    },
    {
      value: 4116406,
      label: "Nossa Senhora das Graças",
      reference: 41
    },
    {
      value: 2804706,
      label: "Nossa Senhora de Lourdes",
      reference: 28
    },
    {
      value: 2206753,
      label: "Nossa Senhora de Nazaré",
      reference: 22
    },
    {
      value: 5106109,
      label: "Nossa Senhora do Livramento",
      reference: 51
    },
    {
      value: 2804805,
      label: "Nossa Senhora do Socorro",
      reference: 28
    },
    {
      value: 2206803,
      label: "Nossa Senhora dos Remédios",
      reference: 22
    },
    {
      value: 3532801,
      label: "Nova Aliança",
      reference: 35
    },
    {
      value: 4116505,
      label: "Nova Aliança do Ivaí",
      reference: 41
    },
    {
      value: 4312757,
      label: "Nova Alvorada",
      reference: 43
    },
    {
      value: 5006002,
      label: "Nova Alvorada do Sul",
      reference: 50
    },
    {
      value: 5214705,
      label: "Nova América",
      reference: 52
    },
    {
      value: 4116604,
      label: "Nova América da Colina",
      reference: 41
    },
    {
      value: 5006200,
      label: "Nova Andradina",
      reference: 50
    },
    {
      value: 4312807,
      label: "Nova Araçá",
      reference: 43
    },
    {
      value: 4116703,
      label: "Nova Aurora",
      reference: 41
    },
    {
      value: 5214804,
      label: "Nova Aurora",
      reference: 52
    },
    {
      value: 5106158,
      label: "Nova Bandeirantes",
      reference: 51
    },
    {
      value: 4312906,
      label: "Nova Bassano",
      reference: 43
    },
    {
      value: 3144672,
      label: "Nova Belém",
      reference: 31
    },
    {
      value: 4312955,
      label: "Nova Boa Vista",
      reference: 43
    },
    {
      value: 5106208,
      label: "Nova Brasilândia",
      reference: 51
    },
    {
      value: 1100148,
      label: "Nova Brasilândia D'Oeste",
      reference: 11
    },
    {
      value: 4313003,
      label: "Nova Bréscia",
      reference: 43
    },
    {
      value: 3532827,
      label: "Nova Campina",
      reference: 35
    },
    {
      value: 2922706,
      label: "Nova Canaã",
      reference: 29
    },
    {
      value: 5106216,
      label: "Nova Canaã do Norte",
      reference: 51
    },
    {
      value: 3532843,
      label: "Nova Canaã Paulista",
      reference: 35
    },
    {
      value: 4313011,
      label: "Nova Candelária",
      reference: 43
    },
    {
      value: 4116802,
      label: "Nova Cantu",
      reference: 41
    },
    {
      value: 3532868,
      label: "Nova Castilho",
      reference: 35
    },
    {
      value: 2107258,
      label: "Nova Colinas",
      reference: 21
    },
    {
      value: 5214838,
      label: "Nova Crixás",
      reference: 52
    },
    {
      value: 2408300,
      label: "Nova Cruz",
      reference: 24
    },
    {
      value: 3144706,
      label: "Nova Era",
      reference: 31
    },
    {
      value: 4211405,
      label: "Nova Erechim",
      reference: 42
    },
    {
      value: 4116901,
      label: "Nova Esperança",
      reference: 41
    },
    {
      value: 1504950,
      label: "Nova Esperança do Piriá",
      reference: 15
    },
    {
      value: 4116950,
      label: "Nova Esperança do Sudoeste",
      reference: 41
    },
    {
      value: 4313037,
      label: "Nova Esperança do Sul",
      reference: 43
    },
    {
      value: 3532900,
      label: "Nova Europa",
      reference: 35
    },
    {
      value: 4117008,
      label: "Nova Fátima",
      reference: 41
    },
    {
      value: 2922730,
      label: "Nova Fátima",
      reference: 29
    },
    {
      value: 2510105,
      label: "Nova Floresta",
      reference: 25
    },
    {
      value: 3303401,
      label: "Nova Friburgo",
      reference: 33
    },
    {
      value: 5214861,
      label: "Nova Glória",
      reference: 52
    },
    {
      value: 3533007,
      label: "Nova Granada",
      reference: 35
    },
    {
      value: 5108808,
      label: "Nova Guarita",
      reference: 51
    },
    {
      value: 3533106,
      label: "Nova Guataporanga",
      reference: 35
    },
    {
      value: 4313060,
      label: "Nova Hartz",
      reference: 43
    },
    {
      value: 2922755,
      label: "Nova Ibiá",
      reference: 29
    },
    {
      value: 3303500,
      label: "Nova Iguaçu",
      reference: 33
    },
    {
      value: 5214879,
      label: "Nova Iguaçu de Goiás",
      reference: 52
    },
    {
      value: 3533205,
      label: "Nova Independência",
      reference: 35
    },
    {
      value: 2107308,
      label: "Nova Iorque",
      reference: 21
    },
    {
      value: 1504976,
      label: "Nova Ipixuna",
      reference: 15
    },
    {
      value: 4211454,
      label: "Nova Itaberaba",
      reference: 42
    },
    {
      value: 2922805,
      label: "Nova Itarana",
      reference: 29
    },
    {
      value: 5106182,
      label: "Nova Lacerda",
      reference: 51
    },
    {
      value: 4117057,
      label: "Nova Laranjeiras",
      reference: 41
    },
    {
      value: 3144805,
      label: "Nova Lima",
      reference: 31
    },
    {
      value: 4117107,
      label: "Nova Londrina",
      reference: 41
    },
    {
      value: 3533304,
      label: "Nova Luzitânia",
      reference: 35
    },
    {
      value: 1100338,
      label: "Nova Mamoré",
      reference: 11
    },
    {
      value: 5108857,
      label: "Nova Marilândia",
      reference: 51
    },
    {
      value: 5108907,
      label: "Nova Maringá",
      reference: 51
    },
    {
      value: 3144904,
      label: "Nova Módica",
      reference: 31
    },
    {
      value: 5108956,
      label: "Nova Monte Verde",
      reference: 51
    },
    {
      value: 5106224,
      label: "Nova Mutum",
      reference: 51
    },
    {
      value: 5106174,
      label: "Nova Nazaré",
      reference: 51
    },
    {
      value: 3533403,
      label: "Nova Odessa",
      reference: 35
    },
    {
      value: 4117206,
      label: "Nova Olímpia",
      reference: 41
    },
    {
      value: 5106232,
      label: "Nova Olímpia",
      reference: 51
    },
    {
      value: 1714880,
      label: "Nova Olinda",
      reference: 17
    },
    {
      value: 2309201,
      label: "Nova Olinda",
      reference: 23
    },
    {
      value: 2510204,
      label: "Nova Olinda",
      reference: 25
    },
    {
      value: 2107357,
      label: "Nova Olinda do Maranhão",
      reference: 21
    },
    {
      value: 1303106,
      label: "Nova Olinda do Norte",
      reference: 13
    },
    {
      value: 4313086,
      label: "Nova Pádua",
      reference: 43
    },
    {
      value: 4313102,
      label: "Nova Palma",
      reference: 43
    },
    {
      value: 2510303,
      label: "Nova Palmeira",
      reference: 25
    },
    {
      value: 4313201,
      label: "Nova Petrópolis",
      reference: 43
    },
    {
      value: 3145000,
      label: "Nova Ponte",
      reference: 31
    },
    {
      value: 3145059,
      label: "Nova Porteirinha",
      reference: 31
    },
    {
      value: 4313300,
      label: "Nova Prata",
      reference: 43
    },
    {
      value: 4117255,
      label: "Nova Prata do Iguaçu",
      reference: 41
    },
    {
      value: 4313334,
      label: "Nova Ramada",
      reference: 43
    },
    {
      value: 2922854,
      label: "Nova Redenção",
      reference: 29
    },
    {
      value: 3145109,
      label: "Nova Resende",
      reference: 31
    },
    {
      value: 5214903,
      label: "Nova Roma",
      reference: 52
    },
    {
      value: 4313359,
      label: "Nova Roma do Sul",
      reference: 43
    },
    {
      value: 1715002,
      label: "Nova Rosalândia",
      reference: 17
    },
    {
      value: 2309300,
      label: "Nova Russas",
      reference: 23
    },
    {
      value: 4117214,
      label: "Nova Santa Bárbara",
      reference: 41
    },
    {
      value: 5106190,
      label: "Nova Santa Helena",
      reference: 51
    },
    {
      value: 4313375,
      label: "Nova Santa Rita",
      reference: 43
    },
    {
      value: 2207959,
      label: "Nova Santa Rita",
      reference: 22
    },
    {
      value: 4117222,
      label: "Nova Santa Rosa",
      reference: 41
    },
    {
      value: 3145208,
      label: "Nova Serrana",
      reference: 31
    },
    {
      value: 2922904,
      label: "Nova Soure",
      reference: 29
    },
    {
      value: 4117271,
      label: "Nova Tebas",
      reference: 41
    },
    {
      value: 1505007,
      label: "Nova Timboteua",
      reference: 15
    },
    {
      value: 4211504,
      label: "Nova Trento",
      reference: 42
    },
    {
      value: 5106240,
      label: "Nova Ubiratã",
      reference: 51
    },
    {
      value: 3136603,
      label: "Nova União",
      reference: 31
    },
    {
      value: 1101435,
      label: "Nova União",
      reference: 11
    },
    {
      value: 3203908,
      label: "Nova Venécia",
      reference: 32
    },
    {
      value: 4211603,
      label: "Nova Veneza",
      reference: 42
    },
    {
      value: 5215009,
      label: "Nova Veneza",
      reference: 52
    },
    {
      value: 2923001,
      label: "Nova Viçosa",
      reference: 29
    },
    {
      value: 5106257,
      label: "Nova Xavantina",
      reference: 51
    },
    {
      value: 3533254,
      label: "Novais",
      reference: 35
    },
    {
      value: 1715101,
      label: "Novo Acordo",
      reference: 17
    },
    {
      value: 1303205,
      label: "Novo Airão",
      reference: 13
    },
    {
      value: 1715150,
      label: "Novo Alegre",
      reference: 17
    },
    {
      value: 1303304,
      label: "Novo Aripuanã",
      reference: 13
    },
    {
      value: 4313490,
      label: "Novo Barreiro",
      reference: 43
    },
    {
      value: 5215207,
      label: "Novo Brasil",
      reference: 52
    },
    {
      value: 4313391,
      label: "Novo Cabrais",
      reference: 43
    },
    {
      value: 3145307,
      label: "Novo Cruzeiro",
      reference: 31
    },
    {
      value: 5215231,
      label: "Novo Gama",
      reference: 52
    },
    {
      value: 4313409,
      label: "Novo Hamburgo",
      reference: 43
    },
    {
      value: 4211652,
      label: "Novo Horizonte",
      reference: 42
    },
    {
      value: 3533502,
      label: "Novo Horizonte",
      reference: 35
    },
    {
      value: 2923035,
      label: "Novo Horizonte",
      reference: 29
    },
    {
      value: 5106273,
      label: "Novo Horizonte do Norte",
      reference: 51
    },
    {
      value: 1100502,
      label: "Novo Horizonte do Oeste",
      reference: 11
    },
    {
      value: 5006259,
      label: "Novo Horizonte do Sul",
      reference: 50
    },
    {
      value: 4117297,
      label: "Novo Itacolomi",
      reference: 41
    },
    {
      value: 1715259,
      label: "Novo Jardim",
      reference: 17
    },
    {
      value: 2705606,
      label: "Novo Lino",
      reference: 27
    },
    {
      value: 4313425,
      label: "Novo Machado",
      reference: 43
    },
    {
      value: 5106265,
      label: "Novo Mundo",
      reference: 51
    },
    {
      value: 2309409,
      label: "Novo Oriente",
      reference: 23
    },
    {
      value: 3145356,
      label: "Novo Oriente de Minas",
      reference: 31
    },
    {
      value: 2206902,
      label: "Novo Oriente do Piauí",
      reference: 22
    },
    {
      value: 5215256,
      label: "Novo Planalto",
      reference: 52
    },
    {
      value: 1505031,
      label: "Novo Progresso",
      reference: 15
    },
    {
      value: 1505064,
      label: "Novo Repartimento",
      reference: 15
    },
    {
      value: 2206951,
      label: "Novo Santo Antônio",
      reference: 22
    },
    {
      value: 5106315,
      label: "Novo Santo Antônio",
      reference: 51
    },
    {
      value: 5106281,
      label: "Novo São Joaquim",
      reference: 51
    },
    {
      value: 4313441,
      label: "Novo Tiradentes",
      reference: 43
    },
    {
      value: 2923050,
      label: "Novo Triunfo",
      reference: 29
    },
    {
      value: 4313466,
      label: "Novo Xingu",
      reference: 43
    },
    {
      value: 3145372,
      label: "Novorizonte",
      reference: 31
    },
    {
      value: 3533601,
      label: "Nuporanga",
      reference: 35
    },
    {
      value: 1505106,
      label: "Óbidos",
      reference: 15
    },
    {
      value: 2309458,
      label: "Ocara",
      reference: 23
    },
    {
      value: 3533700,
      label: "Ocauçu",
      reference: 35
    },
    {
      value: 2207009,
      label: "Oeiras",
      reference: 22
    },
    {
      value: 1505205,
      label: "Oeiras do Pará",
      reference: 15
    },
    {
      value: 1600501,
      label: "Oiapoque",
      reference: 16
    },
    {
      value: 3145406,
      label: "Olaria",
      reference: 31
    },
    {
      value: 3533809,
      label: "Óleo",
      reference: 35
    },
    {
      value: 2510402,
      label: "Olho d'Água",
      reference: 25
    },
    {
      value: 2107407,
      label: "Olho d'Água das Cunhãs",
      reference: 21
    },
    {
      value: 2705705,
      label: "Olho d'Água das Flores",
      reference: 27
    },
    {
      value: 2705804,
      label: "Olho d'Água do Casado",
      reference: 27
    },
    {
      value: 2207108,
      label: "Olho D'Água do Piauí",
      reference: 22
    },
    {
      value: 2705903,
      label: "Olho d'Água Grande",
      reference: 27
    },
    {
      value: 2408409,
      label: "Olho-d'Água do Borges",
      reference: 24
    },
    {
      value: 3145455,
      label: "Olhos d'Água",
      reference: 31
    },
    {
      value: 3533908,
      label: "Olímpia",
      reference: 35
    },
    {
      value: 3145505,
      label: "Olímpio Noronha",
      reference: 31
    },
    {
      value: 2609600,
      label: "Olinda",
      reference: 26
    },
    {
      value: 2107456,
      label: "Olinda Nova do Maranhão",
      reference: 21
    },
    {
      value: 2923100,
      label: "Olindina",
      reference: 29
    },
    {
      value: 2510501,
      label: "Olivedos",
      reference: 25
    },
    {
      value: 3145604,
      label: "Oliveira",
      reference: 31
    },
    {
      value: 1715507,
      label: "Oliveira de Fátima",
      reference: 17
    },
    {
      value: 2923209,
      label: "Oliveira dos Brejinhos",
      reference: 29
    },
    {
      value: 3145703,
      label: "Oliveira Fortes",
      reference: 31
    },
    {
      value: 2706000,
      label: "Olivença",
      reference: 27
    },
    {
      value: 3145802,
      label: "Onça de Pitangui",
      reference: 31
    },
    {
      value: 3534005,
      label: "Onda Verde",
      reference: 35
    },
    {
      value: 3145851,
      label: "Oratórios",
      reference: 31
    },
    {
      value: 3534104,
      label: "Oriente",
      reference: 35
    },
    {
      value: 3534203,
      label: "Orindiúva",
      reference: 35
    },
    {
      value: 1505304,
      label: "Oriximiná",
      reference: 15
    },
    {
      value: 3145877,
      label: "Orizânia",
      reference: 31
    },
    {
      value: 5215306,
      label: "Orizona",
      reference: 52
    },
    {
      value: 3534302,
      label: "Orlândia",
      reference: 35
    },
    {
      value: 4211702,
      label: "Orleans",
      reference: 42
    },
    {
      value: 2609709,
      label: "Orobó",
      reference: 26
    },
    {
      value: 2609808,
      label: "Orocó",
      reference: 26
    },
    {
      value: 2309508,
      label: "Orós",
      reference: 23
    },
    {
      value: 4117305,
      label: "Ortigueira",
      reference: 41
    },
    {
      value: 3534401,
      label: "Osasco",
      reference: 35
    },
    {
      value: 3534500,
      label: "Oscar Bressane",
      reference: 35
    },
    {
      value: 4313508,
      label: "Osório",
      reference: 43
    },
    {
      value: 3534609,
      label: "Osvaldo Cruz",
      reference: 35
    },
    {
      value: 4211751,
      label: "Otacílio Costa",
      reference: 42
    },
    {
      value: 1505403,
      label: "Ourém",
      reference: 15
    },
    {
      value: 2923308,
      label: "Ouriçangas",
      reference: 29
    },
    {
      value: 2609907,
      label: "Ouricuri",
      reference: 26
    },
    {
      value: 1505437,
      label: "Ourilândia do Norte",
      reference: 15
    },
    {
      value: 3534708,
      label: "Ourinhos",
      reference: 35
    },
    {
      value: 4117404,
      label: "Ourizona",
      reference: 41
    },
    {
      value: 4211801,
      label: "Ouro",
      reference: 42
    },
    {
      value: 3145901,
      label: "Ouro Branco",
      reference: 31
    },
    {
      value: 2408508,
      label: "Ouro Branco",
      reference: 24
    },
    {
      value: 2706109,
      label: "Ouro Branco",
      reference: 27
    },
    {
      value: 3146008,
      label: "Ouro Fino",
      reference: 31
    },
    {
      value: 3146107,
      label: "Ouro Preto",
      reference: 31
    },
    {
      value: 1100155,
      label: "Ouro Preto do Oeste",
      reference: 11
    },
    {
      value: 2510600,
      label: "Ouro Velho",
      reference: 25
    },
    {
      value: 4211850,
      label: "Ouro Verde",
      reference: 42
    },
    {
      value: 3534807,
      label: "Ouro Verde",
      reference: 35
    },
    {
      value: 5215405,
      label: "Ouro Verde de Goiás",
      reference: 52
    },
    {
      value: 3146206,
      label: "Ouro Verde de Minas",
      reference: 31
    },
    {
      value: 4117453,
      label: "Ouro Verde do Oeste",
      reference: 41
    },
    {
      value: 3534757,
      label: "Ouroeste",
      reference: 35
    },
    {
      value: 2923357,
      label: "Ourolândia",
      reference: 29
    },
    {
      value: 5215504,
      label: "Ouvidor",
      reference: 52
    },
    {
      value: 3534906,
      label: "Pacaembu",
      reference: 35
    },
    {
      value: 1505486,
      label: "Pacajá",
      reference: 15
    },
    {
      value: 2309607,
      label: "Pacajus",
      reference: 23
    },
    {
      value: 1400456,
      label: "Pacaraima",
      reference: 14
    },
    {
      value: 2309706,
      label: "Pacatuba",
      reference: 23
    },
    {
      value: 2804904,
      label: "Pacatuba",
      reference: 28
    },
    {
      value: 2107506,
      label: "Paço do Lumiar",
      reference: 21
    },
    {
      value: 2309805,
      label: "Pacoti",
      reference: 23
    },
    {
      value: 2309904,
      label: "Pacujá",
      reference: 23
    },
    {
      value: 5215603,
      label: "Padre Bernardo",
      reference: 52
    },
    {
      value: 3146255,
      label: "Padre Carvalho",
      reference: 31
    },
    {
      value: 2207207,
      label: "Padre Marcos",
      reference: 22
    },
    {
      value: 3146305,
      label: "Padre Paraíso",
      reference: 31
    },
    {
      value: 2207306,
      label: "Paes Landim",
      reference: 22
    },
    {
      value: 3146552,
      label: "Pai Pedro",
      reference: 31
    },
    {
      value: 4211876,
      label: "Paial",
      reference: 42
    },
    {
      value: 4117503,
      label: "Paiçandu",
      reference: 41
    },
    {
      value: 4313607,
      label: "Paim Filho",
      reference: 43
    },
    {
      value: 3146404,
      label: "Paineiras",
      reference: 31
    },
    {
      value: 4211892,
      label: "Painel",
      reference: 42
    },
    {
      value: 3146503,
      label: "Pains",
      reference: 31
    },
    {
      value: 3146602,
      label: "Paiva",
      reference: 31
    },
    {
      value: 2207355,
      label: "Pajeú do Piauí",
      reference: 22
    },
    {
      value: 2706208,
      label: "Palestina",
      reference: 27
    },
    {
      value: 3535002,
      label: "Palestina",
      reference: 35
    },
    {
      value: 5215652,
      label: "Palestina de Goiás",
      reference: 52
    },
    {
      value: 1505494,
      label: "Palestina do Pará",
      reference: 15
    },
    {
      value: 2310001,
      label: "Palhano",
      reference: 23
    },
    {
      value: 4211900,
      label: "Palhoça",
      reference: 42
    },
    {
      value: 3146701,
      label: "Palma",
      reference: 31
    },
    {
      value: 4212007,
      label: "Palma Sola",
      reference: 42
    },
    {
      value: 2310100,
      label: "Palmácia",
      reference: 23
    },
    {
      value: 2610004,
      label: "Palmares",
      reference: 26
    },
    {
      value: 4313656,
      label: "Palmares do Sul",
      reference: 43
    },
    {
      value: 3535101,
      label: "Palmares Paulista",
      reference: 35
    },
    {
      value: 4117602,
      label: "Palmas",
      reference: 41
    },
    {
      value: 1721000,
      label: "Palmas",
      reference: 17
    },
    {
      value: 2923407,
      label: "Palmas de Monte Alto",
      reference: 29
    },
    {
      value: 4117701,
      label: "Palmeira",
      reference: 41
    },
    {
      value: 4212056,
      label: "Palmeira",
      reference: 42
    },
    {
      value: 3535200,
      label: "Palmeira d'Oeste",
      reference: 35
    },
    {
      value: 4313706,
      label: "Palmeira das Missões",
      reference: 43
    },
    {
      value: 2207405,
      label: "Palmeira do Piauí",
      reference: 22
    },
    {
      value: 2706307,
      label: "Palmeira dos Índios",
      reference: 27
    },
    {
      value: 2207504,
      label: "Palmeirais",
      reference: 22
    },
    {
      value: 2107605,
      label: "Palmeirândia",
      reference: 21
    },
    {
      value: 1715705,
      label: "Palmeirante",
      reference: 17
    },
    {
      value: 2923506,
      label: "Palmeiras",
      reference: 29
    },
    {
      value: 5215702,
      label: "Palmeiras de Goiás",
      reference: 52
    },
    {
      value: 1713809,
      label: "Palmeiras do Tocantins",
      reference: 17
    },
    {
      value: 2610103,
      label: "Palmeirina",
      reference: 26
    },
    {
      value: 1715754,
      label: "Palmeirópolis",
      reference: 17
    },
    {
      value: 5215801,
      label: "Palmelo",
      reference: 52
    },
    {
      value: 5215900,
      label: "Palminópolis",
      reference: 52
    },
    {
      value: 3535309,
      label: "Palmital",
      reference: 35
    },
    {
      value: 4117800,
      label: "Palmital",
      reference: 41
    },
    {
      value: 4313805,
      label: "Palmitinho",
      reference: 43
    },
    {
      value: 4212106,
      label: "Palmitos",
      reference: 42
    },
    {
      value: 3146750,
      label: "Palmópolis",
      reference: 31
    },
    {
      value: 4117909,
      label: "Palotina",
      reference: 41
    },
    {
      value: 5216007,
      label: "Panamá",
      reference: 52
    },
    {
      value: 4313904,
      label: "Panambi",
      reference: 43
    },
    {
      value: 3204005,
      label: "Pancas",
      reference: 32
    },
    {
      value: 2610202,
      label: "Panelas",
      reference: 26
    },
    {
      value: 3535408,
      label: "Panorama",
      reference: 35
    },
    {
      value: 4313953,
      label: "Pantano Grande",
      reference: 43
    },
    {
      value: 2706406,
      label: "Pão de Açúcar",
      reference: 27
    },
    {
      value: 3146909,
      label: "Papagaios",
      reference: 31
    },
    {
      value: 4212205,
      label: "Papanduva",
      reference: 42
    },
    {
      value: 2207553,
      label: "Paquetá",
      reference: 22
    },
    {
      value: 3147105,
      label: "Pará de Minas",
      reference: 31
    },
    {
      value: 3303609,
      label: "Paracambi",
      reference: 33
    },
    {
      value: 3147006,
      label: "Paracatu",
      reference: 31
    },
    {
      value: 2310209,
      label: "Paracuru",
      reference: 23
    },
    {
      value: 1505502,
      label: "Paragominas",
      reference: 15
    },
    {
      value: 3147204,
      label: "Paraguaçu",
      reference: 31
    },
    {
      value: 3535507,
      label: "Paraguaçu Paulista",
      reference: 35
    },
    {
      value: 4314001,
      label: "Paraí",
      reference: 43
    },
    {
      value: 3303708,
      label: "Paraíba do Sul",
      reference: 33
    },
    {
      value: 2107704,
      label: "Paraibano",
      reference: 21
    },
    {
      value: 3535606,
      label: "Paraibuna",
      reference: 35
    },
    {
      value: 2310258,
      label: "Paraipaba",
      reference: 23
    },
    {
      value: 3535705,
      label: "Paraíso",
      reference: 35
    },
    {
      value: 4212239,
      label: "Paraíso",
      reference: 42
    },
    {
      value: 5006275,
      label: "Paraíso das Águas",
      reference: 50
    },
    {
      value: 4118006,
      label: "Paraíso do Norte",
      reference: 41
    },
    {
      value: 4314027,
      label: "Paraíso do Sul",
      reference: 43
    },
    {
      value: 1716109,
      label: "Paraíso do Tocantins",
      reference: 17
    },
    {
      value: 3147303,
      label: "Paraisópolis",
      reference: 31
    },
    {
      value: 2310308,
      label: "Parambu",
      reference: 23
    },
    {
      value: 2923605,
      label: "Paramirim",
      reference: 29
    },
    {
      value: 2310407,
      label: "Paramoti",
      reference: 23
    },
    {
      value: 1716208,
      label: "Paranã",
      reference: 17
    },
    {
      value: 2408607,
      label: "Paraná",
      reference: 24
    },
    {
      value: 4118105,
      label: "Paranacity",
      reference: 41
    },
    {
      value: 4118204,
      label: "Paranaguá",
      reference: 41
    },
    {
      value: 5006309,
      label: "Paranaíba",
      reference: 50
    },
    {
      value: 5216304,
      label: "Paranaiguara",
      reference: 52
    },
    {
      value: 5106299,
      label: "Paranaíta",
      reference: 51
    },
    {
      value: 3535804,
      label: "Paranapanema",
      reference: 35
    },
    {
      value: 4118303,
      label: "Paranapoema",
      reference: 41
    },
    {
      value: 3535903,
      label: "Paranapuã",
      reference: 35
    },
    {
      value: 2610301,
      label: "Paranatama",
      reference: 26
    },
    {
      value: 5106307,
      label: "Paranatinga",
      reference: 51
    },
    {
      value: 4118402,
      label: "Paranavaí",
      reference: 41
    },
    {
      value: 5006358,
      label: "Paranhos",
      reference: 50
    },
    {
      value: 3147402,
      label: "Paraopeba",
      reference: 31
    },
    {
      value: 3536000,
      label: "Parapuã",
      reference: 35
    },
    {
      value: 2510659,
      label: "Parari",
      reference: 25
    },
    {
      value: 2923704,
      label: "Paratinga",
      reference: 29
    },
    {
      value: 3303807,
      label: "Paraty",
      reference: 33
    },
    {
      value: 2408706,
      label: "Paraú",
      reference: 24
    },
    {
      value: 1505536,
      label: "Parauapebas",
      reference: 15
    },
    {
      value: 5216403,
      label: "Paraúna",
      reference: 52
    },
    {
      value: 2408805,
      label: "Parazinho",
      reference: 24
    },
    {
      value: 3536109,
      label: "Pardinho",
      reference: 35
    },
    {
      value: 4314035,
      label: "Pareci Novo",
      reference: 43
    },
    {
      value: 1101450,
      label: "Parecis",
      reference: 11
    },
    {
      value: 2408904,
      label: "Parelhas",
      reference: 24
    },
    {
      value: 2706422,
      label: "Pariconha",
      reference: 27
    },
    {
      value: 1303403,
      label: "Parintins",
      reference: 13
    },
    {
      value: 2923803,
      label: "Paripiranga",
      reference: 29
    },
    {
      value: 2706448,
      label: "Paripueira",
      reference: 27
    },
    {
      value: 3536208,
      label: "Pariquera-Açu",
      reference: 35
    },
    {
      value: 3536257,
      label: "Parisi",
      reference: 35
    },
    {
      value: 2207603,
      label: "Parnaguá",
      reference: 22
    },
    {
      value: 2207702,
      label: "Parnaíba",
      reference: 22
    },
    {
      value: 2403251,
      label: "Parnamirim",
      reference: 24
    },
    {
      value: 2610400,
      label: "Parnamirim",
      reference: 26
    },
    {
      value: 2107803,
      label: "Parnarama",
      reference: 21
    },
    {
      value: 4314050,
      label: "Parobé",
      reference: 43
    },
    {
      value: 2409100,
      label: "Passa e Fica",
      reference: 24
    },
    {
      value: 3147600,
      label: "Passa Quatro",
      reference: 31
    },
    {
      value: 4314068,
      label: "Passa Sete",
      reference: 43
    },
    {
      value: 3147709,
      label: "Passa Tempo",
      reference: 31
    },
    {
      value: 3147808,
      label: "Passa-Vinte",
      reference: 31
    },
    {
      value: 3147501,
      label: "Passabém",
      reference: 31
    },
    {
      value: 2409209,
      label: "Passagem",
      reference: 24
    },
    {
      value: 2510709,
      label: "Passagem",
      reference: 25
    },
    {
      value: 2107902,
      label: "Passagem Franca",
      reference: 21
    },
    {
      value: 2207751,
      label: "Passagem Franca do Piauí",
      reference: 22
    },
    {
      value: 2610509,
      label: "Passira",
      reference: 26
    },
    {
      value: 2706505,
      label: "Passo de Camaragibe",
      reference: 27
    },
    {
      value: 4212254,
      label: "Passo de Torres",
      reference: 42
    },
    {
      value: 4314076,
      label: "Passo do Sobrado",
      reference: 43
    },
    {
      value: 4314100,
      label: "Passo Fundo",
      reference: 43
    },
    {
      value: 3147907,
      label: "Passos",
      reference: 31
    },
    {
      value: 4212270,
      label: "Passos Maia",
      reference: 42
    },
    {
      value: 2108009,
      label: "Pastos Bons",
      reference: 21
    },
    {
      value: 3147956,
      label: "Patis",
      reference: 31
    },
    {
      value: 4118451,
      label: "Pato Bragado",
      reference: 41
    },
    {
      value: 4118501,
      label: "Pato Branco",
      reference: 41
    },
    {
      value: 2510808,
      label: "Patos",
      reference: 25
    },
    {
      value: 3148004,
      label: "Patos de Minas",
      reference: 31
    },
    {
      value: 2207777,
      label: "Patos do Piauí",
      reference: 22
    },
    {
      value: 3148103,
      label: "Patrocínio",
      reference: 31
    },
    {
      value: 3148202,
      label: "Patrocínio do Muriaé",
      reference: 31
    },
    {
      value: 3536307,
      label: "Patrocínio Paulista",
      reference: 35
    },
    {
      value: 2409308,
      label: "Patu",
      reference: 24
    },
    {
      value: 3303856,
      label: "Paty do Alferes",
      reference: 33
    },
    {
      value: 2923902,
      label: "Pau Brasil",
      reference: 29
    },
    {
      value: 1505551,
      label: "Pau d'Arco",
      reference: 15
    },
    {
      value: 1716307,
      label: "Pau D'Arco",
      reference: 17
    },
    {
      value: 2207793,
      label: "Pau D'Arco do Piauí",
      reference: 22
    },
    {
      value: 2409407,
      label: "Pau dos Ferros",
      reference: 24
    },
    {
      value: 2610608,
      label: "Paudalho",
      reference: 26
    },
    {
      value: 1303502,
      label: "Pauini",
      reference: 13
    },
    {
      value: 3148301,
      label: "Paula Cândido",
      reference: 31
    },
    {
      value: 4118600,
      label: "Paula Freitas",
      reference: 41
    },
    {
      value: 3536406,
      label: "Paulicéia",
      reference: 35
    },
    {
      value: 3536505,
      label: "Paulínia",
      reference: 35
    },
    {
      value: 2108058,
      label: "Paulino Neves",
      reference: 21
    },
    {
      value: 2510907,
      label: "Paulista",
      reference: 25
    },
    {
      value: 2610707,
      label: "Paulista",
      reference: 26
    },
    {
      value: 2207801,
      label: "Paulistana",
      reference: 22
    },
    {
      value: 3536570,
      label: "Paulistânia",
      reference: 35
    },
    {
      value: 3148400,
      label: "Paulistas",
      reference: 31
    },
    {
      value: 2924009,
      label: "Paulo Afonso",
      reference: 29
    },
    {
      value: 4314134,
      label: "Paulo Bento",
      reference: 43
    },
    {
      value: 3536604,
      label: "Paulo de Faria",
      reference: 35
    },
    {
      value: 4118709,
      label: "Paulo Frontin",
      reference: 41
    },
    {
      value: 2706604,
      label: "Paulo Jacinto",
      reference: 27
    },
    {
      value: 4212304,
      label: "Paulo Lopes",
      reference: 42
    },
    {
      value: 2108108,
      label: "Paulo Ramos",
      reference: 21
    },
    {
      value: 3148509,
      label: "Pavão",
      reference: 31
    },
    {
      value: 4314159,
      label: "Paverama",
      reference: 43
    },
    {
      value: 2207850,
      label: "Pavussu",
      reference: 22
    },
    {
      value: 2924058,
      label: "Pé de Serra",
      reference: 29
    },
    {
      value: 4118808,
      label: "Peabiru",
      reference: 41
    },
    {
      value: 3148608,
      label: "Peçanha",
      reference: 31
    },
    {
      value: 3536703,
      label: "Pederneiras",
      reference: 35
    },
    {
      value: 2610806,
      label: "Pedra",
      reference: 26
    },
    {
      value: 3148707,
      label: "Pedra Azul",
      reference: 31
    },
    {
      value: 3536802,
      label: "Pedra Bela",
      reference: 35
    },
    {
      value: 3148756,
      label: "Pedra Bonita",
      reference: 31
    },
    {
      value: 2511004,
      label: "Pedra Branca",
      reference: 25
    },
    {
      value: 2310506,
      label: "Pedra Branca",
      reference: 23
    },
    {
      value: 1600154,
      label: "Pedra Branca do Amapari",
      reference: 16
    },
    {
      value: 3148806,
      label: "Pedra do Anta",
      reference: 31
    },
    {
      value: 3148905,
      label: "Pedra do Indaiá",
      reference: 31
    },
    {
      value: 3149002,
      label: "Pedra Dourada",
      reference: 31
    },
    {
      value: 2409506,
      label: "Pedra Grande",
      reference: 24
    },
    {
      value: 2511103,
      label: "Pedra Lavrada",
      reference: 25
    },
    {
      value: 2805000,
      label: "Pedra Mole",
      reference: 28
    },
    {
      value: 2409605,
      label: "Pedra Preta",
      reference: 24
    },
    {
      value: 5106372,
      label: "Pedra Preta",
      reference: 51
    },
    {
      value: 3149101,
      label: "Pedralva",
      reference: 31
    },
    {
      value: 3536901,
      label: "Pedranópolis",
      reference: 35
    },
    {
      value: 2924108,
      label: "Pedrão",
      reference: 29
    },
    {
      value: 4314175,
      label: "Pedras Altas",
      reference: 43
    },
    {
      value: 2511202,
      label: "Pedras de Fogo",
      reference: 25
    },
    {
      value: 3149150,
      label: "Pedras de Maria da Cruz",
      reference: 31
    },
    {
      value: 4212403,
      label: "Pedras Grandes",
      reference: 42
    },
    {
      value: 3537008,
      label: "Pedregulho",
      reference: 35
    },
    {
      value: 3537107,
      label: "Pedreira",
      reference: 35
    },
    {
      value: 2108207,
      label: "Pedreiras",
      reference: 21
    },
    {
      value: 2805109,
      label: "Pedrinhas",
      reference: 28
    },
    {
      value: 3537156,
      label: "Pedrinhas Paulista",
      reference: 35
    },
    {
      value: 3149200,
      label: "Pedrinópolis",
      reference: 31
    },
    {
      value: 1716505,
      label: "Pedro Afonso",
      reference: 17
    },
    {
      value: 2924207,
      label: "Pedro Alexandre",
      reference: 29
    },
    {
      value: 2409704,
      label: "Pedro Avelino",
      reference: 24
    },
    {
      value: 3204054,
      label: "Pedro Canário",
      reference: 32
    },
    {
      value: 3537206,
      label: "Pedro de Toledo",
      reference: 35
    },
    {
      value: 2108256,
      label: "Pedro do Rosário",
      reference: 21
    },
    {
      value: 5006408,
      label: "Pedro Gomes",
      reference: 50
    },
    {
      value: 2207900,
      label: "Pedro II",
      reference: 22
    },
    {
      value: 2207934,
      label: "Pedro Laurentino",
      reference: 22
    },
    {
      value: 3149309,
      label: "Pedro Leopoldo",
      reference: 31
    },
    {
      value: 4314209,
      label: "Pedro Osório",
      reference: 43
    },
    {
      value: 2512721,
      label: "Pedro Régis",
      reference: 25
    },
    {
      value: 3149408,
      label: "Pedro Teixeira",
      reference: 31
    },
    {
      value: 2409803,
      label: "Pedro Velho",
      reference: 24
    },
    {
      value: 1716604,
      label: "Peixe",
      reference: 17
    },
    {
      value: 1505601,
      label: "Peixe-Boi",
      reference: 15
    },
    {
      value: 5106422,
      label: "Peixoto de Azevedo",
      reference: 51
    },
    {
      value: 4314308,
      label: "Pejuçara",
      reference: 43
    },
    {
      value: 4314407,
      label: "Pelotas",
      reference: 43
    },
    {
      value: 2310605,
      label: "Penaforte",
      reference: 23
    },
    {
      value: 2108306,
      label: "Penalva",
      reference: 21
    },
    {
      value: 3537305,
      label: "Penápolis",
      reference: 35
    },
    {
      value: 2409902,
      label: "Pendências",
      reference: 24
    },
    {
      value: 2706703,
      label: "Penedo",
      reference: 27
    },
    {
      value: 4212502,
      label: "Penha",
      reference: 42
    },
    {
      value: 2310704,
      label: "Pentecoste",
      reference: 23
    },
    {
      value: 3149507,
      label: "Pequeri",
      reference: 31
    },
    {
      value: 3149606,
      label: "Pequi",
      reference: 31
    },
    {
      value: 1716653,
      label: "Pequizeiro",
      reference: 17
    },
    {
      value: 3149705,
      label: "Perdigão",
      reference: 31
    },
    {
      value: 3149804,
      label: "Perdizes",
      reference: 31
    },
    {
      value: 3149903,
      label: "Perdões",
      reference: 31
    },
    {
      value: 3537404,
      label: "Pereira Barreto",
      reference: 35
    },
    {
      value: 3537503,
      label: "Pereiras",
      reference: 35
    },
    {
      value: 2310803,
      label: "Pereiro",
      reference: 23
    },
    {
      value: 2108405,
      label: "Peri Mirim",
      reference: 21
    },
    {
      value: 3149952,
      label: "Periquito",
      reference: 31
    },
    {
      value: 4212601,
      label: "Peritiba",
      reference: 42
    },
    {
      value: 2108454,
      label: "Peritoró",
      reference: 21
    },
    {
      value: 4118857,
      label: "Perobal",
      reference: 41
    },
    {
      value: 4118907,
      label: "Pérola",
      reference: 41
    },
    {
      value: 4119004,
      label: "Pérola d'Oeste",
      reference: 41
    },
    {
      value: 5216452,
      label: "Perolândia",
      reference: 52
    },
    {
      value: 3537602,
      label: "Peruíbe",
      reference: 35
    },
    {
      value: 3150000,
      label: "Pescador",
      reference: 31
    },
    {
      value: 4212650,
      label: "Pescaria Brava",
      reference: 42
    },
    {
      value: 2610905,
      label: "Pesqueira",
      reference: 26
    },
    {
      value: 2611002,
      label: "Petrolândia",
      reference: 26
    },
    {
      value: 4212700,
      label: "Petrolândia",
      reference: 42
    },
    {
      value: 2611101,
      label: "Petrolina",
      reference: 26
    },
    {
      value: 5216809,
      label: "Petrolina de Goiás",
      reference: 52
    },
    {
      value: 3303906,
      label: "Petrópolis",
      reference: 33
    },
    {
      value: 2706802,
      label: "Piaçabuçu",
      reference: 27
    },
    {
      value: 3537701,
      label: "Piacatu",
      reference: 35
    },
    {
      value: 2511301,
      label: "Piancó",
      reference: 25
    },
    {
      value: 2924306,
      label: "Piatã",
      reference: 29
    },
    {
      value: 3150109,
      label: "Piau",
      reference: 31
    },
    {
      value: 4314423,
      label: "Picada Café",
      reference: 43
    },
    {
      value: 1505635,
      label: "Piçarra",
      reference: 15
    },
    {
      value: 2208007,
      label: "Picos",
      reference: 22
    },
    {
      value: 2511400,
      label: "Picuí",
      reference: 25
    },
    {
      value: 3537800,
      label: "Piedade",
      reference: 35
    },
    {
      value: 3150158,
      label: "Piedade de Caratinga",
      reference: 31
    },
    {
      value: 3150208,
      label: "Piedade de Ponte Nova",
      reference: 31
    },
    {
      value: 3150307,
      label: "Piedade do Rio Grande",
      reference: 31
    },
    {
      value: 3150406,
      label: "Piedade dos Gerais",
      reference: 31
    },
    {
      value: 4119103,
      label: "Piên",
      reference: 41
    },
    {
      value: 2924405,
      label: "Pilão Arcado",
      reference: 29
    },
    {
      value: 2511509,
      label: "Pilar",
      reference: 25
    },
    {
      value: 2706901,
      label: "Pilar",
      reference: 27
    },
    {
      value: 5216908,
      label: "Pilar de Goiás",
      reference: 52
    },
    {
      value: 3537909,
      label: "Pilar do Sul",
      reference: 35
    },
    {
      value: 2410009,
      label: "Pilões",
      reference: 24
    },
    {
      value: 2511608,
      label: "Pilões",
      reference: 25
    },
    {
      value: 2511707,
      label: "Pilõezinhos",
      reference: 25
    },
    {
      value: 3150505,
      label: "Pimenta",
      reference: 31
    },
    {
      value: 1100189,
      label: "Pimenta Bueno",
      reference: 11
    },
    {
      value: 2208106,
      label: "Pimenteiras",
      reference: 22
    },
    {
      value: 1101468,
      label: "Pimenteiras do Oeste",
      reference: 11
    },
    {
      value: 2924504,
      label: "Pindaí",
      reference: 29
    },
    {
      value: 3538006,
      label: "Pindamonhangaba",
      reference: 35
    },
    {
      value: 2108504,
      label: "Pindaré-Mirim",
      reference: 21
    },
    {
      value: 2707008,
      label: "Pindoba",
      reference: 27
    },
    {
      value: 2924603,
      label: "Pindobaçu",
      reference: 29
    },
    {
      value: 3538105,
      label: "Pindorama",
      reference: 35
    },
    {
      value: 1717008,
      label: "Pindorama do Tocantins",
      reference: 17
    },
    {
      value: 2310852,
      label: "Pindoretama",
      reference: 23
    },
    {
      value: 3150539,
      label: "Pingo-d'Água",
      reference: 31
    },
    {
      value: 4119152,
      label: "Pinhais",
      reference: 41
    },
    {
      value: 4314456,
      label: "Pinhal",
      reference: 43
    },
    {
      value: 4314464,
      label: "Pinhal da Serra",
      reference: 43
    },
    {
      value: 4119251,
      label: "Pinhal de São Bento",
      reference: 41
    },
    {
      value: 4314472,
      label: "Pinhal Grande",
      reference: 43
    },
    {
      value: 4119202,
      label: "Pinhalão",
      reference: 41
    },
    {
      value: 3538204,
      label: "Pinhalzinho",
      reference: 35
    },
    {
      value: 4212908,
      label: "Pinhalzinho",
      reference: 42
    },
    {
      value: 2805208,
      label: "Pinhão",
      reference: 28
    },
    {
      value: 4119301,
      label: "Pinhão",
      reference: 41
    },
    {
      value: 3303955,
      label: "Pinheiral",
      reference: 33
    },
    {
      value: 4314498,
      label: "Pinheirinho do Vale",
      reference: 43
    },
    {
      value: 2108603,
      label: "Pinheiro",
      reference: 21
    },
    {
      value: 4314506,
      label: "Pinheiro Machado",
      reference: 43
    },
    {
      value: 4213005,
      label: "Pinheiro Preto",
      reference: 42
    },
    {
      value: 3204104,
      label: "Pinheiros",
      reference: 32
    },
    {
      value: 2924652,
      label: "Pintadas",
      reference: 29
    },
    {
      value: 4314548,
      label: "Pinto Bandeira",
      reference: 43
    },
    {
      value: 3150570,
      label: "Pintópolis",
      reference: 31
    },
    {
      value: 2208205,
      label: "Pio IX",
      reference: 22
    },
    {
      value: 2108702,
      label: "Pio XII",
      reference: 21
    },
    {
      value: 3538303,
      label: "Piquerobi",
      reference: 35
    },
    {
      value: 2310902,
      label: "Piquet Carneiro",
      reference: 23
    },
    {
      value: 3538501,
      label: "Piquete",
      reference: 35
    },
    {
      value: 3538600,
      label: "Piracaia",
      reference: 35
    },
    {
      value: 5217104,
      label: "Piracanjuba",
      reference: 52
    },
    {
      value: 3150604,
      label: "Piracema",
      reference: 31
    },
    {
      value: 3538709,
      label: "Piracicaba",
      reference: 35
    },
    {
      value: 2208304,
      label: "Piracuruca",
      reference: 22
    },
    {
      value: 3304003,
      label: "Piraí",
      reference: 33
    },
    {
      value: 2924678,
      label: "Piraí do Norte",
      reference: 29
    },
    {
      value: 4119400,
      label: "Piraí do Sul",
      reference: 41
    },
    {
      value: 3538808,
      label: "Piraju",
      reference: 35
    },
    {
      value: 3150703,
      label: "Pirajuba",
      reference: 31
    },
    {
      value: 3538907,
      label: "Pirajuí",
      reference: 35
    },
    {
      value: 2805307,
      label: "Pirambu",
      reference: 28
    },
    {
      value: 3150802,
      label: "Piranga",
      reference: 31
    },
    {
      value: 3539004,
      label: "Pirangi",
      reference: 35
    },
    {
      value: 3150901,
      label: "Piranguçu",
      reference: 31
    },
    {
      value: 3151008,
      label: "Piranguinho",
      reference: 31
    },
    {
      value: 2707107,
      label: "Piranhas",
      reference: 27
    },
    {
      value: 5217203,
      label: "Piranhas",
      reference: 52
    },
    {
      value: 2108801,
      label: "Pirapemas",
      reference: 21
    },
    {
      value: 3151107,
      label: "Pirapetinga",
      reference: 31
    },
    {
      value: 4314555,
      label: "Pirapó",
      reference: 43
    },
    {
      value: 3151206,
      label: "Pirapora",
      reference: 31
    },
    {
      value: 3539103,
      label: "Pirapora do Bom Jesus",
      reference: 35
    },
    {
      value: 3539202,
      label: "Pirapozinho",
      reference: 35
    },
    {
      value: 4119509,
      label: "Piraquara",
      reference: 41
    },
    {
      value: 1717206,
      label: "Piraquê",
      reference: 17
    },
    {
      value: 3539301,
      label: "Pirassununga",
      reference: 35
    },
    {
      value: 4314605,
      label: "Piratini",
      reference: 43
    },
    {
      value: 3539400,
      label: "Piratininga",
      reference: 35
    },
    {
      value: 4213104,
      label: "Piratuba",
      reference: 42
    },
    {
      value: 3151305,
      label: "Piraúba",
      reference: 31
    },
    {
      value: 5217302,
      label: "Pirenópolis",
      reference: 52
    },
    {
      value: 5217401,
      label: "Pires do Rio",
      reference: 52
    },
    {
      value: 2310951,
      label: "Pires Ferreira",
      reference: 23
    },
    {
      value: 2924702,
      label: "Piripá",
      reference: 29
    },
    {
      value: 2208403,
      label: "Piripiri",
      reference: 22
    },
    {
      value: 2924801,
      label: "Piritiba",
      reference: 29
    },
    {
      value: 2511806,
      label: "Pirpirituba",
      reference: 25
    },
    {
      value: 4119608,
      label: "Pitanga",
      reference: 41
    },
    {
      value: 3539509,
      label: "Pitangueiras",
      reference: 35
    },
    {
      value: 4119657,
      label: "Pitangueiras",
      reference: 41
    },
    {
      value: 3151404,
      label: "Pitangui",
      reference: 31
    },
    {
      value: 2511905,
      label: "Pitimbu",
      reference: 25
    },
    {
      value: 1717503,
      label: "Pium",
      reference: 17
    },
    {
      value: 3204203,
      label: "Piúma",
      reference: 32
    },
    {
      value: 3151503,
      label: "Piumhi",
      reference: 31
    },
    {
      value: 1505650,
      label: "Placas",
      reference: 15
    },
    {
      value: 1200385,
      label: "Plácido de Castro",
      reference: 12
    },
    {
      value: 5217609,
      label: "Planaltina",
      reference: 52
    },
    {
      value: 4119707,
      label: "Planaltina do Paraná",
      reference: 41
    },
    {
      value: 2924900,
      label: "Planaltino",
      reference: 29
    },
    {
      value: 2925006,
      label: "Planalto",
      reference: 29
    },
    {
      value: 4314704,
      label: "Planalto",
      reference: 43
    },
    {
      value: 3539608,
      label: "Planalto",
      reference: 35
    },
    {
      value: 4119806,
      label: "Planalto",
      reference: 41
    },
    {
      value: 4213153,
      label: "Planalto Alegre",
      reference: 42
    },
    {
      value: 5106455,
      label: "Planalto da Serra",
      reference: 51
    },
    {
      value: 3151602,
      label: "Planura",
      reference: 31
    },
    {
      value: 3539707,
      label: "Platina",
      reference: 35
    },
    {
      value: 3539806,
      label: "Poá",
      reference: 35
    },
    {
      value: 2611200,
      label: "Poção",
      reference: 26
    },
    {
      value: 2108900,
      label: "Poção de Pedras",
      reference: 21
    },
    {
      value: 2512002,
      label: "Pocinhos",
      reference: 25
    },
    {
      value: 2410108,
      label: "Poço Branco",
      reference: 24
    },
    {
      value: 2512036,
      label: "Poço Dantas",
      reference: 25
    },
    {
      value: 4314753,
      label: "Poço das Antas",
      reference: 43
    },
    {
      value: 2707206,
      label: "Poço das Trincheiras",
      reference: 27
    },
    {
      value: 2512077,
      label: "Poço de José de Moura",
      reference: 25
    },
    {
      value: 3151701,
      label: "Poço Fundo",
      reference: 31
    },
    {
      value: 2805406,
      label: "Poço Redondo",
      reference: 28
    },
    {
      value: 2805505,
      label: "Poço Verde",
      reference: 28
    },
    {
      value: 2925105,
      label: "Poções",
      reference: 29
    },
    {
      value: 5106505,
      label: "Poconé",
      reference: 51
    },
    {
      value: 3151800,
      label: "Poços de Caldas",
      reference: 31
    },
    {
      value: 3151909,
      label: "Pocrane",
      reference: 31
    },
    {
      value: 2925204,
      label: "Pojuca",
      reference: 29
    },
    {
      value: 3539905,
      label: "Poloni",
      reference: 35
    },
    {
      value: 2512101,
      label: "Pombal",
      reference: 25
    },
    {
      value: 2611309,
      label: "Pombos",
      reference: 26
    },
    {
      value: 4213203,
      label: "Pomerode",
      reference: 42
    },
    {
      value: 3540002,
      label: "Pompéia",
      reference: 35
    },
    {
      value: 3152006,
      label: "Pompéu",
      reference: 31
    },
    {
      value: 3540101,
      label: "Pongaí",
      reference: 35
    },
    {
      value: 1505700,
      label: "Ponta de Pedras",
      reference: 15
    },
    {
      value: 4119905,
      label: "Ponta Grossa",
      reference: 41
    },
    {
      value: 5006606,
      label: "Ponta Porã",
      reference: 50
    },
    {
      value: 3540200,
      label: "Pontal",
      reference: 35
    },
    {
      value: 5106653,
      label: "Pontal do Araguaia",
      reference: 51
    },
    {
      value: 4119954,
      label: "Pontal do Paraná",
      reference: 41
    },
    {
      value: 5217708,
      label: "Pontalina",
      reference: 52
    },
    {
      value: 3540259,
      label: "Pontalinda",
      reference: 35
    },
    {
      value: 4314779,
      label: "Pontão",
      reference: 43
    },
    {
      value: 4213302,
      label: "Ponte Alta",
      reference: 42
    },
    {
      value: 1717800,
      label: "Ponte Alta do Bom Jesus",
      reference: 17
    },
    {
      value: 4213351,
      label: "Ponte Alta do Norte",
      reference: 42
    },
    {
      value: 1717909,
      label: "Ponte Alta do Tocantins",
      reference: 17
    },
    {
      value: 5106703,
      label: "Ponte Branca",
      reference: 51
    },
    {
      value: 3152105,
      label: "Ponte Nova",
      reference: 31
    },
    {
      value: 4314787,
      label: "Ponte Preta",
      reference: 43
    },
    {
      value: 4213401,
      label: "Ponte Serrada",
      reference: 42
    },
    {
      value: 5106752,
      label: "Pontes e Lacerda",
      reference: 51
    },
    {
      value: 3540309,
      label: "Pontes Gestal",
      reference: 35
    },
    {
      value: 3204252,
      label: "Ponto Belo",
      reference: 32
    },
    {
      value: 3152131,
      label: "Ponto Chique",
      reference: 31
    },
    {
      value: 3152170,
      label: "Ponto dos Volantes",
      reference: 31
    },
    {
      value: 2925253,
      label: "Ponto Novo",
      reference: 29
    },
    {
      value: 3540408,
      label: "Populina",
      reference: 35
    },
    {
      value: 2311009,
      label: "Poranga",
      reference: 23
    },
    {
      value: 3540507,
      label: "Porangaba",
      reference: 35
    },
    {
      value: 5218003,
      label: "Porangatu",
      reference: 52
    },
    {
      value: 3304102,
      label: "Porciúncula",
      reference: 33
    },
    {
      value: 4120002,
      label: "Porecatu",
      reference: 41
    },
    {
      value: 2410207,
      label: "Portalegre",
      reference: 24
    },
    {
      value: 4314803,
      label: "Portão",
      reference: 43
    },
    {
      value: 5218052,
      label: "Porteirão",
      reference: 52
    },
    {
      value: 2311108,
      label: "Porteiras",
      reference: 23
    },
    {
      value: 3152204,
      label: "Porteirinha",
      reference: 31
    },
    {
      value: 1505809,
      label: "Portel",
      reference: 15
    },
    {
      value: 5218102,
      label: "Portelândia",
      reference: 52
    },
    {
      value: 2208502,
      label: "Porto",
      reference: 22
    },
    {
      value: 1200807,
      label: "Porto Acre",
      reference: 12
    },
    {
      value: 4314902,
      label: "Porto Alegre",
      reference: 43
    },
    {
      value: 5106778,
      label: "Porto Alegre do Norte",
      reference: 51
    },
    {
      value: 2208551,
      label: "Porto Alegre do Piauí",
      reference: 22
    },
    {
      value: 1718006,
      label: "Porto Alegre do Tocantins",
      reference: 17
    },
    {
      value: 4120101,
      label: "Porto Amazonas",
      reference: 41
    },
    {
      value: 4120150,
      label: "Porto Barreiro",
      reference: 41
    },
    {
      value: 4213500,
      label: "Porto Belo",
      reference: 42
    },
    {
      value: 2707305,
      label: "Porto Calvo",
      reference: 27
    },
    {
      value: 2805604,
      label: "Porto da Folha",
      reference: 28
    },
    {
      value: 1505908,
      label: "Porto de Moz",
      reference: 15
    },
    {
      value: 2707404,
      label: "Porto de Pedras",
      reference: 27
    },
    {
      value: 2410256,
      label: "Porto do Mangue",
      reference: 24
    },
    {
      value: 5106802,
      label: "Porto dos Gaúchos",
      reference: 51
    },
    {
      value: 5106828,
      label: "Porto Esperidião",
      reference: 51
    },
    {
      value: 5106851,
      label: "Porto Estrela",
      reference: 51
    },
    {
      value: 3540606,
      label: "Porto Feliz",
      reference: 35
    },
    {
      value: 3540705,
      label: "Porto Ferreira",
      reference: 35
    },
    {
      value: 3152303,
      label: "Porto Firme",
      reference: 31
    },
    {
      value: 2109007,
      label: "Porto Franco",
      reference: 21
    },
    {
      value: 1600535,
      label: "Porto Grande",
      reference: 16
    },
    {
      value: 4315008,
      label: "Porto Lucena",
      reference: 43
    },
    {
      value: 4315057,
      label: "Porto Mauá",
      reference: 43
    },
    {
      value: 5006903,
      label: "Porto Murtinho",
      reference: 50
    },
    {
      value: 1718204,
      label: "Porto Nacional",
      reference: 17
    },
    {
      value: 3304110,
      label: "Porto Real",
      reference: 33
    },
    {
      value: 2707503,
      label: "Porto Real do Colégio",
      reference: 27
    },
    {
      value: 4120200,
      label: "Porto Rico",
      reference: 41
    },
    {
      value: 2109056,
      label: "Porto Rico do Maranhão",
      reference: 21
    },
    {
      value: 2925303,
      label: "Porto Seguro",
      reference: 29
    },
    {
      value: 4213609,
      label: "Porto União",
      reference: 42
    },
    {
      value: 1100205,
      label: "Porto Velho",
      reference: 11
    },
    {
      value: 4315073,
      label: "Porto Vera Cruz",
      reference: 43
    },
    {
      value: 4120309,
      label: "Porto Vitória",
      reference: 41
    },
    {
      value: 1200393,
      label: "Porto Walter",
      reference: 12
    },
    {
      value: 4315107,
      label: "Porto Xavier",
      reference: 43
    },
    {
      value: 5218300,
      label: "Posse",
      reference: 52
    },
    {
      value: 3152402,
      label: "Poté",
      reference: 31
    },
    {
      value: 2311207,
      label: "Potengi",
      reference: 23
    },
    {
      value: 3540754,
      label: "Potim",
      reference: 35
    },
    {
      value: 2925402,
      label: "Potiraguá",
      reference: 29
    },
    {
      value: 3540804,
      label: "Potirendaba",
      reference: 35
    },
    {
      value: 2311231,
      label: "Potiretama",
      reference: 23
    },
    {
      value: 3152501,
      label: "Pouso Alegre",
      reference: 31
    },
    {
      value: 3152600,
      label: "Pouso Alto",
      reference: 31
    },
    {
      value: 4315131,
      label: "Pouso Novo",
      reference: 43
    },
    {
      value: 4213708,
      label: "Pouso Redondo",
      reference: 42
    },
    {
      value: 5107008,
      label: "Poxoréu",
      reference: 51
    },
    {
      value: 3540853,
      label: "Pracinha",
      reference: 35
    },
    {
      value: 1600550,
      label: "Pracuúba",
      reference: 16
    },
    {
      value: 2925501,
      label: "Prado",
      reference: 29
    },
    {
      value: 4120333,
      label: "Prado Ferreira",
      reference: 41
    },
    {
      value: 3540903,
      label: "Pradópolis",
      reference: 35
    },
    {
      value: 3152709,
      label: "Prados",
      reference: 31
    },
    {
      value: 3541000,
      label: "Praia Grande",
      reference: 35
    },
    {
      value: 4213807,
      label: "Praia Grande",
      reference: 42
    },
    {
      value: 1718303,
      label: "Praia Norte",
      reference: 17
    },
    {
      value: 1506005,
      label: "Prainha",
      reference: 15
    },
    {
      value: 4120358,
      label: "Pranchita",
      reference: 41
    },
    {
      value: 3152808,
      label: "Prata",
      reference: 31
    },
    {
      value: 2512200,
      label: "Prata",
      reference: 25
    },
    {
      value: 2208601,
      label: "Prata do Piauí",
      reference: 22
    },
    {
      value: 3541059,
      label: "Pratânia",
      reference: 35
    },
    {
      value: 3152907,
      label: "Pratápolis",
      reference: 31
    },
    {
      value: 3153004,
      label: "Pratinha",
      reference: 31
    },
    {
      value: 3541109,
      label: "Presidente Alves",
      reference: 35
    },
    {
      value: 3541208,
      label: "Presidente Bernardes",
      reference: 35
    },
    {
      value: 3153103,
      label: "Presidente Bernardes",
      reference: 31
    },
    {
      value: 4213906,
      label: "Presidente Castello Branco",
      reference: 42
    },
    {
      value: 4120408,
      label: "Presidente Castelo Branco",
      reference: 41
    },
    {
      value: 2925600,
      label: "Presidente Dutra",
      reference: 29
    },
    {
      value: 2109106,
      label: "Presidente Dutra",
      reference: 21
    },
    {
      value: 3541307,
      label: "Presidente Epitácio",
      reference: 35
    },
    {
      value: 1303536,
      label: "Presidente Figueiredo",
      reference: 13
    },
    {
      value: 4214003,
      label: "Presidente Getúlio",
      reference: 42
    },
    {
      value: 2925709,
      label: "Presidente Jânio Quadros",
      reference: 29
    },
    {
      value: 3153202,
      label: "Presidente Juscelino",
      reference: 31
    },
    {
      value: 2109205,
      label: "Presidente Juscelino",
      reference: 21
    },
    {
      value: 1718402,
      label: "Presidente Kennedy",
      reference: 17
    },
    {
      value: 3204302,
      label: "Presidente Kennedy",
      reference: 32
    },
    {
      value: 3153301,
      label: "Presidente Kubitschek",
      reference: 31
    },
    {
      value: 4315149,
      label: "Presidente Lucena",
      reference: 43
    },
    {
      value: 1100254,
      label: "Presidente Médici",
      reference: 11
    },
    {
      value: 2109239,
      label: "Presidente Médici",
      reference: 21
    },
    {
      value: 4214102,
      label: "Presidente Nereu",
      reference: 42
    },
    {
      value: 3153400,
      label: "Presidente Olegário",
      reference: 31
    },
    {
      value: 3541406,
      label: "Presidente Prudente",
      reference: 35
    },
    {
      value: 2109270,
      label: "Presidente Sarney",
      reference: 21
    },
    {
      value: 2925758,
      label: "Presidente Tancredo Neves",
      reference: 29
    },
    {
      value: 2109304,
      label: "Presidente Vargas",
      reference: 21
    },
    {
      value: 3541505,
      label: "Presidente Venceslau",
      reference: 35
    },
    {
      value: 2611408,
      label: "Primavera",
      reference: 26
    },
    {
      value: 1506104,
      label: "Primavera",
      reference: 15
    },
    {
      value: 1101476,
      label: "Primavera de Rondônia",
      reference: 11
    },
    {
      value: 5107040,
      label: "Primavera do Leste",
      reference: 51
    },
    {
      value: 2109403,
      label: "Primeira Cruz",
      reference: 21
    },
    {
      value: 4120507,
      label: "Primeiro de Maio",
      reference: 41
    },
    {
      value: 4214151,
      label: "Princesa",
      reference: 42
    },
    {
      value: 2512309,
      label: "Princesa Isabel",
      reference: 25
    },
    {
      value: 5218391,
      label: "Professor Jamil",
      reference: 52
    },
    {
      value: 4315156,
      label: "Progresso",
      reference: 43
    },
    {
      value: 3541604,
      label: "Promissão",
      reference: 35
    },
    {
      value: 2805703,
      label: "Propriá",
      reference: 28
    },
    {
      value: 4315172,
      label: "Protásio Alves",
      reference: 43
    },
    {
      value: 3153608,
      label: "Prudente de Morais",
      reference: 31
    },
    {
      value: 4120606,
      label: "Prudentópolis",
      reference: 41
    },
    {
      value: 1718451,
      label: "Pugmil",
      reference: 17
    },
    {
      value: 2410405,
      label: "Pureza",
      reference: 24
    },
    {
      value: 4315206,
      label: "Putinga",
      reference: 43
    },
    {
      value: 2512408,
      label: "Puxinanã",
      reference: 25
    },
    {
      value: 3541653,
      label: "Quadra",
      reference: 35
    },
    {
      value: 4315305,
      label: "Quaraí",
      reference: 43
    },
    {
      value: 3153707,
      label: "Quartel Geral",
      reference: 31
    },
    {
      value: 4120655,
      label: "Quarto Centenário",
      reference: 41
    },
    {
      value: 3541703,
      label: "Quatá",
      reference: 35
    },
    {
      value: 4120705,
      label: "Quatiguá",
      reference: 41
    },
    {
      value: 1506112,
      label: "Quatipuru",
      reference: 15
    },
    {
      value: 3304128,
      label: "Quatis",
      reference: 33
    },
    {
      value: 4120804,
      label: "Quatro Barras",
      reference: 41
    },
    {
      value: 4315313,
      label: "Quatro Irmãos",
      reference: 43
    },
    {
      value: 4120853,
      label: "Quatro Pontes",
      reference: 41
    },
    {
      value: 2707602,
      label: "Quebrangulo",
      reference: 27
    },
    {
      value: 4120903,
      label: "Quedas do Iguaçu",
      reference: 41
    },
    {
      value: 2208650,
      label: "Queimada Nova",
      reference: 22
    },
    {
      value: 2512507,
      label: "Queimadas",
      reference: 25
    },
    {
      value: 2925808,
      label: "Queimadas",
      reference: 29
    },
    {
      value: 3304144,
      label: "Queimados",
      reference: 33
    },
    {
      value: 3541802,
      label: "Queiroz",
      reference: 35
    },
    {
      value: 3541901,
      label: "Queluz",
      reference: 35
    },
    {
      value: 3153806,
      label: "Queluzito",
      reference: 31
    },
    {
      value: 5107065,
      label: "Querência",
      reference: 51
    },
    {
      value: 4121000,
      label: "Querência do Norte",
      reference: 41
    },
    {
      value: 4315321,
      label: "Quevedos",
      reference: 43
    },
    {
      value: 2925907,
      label: "Quijingue",
      reference: 29
    },
    {
      value: 4214201,
      label: "Quilombo",
      reference: 42
    },
    {
      value: 4121109,
      label: "Quinta do Sol",
      reference: 41
    },
    {
      value: 3542008,
      label: "Quintana",
      reference: 35
    },
    {
      value: 4315354,
      label: "Quinze de Novembro",
      reference: 43
    },
    {
      value: 2611507,
      label: "Quipapá",
      reference: 26
    },
    {
      value: 5218508,
      label: "Quirinópolis",
      reference: 52
    },
    {
      value: 3304151,
      label: "Quissamã",
      reference: 33
    },
    {
      value: 4121208,
      label: "Quitandinha",
      reference: 41
    },
    {
      value: 2311264,
      label: "Quiterianópolis",
      reference: 23
    },
    {
      value: 2512606,
      label: "Quixabá",
      reference: 25
    },
    {
      value: 2611533,
      label: "Quixaba",
      reference: 26
    },
    {
      value: 2925931,
      label: "Quixabeira",
      reference: 29
    },
    {
      value: 2311306,
      label: "Quixadá",
      reference: 23
    },
    {
      value: 2311355,
      label: "Quixelô",
      reference: 23
    },
    {
      value: 2311405,
      label: "Quixeramobim",
      reference: 23
    },
    {
      value: 2311504,
      label: "Quixeré",
      reference: 23
    },
    {
      value: 2410504,
      label: "Rafael Fernandes",
      reference: 24
    },
    {
      value: 2410603,
      label: "Rafael Godeiro",
      reference: 24
    },
    {
      value: 2925956,
      label: "Rafael Jambeiro",
      reference: 29
    },
    {
      value: 3542107,
      label: "Rafard",
      reference: 35
    },
    {
      value: 4121257,
      label: "Ramilândia",
      reference: 41
    },
    {
      value: 3542206,
      label: "Rancharia",
      reference: 35
    },
    {
      value: 4121307,
      label: "Rancho Alegre",
      reference: 41
    },
    {
      value: 4121356,
      label: "Rancho Alegre D'Oeste",
      reference: 41
    },
    {
      value: 4214300,
      label: "Rancho Queimado",
      reference: 42
    },
    {
      value: 2109452,
      label: "Raposa",
      reference: 21
    },
    {
      value: 3153905,
      label: "Raposos",
      reference: 31
    },
    {
      value: 3154002,
      label: "Raul Soares",
      reference: 31
    },
    {
      value: 4121406,
      label: "Realeza",
      reference: 41
    },
    {
      value: 4121505,
      label: "Rebouças",
      reference: 41
    },
    {
      value: 2611606,
      label: "Recife",
      reference: 26
    },
    {
      value: 3154101,
      label: "Recreio",
      reference: 31
    },
    {
      value: 1718501,
      label: "Recursolândia",
      reference: 17
    },
    {
      value: 1506138,
      label: "Redenção",
      reference: 15
    },
    {
      value: 2311603,
      label: "Redenção",
      reference: 23
    },
    {
      value: 3542305,
      label: "Redenção da Serra",
      reference: 35
    },
    {
      value: 2208700,
      label: "Redenção do Gurguéia",
      reference: 22
    },
    {
      value: 4315404,
      label: "Redentora",
      reference: 43
    },
    {
      value: 3154150,
      label: "Reduto",
      reference: 31
    },
    {
      value: 2208809,
      label: "Regeneração",
      reference: 22
    },
    {
      value: 3542404,
      label: "Regente Feijó",
      reference: 35
    },
    {
      value: 3542503,
      label: "Reginópolis",
      reference: 35
    },
    {
      value: 3542602,
      label: "Registro",
      reference: 35
    },
    {
      value: 4315453,
      label: "Relvado",
      reference: 43
    },
    {
      value: 2926004,
      label: "Remanso",
      reference: 29
    },
    {
      value: 2512705,
      label: "Remígio",
      reference: 25
    },
    {
      value: 4121604,
      label: "Renascença",
      reference: 41
    },
    {
      value: 2311702,
      label: "Reriutaba",
      reference: 23
    },
    {
      value: 3304201,
      label: "Resende",
      reference: 33
    },
    {
      value: 3154200,
      label: "Resende Costa",
      reference: 31
    },
    {
      value: 4121703,
      label: "Reserva",
      reference: 41
    },
    {
      value: 5107156,
      label: "Reserva do Cabaçal",
      reference: 51
    },
    {
      value: 4121752,
      label: "Reserva do Iguaçu",
      reference: 41
    },
    {
      value: 3154309,
      label: "Resplendor",
      reference: 31
    },
    {
      value: 3154408,
      label: "Ressaquinha",
      reference: 31
    },
    {
      value: 3542701,
      label: "Restinga",
      reference: 35
    },
    {
      value: 4315503,
      label: "Restinga Sêca",
      reference: 43
    },
    {
      value: 2926103,
      label: "Retirolândia",
      reference: 29
    },
    {
      value: 2512747,
      label: "Riachão",
      reference: 25
    },
    {
      value: 2109502,
      label: "Riachão",
      reference: 21
    },
    {
      value: 2926202,
      label: "Riachão das Neves",
      reference: 29
    },
    {
      value: 2512754,
      label: "Riachão do Bacamarte",
      reference: 25
    },
    {
      value: 2805802,
      label: "Riachão do Dantas",
      reference: 28
    },
    {
      value: 2926301,
      label: "Riachão do Jacuípe",
      reference: 29
    },
    {
      value: 2512762,
      label: "Riachão do Poço",
      reference: 25
    },
    {
      value: 1718550,
      label: "Riachinho",
      reference: 17
    },
    {
      value: 3154457,
      label: "Riachinho",
      reference: 31
    },
    {
      value: 2410702,
      label: "Riacho da Cruz",
      reference: 24
    },
    {
      value: 2611705,
      label: "Riacho das Almas",
      reference: 26
    },
    {
      value: 2410801,
      label: "Riacho de Santana",
      reference: 24
    },
    {
      value: 2926400,
      label: "Riacho de Santana",
      reference: 29
    },
    {
      value: 2512788,
      label: "Riacho de Santo Antônio",
      reference: 25
    },
    {
      value: 2512804,
      label: "Riacho dos Cavalos",
      reference: 25
    },
    {
      value: 3154507,
      label: "Riacho dos Machados",
      reference: 31
    },
    {
      value: 2208858,
      label: "Riacho Frio",
      reference: 22
    },
    {
      value: 2410900,
      label: "Riachuelo",
      reference: 24
    },
    {
      value: 2805901,
      label: "Riachuelo",
      reference: 28
    },
    {
      value: 5218607,
      label: "Rialma",
      reference: 52
    },
    {
      value: 5218706,
      label: "Rianápolis",
      reference: 52
    },
    {
      value: 2109551,
      label: "Ribamar Fiquene",
      reference: 21
    },
    {
      value: 5007109,
      label: "Ribas do Rio Pardo",
      reference: 50
    },
    {
      value: 3542800,
      label: "Ribeira",
      reference: 35
    },
    {
      value: 2926509,
      label: "Ribeira do Amparo",
      reference: 29
    },
    {
      value: 2208874,
      label: "Ribeira do Piauí",
      reference: 22
    },
    {
      value: 2926608,
      label: "Ribeira do Pombal",
      reference: 29
    },
    {
      value: 2611804,
      label: "Ribeirão",
      reference: 26
    },
    {
      value: 3542909,
      label: "Ribeirão Bonito",
      reference: 35
    },
    {
      value: 3543006,
      label: "Ribeirão Branco",
      reference: 35
    },
    {
      value: 5107180,
      label: "Ribeirão Cascalheira",
      reference: 51
    },
    {
      value: 4121802,
      label: "Ribeirão Claro",
      reference: 41
    },
    {
      value: 3543105,
      label: "Ribeirão Corrente",
      reference: 35
    },
    {
      value: 3154606,
      label: "Ribeirão das Neves",
      reference: 31
    },
    {
      value: 2926657,
      label: "Ribeirão do Largo",
      reference: 29
    },
    {
      value: 4121901,
      label: "Ribeirão do Pinhal",
      reference: 41
    },
    {
      value: 3543204,
      label: "Ribeirão do Sul",
      reference: 35
    },
    {
      value: 3543238,
      label: "Ribeirão dos Índios",
      reference: 35
    },
    {
      value: 3543253,
      label: "Ribeirão Grande",
      reference: 35
    },
    {
      value: 3543303,
      label: "Ribeirão Pires",
      reference: 35
    },
    {
      value: 3543402,
      label: "Ribeirão Preto",
      reference: 35
    },
    {
      value: 3154705,
      label: "Ribeirão Vermelho",
      reference: 31
    },
    {
      value: 5107198,
      label: "Ribeirãozinho",
      reference: 51
    },
    {
      value: 2208908,
      label: "Ribeiro Gonçalves",
      reference: 22
    },
    {
      value: 2806008,
      label: "Ribeirópolis",
      reference: 28
    },
    {
      value: 3543600,
      label: "Rifaina",
      reference: 35
    },
    {
      value: 3543709,
      label: "Rincão",
      reference: 35
    },
    {
      value: 3543808,
      label: "Rinópolis",
      reference: 35
    },
    {
      value: 3154804,
      label: "Rio Acima",
      reference: 31
    },
    {
      value: 4122008,
      label: "Rio Azul",
      reference: 41
    },
    {
      value: 3204351,
      label: "Rio Bananal",
      reference: 32
    },
    {
      value: 4122107,
      label: "Rio Bom",
      reference: 41
    },
    {
      value: 3304300,
      label: "Rio Bonito",
      reference: 33
    },
    {
      value: 4122156,
      label: "Rio Bonito do Iguaçu",
      reference: 41
    },
    {
      value: 5107206,
      label: "Rio Branco",
      reference: 51
    },
    {
      value: 1200401,
      label: "Rio Branco",
      reference: 12
    },
    {
      value: 4122172,
      label: "Rio Branco do Ivaí",
      reference: 41
    },
    {
      value: 4122206,
      label: "Rio Branco do Sul",
      reference: 41
    },
    {
      value: 5007208,
      label: "Rio Brilhante",
      reference: 50
    },
    {
      value: 3154903,
      label: "Rio Casca",
      reference: 31
    },
    {
      value: 3304409,
      label: "Rio Claro",
      reference: 33
    },
    {
      value: 3543907,
      label: "Rio Claro",
      reference: 35
    },
    {
      value: 1100262,
      label: "Rio Crespo",
      reference: 11
    },
    {
      value: 1718659,
      label: "Rio da Conceição",
      reference: 17
    },
    {
      value: 4214409,
      label: "Rio das Antas",
      reference: 42
    },
    {
      value: 3304508,
      label: "Rio das Flores",
      reference: 33
    },
    {
      value: 3304524,
      label: "Rio das Ostras",
      reference: 33
    },
    {
      value: 3544004,
      label: "Rio das Pedras",
      reference: 35
    },
    {
      value: 2926707,
      label: "Rio de Contas",
      reference: 29
    },
    {
      value: 3304557,
      label: "Rio de Janeiro",
      reference: 33
    },
    {
      value: 2926806,
      label: "Rio do Antônio",
      reference: 29
    },
    {
      value: 4214508,
      label: "Rio do Campo",
      reference: 42
    },
    {
      value: 2408953,
      label: "Rio do Fogo",
      reference: 24
    },
    {
      value: 4214607,
      label: "Rio do Oeste",
      reference: 42
    },
    {
      value: 2926905,
      label: "Rio do Pires",
      reference: 29
    },
    {
      value: 3155108,
      label: "Rio do Prado",
      reference: 31
    },
    {
      value: 4214805,
      label: "Rio do Sul",
      reference: 42
    },
    {
      value: 3155009,
      label: "Rio Doce",
      reference: 31
    },
    {
      value: 1718709,
      label: "Rio dos Bois",
      reference: 17
    },
    {
      value: 4214706,
      label: "Rio dos Cedros",
      reference: 42
    },
    {
      value: 4315552,
      label: "Rio dos Índios",
      reference: 43
    },
    {
      value: 3155207,
      label: "Rio Espera",
      reference: 31
    },
    {
      value: 2611903,
      label: "Rio Formoso",
      reference: 26
    },
    {
      value: 4214904,
      label: "Rio Fortuna",
      reference: 42
    },
    {
      value: 4315602,
      label: "Rio Grande",
      reference: 43
    },
    {
      value: 3544103,
      label: "Rio Grande da Serra",
      reference: 35
    },
    {
      value: 2209005,
      label: "Rio Grande do Piauí",
      reference: 22
    },
    {
      value: 2707701,
      label: "Rio Largo",
      reference: 27
    },
    {
      value: 3155306,
      label: "Rio Manso",
      reference: 31
    },
    {
      value: 1506161,
      label: "Rio Maria",
      reference: 15
    },
    {
      value: 4215000,
      label: "Rio Negrinho",
      reference: 42
    },
    {
      value: 5007307,
      label: "Rio Negro",
      reference: 50
    },
    {
      value: 4122305,
      label: "Rio Negro",
      reference: 41
    },
    {
      value: 3155405,
      label: "Rio Novo",
      reference: 31
    },
    {
      value: 3204401,
      label: "Rio Novo do Sul",
      reference: 32
    },
    {
      value: 3155504,
      label: "Rio Paranaíba",
      reference: 31
    },
    {
      value: 4315701,
      label: "Rio Pardo",
      reference: 43
    },
    {
      value: 3155603,
      label: "Rio Pardo de Minas",
      reference: 31
    },
    {
      value: 3155702,
      label: "Rio Piracicaba",
      reference: 31
    },
    {
      value: 3155801,
      label: "Rio Pomba",
      reference: 31
    },
    {
      value: 3155900,
      label: "Rio Preto",
      reference: 31
    },
    {
      value: 1303569,
      label: "Rio Preto da Eva",
      reference: 13
    },
    {
      value: 5218789,
      label: "Rio Quente",
      reference: 52
    },
    {
      value: 2927002,
      label: "Rio Real",
      reference: 29
    },
    {
      value: 4215059,
      label: "Rio Rufino",
      reference: 42
    },
    {
      value: 1718758,
      label: "Rio Sono",
      reference: 17
    },
    {
      value: 2512903,
      label: "Rio Tinto",
      reference: 25
    },
    {
      value: 5218805,
      label: "Rio Verde",
      reference: 52
    },
    {
      value: 5007406,
      label: "Rio Verde de Mato Grosso",
      reference: 50
    },
    {
      value: 3156007,
      label: "Rio Vermelho",
      reference: 31
    },
    {
      value: 3544202,
      label: "Riolândia",
      reference: 35
    },
    {
      value: 4315750,
      label: "Riozinho",
      reference: 43
    },
    {
      value: 4215075,
      label: "Riqueza",
      reference: 42
    },
    {
      value: 3156106,
      label: "Ritápolis",
      reference: 31
    },
    {
      value: 3543501,
      label: "Riversul",
      reference: 35
    },
    {
      value: 4315800,
      label: "Roca Sales",
      reference: 43
    },
    {
      value: 5007505,
      label: "Rochedo",
      reference: 50
    },
    {
      value: 3156205,
      label: "Rochedo de Minas",
      reference: 31
    },
    {
      value: 4215109,
      label: "Rodeio",
      reference: 42
    },
    {
      value: 4315909,
      label: "Rodeio Bonito",
      reference: 43
    },
    {
      value: 3156304,
      label: "Rodeiro",
      reference: 31
    },
    {
      value: 2927101,
      label: "Rodelas",
      reference: 29
    },
    {
      value: 2411007,
      label: "Rodolfo Fernandes",
      reference: 24
    },
    {
      value: 1200427,
      label: "Rodrigues Alves",
      reference: 12
    },
    {
      value: 4315958,
      label: "Rolador",
      reference: 43
    },
    {
      value: 4122404,
      label: "Rolândia",
      reference: 41
    },
    {
      value: 4316006,
      label: "Rolante",
      reference: 43
    },
    {
      value: 1100288,
      label: "Rolim de Moura",
      reference: 11
    },
    {
      value: 3156403,
      label: "Romaria",
      reference: 31
    },
    {
      value: 4215208,
      label: "Romelândia",
      reference: 42
    },
    {
      value: 4122503,
      label: "Roncador",
      reference: 41
    },
    {
      value: 4316105,
      label: "Ronda Alta",
      reference: 43
    },
    {
      value: 4316204,
      label: "Rondinha",
      reference: 43
    },
    {
      value: 5107578,
      label: "Rondolândia",
      reference: 51
    },
    {
      value: 4122602,
      label: "Rondon",
      reference: 41
    },
    {
      value: 1506187,
      label: "Rondon do Pará",
      reference: 15
    },
    {
      value: 5107602,
      label: "Rondonópolis",
      reference: 51
    },
    {
      value: 4316303,
      label: "Roque Gonzales",
      reference: 43
    },
    {
      value: 1400472,
      label: "Rorainópolis",
      reference: 14
    },
    {
      value: 3544251,
      label: "Rosana",
      reference: 35
    },
    {
      value: 2109601,
      label: "Rosário",
      reference: 21
    },
    {
      value: 3156452,
      label: "Rosário da Limeira",
      reference: 31
    },
    {
      value: 2806107,
      label: "Rosário do Catete",
      reference: 28
    },
    {
      value: 4122651,
      label: "Rosário do Ivaí",
      reference: 41
    },
    {
      value: 4316402,
      label: "Rosário do Sul",
      reference: 43
    },
    {
      value: 5107701,
      label: "Rosário Oeste",
      reference: 51
    },
    {
      value: 3544301,
      label: "Roseira",
      reference: 35
    },
    {
      value: 2707800,
      label: "Roteiro",
      reference: 27
    },
    {
      value: 3156502,
      label: "Rubelita",
      reference: 31
    },
    {
      value: 3544400,
      label: "Rubiácea",
      reference: 35
    },
    {
      value: 5218904,
      label: "Rubiataba",
      reference: 52
    },
    {
      value: 3156601,
      label: "Rubim",
      reference: 31
    },
    {
      value: 3544509,
      label: "Rubinéia",
      reference: 35
    },
    {
      value: 1506195,
      label: "Rurópolis",
      reference: 15
    },
    {
      value: 2311801,
      label: "Russas",
      reference: 23
    },
    {
      value: 2411106,
      label: "Ruy Barbosa",
      reference: 24
    },
    {
      value: 2927200,
      label: "Ruy Barbosa",
      reference: 29
    },
    {
      value: 3156700,
      label: "Sabará",
      reference: 31
    },
    {
      value: 4122701,
      label: "Sabáudia",
      reference: 41
    },
    {
      value: 3544608,
      label: "Sabino",
      reference: 35
    },
    {
      value: 3156809,
      label: "Sabinópolis",
      reference: 31
    },
    {
      value: 2311900,
      label: "Saboeiro",
      reference: 23
    },
    {
      value: 3156908,
      label: "Sacramento",
      reference: 31
    },
    {
      value: 4316428,
      label: "Sagrada Família",
      reference: 43
    },
    {
      value: 3544707,
      label: "Sagres",
      reference: 35
    },
    {
      value: 2612000,
      label: "Sairé",
      reference: 26
    },
    {
      value: 4316436,
      label: "Saldanha Marinho",
      reference: 43
    },
    {
      value: 3544806,
      label: "Sales",
      reference: 35
    },
    {
      value: 3544905,
      label: "Sales Oliveira",
      reference: 35
    },
    {
      value: 3545001,
      label: "Salesópolis",
      reference: 35
    },
    {
      value: 4215307,
      label: "Salete",
      reference: 42
    },
    {
      value: 2513000,
      label: "Salgadinho",
      reference: 25
    },
    {
      value: 2612109,
      label: "Salgadinho",
      reference: 26
    },
    {
      value: 2806206,
      label: "Salgado",
      reference: 28
    },
    {
      value: 2513109,
      label: "Salgado de São Félix",
      reference: 25
    },
    {
      value: 4122800,
      label: "Salgado Filho",
      reference: 41
    },
    {
      value: 2612208,
      label: "Salgueiro",
      reference: 26
    },
    {
      value: 3157005,
      label: "Salinas",
      reference: 31
    },
    {
      value: 2927309,
      label: "Salinas da Margarida",
      reference: 29
    },
    {
      value: 1506203,
      label: "Salinópolis",
      reference: 15
    },
    {
      value: 2311959,
      label: "Salitre",
      reference: 23
    },
    {
      value: 3545100,
      label: "Salmourão",
      reference: 35
    },
    {
      value: 2612307,
      label: "Saloá",
      reference: 26
    },
    {
      value: 4215356,
      label: "Saltinho",
      reference: 42
    },
    {
      value: 3545159,
      label: "Saltinho",
      reference: 35
    },
    {
      value: 3545209,
      label: "Salto",
      reference: 35
    },
    {
      value: 3157104,
      label: "Salto da Divisa",
      reference: 31
    },
    {
      value: 3545308,
      label: "Salto de Pirapora",
      reference: 35
    },
    {
      value: 5107750,
      label: "Salto do Céu",
      reference: 51
    },
    {
      value: 4122909,
      label: "Salto do Itararé",
      reference: 41
    },
    {
      value: 4316451,
      label: "Salto do Jacuí",
      reference: 43
    },
    {
      value: 4123006,
      label: "Salto do Lontra",
      reference: 41
    },
    {
      value: 3545407,
      label: "Salto Grande",
      reference: 35
    },
    {
      value: 4215406,
      label: "Salto Veloso",
      reference: 42
    },
    {
      value: 2927408,
      label: "Salvador",
      reference: 29
    },
    {
      value: 4316477,
      label: "Salvador das Missões",
      reference: 43
    },
    {
      value: 4316501,
      label: "Salvador do Sul",
      reference: 43
    },
    {
      value: 1506302,
      label: "Salvaterra",
      reference: 15
    },
    {
      value: 2109700,
      label: "Sambaíba",
      reference: 21
    },
    {
      value: 1718808,
      label: "Sampaio",
      reference: 17
    },
    {
      value: 4316600,
      label: "Sananduva",
      reference: 43
    },
    {
      value: 5219001,
      label: "Sanclerlândia",
      reference: 52
    },
    {
      value: 1718840,
      label: "Sandolândia",
      reference: 17
    },
    {
      value: 3545506,
      label: "Sandovalina",
      reference: 35
    },
    {
      value: 4215455,
      label: "Sangão",
      reference: 42
    },
    {
      value: 2612406,
      label: "Sanharó",
      reference: 26
    },
    {
      value: 4317103,
      label: "Sant'Ana do Livramento",
      reference: 43
    },
    {
      value: 3545605,
      label: "Santa Adélia",
      reference: 35
    },
    {
      value: 3545704,
      label: "Santa Albertina",
      reference: 35
    },
    {
      value: 4123105,
      label: "Santa Amélia",
      reference: 41
    },
    {
      value: 2927507,
      label: "Santa Bárbara",
      reference: 29
    },
    {
      value: 3157203,
      label: "Santa Bárbara",
      reference: 31
    },
    {
      value: 3545803,
      label: "Santa Bárbara d'Oeste",
      reference: 35
    },
    {
      value: 5219100,
      label: "Santa Bárbara de Goiás",
      reference: 52
    },
    {
      value: 3157252,
      label: "Santa Bárbara do Leste",
      reference: 31
    },
    {
      value: 3157278,
      label: "Santa Bárbara do Monte Verde",
      reference: 31
    },
    {
      value: 1506351,
      label: "Santa Bárbara do Pará",
      reference: 15
    },
    {
      value: 4316709,
      label: "Santa Bárbara do Sul",
      reference: 43
    },
    {
      value: 3157302,
      label: "Santa Bárbara do Tugúrio",
      reference: 31
    },
    {
      value: 3546009,
      label: "Santa Branca",
      reference: 35
    },
    {
      value: 2927606,
      label: "Santa Brígida",
      reference: 29
    },
    {
      value: 5107248,
      label: "Santa Carmem",
      reference: 51
    },
    {
      value: 4215505,
      label: "Santa Cecília",
      reference: 42
    },
    {
      value: 2513158,
      label: "Santa Cecília",
      reference: 25
    },
    {
      value: 4123204,
      label: "Santa Cecília do Pavão",
      reference: 41
    },
    {
      value: 4316733,
      label: "Santa Cecília do Sul",
      reference: 43
    },
    {
      value: 3546108,
      label: "Santa Clara d'Oeste",
      reference: 35
    },
    {
      value: 4316758,
      label: "Santa Clara do Sul",
      reference: 43
    },
    {
      value: 2411205,
      label: "Santa Cruz",
      reference: 24
    },
    {
      value: 2513208,
      label: "Santa Cruz",
      reference: 25
    },
    {
      value: 2612455,
      label: "Santa Cruz",
      reference: 26
    },
    {
      value: 2927705,
      label: "Santa Cruz Cabrália",
      reference: 29
    },
    {
      value: 2612471,
      label: "Santa Cruz da Baixa Verde",
      reference: 26
    },
    {
      value: 3546207,
      label: "Santa Cruz da Conceição",
      reference: 35
    },
    {
      value: 3546256,
      label: "Santa Cruz da Esperança",
      reference: 35
    },
    {
      value: 2927804,
      label: "Santa Cruz da Vitória",
      reference: 29
    },
    {
      value: 3546306,
      label: "Santa Cruz das Palmeiras",
      reference: 35
    },
    {
      value: 5219209,
      label: "Santa Cruz de Goiás",
      reference: 52
    },
    {
      value: 3157336,
      label: "Santa Cruz de Minas",
      reference: 31
    },
    {
      value: 4123303,
      label: "Santa Cruz de Monte Castelo",
      reference: 41
    },
    {
      value: 3157377,
      label: "Santa Cruz de Salinas",
      reference: 31
    },
    {
      value: 1506401,
      label: "Santa Cruz do Arari",
      reference: 15
    },
    {
      value: 2612505,
      label: "Santa Cruz do Capibaribe",
      reference: 26
    },
    {
      value: 3157401,
      label: "Santa Cruz do Escalvado",
      reference: 31
    },
    {
      value: 2209104,
      label: "Santa Cruz do Piauí",
      reference: 22
    },
    {
      value: 3546405,
      label: "Santa Cruz do Rio Pardo",
      reference: 35
    },
    {
      value: 4316808,
      label: "Santa Cruz do Sul",
      reference: 43
    },
    {
      value: 5107743,
      label: "Santa Cruz do Xingu",
      reference: 51
    },
    {
      value: 2209153,
      label: "Santa Cruz dos Milagres",
      reference: 22
    },
    {
      value: 3157500,
      label: "Santa Efigênia de Minas",
      reference: 31
    },
    {
      value: 3546504,
      label: "Santa Ernestina",
      reference: 35
    },
    {
      value: 4123402,
      label: "Santa Fé",
      reference: 41
    },
    {
      value: 5219258,
      label: "Santa Fé de Goiás",
      reference: 52
    },
    {
      value: 3157609,
      label: "Santa Fé de Minas",
      reference: 31
    },
    {
      value: 1718865,
      label: "Santa Fé do Araguaia",
      reference: 17
    },
    {
      value: 3546603,
      label: "Santa Fé do Sul",
      reference: 35
    },
    {
      value: 2209203,
      label: "Santa Filomena",
      reference: 22
    },
    {
      value: 2612554,
      label: "Santa Filomena",
      reference: 26
    },
    {
      value: 2109759,
      label: "Santa Filomena do Maranhão",
      reference: 21
    },
    {
      value: 3546702,
      label: "Santa Gertrudes",
      reference: 35
    },
    {
      value: 4123501,
      label: "Santa Helena",
      reference: 41
    },
    {
      value: 4215554,
      label: "Santa Helena",
      reference: 42
    },
    {
      value: 2109809,
      label: "Santa Helena",
      reference: 21
    },
    {
      value: 2513307,
      label: "Santa Helena",
      reference: 25
    },
    {
      value: 5219308,
      label: "Santa Helena de Goiás",
      reference: 52
    },
    {
      value: 3157658,
      label: "Santa Helena de Minas",
      reference: 31
    },
    {
      value: 2927903,
      label: "Santa Inês",
      reference: 29
    },
    {
      value: 4123600,
      label: "Santa Inês",
      reference: 41
    },
    {
      value: 2513356,
      label: "Santa Inês",
      reference: 25
    },
    {
      value: 2109908,
      label: "Santa Inês",
      reference: 21
    },
    {
      value: 3546801,
      label: "Santa Isabel",
      reference: 35
    },
    {
      value: 5219357,
      label: "Santa Isabel",
      reference: 52
    },
    {
      value: 4123709,
      label: "Santa Isabel do Ivaí",
      reference: 41
    },
    {
      value: 1303601,
      label: "Santa Isabel do Rio Negro",
      reference: 13
    },
    {
      value: 4123808,
      label: "Santa Izabel do Oeste",
      reference: 41
    },
    {
      value: 1506500,
      label: "Santa Izabel do Pará",
      reference: 15
    },
    {
      value: 3157708,
      label: "Santa Juliana",
      reference: 31
    },
    {
      value: 3204500,
      label: "Santa Leopoldina",
      reference: 32
    },
    {
      value: 3546900,
      label: "Santa Lúcia",
      reference: 35
    },
    {
      value: 4123824,
      label: "Santa Lúcia",
      reference: 41
    },
    {
      value: 2209302,
      label: "Santa Luz",
      reference: 22
    },
    {
      value: 2110005,
      label: "Santa Luzia",
      reference: 21
    },
    {
      value: 2928059,
      label: "Santa Luzia",
      reference: 29
    },
    {
      value: 3157807,
      label: "Santa Luzia",
      reference: 31
    },
    {
      value: 2513406,
      label: "Santa Luzia",
      reference: 25
    },
    {
      value: 1100296,
      label: "Santa Luzia D'Oeste",
      reference: 11
    },
    {
      value: 2806305,
      label: "Santa Luzia do Itanhy",
      reference: 28
    },
    {
      value: 2707909,
      label: "Santa Luzia do Norte",
      reference: 27
    },
    {
      value: 1506559,
      label: "Santa Luzia do Pará",
      reference: 15
    },
    {
      value: 2110039,
      label: "Santa Luzia do Paruá",
      reference: 21
    },
    {
      value: 3157906,
      label: "Santa Margarida",
      reference: 31
    },
    {
      value: 4316972,
      label: "Santa Margarida do Sul",
      reference: 43
    },
    {
      value: 4316907,
      label: "Santa Maria",
      reference: 43
    },
    {
      value: 2409332,
      label: "Santa Maria",
      reference: 24
    },
    {
      value: 2612604,
      label: "Santa Maria da Boa Vista",
      reference: 26
    },
    {
      value: 3547007,
      label: "Santa Maria da Serra",
      reference: 35
    },
    {
      value: 2928109,
      label: "Santa Maria da Vitória",
      reference: 29
    },
    {
      value: 1506583,
      label: "Santa Maria das Barreiras",
      reference: 15
    },
    {
      value: 3158003,
      label: "Santa Maria de Itabira",
      reference: 31
    },
    {
      value: 3204559,
      label: "Santa Maria de Jetibá",
      reference: 32
    },
    {
      value: 2612703,
      label: "Santa Maria do Cambucá",
      reference: 26
    },
    {
      value: 4316956,
      label: "Santa Maria do Herval",
      reference: 43
    },
    {
      value: 4123857,
      label: "Santa Maria do Oeste",
      reference: 41
    },
    {
      value: 1506609,
      label: "Santa Maria do Pará",
      reference: 15
    },
    {
      value: 3158102,
      label: "Santa Maria do Salto",
      reference: 31
    },
    {
      value: 3158201,
      label: "Santa Maria do Suaçuí",
      reference: 31
    },
    {
      value: 1718881,
      label: "Santa Maria do Tocantins",
      reference: 17
    },
    {
      value: 3304607,
      label: "Santa Maria Madalena",
      reference: 33
    },
    {
      value: 4123907,
      label: "Santa Mariana",
      reference: 41
    },
    {
      value: 3547106,
      label: "Santa Mercedes",
      reference: 35
    },
    {
      value: 4123956,
      label: "Santa Mônica",
      reference: 41
    },
    {
      value: 2312205,
      label: "Santa Quitéria",
      reference: 23
    },
    {
      value: 2110104,
      label: "Santa Quitéria do Maranhão",
      reference: 21
    },
    {
      value: 2110203,
      label: "Santa Rita",
      reference: 21
    },
    {
      value: 2513703,
      label: "Santa Rita",
      reference: 25
    },
    {
      value: 3547403,
      label: "Santa Rita d'Oeste",
      reference: 35
    },
    {
      value: 3159209,
      label: "Santa Rita de Caldas",
      reference: 31
    },
    {
      value: 2928406,
      label: "Santa Rita de Cássia",
      reference: 29
    },
    {
      value: 3159407,
      label: "Santa Rita de Ibitipoca",
      reference: 31
    },
    {
      value: 3159308,
      label: "Santa Rita de Jacutinga",
      reference: 31
    },
    {
      value: 3159357,
      label: "Santa Rita de Minas",
      reference: 31
    },
    {
      value: 5219407,
      label: "Santa Rita do Araguaia",
      reference: 52
    },
    {
      value: 3159506,
      label: "Santa Rita do Itueto",
      reference: 31
    },
    {
      value: 5219456,
      label: "Santa Rita do Novo Destino",
      reference: 52
    },
    {
      value: 5007554,
      label: "Santa Rita do Pardo",
      reference: 50
    },
    {
      value: 3547502,
      label: "Santa Rita do Passa Quatro",
      reference: 35
    },
    {
      value: 3159605,
      label: "Santa Rita do Sapucaí",
      reference: 31
    },
    {
      value: 1718899,
      label: "Santa Rita do Tocantins",
      reference: 17
    },
    {
      value: 5107768,
      label: "Santa Rita do Trivelato",
      reference: 51
    },
    {
      value: 4317202,
      label: "Santa Rosa",
      reference: 43
    },
    {
      value: 3159704,
      label: "Santa Rosa da Serra",
      reference: 31
    },
    {
      value: 5219506,
      label: "Santa Rosa de Goiás",
      reference: 52
    },
    {
      value: 4215604,
      label: "Santa Rosa de Lima",
      reference: 42
    },
    {
      value: 2806503,
      label: "Santa Rosa de Lima",
      reference: 28
    },
    {
      value: 3547601,
      label: "Santa Rosa de Viterbo",
      reference: 35
    },
    {
      value: 2209377,
      label: "Santa Rosa do Piauí",
      reference: 22
    },
    {
      value: 1200435,
      label: "Santa Rosa do Purus",
      reference: 12
    },
    {
      value: 4215653,
      label: "Santa Rosa do Sul",
      reference: 42
    },
    {
      value: 1718907,
      label: "Santa Rosa do Tocantins",
      reference: 17
    },
    {
      value: 3547650,
      label: "Santa Salete",
      reference: 35
    },
    {
      value: 3204609,
      label: "Santa Teresa",
      reference: 32
    },
    {
      value: 2928505,
      label: "Santa Teresinha",
      reference: 29
    },
    {
      value: 2513802,
      label: "Santa Teresinha",
      reference: 25
    },
    {
      value: 4317251,
      label: "Santa Tereza",
      reference: 43
    },
    {
      value: 5219605,
      label: "Santa Tereza de Goiás",
      reference: 52
    },
    {
      value: 4124020,
      label: "Santa Tereza do Oeste",
      reference: 41
    },
    {
      value: 1719004,
      label: "Santa Tereza do Tocantins",
      reference: 17
    },
    {
      value: 4215679,
      label: "Santa Terezinha",
      reference: 42
    },
    {
      value: 5107776,
      label: "Santa Terezinha",
      reference: 51
    },
    {
      value: 2612802,
      label: "Santa Terezinha",
      reference: 26
    },
    {
      value: 5219704,
      label: "Santa Terezinha de Goiás",
      reference: 52
    },
    {
      value: 4124053,
      label: "Santa Terezinha de Itaipu",
      reference: 41
    },
    {
      value: 4215695,
      label: "Santa Terezinha do Progresso",
      reference: 42
    },
    {
      value: 1720002,
      label: "Santa Terezinha do Tocantins",
      reference: 17
    },
    {
      value: 3159803,
      label: "Santa Vitória",
      reference: 31
    },
    {
      value: 4317301,
      label: "Santa Vitória do Palmar",
      reference: 43
    },
    {
      value: 2928000,
      label: "Santaluz",
      reference: 29
    },
    {
      value: 2928208,
      label: "Santana",
      reference: 29
    },
    {
      value: 1600600,
      label: "Santana",
      reference: 16
    },
    {
      value: 4317004,
      label: "Santana da Boa Vista",
      reference: 43
    },
    {
      value: 3547205,
      label: "Santana da Ponte Pensa",
      reference: 35
    },
    {
      value: 3158300,
      label: "Santana da Vargem",
      reference: 31
    },
    {
      value: 3158409,
      label: "Santana de Cataguases",
      reference: 31
    },
    {
      value: 2513505,
      label: "Santana de Mangueira",
      reference: 25
    },
    {
      value: 3547304,
      label: "Santana de Parnaíba",
      reference: 35
    },
    {
      value: 3158508,
      label: "Santana de Pirapama",
      reference: 31
    },
    {
      value: 2312007,
      label: "Santana do Acaraú",
      reference: 23
    },
    {
      value: 1506708,
      label: "Santana do Araguaia",
      reference: 15
    },
    {
      value: 2312106,
      label: "Santana do Cariri",
      reference: 23
    },
    {
      value: 3158607,
      label: "Santana do Deserto",
      reference: 31
    },
    {
      value: 3158706,
      label: "Santana do Garambéu",
      reference: 31
    },
    {
      value: 2708006,
      label: "Santana do Ipanema",
      reference: 27
    },
    {
      value: 4124004,
      label: "Santana do Itararé",
      reference: 41
    },
    {
      value: 3158805,
      label: "Santana do Jacaré",
      reference: 31
    },
    {
      value: 3158904,
      label: "Santana do Manhuaçu",
      reference: 31
    },
    {
      value: 2110237,
      label: "Santana do Maranhão",
      reference: 21
    },
    {
      value: 2411403,
      label: "Santana do Matos",
      reference: 24
    },
    {
      value: 2708105,
      label: "Santana do Mundaú",
      reference: 27
    },
    {
      value: 3158953,
      label: "Santana do Paraíso",
      reference: 31
    },
    {
      value: 2209351,
      label: "Santana do Piauí",
      reference: 22
    },
    {
      value: 3159001,
      label: "Santana do Riacho",
      reference: 31
    },
    {
      value: 2806404,
      label: "Santana do São Francisco",
      reference: 28
    },
    {
      value: 2411429,
      label: "Santana do Seridó",
      reference: 24
    },
    {
      value: 2513604,
      label: "Santana dos Garrotes",
      reference: 25
    },
    {
      value: 3159100,
      label: "Santana dos Montes",
      reference: 31
    },
    {
      value: 2928307,
      label: "Santanópolis",
      reference: 29
    },
    {
      value: 1506807,
      label: "Santarém",
      reference: 15
    },
    {
      value: 1506906,
      label: "Santarém Novo",
      reference: 15
    },
    {
      value: 4317400,
      label: "Santiago",
      reference: 43
    },
    {
      value: 4215687,
      label: "Santiago do Sul",
      reference: 42
    },
    {
      value: 5107263,
      label: "Santo Afonso",
      reference: 51
    },
    {
      value: 2928604,
      label: "Santo Amaro",
      reference: 29
    },
    {
      value: 4215703,
      label: "Santo Amaro da Imperatriz",
      reference: 42
    },
    {
      value: 2806602,
      label: "Santo Amaro das Brotas",
      reference: 28
    },
    {
      value: 2110278,
      label: "Santo Amaro do Maranhão",
      reference: 21
    },
    {
      value: 3547700,
      label: "Santo Anastácio",
      reference: 35
    },
    {
      value: 3547809,
      label: "Santo André",
      reference: 35
    },
    {
      value: 2513851,
      label: "Santo André",
      reference: 25
    },
    {
      value: 4317509,
      label: "Santo Ângelo",
      reference: 43
    },
    {
      value: 2411502,
      label: "Santo Antônio",
      reference: 24
    },
    {
      value: 3547908,
      label: "Santo Antônio da Alegria",
      reference: 35
    },
    {
      value: 5219712,
      label: "Santo Antônio da Barra",
      reference: 52
    },
    {
      value: 4317608,
      label: "Santo Antônio da Patrulha",
      reference: 43
    },
    {
      value: 4124103,
      label: "Santo Antônio da Platina",
      reference: 41
    },
    {
      value: 4317707,
      label: "Santo Antônio das Missões",
      reference: 43
    },
    {
      value: 5219738,
      label: "Santo Antônio de Goiás",
      reference: 52
    },
    {
      value: 2928703,
      label: "Santo Antônio de Jesus",
      reference: 29
    },
    {
      value: 2209401,
      label: "Santo Antônio de Lisboa",
      reference: 22
    },
    {
      value: 3304706,
      label: "Santo Antônio de Pádua",
      reference: 33
    },
    {
      value: 3548005,
      label: "Santo Antônio de Posse",
      reference: 35
    },
    {
      value: 3159902,
      label: "Santo Antônio do Amparo",
      reference: 31
    },
    {
      value: 3548054,
      label: "Santo Antônio do Aracanguá",
      reference: 35
    },
    {
      value: 3160009,
      label: "Santo Antônio do Aventureiro",
      reference: 31
    },
    {
      value: 4124202,
      label: "Santo Antônio do Caiuá",
      reference: 41
    },
    {
      value: 5219753,
      label: "Santo Antônio do Descoberto",
      reference: 52
    },
    {
      value: 3160108,
      label: "Santo Antônio do Grama",
      reference: 31
    },
    {
      value: 1303700,
      label: "Santo Antônio do Içá",
      reference: 13
    },
    {
      value: 3160207,
      label: "Santo Antônio do Itambé",
      reference: 31
    },
    {
      value: 3160306,
      label: "Santo Antônio do Jacinto",
      reference: 31
    },
    {
      value: 3548104,
      label: "Santo Antônio do Jardim",
      reference: 35
    },
    {
      value: 5107792,
      label: "Santo Antônio do Leste",
      reference: 51
    },
    {
      value: 5107800,
      label: "Santo Antônio do Leverger",
      reference: 51
    },
    {
      value: 3160405,
      label: "Santo Antônio do Monte",
      reference: 31
    },
    {
      value: 4317558,
      label: "Santo Antônio do Palma",
      reference: 43
    },
    {
      value: 4124301,
      label: "Santo Antônio do Paraíso",
      reference: 41
    },
    {
      value: 3548203,
      label: "Santo Antônio do Pinhal",
      reference: 35
    },
    {
      value: 4317756,
      label: "Santo Antônio do Planalto",
      reference: 43
    },
    {
      value: 3160454,
      label: "Santo Antônio do Retiro",
      reference: 31
    },
    {
      value: 3160504,
      label: "Santo Antônio do Rio Abaixo",
      reference: 31
    },
    {
      value: 4124400,
      label: "Santo Antônio do Sudoeste",
      reference: 41
    },
    {
      value: 1507003,
      label: "Santo Antônio do Tauá",
      reference: 15
    },
    {
      value: 2110302,
      label: "Santo Antônio dos Lopes",
      reference: 21
    },
    {
      value: 2209450,
      label: "Santo Antônio dos Milagres",
      reference: 22
    },
    {
      value: 4317806,
      label: "Santo Augusto",
      reference: 43
    },
    {
      value: 4317905,
      label: "Santo Cristo",
      reference: 43
    },
    {
      value: 2928802,
      label: "Santo Estêvão",
      reference: 29
    },
    {
      value: 3548302,
      label: "Santo Expedito",
      reference: 35
    },
    {
      value: 4317954,
      label: "Santo Expedito do Sul",
      reference: 43
    },
    {
      value: 3160603,
      label: "Santo Hipólito",
      reference: 31
    },
    {
      value: 4124509,
      label: "Santo Inácio",
      reference: 41
    },
    {
      value: 2209500,
      label: "Santo Inácio do Piauí",
      reference: 22
    },
    {
      value: 3548401,
      label: "Santópolis do Aguapeí",
      reference: 35
    },
    {
      value: 3548500,
      label: "Santos",
      reference: 35
    },
    {
      value: 3160702,
      label: "Santos Dumont",
      reference: 31
    },
    {
      value: 2312304,
      label: "São Benedito",
      reference: 23
    },
    {
      value: 2110401,
      label: "São Benedito do Rio Preto",
      reference: 21
    },
    {
      value: 2612901,
      label: "São Benedito do Sul",
      reference: 26
    },
    {
      value: 2513927,
      label: "São Bentinho",
      reference: 25
    },
    {
      value: 2513901,
      label: "São Bento",
      reference: 25
    },
    {
      value: 2110500,
      label: "São Bento",
      reference: 21
    },
    {
      value: 3160801,
      label: "São Bento Abade",
      reference: 31
    },
    {
      value: 2411601,
      label: "São Bento do Norte",
      reference: 24
    },
    {
      value: 3548609,
      label: "São Bento do Sapucaí",
      reference: 35
    },
    {
      value: 4215802,
      label: "São Bento do Sul",
      reference: 42
    },
    {
      value: 1720101,
      label: "São Bento do Tocantins",
      reference: 17
    },
    {
      value: 2411700,
      label: "São Bento do Trairí",
      reference: 24
    },
    {
      value: 2613008,
      label: "São Bento do Una",
      reference: 26
    },
    {
      value: 4215752,
      label: "São Bernardino",
      reference: 42
    },
    {
      value: 2110609,
      label: "São Bernardo",
      reference: 21
    },
    {
      value: 3548708,
      label: "São Bernardo do Campo",
      reference: 35
    },
    {
      value: 4215901,
      label: "São Bonifácio",
      reference: 42
    },
    {
      value: 4318002,
      label: "São Borja",
      reference: 43
    },
    {
      value: 2708204,
      label: "São Brás",
      reference: 27
    },
    {
      value: 3160900,
      label: "São Brás do Suaçuí",
      reference: 31
    },
    {
      value: 2209559,
      label: "São Braz do Piauí",
      reference: 22
    },
    {
      value: 2613107,
      label: "São Caetano",
      reference: 26
    },
    {
      value: 1507102,
      label: "São Caetano de Odivelas",
      reference: 15
    },
    {
      value: 3548807,
      label: "São Caetano do Sul",
      reference: 35
    },
    {
      value: 3548906,
      label: "São Carlos",
      reference: 35
    },
    {
      value: 4216008,
      label: "São Carlos",
      reference: 42
    },
    {
      value: 4124608,
      label: "São Carlos do Ivaí",
      reference: 41
    },
    {
      value: 2806701,
      label: "São Cristóvão",
      reference: 28
    },
    {
      value: 4216057,
      label: "São Cristovão do Sul",
      reference: 42
    },
    {
      value: 2928901,
      label: "São Desidério",
      reference: 29
    },
    {
      value: 2928950,
      label: "São Domingos",
      reference: 29
    },
    {
      value: 4216107,
      label: "São Domingos",
      reference: 42
    },
    {
      value: 2513968,
      label: "São Domingos",
      reference: 25
    },
    {
      value: 2806800,
      label: "São Domingos",
      reference: 28
    },
    {
      value: 5219803,
      label: "São Domingos",
      reference: 52
    },
    {
      value: 3160959,
      label: "São Domingos das Dores",
      reference: 31
    },
    {
      value: 1507151,
      label: "São Domingos do Araguaia",
      reference: 15
    },
    {
      value: 2110658,
      label: "São Domingos do Azeitão",
      reference: 21
    },
    {
      value: 1507201,
      label: "São Domingos do Capim",
      reference: 15
    },
    {
      value: 2513943,
      label: "São Domingos do Cariri",
      reference: 25
    },
    {
      value: 2110708,
      label: "São Domingos do Maranhão",
      reference: 21
    },
    {
      value: 3204658,
      label: "São Domingos do Norte",
      reference: 32
    },
    {
      value: 3161007,
      label: "São Domingos do Prata",
      reference: 31
    },
    {
      value: 4318051,
      label: "São Domingos do Sul",
      reference: 43
    },
    {
      value: 2929107,
      label: "São Felipe",
      reference: 29
    },
    {
      value: 1101484,
      label: "São Felipe D'Oeste",
      reference: 11
    },
    {
      value: 2929008,
      label: "São Félix",
      reference: 29
    },
    {
      value: 2110807,
      label: "São Félix de Balsas",
      reference: 21
    },
    {
      value: 3161056,
      label: "São Félix de Minas",
      reference: 31
    },
    {
      value: 5107859,
      label: "São Félix do Araguaia",
      reference: 51
    },
    {
      value: 2929057,
      label: "São Félix do Coribe",
      reference: 29
    },
    {
      value: 2209609,
      label: "São Félix do Piauí",
      reference: 22
    },
    {
      value: 1720150,
      label: "São Félix do Tocantins",
      reference: 17
    },
    {
      value: 1507300,
      label: "São Félix do Xingu",
      reference: 15
    },
    {
      value: 2411809,
      label: "São Fernando",
      reference: 24
    },
    {
      value: 3304805,
      label: "São Fidélis",
      reference: 33
    },
    {
      value: 3549003,
      label: "São Francisco",
      reference: 35
    },
    {
      value: 2513984,
      label: "São Francisco",
      reference: 25
    },
    {
      value: 2806909,
      label: "São Francisco",
      reference: 28
    },
    {
      value: 3161106,
      label: "São Francisco",
      reference: 31
    },
    {
      value: 4318101,
      label: "São Francisco de Assis",
      reference: 43
    },
    {
      value: 2209658,
      label: "São Francisco de Assis do Piauí",
      reference: 22
    },
    {
      value: 5219902,
      label: "São Francisco de Goiás",
      reference: 52
    },
    {
      value: 3304755,
      label: "São Francisco de Itabapoana",
      reference: 33
    },
    {
      value: 4318200,
      label: "São Francisco de Paula",
      reference: 43
    },
    {
      value: 3161205,
      label: "São Francisco de Paula",
      reference: 31
    },
    {
      value: 3161304,
      label: "São Francisco de Sales",
      reference: 31
    },
    {
      value: 2110856,
      label: "São Francisco do Brejão",
      reference: 21
    },
    {
      value: 2929206,
      label: "São Francisco do Conde",
      reference: 29
    },
    {
      value: 3161403,
      label: "São Francisco do Glória",
      reference: 31
    },
    {
      value: 1101492,
      label: "São Francisco do Guaporé",
      reference: 11
    },
    {
      value: 2110906,
      label: "São Francisco do Maranhão",
      reference: 21
    },
    {
      value: 2411908,
      label: "São Francisco do Oeste",
      reference: 24
    },
    {
      value: 1507409,
      label: "São Francisco do Pará",
      reference: 15
    },
    {
      value: 2209708,
      label: "São Francisco do Piauí",
      reference: 22
    },
    {
      value: 4216206,
      label: "São Francisco do Sul",
      reference: 42
    },
    {
      value: 4318309,
      label: "São Gabriel",
      reference: 43
    },
    {
      value: 2929255,
      label: "São Gabriel",
      reference: 29
    },
    {
      value: 1303809,
      label: "São Gabriel da Cachoeira",
      reference: 13
    },
    {
      value: 3204708,
      label: "São Gabriel da Palha",
      reference: 32
    },
    {
      value: 5007695,
      label: "São Gabriel do Oeste",
      reference: 50
    },
    {
      value: 3161502,
      label: "São Geraldo",
      reference: 31
    },
    {
      value: 3161601,
      label: "São Geraldo da Piedade",
      reference: 31
    },
    {
      value: 1507458,
      label: "São Geraldo do Araguaia",
      reference: 15
    },
    {
      value: 3161650,
      label: "São Geraldo do Baixio",
      reference: 31
    },
    {
      value: 3304904,
      label: "São Gonçalo",
      reference: 33
    },
    {
      value: 3161700,
      label: "São Gonçalo do Abaeté",
      reference: 31
    },
    {
      value: 2412005,
      label: "São Gonçalo do Amarante",
      reference: 24
    },
    {
      value: 2312403,
      label: "São Gonçalo do Amarante",
      reference: 23
    },
    {
      value: 2209757,
      label: "São Gonçalo do Gurguéia",
      reference: 22
    },
    {
      value: 3161809,
      label: "São Gonçalo do Pará",
      reference: 31
    },
    {
      value: 2209807,
      label: "São Gonçalo do Piauí",
      reference: 22
    },
    {
      value: 3161908,
      label: "São Gonçalo do Rio Abaixo",
      reference: 31
    },
    {
      value: 3125507,
      label: "São Gonçalo do Rio Preto",
      reference: 31
    },
    {
      value: 3162005,
      label: "São Gonçalo do Sapucaí",
      reference: 31
    },
    {
      value: 2929305,
      label: "São Gonçalo dos Campos",
      reference: 29
    },
    {
      value: 3162104,
      label: "São Gotardo",
      reference: 31
    },
    {
      value: 4318408,
      label: "São Jerônimo",
      reference: 43
    },
    {
      value: 4124707,
      label: "São Jerônimo da Serra",
      reference: 41
    },
    {
      value: 4124806,
      label: "São João",
      reference: 41
    },
    {
      value: 2613206,
      label: "São João",
      reference: 26
    },
    {
      value: 2111003,
      label: "São João Batista",
      reference: 21
    },
    {
      value: 4216305,
      label: "São João Batista",
      reference: 42
    },
    {
      value: 3162203,
      label: "São João Batista do Glória",
      reference: 31
    },
    {
      value: 5220009,
      label: "São João d'Aliança",
      reference: 52
    },
    {
      value: 1400506,
      label: "São João da Baliza",
      reference: 14
    },
    {
      value: 3305000,
      label: "São João da Barra",
      reference: 33
    },
    {
      value: 3549102,
      label: "São João da Boa Vista",
      reference: 35
    },
    {
      value: 2209856,
      label: "São João da Canabrava",
      reference: 22
    },
    {
      value: 2209872,
      label: "São João da Fronteira",
      reference: 22
    },
    {
      value: 3162252,
      label: "São João da Lagoa",
      reference: 31
    },
    {
      value: 3162302,
      label: "São João da Mata",
      reference: 31
    },
    {
      value: 5220058,
      label: "São João da Paraúna",
      reference: 52
    },
    {
      value: 1507466,
      label: "São João da Ponta",
      reference: 15
    },
    {
      value: 3162401,
      label: "São João da Ponte",
      reference: 31
    },
    {
      value: 2209906,
      label: "São João da Serra",
      reference: 22
    },
    {
      value: 4318424,
      label: "São João da Urtiga",
      reference: 43
    },
    {
      value: 2209955,
      label: "São João da Varjota",
      reference: 22
    },
    {
      value: 3549201,
      label: "São João das Duas Pontes",
      reference: 35
    },
    {
      value: 3162450,
      label: "São João das Missões",
      reference: 31
    },
    {
      value: 3549250,
      label: "São João de Iracema",
      reference: 35
    },
    {
      value: 3305109,
      label: "São João de Meriti",
      reference: 33
    },
    {
      value: 1507474,
      label: "São João de Pirabas",
      reference: 15
    },
    {
      value: 3162500,
      label: "São João del Rei",
      reference: 31
    },
    {
      value: 1507508,
      label: "São João do Araguaia",
      reference: 15
    },
    {
      value: 2209971,
      label: "São João do Arraial",
      reference: 22
    },
    {
      value: 4124905,
      label: "São João do Caiuá",
      reference: 41
    },
    {
      value: 2514008,
      label: "São João do Cariri",
      reference: 25
    },
    {
      value: 2111029,
      label: "São João do Carú",
      reference: 21
    },
    {
      value: 4216354,
      label: "São João do Itaperiú",
      reference: 42
    },
    {
      value: 4125001,
      label: "São João do Ivaí",
      reference: 41
    },
    {
      value: 2312502,
      label: "São João do Jaguaribe",
      reference: 23
    },
    {
      value: 3162559,
      label: "São João do Manhuaçu",
      reference: 31
    },
    {
      value: 3162575,
      label: "São João do Manteninha",
      reference: 31
    },
    {
      value: 4216255,
      label: "São João do Oeste",
      reference: 42
    },
    {
      value: 3162609,
      label: "São João do Oriente",
      reference: 31
    },
    {
      value: 3162658,
      label: "São João do Pacuí",
      reference: 31
    },
    {
      value: 3162708,
      label: "São João do Paraíso",
      reference: 31
    },
    {
      value: 2111052,
      label: "São João do Paraíso",
      reference: 21
    },
    {
      value: 3549300,
      label: "São João do Pau d'Alho",
      reference: 35
    },
    {
      value: 2210003,
      label: "São João do Piauí",
      reference: 22
    },
    {
      value: 4318432,
      label: "São João do Polêsine",
      reference: 43
    },
    {
      value: 2500700,
      label: "São João do Rio do Peixe",
      reference: 25
    },
    {
      value: 2412104,
      label: "São João do Sabugi",
      reference: 24
    },
    {
      value: 2111078,
      label: "São João do Soter",
      reference: 21
    },
    {
      value: 4216404,
      label: "São João do Sul",
      reference: 42
    },
    {
      value: 2514107,
      label: "São João do Tigre",
      reference: 25
    },
    {
      value: 4125100,
      label: "São João do Triunfo",
      reference: 41
    },
    {
      value: 2111102,
      label: "São João dos Patos",
      reference: 21
    },
    {
      value: 3162807,
      label: "São João Evangelista",
      reference: 31
    },
    {
      value: 3162906,
      label: "São João Nepomuceno",
      reference: 31
    },
    {
      value: 4216503,
      label: "São Joaquim",
      reference: 42
    },
    {
      value: 3549409,
      label: "São Joaquim da Barra",
      reference: 35
    },
    {
      value: 3162922,
      label: "São Joaquim de Bicas",
      reference: 31
    },
    {
      value: 2613305,
      label: "São Joaquim do Monte",
      reference: 26
    },
    {
      value: 4318440,
      label: "São Jorge",
      reference: 43
    },
    {
      value: 4125209,
      label: "São Jorge d'Oeste",
      reference: 41
    },
    {
      value: 4125308,
      label: "São Jorge do Ivaí",
      reference: 41
    },
    {
      value: 4125357,
      label: "São Jorge do Patrocínio",
      reference: 41
    },
    {
      value: 4216602,
      label: "São José",
      reference: 42
    },
    {
      value: 3162948,
      label: "São José da Barra",
      reference: 31
    },
    {
      value: 3549508,
      label: "São José da Bela Vista",
      reference: 35
    },
    {
      value: 4125407,
      label: "São José da Boa Vista",
      reference: 41
    },
    {
      value: 2613404,
      label: "São José da Coroa Grande",
      reference: 26
    },
    {
      value: 2514206,
      label: "São José da Lagoa Tapada",
      reference: 25
    },
    {
      value: 2708303,
      label: "São José da Laje",
      reference: 27
    },
    {
      value: 3162955,
      label: "São José da Lapa",
      reference: 31
    },
    {
      value: 3163003,
      label: "São José da Safira",
      reference: 31
    },
    {
      value: 2708402,
      label: "São José da Tapera",
      reference: 27
    },
    {
      value: 3163102,
      label: "São José da Varginha",
      reference: 31
    },
    {
      value: 2929354,
      label: "São José da Vitória",
      reference: 29
    },
    {
      value: 4318457,
      label: "São José das Missões",
      reference: 43
    },
    {
      value: 4125456,
      label: "São José das Palmeiras",
      reference: 41
    },
    {
      value: 2514305,
      label: "São José de Caiana",
      reference: 25
    },
    {
      value: 2514404,
      label: "São José de Espinharas",
      reference: 25
    },
    {
      value: 2412203,
      label: "São José de Mipibu",
      reference: 24
    },
    {
      value: 2514503,
      label: "São José de Piranhas",
      reference: 25
    },
    {
      value: 2514552,
      label: "São José de Princesa",
      reference: 25
    },
    {
      value: 2111201,
      label: "São José de Ribamar",
      reference: 21
    },
    {
      value: 3305133,
      label: "São José de Ubá",
      reference: 33
    },
    {
      value: 3163201,
      label: "São José do Alegre",
      reference: 31
    },
    {
      value: 3549607,
      label: "São José do Barreiro",
      reference: 35
    },
    {
      value: 2613503,
      label: "São José do Belmonte",
      reference: 26
    },
    {
      value: 2514602,
      label: "São José do Bonfim",
      reference: 25
    },
    {
      value: 2514651,
      label: "São José do Brejo do Cruz",
      reference: 25
    },
    {
      value: 3204807,
      label: "São José do Calçado",
      reference: 32
    },
    {
      value: 2412302,
      label: "São José do Campestre",
      reference: 24
    },
    {
      value: 4216701,
      label: "São José do Cedro",
      reference: 42
    },
    {
      value: 4216800,
      label: "São José do Cerrito",
      reference: 42
    },
    {
      value: 2210052,
      label: "São José do Divino",
      reference: 22
    },
    {
      value: 3163300,
      label: "São José do Divino",
      reference: 31
    },
    {
      value: 2613602,
      label: "São José do Egito",
      reference: 26
    },
    {
      value: 3163409,
      label: "São José do Goiabal",
      reference: 31
    },
    {
      value: 4318465,
      label: "São José do Herval",
      reference: 43
    },
    {
      value: 4318481,
      label: "São José do Hortêncio",
      reference: 43
    },
    {
      value: 4318499,
      label: "São José do Inhacorá",
      reference: 43
    },
    {
      value: 2929370,
      label: "São José do Jacuípe",
      reference: 29
    },
    {
      value: 3163508,
      label: "São José do Jacuri",
      reference: 31
    },
    {
      value: 3163607,
      label: "São José do Mantimento",
      reference: 31
    },
    {
      value: 4318507,
      label: "São José do Norte",
      reference: 43
    },
    {
      value: 4318606,
      label: "São José do Ouro",
      reference: 43
    },
    {
      value: 2210102,
      label: "São José do Peixe",
      reference: 22
    },
    {
      value: 2210201,
      label: "São José do Piauí",
      reference: 22
    },
    {
      value: 5107297,
      label: "São José do Povo",
      reference: 51
    },
    {
      value: 5107305,
      label: "São José do Rio Claro",
      reference: 51
    },
    {
      value: 3549706,
      label: "São José do Rio Pardo",
      reference: 35
    },
    {
      value: 3549805,
      label: "São José do Rio Preto",
      reference: 35
    },
    {
      value: 2514701,
      label: "São José do Sabugi",
      reference: 25
    },
    {
      value: 2412401,
      label: "São José do Seridó",
      reference: 24
    },
    {
      value: 4318614,
      label: "São José do Sul",
      reference: 43
    },
    {
      value: 3305158,
      label: "São José do Vale do Rio Preto",
      reference: 33
    },
    {
      value: 5107354,
      label: "São José do Xingu",
      reference: 51
    },
    {
      value: 4318622,
      label: "São José dos Ausentes",
      reference: 43
    },
    {
      value: 2111250,
      label: "São José dos Basílios",
      reference: 21
    },
    {
      value: 3549904,
      label: "São José dos Campos",
      reference: 35
    },
    {
      value: 2514800,
      label: "São José dos Cordeiros",
      reference: 25
    },
    {
      value: 4125506,
      label: "São José dos Pinhais",
      reference: 41
    },
    {
      value: 5107107,
      label: "São José dos Quatro Marcos",
      reference: 51
    },
    {
      value: 2514453,
      label: "São José dos Ramos",
      reference: 25
    },
    {
      value: 2210300,
      label: "São Julião",
      reference: 22
    },
    {
      value: 4318705,
      label: "São Leopoldo",
      reference: 43
    },
    {
      value: 3163706,
      label: "São Lourenço",
      reference: 31
    },
    {
      value: 2613701,
      label: "São Lourenço da Mata",
      reference: 26
    },
    {
      value: 3549953,
      label: "São Lourenço da Serra",
      reference: 35
    },
    {
      value: 4216909,
      label: "São Lourenço do Oeste",
      reference: 42
    },
    {
      value: 2210359,
      label: "São Lourenço do Piauí",
      reference: 22
    },
    {
      value: 4318804,
      label: "São Lourenço do Sul",
      reference: 43
    },
    {
      value: 4217006,
      label: "São Ludgero",
      reference: 42
    },
    {
      value: 2111300,
      label: "São Luís",
      reference: 21
    },
    {
      value: 5220108,
      label: "São Luís de Montes Belos",
      reference: 52
    },
    {
      value: 2312601,
      label: "São Luís do Curu",
      reference: 23
    },
    {
      value: 2210375,
      label: "São Luis do Piauí",
      reference: 22
    },
    {
      value: 2708501,
      label: "São Luís do Quitunde",
      reference: 27
    },
    {
      value: 2111409,
      label: "São Luís Gonzaga do Maranhão",
      reference: 21
    },
    {
      value: 1400605,
      label: "São Luiz",
      reference: 14
    },
    {
      value: 5220157,
      label: "São Luiz do Norte",
      reference: 52
    },
    {
      value: 3550001,
      label: "São Luiz do Paraitinga",
      reference: 35
    },
    {
      value: 4318903,
      label: "São Luiz Gonzaga",
      reference: 43
    },
    {
      value: 2514909,
      label: "São Mamede",
      reference: 25
    },
    {
      value: 4125555,
      label: "São Manoel do Paraná",
      reference: 41
    },
    {
      value: 3550100,
      label: "São Manuel",
      reference: 35
    },
    {
      value: 4319000,
      label: "São Marcos",
      reference: 43
    },
    {
      value: 4217105,
      label: "São Martinho",
      reference: 42
    },
    {
      value: 4319109,
      label: "São Martinho",
      reference: 43
    },
    {
      value: 4319125,
      label: "São Martinho da Serra",
      reference: 43
    },
    {
      value: 3204906,
      label: "São Mateus",
      reference: 32
    },
    {
      value: 2111508,
      label: "São Mateus do Maranhão",
      reference: 21
    },
    {
      value: 4125605,
      label: "São Mateus do Sul",
      reference: 41
    },
    {
      value: 2412500,
      label: "São Miguel",
      reference: 24
    },
    {
      value: 3550209,
      label: "São Miguel Arcanjo",
      reference: 35
    },
    {
      value: 2210383,
      label: "São Miguel da Baixa Grande",
      reference: 22
    },
    {
      value: 4217154,
      label: "São Miguel da Boa Vista",
      reference: 42
    },
    {
      value: 2929404,
      label: "São Miguel das Matas",
      reference: 29
    },
    {
      value: 4319158,
      label: "São Miguel das Missões",
      reference: 43
    },
    {
      value: 2515005,
      label: "São Miguel de Taipu",
      reference: 25
    },
    {
      value: 2807006,
      label: "São Miguel do Aleixo",
      reference: 28
    },
    {
      value: 3163805,
      label: "São Miguel do Anta",
      reference: 31
    },
    {
      value: 5220207,
      label: "São Miguel do Araguaia",
      reference: 52
    },
    {
      value: 2210391,
      label: "São Miguel do Fidalgo",
      reference: 22
    },
    {
      value: 2412559,
      label: "São Miguel do Gostoso",
      reference: 24
    },
    {
      value: 1507607,
      label: "São Miguel do Guamá",
      reference: 15
    },
    {
      value: 1100320,
      label: "São Miguel do Guaporé",
      reference: 11
    },
    {
      value: 4125704,
      label: "São Miguel do Iguaçu",
      reference: 41
    },
    {
      value: 4217204,
      label: "São Miguel do Oeste",
      reference: 42
    },
    {
      value: 5220264,
      label: "São Miguel do Passa Quatro",
      reference: 52
    },
    {
      value: 2210409,
      label: "São Miguel do Tapuio",
      reference: 22
    },
    {
      value: 1720200,
      label: "São Miguel do Tocantins",
      reference: 17
    },
    {
      value: 2708600,
      label: "São Miguel dos Campos",
      reference: 27
    },
    {
      value: 2708709,
      label: "São Miguel dos Milagres",
      reference: 27
    },
    {
      value: 4319208,
      label: "São Nicolau",
      reference: 43
    },
    {
      value: 5220280,
      label: "São Patrício",
      reference: 52
    },
    {
      value: 3550308,
      label: "São Paulo",
      reference: 35
    },
    {
      value: 4319307,
      label: "São Paulo das Missões",
      reference: 43
    },
    {
      value: 1303908,
      label: "São Paulo de Olivença",
      reference: 13
    },
    {
      value: 2412609,
      label: "São Paulo do Potengi",
      reference: 24
    },
    {
      value: 2412708,
      label: "São Pedro",
      reference: 24
    },
    {
      value: 3550407,
      label: "São Pedro",
      reference: 35
    },
    {
      value: 2111532,
      label: "São Pedro da Água Branca",
      reference: 21
    },
    {
      value: 3305208,
      label: "São Pedro da Aldeia",
      reference: 33
    },
    {
      value: 5107404,
      label: "São Pedro da Cipa",
      reference: 51
    },
    {
      value: 4319356,
      label: "São Pedro da Serra",
      reference: 43
    },
    {
      value: 3163904,
      label: "São Pedro da União",
      reference: 31
    },
    {
      value: 4319364,
      label: "São Pedro das Missões",
      reference: 43
    },
    {
      value: 4217253,
      label: "São Pedro de Alcântara",
      reference: 42
    },
    {
      value: 4319372,
      label: "São Pedro do Butiá",
      reference: 43
    },
    {
      value: 4125753,
      label: "São Pedro do Iguaçu",
      reference: 41
    },
    {
      value: 4125803,
      label: "São Pedro do Ivaí",
      reference: 41
    },
    {
      value: 4125902,
      label: "São Pedro do Paraná",
      reference: 41
    },
    {
      value: 2210508,
      label: "São Pedro do Piauí",
      reference: 22
    },
    {
      value: 3164100,
      label: "São Pedro do Suaçuí",
      reference: 31
    },
    {
      value: 4319406,
      label: "São Pedro do Sul",
      reference: 43
    },
    {
      value: 3550506,
      label: "São Pedro do Turvo",
      reference: 35
    },
    {
      value: 2111573,
      label: "São Pedro dos Crentes",
      reference: 21
    },
    {
      value: 3164001,
      label: "São Pedro dos Ferros",
      reference: 31
    },
    {
      value: 2412807,
      label: "São Rafael",
      reference: 24
    },
    {
      value: 2111607,
      label: "São Raimundo das Mangabeiras",
      reference: 21
    },
    {
      value: 2111631,
      label: "São Raimundo do Doca Bezerra",
      reference: 21
    },
    {
      value: 2210607,
      label: "São Raimundo Nonato",
      reference: 22
    },
    {
      value: 2111672,
      label: "São Roberto",
      reference: 21
    },
    {
      value: 3164209,
      label: "São Romão",
      reference: 31
    },
    {
      value: 3550605,
      label: "São Roque",
      reference: 35
    },
    {
      value: 3164308,
      label: "São Roque de Minas",
      reference: 31
    },
    {
      value: 3204955,
      label: "São Roque do Canaã",
      reference: 32
    },
    {
      value: 1720259,
      label: "São Salvador do Tocantins",
      reference: 17
    },
    {
      value: 3550704,
      label: "São Sebastião",
      reference: 35
    },
    {
      value: 2708808,
      label: "São Sebastião",
      reference: 27
    },
    {
      value: 4126009,
      label: "São Sebastião da Amoreira",
      reference: 41
    },
    {
      value: 3164407,
      label: "São Sebastião da Bela Vista",
      reference: 31
    },
    {
      value: 1507706,
      label: "São Sebastião da Boa Vista",
      reference: 15
    },
    {
      value: 3550803,
      label: "São Sebastião da Grama",
      reference: 35
    },
    {
      value: 3164431,
      label: "São Sebastião da Vargem Alegre",
      reference: 31
    },
    {
      value: 2515104,
      label: "São Sebastião de Lagoa de Roça",
      reference: 25
    },
    {
      value: 3305307,
      label: "São Sebastião do Alto",
      reference: 33
    },
    {
      value: 3164472,
      label: "São Sebastião do Anta",
      reference: 31
    },
    {
      value: 4319505,
      label: "São Sebastião do Caí",
      reference: 43
    },
    {
      value: 3164506,
      label: "São Sebastião do Maranhão",
      reference: 31
    },
    {
      value: 3164605,
      label: "São Sebastião do Oeste",
      reference: 31
    },
    {
      value: 3164704,
      label: "São Sebastião do Paraíso",
      reference: 31
    },
    {
      value: 2929503,
      label: "São Sebastião do Passé",
      reference: 29
    },
    {
      value: 3164803,
      label: "São Sebastião do Rio Preto",
      reference: 31
    },
    {
      value: 3164902,
      label: "São Sebastião do Rio Verde",
      reference: 31
    },
    {
      value: 1720309,
      label: "São Sebastião do Tocantins",
      reference: 17
    },
    {
      value: 1303957,
      label: "São Sebastião do Uatumã",
      reference: 13
    },
    {
      value: 2515203,
      label: "São Sebastião do Umbuzeiro",
      reference: 25
    },
    {
      value: 4319604,
      label: "São Sepé",
      reference: 43
    },
    {
      value: 3550902,
      label: "São Simão",
      reference: 35
    },
    {
      value: 5220405,
      label: "São Simão",
      reference: 52
    },
    {
      value: 3165206,
      label: "São Thomé das Letras",
      reference: 31
    },
    {
      value: 3165008,
      label: "São Tiago",
      reference: 31
    },
    {
      value: 3165107,
      label: "São Tomás de Aquino",
      reference: 31
    },
    {
      value: 4126108,
      label: "São Tomé",
      reference: 41
    },
    {
      value: 2412906,
      label: "São Tomé",
      reference: 24
    },
    {
      value: 4319703,
      label: "São Valentim",
      reference: 43
    },
    {
      value: 4319711,
      label: "São Valentim do Sul",
      reference: 43
    },
    {
      value: 1720499,
      label: "São Valério",
      reference: 17
    },
    {
      value: 4319737,
      label: "São Valério do Sul",
      reference: 43
    },
    {
      value: 4319752,
      label: "São Vendelino",
      reference: 43
    },
    {
      value: 3551009,
      label: "São Vicente",
      reference: 35
    },
    {
      value: 2413003,
      label: "São Vicente",
      reference: 24
    },
    {
      value: 3165305,
      label: "São Vicente de Minas",
      reference: 31
    },
    {
      value: 2515401,
      label: "São Vicente do Seridó",
      reference: 25
    },
    {
      value: 4319802,
      label: "São Vicente do Sul",
      reference: 43
    },
    {
      value: 2613800,
      label: "São Vicente Ferrer",
      reference: 26
    },
    {
      value: 2111706,
      label: "São Vicente Ferrer",
      reference: 21
    },
    {
      value: 2515302,
      label: "Sapé",
      reference: 25
    },
    {
      value: 2929602,
      label: "Sapeaçu",
      reference: 29
    },
    {
      value: 5107875,
      label: "Sapezal",
      reference: 51
    },
    {
      value: 4319901,
      label: "Sapiranga",
      reference: 43
    },
    {
      value: 4126207,
      label: "Sapopema",
      reference: 41
    },
    {
      value: 3165404,
      label: "Sapucaí-Mirim",
      reference: 31
    },
    {
      value: 1507755,
      label: "Sapucaia",
      reference: 15
    },
    {
      value: 3305406,
      label: "Sapucaia",
      reference: 33
    },
    {
      value: 4320008,
      label: "Sapucaia do Sul",
      reference: 43
    },
    {
      value: 3305505,
      label: "Saquarema",
      reference: 33
    },
    {
      value: 4126256,
      label: "Sarandi",
      reference: 41
    },
    {
      value: 4320107,
      label: "Sarandi",
      reference: 43
    },
    {
      value: 3551108,
      label: "Sarapuí",
      reference: 35
    },
    {
      value: 3165503,
      label: "Sardoá",
      reference: 31
    },
    {
      value: 3551207,
      label: "Sarutaiá",
      reference: 35
    },
    {
      value: 3165537,
      label: "Sarzedo",
      reference: 31
    },
    {
      value: 2929701,
      label: "Sátiro Dias",
      reference: 29
    },
    {
      value: 2708907,
      label: "Satuba",
      reference: 27
    },
    {
      value: 2111722,
      label: "Satubinha",
      reference: 21
    },
    {
      value: 2929750,
      label: "Saubara",
      reference: 29
    },
    {
      value: 4126272,
      label: "Saudade do Iguaçu",
      reference: 41
    },
    {
      value: 4217303,
      label: "Saudades",
      reference: 42
    },
    {
      value: 2929800,
      label: "Saúde",
      reference: 29
    },
    {
      value: 4217402,
      label: "Schroeder",
      reference: 42
    },
    {
      value: 2929909,
      label: "Seabra",
      reference: 29
    },
    {
      value: 4217501,
      label: "Seara",
      reference: 42
    },
    {
      value: 3551306,
      label: "Sebastianópolis do Sul",
      reference: 35
    },
    {
      value: 2210623,
      label: "Sebastião Barros",
      reference: 22
    },
    {
      value: 2930006,
      label: "Sebastião Laranjeiras",
      reference: 29
    },
    {
      value: 2210631,
      label: "Sebastião Leal",
      reference: 22
    },
    {
      value: 4320206,
      label: "Seberi",
      reference: 43
    },
    {
      value: 4320230,
      label: "Sede Nova",
      reference: 43
    },
    {
      value: 4320263,
      label: "Segredo",
      reference: 43
    },
    {
      value: 4320305,
      label: "Selbach",
      reference: 43
    },
    {
      value: 5007802,
      label: "Selvíria",
      reference: 50
    },
    {
      value: 3165560,
      label: "Sem-Peixe",
      reference: 31
    },
    {
      value: 1200500,
      label: "Sena Madureira",
      reference: 12
    },
    {
      value: 2111748,
      label: "Senador Alexandre Costa",
      reference: 21
    },
    {
      value: 3165578,
      label: "Senador Amaral",
      reference: 31
    },
    {
      value: 5220454,
      label: "Senador Canedo",
      reference: 52
    },
    {
      value: 3165602,
      label: "Senador Cortes",
      reference: 31
    },
    {
      value: 2413102,
      label: "Senador Elói de Souza",
      reference: 24
    },
    {
      value: 3165701,
      label: "Senador Firmino",
      reference: 31
    },
    {
      value: 2413201,
      label: "Senador Georgino Avelino",
      reference: 24
    },
    {
      value: 1200450,
      label: "Senador Guiomard",
      reference: 12
    },
    {
      value: 3165800,
      label: "Senador José Bento",
      reference: 31
    },
    {
      value: 1507805,
      label: "Senador José Porfírio",
      reference: 15
    },
    {
      value: 2111763,
      label: "Senador La Rocque",
      reference: 21
    },
    {
      value: 3165909,
      label: "Senador Modestino Gonçalves",
      reference: 31
    },
    {
      value: 2312700,
      label: "Senador Pompeu",
      reference: 23
    },
    {
      value: 2708956,
      label: "Senador Rui Palmeira",
      reference: 27
    },
    {
      value: 2312809,
      label: "Senador Sá",
      reference: 23
    },
    {
      value: 4320321,
      label: "Senador Salgado Filho",
      reference: 43
    },
    {
      value: 4126306,
      label: "Sengés",
      reference: 41
    },
    {
      value: 2930105,
      label: "Senhor do Bonfim",
      reference: 29
    },
    {
      value: 3166006,
      label: "Senhora de Oliveira",
      reference: 31
    },
    {
      value: 3166105,
      label: "Senhora do Porto",
      reference: 31
    },
    {
      value: 3166204,
      label: "Senhora dos Remédios",
      reference: 31
    },
    {
      value: 4320354,
      label: "Sentinela do Sul",
      reference: 43
    },
    {
      value: 2930204,
      label: "Sento Sé",
      reference: 29
    },
    {
      value: 4320404,
      label: "Serafina Corrêa",
      reference: 43
    },
    {
      value: 3166303,
      label: "Sericita",
      reference: 31
    },
    {
      value: 1101500,
      label: "Seringueiras",
      reference: 11
    },
    {
      value: 4320453,
      label: "Sério",
      reference: 43
    },
    {
      value: 3166402,
      label: "Seritinga",
      reference: 31
    },
    {
      value: 3305554,
      label: "Seropédica",
      reference: 33
    },
    {
      value: 3205002,
      label: "Serra",
      reference: 32
    },
    {
      value: 4217550,
      label: "Serra Alta",
      reference: 42
    },
    {
      value: 3551405,
      label: "Serra Azul",
      reference: 35
    },
    {
      value: 3166501,
      label: "Serra Azul de Minas",
      reference: 31
    },
    {
      value: 2515500,
      label: "Serra Branca",
      reference: 25
    },
    {
      value: 2410306,
      label: "Serra Caiada",
      reference: 24
    },
    {
      value: 2515609,
      label: "Serra da Raiz",
      reference: 25
    },
    {
      value: 3166600,
      label: "Serra da Saudade",
      reference: 31
    },
    {
      value: 2413300,
      label: "Serra de São Bento",
      reference: 24
    },
    {
      value: 2413359,
      label: "Serra do Mel",
      reference: 24
    },
    {
      value: 1600055,
      label: "Serra do Navio",
      reference: 16
    },
    {
      value: 2930154,
      label: "Serra do Ramalho",
      reference: 29
    },
    {
      value: 3166808,
      label: "Serra do Salitre",
      reference: 31
    },
    {
      value: 3166709,
      label: "Serra dos Aimorés",
      reference: 31
    },
    {
      value: 2930303,
      label: "Serra Dourada",
      reference: 29
    },
    {
      value: 2515708,
      label: "Serra Grande",
      reference: 25
    },
    {
      value: 3551603,
      label: "Serra Negra",
      reference: 35
    },
    {
      value: 2413409,
      label: "Serra Negra do Norte",
      reference: 24
    },
    {
      value: 5107883,
      label: "Serra Nova Dourada",
      reference: 51
    },
    {
      value: 2930402,
      label: "Serra Preta",
      reference: 29
    },
    {
      value: 2515807,
      label: "Serra Redonda",
      reference: 25
    },
    {
      value: 2613909,
      label: "Serra Talhada",
      reference: 26
    },
    {
      value: 3551504,
      label: "Serrana",
      reference: 35
    },
    {
      value: 3166907,
      label: "Serrania",
      reference: 31
    },
    {
      value: 2111789,
      label: "Serrano do Maranhão",
      reference: 21
    },
    {
      value: 5220504,
      label: "Serranópolis",
      reference: 52
    },
    {
      value: 3166956,
      label: "Serranópolis de Minas",
      reference: 31
    },
    {
      value: 4126355,
      label: "Serranópolis do Iguaçu",
      reference: 41
    },
    {
      value: 3167004,
      label: "Serranos",
      reference: 31
    },
    {
      value: 2515906,
      label: "Serraria",
      reference: 25
    },
    {
      value: 2413508,
      label: "Serrinha",
      reference: 24
    },
    {
      value: 2930501,
      label: "Serrinha",
      reference: 29
    },
    {
      value: 2413557,
      label: "Serrinha dos Pintos",
      reference: 24
    },
    {
      value: 2614006,
      label: "Serrita",
      reference: 26
    },
    {
      value: 3167103,
      label: "Serro",
      reference: 31
    },
    {
      value: 2930600,
      label: "Serrolândia",
      reference: 29
    },
    {
      value: 4126405,
      label: "Sertaneja",
      reference: 41
    },
    {
      value: 2614105,
      label: "Sertânia",
      reference: 26
    },
    {
      value: 4126504,
      label: "Sertanópolis",
      reference: 41
    },
    {
      value: 4320503,
      label: "Sertão",
      reference: 43
    },
    {
      value: 4320552,
      label: "Sertão Santana",
      reference: 43
    },
    {
      value: 3551702,
      label: "Sertãozinho",
      reference: 35
    },
    {
      value: 2515930,
      label: "Sertãozinho",
      reference: 25
    },
    {
      value: 3551801,
      label: "Sete Barras",
      reference: 35
    },
    {
      value: 4320578,
      label: "Sete de Setembro",
      reference: 43
    },
    {
      value: 3167202,
      label: "Sete Lagoas",
      reference: 31
    },
    {
      value: 5007703,
      label: "Sete Quedas",
      reference: 50
    },
    {
      value: 3165552,
      label: "Setubinha",
      reference: 31
    },
    {
      value: 4320602,
      label: "Severiano de Almeida",
      reference: 43
    },
    {
      value: 2413607,
      label: "Severiano Melo",
      reference: 24
    },
    {
      value: 3551900,
      label: "Severínia",
      reference: 35
    },
    {
      value: 4217600,
      label: "Siderópolis",
      reference: 42
    },
    {
      value: 5007901,
      label: "Sidrolândia",
      reference: 50
    },
    {
      value: 2210656,
      label: "Sigefredo Pacheco",
      reference: 22
    },
    {
      value: 3305604,
      label: "Silva Jardim",
      reference: 33
    },
    {
      value: 5220603,
      label: "Silvânia",
      reference: 52
    },
    {
      value: 1720655,
      label: "Silvanópolis",
      reference: 17
    },
    {
      value: 4320651,
      label: "Silveira Martins",
      reference: 43
    },
    {
      value: 3167301,
      label: "Silveirânia",
      reference: 31
    },
    {
      value: 3552007,
      label: "Silveiras",
      reference: 35
    },
    {
      value: 1304005,
      label: "Silves",
      reference: 13
    },
    {
      value: 3167400,
      label: "Silvianópolis",
      reference: 31
    },
    {
      value: 2807105,
      label: "Simão Dias",
      reference: 28
    },
    {
      value: 3167509,
      label: "Simão Pereira",
      reference: 31
    },
    {
      value: 2210706,
      label: "Simões",
      reference: 22
    },
    {
      value: 2930709,
      label: "Simões Filho",
      reference: 29
    },
    {
      value: 5220686,
      label: "Simolândia",
      reference: 52
    },
    {
      value: 3167608,
      label: "Simonésia",
      reference: 31
    },
    {
      value: 2210805,
      label: "Simplício Mendes",
      reference: 22
    },
    {
      value: 4320677,
      label: "Sinimbu",
      reference: 43
    },
    {
      value: 5107909,
      label: "Sinop",
      reference: 51
    },
    {
      value: 4126603,
      label: "Siqueira Campos",
      reference: 41
    },
    {
      value: 2614204,
      label: "Sirinhaém",
      reference: 26
    },
    {
      value: 2807204,
      label: "Siriri",
      reference: 28
    },
    {
      value: 5220702,
      label: "Sítio d'Abadia",
      reference: 52
    },
    {
      value: 2930758,
      label: "Sítio do Mato",
      reference: 29
    },
    {
      value: 2930766,
      label: "Sítio do Quinto",
      reference: 29
    },
    {
      value: 2111805,
      label: "Sítio Novo",
      reference: 21
    },
    {
      value: 2413706,
      label: "Sítio Novo",
      reference: 24
    },
    {
      value: 1720804,
      label: "Sítio Novo do Tocantins",
      reference: 17
    },
    {
      value: 2930774,
      label: "Sobradinho",
      reference: 29
    },
    {
      value: 4320701,
      label: "Sobradinho",
      reference: 43
    },
    {
      value: 2515971,
      label: "Sobrado",
      reference: 25
    },
    {
      value: 2312908,
      label: "Sobral",
      reference: 23
    },
    {
      value: 3167707,
      label: "Sobrália",
      reference: 31
    },
    {
      value: 3552106,
      label: "Socorro",
      reference: 35
    },
    {
      value: 2210904,
      label: "Socorro do Piauí",
      reference: 22
    },
    {
      value: 2516003,
      label: "Solânea",
      reference: 25
    },
    {
      value: 2516102,
      label: "Soledade",
      reference: 25
    },
    {
      value: 4320800,
      label: "Soledade",
      reference: 43
    },
    {
      value: 3167806,
      label: "Soledade de Minas",
      reference: 31
    },
    {
      value: 2614402,
      label: "Solidão",
      reference: 26
    },
    {
      value: 2313005,
      label: "Solonópole",
      reference: 23
    },
    {
      value: 4217709,
      label: "Sombrio",
      reference: 42
    },
    {
      value: 5007935,
      label: "Sonora",
      reference: 50
    },
    {
      value: 3205010,
      label: "Sooretama",
      reference: 32
    },
    {
      value: 3552205,
      label: "Sorocaba",
      reference: 35
    },
    {
      value: 5107925,
      label: "Sorriso",
      reference: 51
    },
    {
      value: 2516151,
      label: "Sossêgo",
      reference: 25
    },
    {
      value: 1507904,
      label: "Soure",
      reference: 15
    },
    {
      value: 2516201,
      label: "Sousa",
      reference: 25
    },
    {
      value: 2930808,
      label: "Souto Soares",
      reference: 29
    },
    {
      value: 1720853,
      label: "Sucupira",
      reference: 17
    },
    {
      value: 2111904,
      label: "Sucupira do Norte",
      reference: 21
    },
    {
      value: 2111953,
      label: "Sucupira do Riachão",
      reference: 21
    },
    {
      value: 3552304,
      label: "Sud Mennucci",
      reference: 35
    },
    {
      value: 4217758,
      label: "Sul Brasil",
      reference: 42
    },
    {
      value: 4126652,
      label: "Sulina",
      reference: 41
    },
    {
      value: 3552403,
      label: "Sumaré",
      reference: 35
    },
    {
      value: 2516300,
      label: "Sumé",
      reference: 25
    },
    {
      value: 3305703,
      label: "Sumidouro",
      reference: 33
    },
    {
      value: 2614501,
      label: "Surubim",
      reference: 26
    },
    {
      value: 2210938,
      label: "Sussuapara",
      reference: 22
    },
    {
      value: 3552551,
      label: "Suzanápolis",
      reference: 35
    },
    {
      value: 3552502,
      label: "Suzano",
      reference: 35
    },
    {
      value: 4320859,
      label: "Tabaí",
      reference: 43
    },
    {
      value: 5107941,
      label: "Tabaporã",
      reference: 51
    },
    {
      value: 3552601,
      label: "Tabapuã",
      reference: 35
    },
    {
      value: 3552700,
      label: "Tabatinga",
      reference: 35
    },
    {
      value: 1304062,
      label: "Tabatinga",
      reference: 13
    },
    {
      value: 2614600,
      label: "Tabira",
      reference: 26
    },
    {
      value: 3552809,
      label: "Taboão da Serra",
      reference: 35
    },
    {
      value: 2930907,
      label: "Tabocas do Brejo Velho",
      reference: 29
    },
    {
      value: 2413805,
      label: "Taboleiro Grande",
      reference: 24
    },
    {
      value: 3167905,
      label: "Tabuleiro",
      reference: 31
    },
    {
      value: 2313104,
      label: "Tabuleiro do Norte",
      reference: 23
    },
    {
      value: 2614709,
      label: "Tacaimbó",
      reference: 26
    },
    {
      value: 2614808,
      label: "Tacaratu",
      reference: 26
    },
    {
      value: 3552908,
      label: "Taciba",
      reference: 35
    },
    {
      value: 2516409,
      label: "Tacima",
      reference: 25
    },
    {
      value: 5007950,
      label: "Tacuru",
      reference: 50
    },
    {
      value: 3553005,
      label: "Taguaí",
      reference: 35
    },
    {
      value: 1720903,
      label: "Taguatinga",
      reference: 17
    },
    {
      value: 3553104,
      label: "Taiaçu",
      reference: 35
    },
    {
      value: 1507953,
      label: "Tailândia",
      reference: 15
    },
    {
      value: 4217808,
      label: "Taió",
      reference: 42
    },
    {
      value: 3168002,
      label: "Taiobeiras",
      reference: 31
    },
    {
      value: 1720937,
      label: "Taipas do Tocantins",
      reference: 17
    },
    {
      value: 2413904,
      label: "Taipu",
      reference: 24
    },
    {
      value: 3553203,
      label: "Taiúva",
      reference: 35
    },
    {
      value: 1720978,
      label: "Talismã",
      reference: 17
    },
    {
      value: 2614857,
      label: "Tamandaré",
      reference: 26
    },
    {
      value: 4126678,
      label: "Tamarana",
      reference: 41
    },
    {
      value: 3553302,
      label: "Tambaú",
      reference: 35
    },
    {
      value: 4126702,
      label: "Tamboara",
      reference: 41
    },
    {
      value: 2313203,
      label: "Tamboril",
      reference: 23
    },
    {
      value: 2210953,
      label: "Tamboril do Piauí",
      reference: 22
    },
    {
      value: 3553401,
      label: "Tanabi",
      reference: 35
    },
    {
      value: 2414001,
      label: "Tangará",
      reference: 24
    },
    {
      value: 4217907,
      label: "Tangará",
      reference: 42
    },
    {
      value: 5107958,
      label: "Tangará da Serra",
      reference: 51
    },
    {
      value: 3305752,
      label: "Tanguá",
      reference: 33
    },
    {
      value: 2931004,
      label: "Tanhaçu",
      reference: 29
    },
    {
      value: 2709004,
      label: "Tanque d'Arca",
      reference: 27
    },
    {
      value: 2210979,
      label: "Tanque do Piauí",
      reference: 22
    },
    {
      value: 2931053,
      label: "Tanque Novo",
      reference: 29
    },
    {
      value: 2931103,
      label: "Tanquinho",
      reference: 29
    },
    {
      value: 3168051,
      label: "Taparuba",
      reference: 31
    },
    {
      value: 1304104,
      label: "Tapauá",
      reference: 13
    },
    {
      value: 4126801,
      label: "Tapejara",
      reference: 41
    },
    {
      value: 4320909,
      label: "Tapejara",
      reference: 43
    },
    {
      value: 4321006,
      label: "Tapera",
      reference: 43
    },
    {
      value: 2931202,
      label: "Taperoá",
      reference: 29
    },
    {
      value: 2516508,
      label: "Taperoá",
      reference: 25
    },
    {
      value: 4321105,
      label: "Tapes",
      reference: 43
    },
    {
      value: 4126900,
      label: "Tapira",
      reference: 41
    },
    {
      value: 3168101,
      label: "Tapira",
      reference: 31
    },
    {
      value: 3168200,
      label: "Tapiraí",
      reference: 31
    },
    {
      value: 3553500,
      label: "Tapiraí",
      reference: 35
    },
    {
      value: 2931301,
      label: "Tapiramutá",
      reference: 29
    },
    {
      value: 3553609,
      label: "Tapiratiba",
      reference: 35
    },
    {
      value: 5108006,
      label: "Tapurah",
      reference: 51
    },
    {
      value: 4321204,
      label: "Taquara",
      reference: 43
    },
    {
      value: 3168309,
      label: "Taquaraçu de Minas",
      reference: 31
    },
    {
      value: 3553658,
      label: "Taquaral",
      reference: 35
    },
    {
      value: 5221007,
      label: "Taquaral de Goiás",
      reference: 52
    },
    {
      value: 2709103,
      label: "Taquarana",
      reference: 27
    },
    {
      value: 4321303,
      label: "Taquari",
      reference: 43
    },
    {
      value: 3553708,
      label: "Taquaritinga",
      reference: 35
    },
    {
      value: 2615003,
      label: "Taquaritinga do Norte",
      reference: 26
    },
    {
      value: 3553807,
      label: "Taquarituba",
      reference: 35
    },
    {
      value: 3553856,
      label: "Taquarivaí",
      reference: 35
    },
    {
      value: 4321329,
      label: "Taquaruçu do Sul",
      reference: 43
    },
    {
      value: 5007976,
      label: "Taquarussu",
      reference: 50
    },
    {
      value: 3553906,
      label: "Tarabai",
      reference: 35
    },
    {
      value: 1200609,
      label: "Tarauacá",
      reference: 12
    },
    {
      value: 2313252,
      label: "Tarrafas",
      reference: 23
    },
    {
      value: 1600709,
      label: "Tartarugalzinho",
      reference: 16
    },
    {
      value: 3553955,
      label: "Tarumã",
      reference: 35
    },
    {
      value: 3168408,
      label: "Tarumirim",
      reference: 31
    },
    {
      value: 2112001,
      label: "Tasso Fragoso",
      reference: 21
    },
    {
      value: 3554003,
      label: "Tatuí",
      reference: 35
    },
    {
      value: 2313302,
      label: "Tauá",
      reference: 23
    },
    {
      value: 3554102,
      label: "Taubaté",
      reference: 35
    },
    {
      value: 4321352,
      label: "Tavares",
      reference: 43
    },
    {
      value: 2516607,
      label: "Tavares",
      reference: 25
    },
    {
      value: 1304203,
      label: "Tefé",
      reference: 13
    },
    {
      value: 2516706,
      label: "Teixeira",
      reference: 25
    },
    {
      value: 2931350,
      label: "Teixeira de Freitas",
      reference: 29
    },
    {
      value: 4127007,
      label: "Teixeira Soares",
      reference: 41
    },
    {
      value: 3168507,
      label: "Teixeiras",
      reference: 31
    },
    {
      value: 1101559,
      label: "Teixeirópolis",
      reference: 11
    },
    {
      value: 2313351,
      label: "Tejuçuoca",
      reference: 23
    },
    {
      value: 3554201,
      label: "Tejupá",
      reference: 35
    },
    {
      value: 4127106,
      label: "Telêmaco Borba",
      reference: 41
    },
    {
      value: 2807303,
      label: "Telha",
      reference: 28
    },
    {
      value: 2414100,
      label: "Tenente Ananias",
      reference: 24
    },
    {
      value: 2414159,
      label: "Tenente Laurentino Cruz",
      reference: 24
    },
    {
      value: 4321402,
      label: "Tenente Portela",
      reference: 43
    },
    {
      value: 2516755,
      label: "Tenório",
      reference: 25
    },
    {
      value: 2931400,
      label: "Teodoro Sampaio",
      reference: 29
    },
    {
      value: 3554300,
      label: "Teodoro Sampaio",
      reference: 35
    },
    {
      value: 2931509,
      label: "Teofilândia",
      reference: 29
    },
    {
      value: 3168606,
      label: "Teófilo Otoni",
      reference: 31
    },
    {
      value: 2931608,
      label: "Teolândia",
      reference: 29
    },
    {
      value: 2709152,
      label: "Teotônio Vilela",
      reference: 27
    },
    {
      value: 5008008,
      label: "Terenos",
      reference: 50
    },
    {
      value: 2211001,
      label: "Teresina",
      reference: 22
    },
    {
      value: 5221080,
      label: "Teresina de Goiás",
      reference: 52
    },
    {
      value: 3305802,
      label: "Teresópolis",
      reference: 33
    },
    {
      value: 2615102,
      label: "Terezinha",
      reference: 26
    },
    {
      value: 5221197,
      label: "Terezópolis de Goiás",
      reference: 52
    },
    {
      value: 1507961,
      label: "Terra Alta",
      reference: 15
    },
    {
      value: 4127205,
      label: "Terra Boa",
      reference: 41
    },
    {
      value: 4321436,
      label: "Terra de Areia",
      reference: 43
    },
    {
      value: 2931707,
      label: "Terra Nova",
      reference: 29
    },
    {
      value: 2615201,
      label: "Terra Nova",
      reference: 26
    },
    {
      value: 5108055,
      label: "Terra Nova do Norte",
      reference: 51
    },
    {
      value: 4127304,
      label: "Terra Rica",
      reference: 41
    },
    {
      value: 4127403,
      label: "Terra Roxa",
      reference: 41
    },
    {
      value: 3554409,
      label: "Terra Roxa",
      reference: 35
    },
    {
      value: 1507979,
      label: "Terra Santa",
      reference: 15
    },
    {
      value: 5108105,
      label: "Tesouro",
      reference: 51
    },
    {
      value: 4321451,
      label: "Teutônia",
      reference: 43
    },
    {
      value: 1101609,
      label: "Theobroma",
      reference: 11
    },
    {
      value: 2313401,
      label: "Tianguá",
      reference: 23
    },
    {
      value: 4127502,
      label: "Tibagi",
      reference: 41
    },
    {
      value: 2411056,
      label: "Tibau",
      reference: 24
    },
    {
      value: 2414209,
      label: "Tibau do Sul",
      reference: 24
    },
    {
      value: 3554508,
      label: "Tietê",
      reference: 35
    },
    {
      value: 4217956,
      label: "Tigrinhos",
      reference: 42
    },
    {
      value: 4218004,
      label: "Tijucas",
      reference: 42
    },
    {
      value: 4127601,
      label: "Tijucas do Sul",
      reference: 41
    },
    {
      value: 2615300,
      label: "Timbaúba",
      reference: 26
    },
    {
      value: 2414308,
      label: "Timbaúba dos Batistas",
      reference: 24
    },
    {
      value: 4218103,
      label: "Timbé do Sul",
      reference: 42
    },
    {
      value: 2112100,
      label: "Timbiras",
      reference: 21
    },
    {
      value: 4218202,
      label: "Timbó",
      reference: 42
    },
    {
      value: 4218251,
      label: "Timbó Grande",
      reference: 42
    },
    {
      value: 3554607,
      label: "Timburi",
      reference: 35
    },
    {
      value: 2112209,
      label: "Timon",
      reference: 21
    },
    {
      value: 3168705,
      label: "Timóteo",
      reference: 31
    },
    {
      value: 4321469,
      label: "Tio Hugo",
      reference: 43
    },
    {
      value: 3168804,
      label: "Tiradentes",
      reference: 31
    },
    {
      value: 4321477,
      label: "Tiradentes do Sul",
      reference: 43
    },
    {
      value: 3168903,
      label: "Tiros",
      reference: 31
    },
    {
      value: 2807402,
      label: "Tobias Barreto",
      reference: 28
    },
    {
      value: 1721109,
      label: "Tocantínia",
      reference: 17
    },
    {
      value: 1721208,
      label: "Tocantinópolis",
      reference: 17
    },
    {
      value: 3169000,
      label: "Tocantins",
      reference: 31
    },
    {
      value: 3169059,
      label: "Tocos do Moji",
      reference: 31
    },
    {
      value: 3169109,
      label: "Toledo",
      reference: 31
    },
    {
      value: 4127700,
      label: "Toledo",
      reference: 41
    },
    {
      value: 2807501,
      label: "Tomar do Geru",
      reference: 28
    },
    {
      value: 4127809,
      label: "Tomazina",
      reference: 41
    },
    {
      value: 3169208,
      label: "Tombos",
      reference: 31
    },
    {
      value: 1508001,
      label: "Tomé-Açu",
      reference: 15
    },
    {
      value: 1304237,
      label: "Tonantins",
      reference: 13
    },
    {
      value: 2615409,
      label: "Toritama",
      reference: 26
    },
    {
      value: 5108204,
      label: "Torixoréu",
      reference: 51
    },
    {
      value: 4321493,
      label: "Toropi",
      reference: 43
    },
    {
      value: 3554656,
      label: "Torre de Pedra",
      reference: 35
    },
    {
      value: 4321501,
      label: "Torres",
      reference: 43
    },
    {
      value: 3554706,
      label: "Torrinha",
      reference: 35
    },
    {
      value: 2414407,
      label: "Touros",
      reference: 24
    },
    {
      value: 3554755,
      label: "Trabiju",
      reference: 35
    },
    {
      value: 1508035,
      label: "Tracuateua",
      reference: 15
    },
    {
      value: 2615508,
      label: "Tracunhaém",
      reference: 26
    },
    {
      value: 2709202,
      label: "Traipu",
      reference: 27
    },
    {
      value: 1508050,
      label: "Trairão",
      reference: 15
    },
    {
      value: 2313500,
      label: "Trairi",
      reference: 23
    },
    {
      value: 3305901,
      label: "Trajano de Moraes",
      reference: 33
    },
    {
      value: 4321600,
      label: "Tramandaí",
      reference: 43
    },
    {
      value: 4321626,
      label: "Travesseiro",
      reference: 43
    },
    {
      value: 2931806,
      label: "Tremedal",
      reference: 29
    },
    {
      value: 3554805,
      label: "Tremembé",
      reference: 35
    },
    {
      value: 4321634,
      label: "Três Arroios",
      reference: 43
    },
    {
      value: 4218301,
      label: "Três Barras",
      reference: 42
    },
    {
      value: 4127858,
      label: "Três Barras do Paraná",
      reference: 41
    },
    {
      value: 4321667,
      label: "Três Cachoeiras",
      reference: 43
    },
    {
      value: 3169307,
      label: "Três Corações",
      reference: 31
    },
    {
      value: 4321709,
      label: "Três Coroas",
      reference: 43
    },
    {
      value: 4321808,
      label: "Três de Maio",
      reference: 43
    },
    {
      value: 4321832,
      label: "Três Forquilhas",
      reference: 43
    },
    {
      value: 3554904,
      label: "Três Fronteiras",
      reference: 35
    },
    {
      value: 5008305,
      label: "Três Lagoas",
      reference: 50
    },
    {
      value: 3169356,
      label: "Três Marias",
      reference: 31
    },
    {
      value: 4321857,
      label: "Três Palmeiras",
      reference: 43
    },
    {
      value: 4321907,
      label: "Três Passos",
      reference: 43
    },
    {
      value: 3169406,
      label: "Três Pontas",
      reference: 31
    },
    {
      value: 5221304,
      label: "Três Ranchos",
      reference: 52
    },
    {
      value: 3306008,
      label: "Três Rios",
      reference: 33
    },
    {
      value: 4218350,
      label: "Treviso",
      reference: 42
    },
    {
      value: 4218400,
      label: "Treze de Maio",
      reference: 42
    },
    {
      value: 4218509,
      label: "Treze Tílias",
      reference: 42
    },
    {
      value: 5221403,
      label: "Trindade",
      reference: 52
    },
    {
      value: 2615607,
      label: "Trindade",
      reference: 26
    },
    {
      value: 4321956,
      label: "Trindade do Sul",
      reference: 43
    },
    {
      value: 4322004,
      label: "Triunfo",
      reference: 43
    },
    {
      value: 2516805,
      label: "Triunfo",
      reference: 25
    },
    {
      value: 2615706,
      label: "Triunfo",
      reference: 26
    },
    {
      value: 2414456,
      label: "Triunfo Potiguar",
      reference: 24
    },
    {
      value: 2112233,
      label: "Trizidela do Vale",
      reference: 21
    },
    {
      value: 5221452,
      label: "Trombas",
      reference: 52
    },
    {
      value: 4218608,
      label: "Trombudo Central",
      reference: 42
    },
    {
      value: 4218707,
      label: "Tubarão",
      reference: 42
    },
    {
      value: 2931905,
      label: "Tucano",
      reference: 29
    },
    {
      value: 1508084,
      label: "Tucumã",
      reference: 15
    },
    {
      value: 4322103,
      label: "Tucunduva",
      reference: 43
    },
    {
      value: 1508100,
      label: "Tucuruí",
      reference: 15
    },
    {
      value: 2112274,
      label: "Tufilândia",
      reference: 21
    },
    {
      value: 3554953,
      label: "Tuiuti",
      reference: 35
    },
    {
      value: 3169505,
      label: "Tumiritinga",
      reference: 31
    },
    {
      value: 4218756,
      label: "Tunápolis",
      reference: 42
    },
    {
      value: 4322152,
      label: "Tunas",
      reference: 43
    },
    {
      value: 4127882,
      label: "Tunas do Paraná",
      reference: 41
    },
    {
      value: 4127908,
      label: "Tuneiras do Oeste",
      reference: 41
    },
    {
      value: 2112308,
      label: "Tuntum",
      reference: 21
    },
    {
      value: 3555000,
      label: "Tupã",
      reference: 35
    },
    {
      value: 3169604,
      label: "Tupaciguara",
      reference: 31
    },
    {
      value: 2615805,
      label: "Tupanatinga",
      reference: 26
    },
    {
      value: 4322186,
      label: "Tupanci do Sul",
      reference: 43
    },
    {
      value: 4322202,
      label: "Tupanciretã",
      reference: 43
    },
    {
      value: 4322251,
      label: "Tupandi",
      reference: 43
    },
    {
      value: 4322301,
      label: "Tuparendi",
      reference: 43
    },
    {
      value: 2615904,
      label: "Tuparetama",
      reference: 26
    },
    {
      value: 4127957,
      label: "Tupãssi",
      reference: 41
    },
    {
      value: 3555109,
      label: "Tupi Paulista",
      reference: 35
    },
    {
      value: 1721257,
      label: "Tupirama",
      reference: 17
    },
    {
      value: 1721307,
      label: "Tupiratins",
      reference: 17
    },
    {
      value: 2112407,
      label: "Turiaçu",
      reference: 21
    },
    {
      value: 2112456,
      label: "Turilândia",
      reference: 21
    },
    {
      value: 3555208,
      label: "Turiúba",
      reference: 35
    },
    {
      value: 3555307,
      label: "Turmalina",
      reference: 35
    },
    {
      value: 3169703,
      label: "Turmalina",
      reference: 31
    },
    {
      value: 4322327,
      label: "Turuçu",
      reference: 43
    },
    {
      value: 2313559,
      label: "Tururu",
      reference: 23
    },
    {
      value: 5221502,
      label: "Turvânia",
      reference: 52
    },
    {
      value: 5221551,
      label: "Turvelândia",
      reference: 52
    },
    {
      value: 4127965,
      label: "Turvo",
      reference: 41
    },
    {
      value: 4218806,
      label: "Turvo",
      reference: 42
    },
    {
      value: 3169802,
      label: "Turvolândia",
      reference: 31
    },
    {
      value: 2112506,
      label: "Tutóia",
      reference: 21
    },
    {
      value: 1304260,
      label: "Uarini",
      reference: 13
    },
    {
      value: 2932002,
      label: "Uauá",
      reference: 29
    },
    {
      value: 3169901,
      label: "Ubá",
      reference: 31
    },
    {
      value: 3170008,
      label: "Ubaí",
      reference: 31
    },
    {
      value: 2932101,
      label: "Ubaíra",
      reference: 29
    },
    {
      value: 2932200,
      label: "Ubaitaba",
      reference: 29
    },
    {
      value: 2313609,
      label: "Ubajara",
      reference: 23
    },
    {
      value: 3170057,
      label: "Ubaporanga",
      reference: 31
    },
    {
      value: 3555356,
      label: "Ubarana",
      reference: 35
    },
    {
      value: 2932309,
      label: "Ubatã",
      reference: 29
    },
    {
      value: 3555406,
      label: "Ubatuba",
      reference: 35
    },
    {
      value: 3170107,
      label: "Uberaba",
      reference: 31
    },
    {
      value: 3170206,
      label: "Uberlândia",
      reference: 31
    },
    {
      value: 3555505,
      label: "Ubirajara",
      reference: 35
    },
    {
      value: 4128005,
      label: "Ubiratã",
      reference: 41
    },
    {
      value: 4322343,
      label: "Ubiretama",
      reference: 43
    },
    {
      value: 3555604,
      label: "Uchoa",
      reference: 35
    },
    {
      value: 2932408,
      label: "Uibaí",
      reference: 29
    },
    {
      value: 1400704,
      label: "Uiramutã",
      reference: 14
    },
    {
      value: 5221577,
      label: "Uirapuru",
      reference: 52
    },
    {
      value: 2516904,
      label: "Uiraúna",
      reference: 25
    },
    {
      value: 1508126,
      label: "Ulianópolis",
      reference: 15
    },
    {
      value: 2313708,
      label: "Umari",
      reference: 23
    },
    {
      value: 2414506,
      label: "Umarizal",
      reference: 24
    },
    {
      value: 2807600,
      label: "Umbaúba",
      reference: 28
    },
    {
      value: 2932457,
      label: "Umburanas",
      reference: 29
    },
    {
      value: 3170305,
      label: "Umburatiba",
      reference: 31
    },
    {
      value: 2517001,
      label: "Umbuzeiro",
      reference: 25
    },
    {
      value: 2313757,
      label: "Umirim",
      reference: 23
    },
    {
      value: 4128104,
      label: "Umuarama",
      reference: 41
    },
    {
      value: 2932507,
      label: "Una",
      reference: 29
    },
    {
      value: 3170404,
      label: "Unaí",
      reference: 31
    },
    {
      value: 2211100,
      label: "União",
      reference: 22
    },
    {
      value: 4322350,
      label: "União da Serra",
      reference: 43
    },
    {
      value: 4128203,
      label: "União da Vitória",
      reference: 41
    },
    {
      value: 3170438,
      label: "União de Minas",
      reference: 31
    },
    {
      value: 4218855,
      label: "União do Oeste",
      reference: 42
    },
    {
      value: 5108303,
      label: "União do Sul",
      reference: 51
    },
    {
      value: 2709301,
      label: "União dos Palmares",
      reference: 27
    },
    {
      value: 3555703,
      label: "União Paulista",
      reference: 35
    },
    {
      value: 4128302,
      label: "Uniflor",
      reference: 41
    },
    {
      value: 4322376,
      label: "Unistalda",
      reference: 43
    },
    {
      value: 2414605,
      label: "Upanema",
      reference: 24
    },
    {
      value: 4128401,
      label: "Uraí",
      reference: 41
    },
    {
      value: 2932606,
      label: "Urandi",
      reference: 29
    },
    {
      value: 3555802,
      label: "Urânia",
      reference: 35
    },
    {
      value: 2112605,
      label: "Urbano Santos",
      reference: 21
    },
    {
      value: 3555901,
      label: "Uru",
      reference: 35
    },
    {
      value: 5221601,
      label: "Uruaçu",
      reference: 52
    },
    {
      value: 5221700,
      label: "Uruana",
      reference: 52
    },
    {
      value: 3170479,
      label: "Uruana de Minas",
      reference: 31
    },
    {
      value: 1508159,
      label: "Uruará",
      reference: 15
    },
    {
      value: 4218905,
      label: "Urubici",
      reference: 42
    },
    {
      value: 2313807,
      label: "Uruburetama",
      reference: 23
    },
    {
      value: 3170503,
      label: "Urucânia",
      reference: 31
    },
    {
      value: 1304302,
      label: "Urucará",
      reference: 13
    },
    {
      value: 2932705,
      label: "Uruçuca",
      reference: 29
    },
    {
      value: 2211209,
      label: "Uruçuí",
      reference: 22
    },
    {
      value: 3170529,
      label: "Urucuia",
      reference: 31
    },
    {
      value: 1304401,
      label: "Urucurituba",
      reference: 13
    },
    {
      value: 4322400,
      label: "Uruguaiana",
      reference: 43
    },
    {
      value: 2313906,
      label: "Uruoca",
      reference: 23
    },
    {
      value: 1101708,
      label: "Urupá",
      reference: 11
    },
    {
      value: 4218954,
      label: "Urupema",
      reference: 42
    },
    {
      value: 3556008,
      label: "Urupês",
      reference: 35
    },
    {
      value: 4219002,
      label: "Urussanga",
      reference: 42
    },
    {
      value: 5221809,
      label: "Urutaí",
      reference: 52
    },
    {
      value: 2932804,
      label: "Utinga",
      reference: 29
    },
    {
      value: 4322509,
      label: "Vacaria",
      reference: 43
    },
    {
      value: 5108352,
      label: "Vale de São Domingos",
      reference: 51
    },
    {
      value: 1101757,
      label: "Vale do Anari",
      reference: 11
    },
    {
      value: 1101807,
      label: "Vale do Paraíso",
      reference: 11
    },
    {
      value: 4322533,
      label: "Vale do Sol",
      reference: 43
    },
    {
      value: 4322541,
      label: "Vale Real",
      reference: 43
    },
    {
      value: 4322525,
      label: "Vale Verde",
      reference: 43
    },
    {
      value: 2932903,
      label: "Valença",
      reference: 29
    },
    {
      value: 3306107,
      label: "Valença",
      reference: 33
    },
    {
      value: 2211308,
      label: "Valença do Piauí",
      reference: 22
    },
    {
      value: 2933000,
      label: "Valente",
      reference: 29
    },
    {
      value: 3556107,
      label: "Valentim Gentil",
      reference: 35
    },
    {
      value: 3556206,
      label: "Valinhos",
      reference: 35
    },
    {
      value: 3556305,
      label: "Valparaíso",
      reference: 35
    },
    {
      value: 5221858,
      label: "Valparaíso de Goiás",
      reference: 52
    },
    {
      value: 4322558,
      label: "Vanini",
      reference: 43
    },
    {
      value: 4219101,
      label: "Vargeão",
      reference: 42
    },
    {
      value: 4219150,
      label: "Vargem",
      reference: 42
    },
    {
      value: 3556354,
      label: "Vargem",
      reference: 35
    },
    {
      value: 3170578,
      label: "Vargem Alegre",
      reference: 31
    },
    {
      value: 3205036,
      label: "Vargem Alta",
      reference: 32
    },
    {
      value: 3170602,
      label: "Vargem Bonita",
      reference: 31
    },
    {
      value: 4219176,
      label: "Vargem Bonita",
      reference: 42
    },
    {
      value: 2112704,
      label: "Vargem Grande",
      reference: 21
    },
    {
      value: 3170651,
      label: "Vargem Grande do Rio Pardo",
      reference: 31
    },
    {
      value: 3556404,
      label: "Vargem Grande do Sul",
      reference: 35
    },
    {
      value: 3556453,
      label: "Vargem Grande Paulista",
      reference: 35
    },
    {
      value: 3170701,
      label: "Varginha",
      reference: 31
    },
    {
      value: 5221908,
      label: "Varjão",
      reference: 52
    },
    {
      value: 3170750,
      label: "Varjão de Minas",
      reference: 31
    },
    {
      value: 2313955,
      label: "Varjota",
      reference: 23
    },
    {
      value: 3306156,
      label: "Varre-Sai",
      reference: 33
    },
    {
      value: 2414704,
      label: "Várzea",
      reference: 24
    },
    {
      value: 2517100,
      label: "Várzea",
      reference: 25
    },
    {
      value: 2314003,
      label: "Várzea Alegre",
      reference: 23
    },
    {
      value: 2211357,
      label: "Várzea Branca",
      reference: 22
    },
    {
      value: 3170800,
      label: "Várzea da Palma",
      reference: 31
    },
    {
      value: 2933059,
      label: "Várzea da Roça",
      reference: 29
    },
    {
      value: 2933109,
      label: "Várzea do Poço",
      reference: 29
    },
    {
      value: 2211407,
      label: "Várzea Grande",
      reference: 22
    },
    {
      value: 5108402,
      label: "Várzea Grande",
      reference: 51
    },
    {
      value: 2933158,
      label: "Várzea Nova",
      reference: 29
    },
    {
      value: 3556503,
      label: "Várzea Paulista",
      reference: 35
    },
    {
      value: 2933174,
      label: "Varzedo",
      reference: 29
    },
    {
      value: 3170909,
      label: "Varzelândia",
      reference: 31
    },
    {
      value: 3306206,
      label: "Vassouras",
      reference: 33
    },
    {
      value: 3171006,
      label: "Vazante",
      reference: 31
    },
    {
      value: 4322608,
      label: "Venâncio Aires",
      reference: 43
    },
    {
      value: 3205069,
      label: "Venda Nova do Imigrante",
      reference: 32
    },
    {
      value: 2414753,
      label: "Venha-Ver",
      reference: 24
    },
    {
      value: 4128534,
      label: "Ventania",
      reference: 41
    },
    {
      value: 2616001,
      label: "Venturosa",
      reference: 26
    },
    {
      value: 5108501,
      label: "Vera",
      reference: 51
    },
    {
      value: 2414803,
      label: "Vera Cruz",
      reference: 24
    },
    {
      value: 2933208,
      label: "Vera Cruz",
      reference: 29
    },
    {
      value: 4322707,
      label: "Vera Cruz",
      reference: 43
    },
    {
      value: 3556602,
      label: "Vera Cruz",
      reference: 35
    },
    {
      value: 4128559,
      label: "Vera Cruz do Oeste",
      reference: 41
    },
    {
      value: 2211506,
      label: "Vera Mendes",
      reference: 22
    },
    {
      value: 4322806,
      label: "Veranópolis",
      reference: 43
    },
    {
      value: 2616100,
      label: "Verdejante",
      reference: 26
    },
    {
      value: 3171030,
      label: "Verdelândia",
      reference: 31
    },
    {
      value: 4128609,
      label: "Verê",
      reference: 41
    },
    {
      value: 2933257,
      label: "Vereda",
      reference: 29
    },
    {
      value: 3171071,
      label: "Veredinha",
      reference: 31
    },
    {
      value: 3171105,
      label: "Veríssimo",
      reference: 31
    },
    {
      value: 3171154,
      label: "Vermelho Novo",
      reference: 31
    },
    {
      value: 2616183,
      label: "Vertente do Lério",
      reference: 26
    },
    {
      value: 2616209,
      label: "Vertentes",
      reference: 26
    },
    {
      value: 3171204,
      label: "Vespasiano",
      reference: 31
    },
    {
      value: 4322855,
      label: "Vespasiano Corrêa",
      reference: 43
    },
    {
      value: 4322905,
      label: "Viadutos",
      reference: 43
    },
    {
      value: 4323002,
      label: "Viamão",
      reference: 43
    },
    {
      value: 3205101,
      label: "Viana",
      reference: 32
    },
    {
      value: 2112803,
      label: "Viana",
      reference: 21
    },
    {
      value: 5222005,
      label: "Vianópolis",
      reference: 52
    },
    {
      value: 2616308,
      label: "Vicência",
      reference: 26
    },
    {
      value: 4323101,
      label: "Vicente Dutra",
      reference: 43
    },
    {
      value: 5008404,
      label: "Vicentina",
      reference: 50
    },
    {
      value: 5222054,
      label: "Vicentinópolis",
      reference: 52
    },
    {
      value: 2414902,
      label: "Viçosa",
      reference: 24
    },
    {
      value: 2709400,
      label: "Viçosa",
      reference: 27
    },
    {
      value: 3171303,
      label: "Viçosa",
      reference: 31
    },
    {
      value: 2314102,
      label: "Viçosa do Ceará",
      reference: 23
    },
    {
      value: 4323200,
      label: "Victor Graeff",
      reference: 43
    },
    {
      value: 4219200,
      label: "Vidal Ramos",
      reference: 42
    },
    {
      value: 4219309,
      label: "Videira",
      reference: 42
    },
    {
      value: 3171402,
      label: "Vieiras",
      reference: 31
    },
    {
      value: 2517209,
      label: "Vieirópolis",
      reference: 25
    },
    {
      value: 1508209,
      label: "Vigia",
      reference: 15
    },
    {
      value: 5105507,
      label: "Vila Bela da Santíssima Trindade",
      reference: 51
    },
    {
      value: 5222203,
      label: "Vila Boa",
      reference: 52
    },
    {
      value: 2415008,
      label: "Vila Flor",
      reference: 24
    },
    {
      value: 4323309,
      label: "Vila Flores",
      reference: 43
    },
    {
      value: 4323358,
      label: "Vila Lângaro",
      reference: 43
    },
    {
      value: 4323408,
      label: "Vila Maria",
      reference: 43
    },
    {
      value: 2211605,
      label: "Vila Nova do Piauí",
      reference: 22
    },
    {
      value: 4323457,
      label: "Vila Nova do Sul",
      reference: 43
    },
    {
      value: 2112852,
      label: "Vila Nova dos Martírios",
      reference: 21
    },
    {
      value: 3205150,
      label: "Vila Pavão",
      reference: 32
    },
    {
      value: 5222302,
      label: "Vila Propício",
      reference: 52
    },
    {
      value: 5108600,
      label: "Vila Rica",
      reference: 51
    },
    {
      value: 3205176,
      label: "Vila Valério",
      reference: 32
    },
    {
      value: 3205200,
      label: "Vila Velha",
      reference: 32
    },
    {
      value: 1100304,
      label: "Vilhena",
      reference: 11
    },
    {
      value: 3556701,
      label: "Vinhedo",
      reference: 35
    },
    {
      value: 3556800,
      label: "Viradouro",
      reference: 35
    },
    {
      value: 3171600,
      label: "Virgem da Lapa",
      reference: 31
    },
    {
      value: 3171709,
      label: "Virgínia",
      reference: 31
    },
    {
      value: 3171808,
      label: "Virginópolis",
      reference: 31
    },
    {
      value: 3171907,
      label: "Virgolândia",
      reference: 31
    },
    {
      value: 4128658,
      label: "Virmond",
      reference: 41
    },
    {
      value: 3172004,
      label: "Visconde do Rio Branco",
      reference: 31
    },
    {
      value: 1508308,
      label: "Viseu",
      reference: 15
    },
    {
      value: 4323507,
      label: "Vista Alegre",
      reference: 43
    },
    {
      value: 3556909,
      label: "Vista Alegre do Alto",
      reference: 35
    },
    {
      value: 4323606,
      label: "Vista Alegre do Prata",
      reference: 43
    },
    {
      value: 4323705,
      label: "Vista Gaúcha",
      reference: 43
    },
    {
      value: 2505501,
      label: "Vista Serrana",
      reference: 25
    },
    {
      value: 4219358,
      label: "Vitor Meireles",
      reference: 42
    },
    {
      value: 3205309,
      label: "Vitória",
      reference: 32
    },
    {
      value: 3556958,
      label: "Vitória Brasil",
      reference: 35
    },
    {
      value: 2933307,
      label: "Vitória da Conquista",
      reference: 29
    },
    {
      value: 4323754,
      label: "Vitória das Missões",
      reference: 43
    },
    {
      value: 2616407,
      label: "Vitória de Santo Antão",
      reference: 26
    },
    {
      value: 1600808,
      label: "Vitória do Jari",
      reference: 16
    },
    {
      value: 2112902,
      label: "Vitória do Mearim",
      reference: 21
    },
    {
      value: 1508357,
      label: "Vitória do Xingu",
      reference: 15
    },
    {
      value: 4128708,
      label: "Vitorino",
      reference: 41
    },
    {
      value: 2113009,
      label: "Vitorino Freire",
      reference: 21
    },
    {
      value: 3172103,
      label: "Volta Grande",
      reference: 31
    },
    {
      value: 3306305,
      label: "Volta Redonda",
      reference: 33
    },
    {
      value: 3557006,
      label: "Votorantim",
      reference: 35
    },
    {
      value: 3557105,
      label: "Votuporanga",
      reference: 35
    },
    {
      value: 2933406,
      label: "Wagner",
      reference: 29
    },
    {
      value: 2211704,
      label: "Wall Ferraz",
      reference: 22
    },
    {
      value: 1722081,
      label: "Wanderlândia",
      reference: 17
    },
    {
      value: 2933455,
      label: "Wanderley",
      reference: 29
    },
    {
      value: 3172202,
      label: "Wenceslau Braz",
      reference: 31
    },
    {
      value: 4128500,
      label: "Wenceslau Braz",
      reference: 41
    },
    {
      value: 2933505,
      label: "Wenceslau Guimarães",
      reference: 29
    },
    {
      value: 4323770,
      label: "Westfália",
      reference: 43
    },
    {
      value: 4219408,
      label: "Witmarsum",
      reference: 42
    },
    {
      value: 1722107,
      label: "Xambioá",
      reference: 17
    },
    {
      value: 4128807,
      label: "Xambrê",
      reference: 41
    },
    {
      value: 4323804,
      label: "Xangri-lá",
      reference: 43
    },
    {
      value: 4219507,
      label: "Xanxerê",
      reference: 42
    },
    {
      value: 1200708,
      label: "Xapuri",
      reference: 12
    },
    {
      value: 4219606,
      label: "Xavantina",
      reference: 42
    },
    {
      value: 4219705,
      label: "Xaxim",
      reference: 42
    },
    {
      value: 2616506,
      label: "Xexéu",
      reference: 26
    },
    {
      value: 1508407,
      label: "Xinguara",
      reference: 15
    },
    {
      value: 2933604,
      label: "Xique-Xique",
      reference: 29
    },
    {
      value: 2517407,
      label: "Zabelê",
      reference: 25
    },
    {
      value: 3557154,
      label: "Zacarias",
      reference: 35
    },
    {
      value: 2114007,
      label: "Zé Doca",
      reference: 21
    },
    {
      value: 4219853,
      label: "Zortéa",
      reference: 42
    }
  ]
};
